
// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//   getBusOwners,
//   getBusOwnerById,
//   createBusOwner,
//   updateBusOwner,
//   deleteBusOwner,
//   approveBusOwner,
//   addBusToOwner,
//   getSeatLayoutsByBustype,
//   getAllCategory
// } from '../../Services/Operations/ProductAPI';
// import {
//   getDriversByBusOwner,
//   getConductorsByBusOwner,
//   assignDriverToBus,
//   assignConductorToBus,
//   unassignDriverFromBus,
//   unassignConductorFromBus
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/BusFareChart.css';
// import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';

// const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
//   const { token } = useSelector(state => state.user);
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   // Add this with your other states
// const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
// const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']); // Default

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     totalSeats: '',
//     amenities: [],
//     busClass: 'Economy',
//     images: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [routes, setRoutes] = useState([]);
//   const [selectedRouteUp, setSelectedRouteUp] = useState(null);
//   const [selectedRouteDown, setSelectedRouteDown] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false); // Add loading state

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Selected Images
//   const [selectedImages, setSelectedImages] = useState([]);

//   // Constants
//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const BUS_CLASSES = ['Economy', 'Premium', 'Luxury'];

//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle', 
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks', 
//     'GPS Tracking', 'SOS Switch'
//   ];

//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

// // Call this when component mounts or when category changes
// // Fetch configurations when category changes
// useEffect(() => {
//   if (form.busCategory) {
//     fetchAvailableConfigurations();
//   }
// }, [form.busCategory, token]);
//   // Helper Functions
//   const getCategoryMultiplier = () => {
//     const multipliers = {
//       'Seater': 1.0,
//       'Sleeper': 1.5,
//       'Seater+Sleeper': 1.3
//     };
//     return multipliers[form.busCategory] || 1.0;
//   };


//   const getStopColor = (type) => {
//     switch(type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   // Fetch Routes
//   useEffect(() => {
//     const fetchRoutes = async () => {
//       try {
//         setLoadingRoutes(true);
//         const response = await getAllBusownerAdminRoutes(token, 1, 100, '', ownerId);
//         if (response && response.success && response.routes) {
//           setRoutes(response.routes);
//         }
//       } catch (error) {
//         console.error('Error fetching routes:', error);
//         toast.error('Failed to fetch routes');
//       } finally {
//         setLoadingRoutes(false);
//       }
//     };

//     fetchRoutes();
//   }, [token, ownerId]);

// // Fetch Layout Templates based on selected configuration
// const fetchLayouts = async (config) => {
//   try {
//     if (!config) return;

//     setLoadingLayouts(true);

//     // Format the config for API (replace x with * if needed)
//     let bustype = config.replace('x', '*');

//     console.log(`Fetching layouts for bustype: ${bustype}`);

//     // Call the API with the bustype parameter
//     const response = await getSeatLayoutsByBustype(bustype, token);

//     console.log('Layout API Response:', response);

//     if (response && response.success) {
//       if (response.data && Array.isArray(response.data)) {
//         // Filter layouts by seat type if category is specific
//         let filteredLayouts = response.data;

//         if (form.busCategory === 'Seater') {
//           filteredLayouts = response.data.filter(layout => 
//             layout.seatType === 'seat' || layout.seatType === 'seater'
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           filteredLayouts = response.data.filter(layout => 
//             layout.seatType === 'sleeper'
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           filteredLayouts = response.data.filter(layout => 
//             layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//           );
//         }

//         setLayoutTemplates(filteredLayouts);

//         if (filteredLayouts.length === 0) {
//           toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
//         } else {
//           toast.success(`Found ${filteredLayouts.length} layout(s) for ${config}`);
//         }
//       } else {
//         setLayoutTemplates([]);
//         toast.info(`No layouts found for ${config} configuration`);
//       }
//     } else {
//       console.error('Failed to fetch layouts:', response);
//       setLayoutTemplates([]);
//       toast.error(response?.message || 'Failed to load seat layouts');
//     }
//   } catch (error) {
//     console.error("Layout Fetch Error:", error);
//     toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
//     setLayoutTemplates([]);
//   } finally {
//     setLoadingLayouts(false);
//   }
// };

// // Handle Category Change - only set category, don't fetch layouts
// const handleCategoryChange = (category) => {
//   setForm(prev => ({ ...prev, busCategory: category }));
//   // Reset selected template when category changes
//   setSelectedTemplate(null);
//   setActiveSeats([]);
//   setLayoutTemplates([]); // Clear templates
//   // Don't fetch layouts here - wait for configuration selection
// };

// const fetchAvailableConfigurations = async () => {
//   try {
//     setLoadingLayouts(true);
//     const response = await getAllCategory(token);

//     if (response && response.success && response.data) {
//       // Filter categories by selected bus category and available seat types
//       let relevantCategories = response.data;

//       if (form.busCategory === 'Seater') {
//         relevantCategories = response.data.filter(cat => 
//           cat.availableSeatTypes?.includes('seat') || 
//           cat.availableSeatTypes?.includes('seater')
//         );
//       } else if (form.busCategory === 'Sleeper') {
//         relevantCategories = response.data.filter(cat => 
//           cat.availableSeatTypes?.includes('sleeper')
//         );
//       } else if (form.busCategory === 'Seater+Sleeper') {
//         relevantCategories = response.data.filter(cat => 
//           cat.availableSeatTypes?.includes('seater+sleeper') || 
//           cat.availableSeatTypes?.includes('seat+sleeper')
//         );
//       }

//       // Extract configurations from filtered categories
//       const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//       if (configs.length > 0) {
//         setAvailableConfigurations(configs);
//         // Don't auto-fetch layouts - let user select configuration first
//         setSelectedConfiguration(configs[0]);
//         // Clear any existing templates
//         setLayoutTemplates([]);
//       } else {
//         setAvailableConfigurations([]);
//         setLayoutTemplates([]);
//         toast.info(`No configurations available for ${form.busCategory}`);
//       }
//     }
//   } catch (error) {
//     console.error('Error fetching configurations:', error);
//     setAvailableConfigurations([]);
//   } finally {
//     setLoadingLayouts(false);
//   }
// };

//   // Image Handlers
//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];

//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({
//           file: file,
//           preview: e.target.result,
//           name: file.name
//         });

//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

// // Template Selection
// const openTemplateSelector = () => {
//   if (!form.busCategory) {
//     toast.error('Please select a Bus Category first');
//     return;
//   }
//   if (!selectedConfiguration) {
//     toast.error('Please select a Bus Configuration first');
//     return;
//   }
//   if (layoutTemplates.length === 0) {
//     toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
//     return;
//   }
//   setShowTemplateModal(true);
// };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);

//     // Initialize all seats as active by default
//     const allSeatNumbers = template.seats.map(s => s.seatNumber);
//     setActiveSeats(allSeatNumbers);

//     setForm(prev => ({
//       ...prev,
//       totalSeats: String(template.totalSeats || allSeatNumbers.length)
//     }));

//     setShowTemplateModal(false);
//     setShowLayoutModal(true);

//     toast.success(`Selected template: ${template.name}`);
//   };

//   const toggleSeatSelection = (seatNumber) => {
//     if (activeSeats.includes(seatNumber)) {
//       setActiveSeats(activeSeats.filter(s => s !== seatNumber));
//     } else {
//       setActiveSeats([...activeSeats, seatNumber]);
//     }
//   };

//   // Toggle Operating Day
//   const toggleDay = (day) => {
//     setOperatingDays(prev => 
//       prev.includes(day) 
//         ? prev.filter(d => d !== day) 
//         : [...prev, day]
//     );
//   };

//   // Generate Fare Matrix for a route
//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     // Sort stops by sequence
//     const sortedStops = [...(routeData.intermediateStops || [])]
//       .sort((a, b) => a.sequence - b.sequence);

//     // Create all stops array
//     const allStops = [
//       { 
//         id: 'origin', 
//         name: routeData.origin?.city || 'Origin', 
//         distanceFromOrigin: 0,
//         type: 'origin'
//       },
//       ...sortedStops.map((s, i) => ({ 
//         id: s._id || `stop_${i}`, 
//         name: s.city || s.name || `Stop ${i+1}`, 
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: 'stop',
//         sequence: s.sequence
//       })),
//       { 
//         id: 'destination', 
//         name: routeData.destination?.city || 'Destination', 
//         distanceFromOrigin: parseFloat(routeData.destination?.distanceFromOrigin) || 
//                             parseFloat(routeData.routeDetails?.totalDistance) || 0,
//         type: 'destination'
//       }
//     ];

//     // Build matrix
//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (parseFloat(toStop.distanceFromOrigin) - parseFloat(fromStop.distanceFromOrigin)).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         sequence: fromStop.sequence,
//         toCells: toCells
//       };
//     });

//     // Remove destination row
//     return matrix.filter(row => row.fromId !== 'destination');
//   };

//   // Handle Generate Matrix
//   const handleGenerateMatrix = () => {
//     if (!selectedRouteUp) {
//       toast.error('Please select at least the Main/Up Route');
//       return;
//     }

//     if (tripType === 'roundTrip' && !selectedRouteDown) {
//       toast.error('Please select the Return/Down Route');
//       return;
//     }

//     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//       toast.error('Please fill all Pricing Fields');
//       return;
//     }

//     // Generate Up Matrix
//     const matrixUp = generateMatrixForRoute(selectedRouteUp);
//     setFareMatrixUp(matrixUp);

//     // Generate Down Matrix for Round Trip
//     if (tripType === 'roundTrip' && selectedRouteDown) {
//       const matrixDown = generateMatrixForRoute(selectedRouteDown);
//       setFareMatrixDown(matrixDown);
//     } else {
//       setFareMatrixDown([]);
//     }

//     toast.success(tripType === 'roundTrip' 
//       ? 'Both Fare Matrices Generated!' 
//       : 'Fare Matrix Generated!'
//     );
//   };

//   // Handle Price Change
//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = { 
//           ...newToCells[colIndex], 
//           price: parseInt(newPrice) || 0 
//         };
//       }
//       return { ...row, toCells: newToCells };
//     });

//     if (isUp) {
//       setFareMatrixUp(updatedMatrix);
//     } else {
//       setFareMatrixDown(updatedMatrix);
//     }
//   };

// // Handle Submit - FIXED for admin API compatibility
// const handleSubmitBus = async () => {
//   try {
//     setIsSubmitting(true);
//     setError(null);

//     // Validation
//     if (!form.busNumber) {
//       throw new Error('Bus Number is required');
//     }
//     if (!form.busName) {
//       throw new Error('Bus Name is required');
//     }
//     if (!form.busType) {
//       throw new Error('Bus Type is required');
//     }
//     if (!form.busCategory) {
//       throw new Error('Bus Category is required');
//     }
//     if (!selectedRouteUp) {
//       throw new Error('Please select at least one route');
//     }
//     if (tripType === 'roundTrip' && !selectedRouteDown) {
//       throw new Error('Please select return route for round trip');
//     }
//     if (operatingDays.length === 0) {
//       throw new Error('Please select at least one operating day');
//     }
//     if (!selectedTemplate) {
//       throw new Error('Please configure seat layout');
//     }
//     if (fareMatrixUp.length === 0) {
//       throw new Error('Please generate Fare Matrix');
//     }

//     // Process Amenities
//     const amenitiesArray = form.amenities || [];

//     // Process Seats - Map to the format expected by admin API
//     const finalSeatsPayload = selectedTemplate.seats
//       .filter(s => activeSeats.includes(s.seatNumber))
//       .map(s => ({
//         seatNumber: s.seatNumber,
//         row: s.row,
//         column: s.column,
//         seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//         position: s.position || getSeatPosition(s.column),
//         isActive: true,
//         price: calculateSeatPrice(s, pricing.basePrice, s.position)
//       }));

//     // Seat Configuration
//     const seatConfigPayload = {
//       busType: selectedTemplate.configuration || '2*2',
//       totalSeats: activeSeats.length,
//       seatsPerRow: selectedTemplate.seatsPerRow || 4,
//       totalRows: Math.ceil(activeSeats.length / (selectedTemplate.seatsPerRow || 4))
//     };

//     // Construct Route Schedules
//     const routeSchedules = [];

//     // Up Route
//     routeSchedules.push({
//       routeId: selectedRouteUp._id,
//       direction: 'UP',
//       fareMatrix: fareMatrixUp,
//       operatingDays: operatingDays,
//       departureTime: selectedRouteUp.departureTime || '08:00',
//       arrivalTime: selectedRouteUp.arrivalTime || '20:00'
//     });

//     // Down Route for Round Trip
//     if (tripType === 'roundTrip' && selectedRouteDown) {
//       routeSchedules.push({
//         routeId: selectedRouteDown._id,
//         direction: 'DOWN',
//         fareMatrix: fareMatrixDown,
//         operatingDays: operatingDays,
//         departureTime: selectedRouteDown.departureTime || '08:00',
//         arrivalTime: selectedRouteDown.arrivalTime || '20:00'
//       });
//     }

//     console.log("pricing : ",pricing)

//     // ADMIN API expects 'fare' object, not 'fareDetails'
//     const fare = {
//       basePrice: parseFloat(pricing.basePrice) || 0,
//       costPerKm: parseFloat(pricing.costPerKm) || 0,
//       fareMatrix: fareMatrixUp, // Primary fare matrix
//       seatTypeMultipliers: {
//         standard: 1.0,
//         premium: 1.2,
//         luxury: 1.5
//       }
//     };

//     // Create FormData for file upload
//     const formData = new FormData();

//     // Append basic fields
//     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//     formData.append('busName', form.busName.trim());
//     formData.append('busType', form.busType);
//     formData.append('busCategory', form.busCategory);
//     formData.append('totalSeats', activeSeats.length.toString());
//     formData.append('busClass', form.busClass || 'Economy');
//     formData.append('tripType', tripType);
//     formData.append('route', selectedRouteUp._id);
//     formData.append('isActive', 'true');

//     // Append JSON stringified data
//     formData.append('amenities', JSON.stringify(amenitiesArray));
//     formData.append('routeSchedules', JSON.stringify(routeSchedules)); // This will be parsed by backend
//     formData.append('seats', JSON.stringify(finalSeatsPayload));
//     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//     formData.append('fare', JSON.stringify(fare));
//     formData.append('operatingDays', JSON.stringify(operatingDays));

//     // Append images
//     selectedImages.forEach((img, index) => {
//       if (img.file) {
//         formData.append('images', img.file);
//       }
//     });

//     console.log('Submitting FormData to ADMIN API:');
//     for (let pair of formData.entries()) {
//       console.log(pair[0] + ': ' + (pair[0] === 'images' ? 'File' : pair[1].substring(0, 100) + '...'));
//     }

//     // Call ADMIN API with FormData
//     const response = await addBusToOwner(ownerId, formData, token);

//     if (response && response.success) {
//       toast.success(tripType === 'roundTrip' 
//         ? 'Bus added successfully with round trip routes!' 
//         : 'Bus added successfully!'
//       );

//       onBusAdded();
//       onClose();
//     } else {
//       throw new Error(response?.message || 'Failed to add bus');
//     }

//   } catch (err) {
//     console.error('Error adding bus:', err);
//     setError(err.message || 'Failed to add bus');
//     toast.error(err.message || 'Failed to add bus');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   // Helper function for seat position
//   const getSeatPosition = (column) => {
//     switch(parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   // Helper function for seat price
//   const calculateSeatPrice = (seat, basePrice, position) => {
//     let price = parseFloat(basePrice) || 0;

//     // Position multiplier
//     if (position === 'window') price *= 1.1;
//     if (position === 'aisle') price *= 1.05;

//     // Row multiplier (front rows premium)
//     if (seat.row === 1) price *= 1.2;

//     return Math.round(price);
//   };

//   // Render Fare Matrix
//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRouteUp : selectedRouteDown;

//     if (!currentRoute || currentMatrix.length === 0) return null;

//     // Get all stops for headers
//     const sortedStops = [...(currentRoute.intermediateStops || [])]
//       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//     const allStops = [
//       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
//       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
//       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
//     ];

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">
//           {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//         </h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="corner-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                         <span className="stop-type">{stop.type}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                         <span className="stop-type">{row.fromType}</span>
//                       </div>
//                     </td>
//                     {row.toCells.map((cell, colIndex) => {
//                       if (cell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{cell.distanceKm} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="number"
//                                   className="matrix-input"
//                                   value={cell.price}
//                                   onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//                                   min="0"
//                                   step="1"
//                                 />
//                               </div>
//                             </div>
//                           </td>
//                         );
//                       }
//                       return (
//                         <td key={colIndex} className="na-cell">
//                           —
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

// // Render Seat Layout Visualizer - FIXED VERSION
// const renderSeatVisualizer = () => {
//   if (!selectedTemplate) return null;

//   const { seats, configuration, seatType } = selectedTemplate;

//   // Parse configuration (e.g., "2*2")
//   let leftCount = 2, rightCount = 2;
//   try {
//     if (configuration && configuration.includes('*')) {
//       const parts = configuration.split('*');
//       leftCount = parseInt(parts[0]) || 2;
//       rightCount = parseInt(parts[1]) || 2;
//     }
//   } catch (e) {
//     leftCount = 2;
//     rightCount = 2;
//   }

//   const totalConfigCols = leftCount + rightCount;

//   // Group seats by row
//   const seatsByRow = {};
//   seats.forEach(seat => {
//     if (!seatsByRow[seat.row]) {
//       seatsByRow[seat.row] = [];
//     }
//     seatsByRow[seat.row].push(seat);
//   });

//   // Get all row numbers and sort them
//   const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

//   const rows = [];

//   // Helper to render seat
//   const renderSeat = (seatObj) => {
//     const isSelected = activeSeats.includes(seatObj.seatNumber);
//     const isSleeper = seatObj.seatType === 'sleeper' || 
//       seatObj.seatType === 'seat+sleeper' ||
//       selectedTemplate.seatType === 'sleeper' || 
//       selectedTemplate.seatType === 'seater+sleeper';

//     return (
//       <button
//         key={seatObj.seatNumber}
//         className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${isSelected ? 'selected' : ''}`}
//         onClick={() => toggleSeatSelection(seatObj.seatNumber)}
//         title={`Seat ${seatObj.seatNumber} - ${seatObj.position || 'Standard'}`}
//         type="button"
//       >
//         <span className="seat-number">{seatObj.seatNumber}</span>
//       </button>
//     );
//   };

//   // Build rows
//   rowNumbers.forEach(rowNum => {
//     const seatsInRow = seatsByRow[rowNum];

//     // Check if this is a back row (has more than totalConfigCols seats or position is 'back')
//     const isBackRow = seatsInRow.some(s => s.position === 'back') || 
//                       seatsInRow.length > totalConfigCols;

//     // Check if this is a front row
//     const isFrontRow = seatsInRow.some(s => s.position === 'front');

//     if (isBackRow) {
//       // Back row - seats in a straight line
//       const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row back-row">
//           <div className="row-label">
//             {isFrontRow ? 'Front' : isBackRow ? 'Back' : `Row ${rowNum}`}
//           </div>
//           <div className="seats-container">
//             {sortedSeats.map(seat => renderSeat(seat))}
//           </div>
//         </div>
//       );
//     } else {
//       // Normal row - split left and right with aisle
//       const leftSeats = seatsInRow
//         .filter(s => (s.column || 0) <= leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));

//       const rightSeats = seatsInRow
//         .filter(s => (s.column || 0) > leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));

//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row">
//           <div className="row-label">Row {rowNum}</div>
//           <div className="left-seats">
//             {leftSeats.map(seat => renderSeat(seat))}
//           </div>
//           <div className="aisle">Aisle</div>
//           <div className="right-seats">
//             {rightSeats.map(seat => renderSeat(seat))}
//           </div>
//         </div>
//       );
//     }
//   });

//   return (
//     <div className="seat-layout-visualizer">
//       <div className="bus-header">
//         <div className="driver-area">Driver</div>
//         <div className="bus-info">
//           <span className="bus-config">{selectedTemplate.configuration}</span>
//           <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
//         </div>
//       </div>
//       <div className="bus-body">
//         {rows}
//       </div>
//       <div className="seat-legend">
//         <div className="legend-item">
//           <div className="seat-sample selected"></div>
//           <span>Active Seat ({activeSeats.length})</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample"></div>
//           <span>Inactive Seat</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample sleeper"></div>
//           <span>Sleeper</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample front"></div>
//           <span>Front</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample back"></div>
//           <span>Back</span>
//         </div>
//       </div>
//       <div className="seat-summary">
//         <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
//       </div>
//     </div>
//   );
// };

//   // Progress Steps Component
//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">1</div>
//         <div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">2</div>
//         <div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">3</div>
//         <div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div>
//         <div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   // Render Basic Info Tab
//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Bus Information</h3>
//         <p className="section-subtitle">Enter basic details about the bus</p>
//       </div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🚌</span>
//             Bus Number *
//           </label>
//           <input
//             type="text"
//             value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             placeholder="e.g., WB01AB1234"
//             className="modern-input"
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🏷️</span>
//             Bus Name *
//           </label>
//           <input
//             type="text"
//             value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             placeholder="e.g., Volvo Multi-Axle"
//             className="modern-input"
//             required
//           />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🖼️</span>
//           Bus Images
//         </h4>
//         <div className="images-upload-area">
//           <input
//             type="file"
//             id="bus-images"
//             multiple
//             accept="image/*"
//             onChange={handleImageUpload}
//             className="image-upload-input"
//             style={{ display: 'none' }}
//           />
//           <label htmlFor="bus-images" className="image-upload-label">
//             <span className="upload-icon">📁</span>
//             <span className="upload-text">Click to upload images</span>
//             <span className="upload-hint">Upload multiple images (max 10)</span>
//           </label>

//           {selectedImages.length > 0 && (
//             <div className="selected-images-preview">
//               <h5>Selected Images ({selectedImages.length})</h5>
//               <div className="images-grid">
//                 {selectedImages.map((image, index) => (
//                   <div key={index} className="image-preview-item">
//                     <img
//                       src={image.preview}
//                       alt={`Bus ${index + 1}`}
//                       className="preview-image"
//                     />
//                     <button
//                       type="button"
//                       className="remove-image-btn"
//                       onClick={() => removeImage(index)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">🔧</span>
//             Bus Type *
//           </label>
//           <select
//             value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_TYPES.map(type => (
//               <option key={type} value={type}>{type}</option>
//             ))}
//           </select>
//         </div>

//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">📊</span>
//             Bus Category *
//           </label>
//           <select
//             value={form.busCategory}
//             onChange={(e) => handleCategoryChange(e.target.value)}
//             className="modern-select"
//           >
//             <option value="">Select Category</option>
//             {BUS_CATEGORIES.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">💺</span>
//             Bus Class
//           </label>
//           <select
//             value={form.busClass}
//             onChange={(e) => setForm(prev => ({ ...prev, busClass: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_CLASSES.map(cls => (
//               <option key={cls} value={cls}>{cls}</option>
//             ))}
//           </select>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">✨</span>
//           Amenities
//         </h4>
//         <div className="amenities-grid compact">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-option compact">
//               <input
//                 type="checkbox"
//                 checked={form.amenities.includes(amenity)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: [...prev.amenities, amenity]
//                     }));
//                   } else {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: prev.amenities.filter(a => a !== amenity)
//                     }));
//                   }
//                 }}
//                 className="amenity-checkbox"
//               />
//               <span className="amenity-content">
//                 <span className="amenity-icon">✓</span>
//                 <span className="amenity-label">{amenity}</span>
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           className="modern-btn primary full-width"
//           onClick={() => setActiveTab('route')}
//           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
//         >
//           Continue to Route & Pricing
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   // Render Route & Pricing Tab
//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Route & Pricing Configuration</h3>
//         <p className="section-subtitle">Select routes and configure pricing for this bus</p>
//       </div>

//       {/* Trip Type Toggle */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔄</span>
//           Trip Type
//         </h4>
//         <div className="trip-type-container">
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}
//           >
//             <span className="btn-icon">➡️</span>
//             One Way
//           </button>
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}
//           >
//             <span className="btn-icon">🔄</span>
//             Round Trip
//           </button>
//         </div>
//       </div>

//       {/* Route Selection */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🗺️</span>
//           Route Selection {tripType === 'roundTrip' ? '(Up & Down)' : ''}
//         </h4>

//         <div className="route-selector">
//           <label className="input-label">Main Route (Up) *</label>
//           <select
//             value={selectedRouteUp?._id || ''}
//             onChange={(e) => {
//               const route = routes.find(r => r._id === e.target.value);
//               setSelectedRouteUp(route);
//               setFareMatrixUp([]);
//             }}
//             className="modern-select"
//             disabled={loadingRoutes}
//           >
//             <option value="">Select Up Route</option>
//             {routes.map(route => (
//               <option key={route._id} value={route._id}>
//                 {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''})
//               </option>
//             ))}
//           </select>
//         </div>

//         {tripType === 'roundTrip' && (
//           <div className="route-selector" style={{ marginTop: '15px' }}>
//             <label className="input-label">Return Route (Down) *</label>
//             <select
//               value={selectedRouteDown?._id || ''}
//               onChange={(e) => {
//                 const route = routes.find(r => r._id === e.target.value);
//                 setSelectedRouteDown(route);
//                 setFareMatrixDown([]);
//               }}
//               className="modern-select"
//               disabled={loadingRoutes}
//             >
//               <option value="">Select Down Route</option>
//               {routes.map(route => (
//                 <option key={route._id} value={route._id}>
//                   {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''})
//                 </option>
//               ))}
//             </select>
//           </div>
//         )}
//       </div>

//       {/* Operating Days */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📅</span>
//           Operating Days *
//         </h4>
//         <div className="days-grid compact">
//           {DAYS_OF_WEEK.map(day => (
//             <button
//               key={day}
//               type="button"
//               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}
//               title={day}
//             >
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//         <div className="selected-days">
//           Selected: {operatingDays.length} days
//         </div>
//       </div>

//       {/* Pricing Configuration */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💰</span>
//           Pricing Configuration
//         </h4>

//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>

//         {selectedRouteUp && (
//           <div className="pricing-summary">
//             <div className="summary-item">
//               <span>Category Multiplier:</span>
//               <span className="value accent">{getCategoryMultiplier()}x</span>
//             </div>
//             <div className="summary-item">
//               <span>Route Distance:</span>
//               <span className="value">{selectedRouteUp.routeDetails?.totalDistance || 0} km</span>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Generate Matrix Button */}
//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('basic')}
//         >
//           ← Back
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary generate-matrix-btn"
//           onClick={() => {
//             handleGenerateMatrix();
//             if (fareMatrixUp.length > 0) {
//               setActiveTab('matrix');
//             }
//           }}
//           disabled={!selectedRouteUp || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
//         >
//           Generate Fare Matrix
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   // Render Fare Matrix Tab
//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Fare Matrix Configuration</h3>
//         <p className="section-subtitle">Review and edit fares for each route</p>
//       </div>

//       {/* Matrix Tabs for Round Trip */}
//       {tripType === 'roundTrip' && (
//         <div className="matrix-tabs">
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}
//           >
//             Up Route: {selectedRouteUp?.routeName || 'Selected Route'}
//           </button>
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}
//           >
//             Down Route: {selectedRouteDown?.routeName || 'Selected Route'}
//           </button>
//         </div>
//       )}

//       {/* Render Matrix */}
//       {tripType === 'roundTrip' ? (
//         <>
//           {activeMatrixTab === 'up' && renderMatrix('up')}
//           {activeMatrixTab === 'down' && renderMatrix('down')}
//         </>
//       ) : (
//         renderMatrix('up')
//       )}

//       <div className="matrix-info">
//         <div className="info-card">
//           <div className="info-item">
//             <span className="label">Total Stops:</span>
//             <span className="value">
//               {selectedRouteUp ? 
//                 (selectedRouteUp.intermediateStops?.length || 0) + 2 : 0}
//             </span>
//           </div>
//           <div className="info-item">
//             <span className="label">Category Multiplier:</span>
//             <span className="value accent">{getCategoryMultiplier()}x</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Base Price:</span>
//             <span className="value">₹{pricing.basePrice}</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Cost/km:</span>
//             <span className="value">₹{pricing.costPerKm}</span>
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('route')}
//         >
//           ← Back to Pricing
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={() => setActiveTab('seats')}
//           disabled={fareMatrixUp.length === 0}
//         >
//           Continue to Seat Layout
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

// // Render Seat Layout Tab - COMPLETE UPDATED VERSION
// const renderSeatLayoutTab = () => (
//   <div className="tab-content-wrapper">
//     <div className="section-title">
//       <h3>Seat Layout Configuration</h3>
//       <p className="section-subtitle">Configure seat layout for this bus</p>
//     </div>

//     {/* Bus Configuration Selector */}
//     <div className="section-card">
//       <h4 className="card-title">
//         <span className="title-icon">🔧</span>
//         Bus Configuration
//       </h4>
//       <div className="config-selector">
//         <label className="input-label">Select Bus Configuration *</label>
//         {loadingLayouts ? (
//           <div className="loading-configs">
//             <span>Loading configurations...</span>
//           </div>
//         ) : (
//           <>

// <div className="config-buttons">
//   {availableConfigurations.map(config => {
//     // Check if this configuration might have layouts
//     const hasLayouts = true; // You could add logic here

//     return (
//       <button
//         key={config}
//         type="button"
//         className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//         onClick={() => {
//           setSelectedConfiguration(config);
//           setSelectedTemplate(null);
//           setActiveSeats([]);
//           fetchLayouts(config);
//         }}
//       >
//         {config}
//       </button>
//     );
//   })}
// </div>
//             <small className="helper-text">
//               {form.busCategory} bus with {selectedConfiguration} configuration
//             </small>
//           </>
//         )}
//       </div>
//     </div>

//     {/* Seat Template Selection */}
//     <div className="section-card">
//       <h4 className="card-title">
//         <span className="title-icon">💺</span>
//         Seat Layout Template
//       </h4>

//       {!selectedTemplate ? (
//         <button
//           type="button"
//           className="modern-btn outline full-width"
//           onClick={openTemplateSelector}
//           disabled={loadingLayouts}
//         >
//           {loadingLayouts ? (
//             <>
//               <span className="btn-icon">⏳</span>
//               Loading Layouts...
//             </>
//           ) : (
//             <>
//               <span className="btn-icon">📋</span>
//               Select Layout Template
//             </>
//           )}
//         </button>
//       ) : (
//         <div className="selected-template-info">
//           <div className="template-details">
//             <span className="template-name">{selectedTemplate.name}</span>
//             <span className="template-config">{selectedTemplate.configuration}</span>
//             <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
//             <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
//           </div>
//           <button
//             type="button"
//             className="btn-small"
//             onClick={() => {
//               setSelectedTemplate(null);
//               setActiveSeats([]);
//             }}
//           >
//             Change
//           </button>
//         </div>
//       )}
//     </div>

//     {/* Seat Visualizer */}
//     {selectedTemplate && (
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">👁️</span>
//           Seat Layout Visualizer
//         </h4>
//         <button
//           type="button"
//           className="view-layout-btn"
//           onClick={() => setShowLayoutModal(true)}
//         >
//           View / Edit Active Seats
//         </button>

//         <div className="seat-summary">
//           <div className="summary-item">
//             <span>Total Seats in Template:</span>
//             <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
//           </div>
//           <div className="summary-item">
//             <span>Active Seats:</span>
//             <span className="value accent">{activeSeats.length}</span>
//           </div>
//           <div className="summary-item">
//             <span>Inactive Seats:</span>
//             <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
//           </div>
//         </div>
//       </div>
//     )}

//     <div className="form-actions">
//       <button
//         type="button"
//         className="modern-btn outline"
//         onClick={() => setActiveTab('matrix')}
//       >
//         ← Back to Matrix
//       </button>
//       <button
//         type="button"
//         className="modern-btn primary"
//         onClick={handleSubmitBus}
//         disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
//       >
//         {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
//         <span className="btn-icon">✓</span>
//       </button>
//     </div>
//   </div>
// );

//   // Layout Modal
//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Active Seats</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {renderSeatVisualizer()}
//         </div>
//         <div className="modal-footer">
//           <button
//             type="button"
//             className="modern-btn primary"
//             onClick={() => setShowLayoutModal(false)}
//           >
//             Confirm Layout
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   // Template Selection Modal
//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Seat Layout Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {loadingLayouts ? (
//             <div className="loading-container">
//               <p>Loading templates...</p>
//             </div>
//           ) : layoutTemplates.length === 0 ? (
//   <div className="no-templates">
//     <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
//     <p className="hint">Available configurations with layouts:</p>
//     <div className="available-configs">
//       {availableConfigurations.map(config => (
//         <span key={config} className="config-chip">{config}</span>
//       ))}
//     </div>
//     <p className="hint">Try selecting a different configuration</p>
//   </div>
// )  : (
//             <div className="templates-grid">
//               {layoutTemplates.map(template => (
//                 <button
//                   type="button"
//                   key={template._id}
//                   className="template-card"
//                   onClick={() => handleSelectTemplate(template)}
//                 >
//                   <h4 className="template-name">{template.name}</h4>
//                   <div className="template-details">
//                     <span className="config">Config: {template.configuration}</span>
//                     <span className="seats">Seats: {template.totalSeats}</span>
//                   </div>
//                   <div className="template-preview">
//                     <span className="rows">Rows: {template.rows}</span>
//                     <span className="cols">Cols: {template.columns}</span>
//                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">
//               <span className="title-icon">🚌</span>
//               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
//             </h2>
//             <p className="modal-subtitle">Configure bus details with route selection</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>
//             <span className="close-icon">×</span>
//           </button>
//         </div>

//         <div className="modal-body modern">
//           <ProgressSteps />

//           <div className="tab-container">
//             {activeTab === 'basic' && renderBasicInfoTab()}
//             {activeTab === 'route' && renderRouteTab()}
//             {activeTab === 'matrix' && renderMatrixTab()}
//             {activeTab === 'seats' && renderSeatLayoutTab()}
//           </div>

//           {error && (
//             <div className="error-message modern">
//               <span className="error-icon">⚠️</span>
//               {error}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Modals */}
//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//     </div>
//   );
// };

//   const BusOwnerManage = () => {
//     const { token } = useSelector(state => state.user);
//     const [busOwners, setBusOwners] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [editingOwner, setEditingOwner] = useState(null);
//     const [editForm, setEditForm] = useState({});
//     const [viewingOwner, setViewingOwner] = useState(null);
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [showAddBusModal, setShowAddBusModal] = useState(false);
//     const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
//     const [newOwner, setNewOwner] = useState({
//       name: '',
//       email: '',
//       phone: '',
//       companyName: ''
//     });
//     const [error, setError] = useState(null);

//     // Bus Management states
//     const [showBusManagement, setShowBusManagement] = useState(false);
//     const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
//     const [selectedOwner, setSelectedOwner] = useState(null);
//     const [busSearchTerm, setBusSearchTerm] = useState('');
//     const [busDetailsLoading, setBusDetailsLoading] = useState(false);


//     // Pagination states
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalOwners, setTotalOwners] = useState(0);
//     const [pageSize] = useState(10);

//     // Helper function to get sequential number
//     const getSequentialNumber = (index) => {
//       return (currentPage - 1) * pageSize + index + 1;
//     };

//     // Helper function to get full image URL
//     const getFullImageUrl = (imagePath) => {
//       // if (!imagePath) return defaultAvatar;

//       // Check if it's already a full URL
//       if (imagePath.startsWith('http')) {
//         return imagePath;
//       }

//       // Add base URL for relative paths
//       return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
//     };

//     // Add this useEffect after your existing useEffect
//     useEffect(() => {
//       // Fetch bus owners when page changes
//       fetchBusOwners();
//     }, [currentPage]);

//     // Also update your existing useEffect for search
//     useEffect(() => {
//       // Reset to first page when search term changes
//       setCurrentPage(1);

//       // Use a timer to debounce the search
//       const timer = setTimeout(() => {
//         fetchBusOwners();
//       }, 500); // 500ms delay to avoid too many API calls

//       return () => clearTimeout(timer);
//     }, [searchTerm]);

//     const fetchBusOwners = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         console.log(`Fetching page ${currentPage} with limit ${pageSize}, search: ${searchTerm}`);

//         // Pass pagination parameters AND search term
//         const response = await getBusOwners(token, currentPage, pageSize, searchTerm);

//         if (response && response.success && response.busOwners) {
//           console.log(`Received ${response.busOwners.length} owners, total: ${response.total}`);

//           const transformedOwners = response.busOwners.map((owner, index) => ({
//             id: owner._id,
//             serialNo: getSequentialNumber(index),
//             profileImage: owner.profileImage || '',
//             name: owner.name || '',
//             company: owner.companyName || '',
//             email: owner.email || '',
//             phone: owner.phone || '',
//             buses: owner.busCount || 0,
//             routes: owner.routeCount || 0,
//             joined: new Date(owner.createdAt).toISOString().split('T')[0],
//             status: owner.isVerified ? 'Verified' : 'Pending',
//             adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
//             _id: owner._id,
//             isVerified: owner.isVerified,
//             isProfileComplete: owner.isProfileComplete,
//             isApprovedByAdmin: owner.isApprovedByAdmin,
//             activeBuses: owner.activeBuses || 0,
//             driverCount: owner.driverCount || 0,
//             conductorCount: owner.conductorCount || 0,
//             createdAt: owner.createdAt,
//             updatedAt: owner.updatedAt,
//             address: owner.address || {},
//             city: owner.address?.city || '',
//             state: owner.address?.state || owner.state || '',
//             pincode: owner.address?.pincode || '',
//             busAll: owner.busAll || []
//           }));

//           setBusOwners(transformedOwners);

//           // Set pagination info from API response
//           if (response.totalPages) {
//             setTotalPages(response.totalPages);
//           }
//           if (response.total) {
//             setTotalOwners(response.total);
//           } else {
//             setTotalOwners(response.busOwners.length);
//           }
//         } else {
//           setError('No bus owners data found in response');
//           setBusOwners([]);
//           setTotalPages(1);
//           setTotalOwners(0);
//         }
//       } catch (err) {
//         console.error('Error fetching bus owners:', err);
//         setError('Failed to fetch bus owners. Please try again.');
//         setBusOwners([]);
//         setTotalPages(1);
//         setTotalOwners(0);
//       } finally {
//         setLoading(false);
//       }
//     };

//     const handleSearchChange = (e) => {
//       const value = e.target.value;
//       setSearchTerm(value);
//       // Don't fetch here - let the useEffect handle it
//     };

//     // Add these handler functions to your component
//     const handleViewBusDetails = (bus) => {
//       alert(`Viewing bus details:\n\nBus Name: ${bus.busName}\nBus Number: ${bus.busNumber}\nType: ${bus.busType}\nTotal Seats: ${bus.totalSeats}\nAvailable Seats: ${bus.availableSeats}\nPrice: ₹${bus.basePrice}\nStatus: ${bus.isActive ? 'Active' : 'Inactive'}`);
//     };

//     const handleEditBus = (bus) => {
//       alert(`Edit functionality for bus: ${bus.busName} (${bus.busNumber}) would open here.`);
//     };

//     const handleToggleBusStatus = async (busId, activate) => {
//       const action = activate ? 'activate' : 'deactivate';
//       if (window.confirm(`Are you sure you want to ${action} this bus?`)) {
//         try {
//           // Call your API to update bus status
//           // const response = await updateBusStatus(busId, { isActive: activate }, token);
//           // if (response.success) {
//           //   // Update local state
//           //   setSelectedOwnerBuses(prev => 
//           //     prev.map(bus => 
//           //       bus._id === busId ? { ...bus, isActive: activate } : bus
//           //     )
//           //   );
//           //   alert(`Bus ${action}d successfully!`);
//           // }
//           alert(`Bus ${action}d successfully! (API call would be made here)`);
//         } catch (err) {
//           console.error(`Error ${action}ing bus:`, err);
//           alert(`Failed to ${action} bus. Please try again.`);
//         }
//       }
//     };

//     const busManagementStyles = `
//     .bus-management-modal {
//       max-width: 1200px !important;
//       width: 95% !important;
//       max-height: 85vh;
//       overflow-y: auto;
//     }

//     .bus-management-table {
//       font-size: 14px;
//     }

//     .bus-management-table th {
//       background-color: #f8f9fa;
//       position: sticky;
//       top: 0;
//       z-index: 10;
//     }

//     .bus-management-table td {
//       vertical-align: middle;
//     }

//     .staff-details {
//       min-width: 200px;
//     }

//     .staff-name {
//       font-weight: 600;
//       color: #333;
//     }

//     .staff-contact {
//       color: #666;
//       font-size: 13px;
//     }

//     .bus-info-cell {
//       min-width: 150px;
//     }

//     .no-staff {
//       color: #dc3545;
//       font-style: italic;
//       font-size: 13px;
//     }

//     .bus-status-active {
//       background-color: #d4edda;
//       color: #155724;
//       padding: 4px 8px;
//       border-radius: 4px;
//       font-size: 12px;
//       font-weight: 600;
//     }

//     .bus-status-inactive {
//       background-color: #f8d7da;
//       color: #721c24;
//       padding: 4px 8px;
//       border-radius: 4px;
//       font-size: 12px;
//       font-weight: 600;
//     }

//     .bus-actions {
//       display: flex;
//       gap: 5px;
//       flex-wrap: wrap;
//     }

//     .bus-action-btn {
//       padding: 4px 8px;
//       font-size: 12px;
//       border-radius: 4px;
//       border: none;
//       cursor: pointer;
//       transition: all 0.2s;
//     }

//     .bus-action-btn:hover {
//       opacity: 0.9;
//       transform: translateY(-1px);
//     }

//     .bus-action-view {
//       background-color: #17a2b8;
//       color: white;
//     }

//     .bus-action-edit {
//       background-color: #ffc107;
//       color: #000;
//     }

//     .bus-action-activate {
//       background-color: #28a745;
//       color: white;
//     }

//     .bus-action-deactivate {
//       background-color: #dc3545;
//       color: white;
//     }
//   `;

//     const fetchBusOwnerById = async (id) => {
//       try {
//         const response = await getBusOwnerById(id, token);
//         return response.data || response;
//       } catch (err) {
//         console.error('Error fetching bus owner:', err);
//         throw err;
//       }
//     };

//     const handleApproveOwner = async (ownerId) => {
//       try {
//         setError(null);
//         const response = await approveBusOwner(ownerId, token);
//         console.log("Approve response: ", response);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === ownerId ? {
//                 ...owner,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
//                 adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending'
//               } : owner
//             )
//           );
//           alert('Bus owner approved successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to approve bus owner');
//         }
//       } catch (err) {
//         console.error('Error approving bus owner:', err);
//         setError('Failed to approve bus owner. Please try again.');
//         alert('Failed to approve bus owner. Please try again.');
//       }
//     };

//     const handleManageBuses = async (owner) => {
//       console.log("handleManageBuses ; ", owner)
//       if (owner.buses === 0) {
//         // alert('This owner has no buses registered.');
//         toast.error("This owner has no buses registered")
//         return;
//       }

//       console.log('Owner bus data:', owner);

//       // Check if busAll exists and has data
//       if (!owner.busAll || owner.busAll.length === 0) {
//         // If no bus data, try to fetch it separately
//         try {
//           setBusDetailsLoading(true);
//           const response = await getBusOwnerById(owner.id, token);

//           if (response.success && response.data && response.data.busAll) {
//             // Update the owner with bus data
//             const updatedOwner = {
//               ...owner,
//               busAll: response.data.busAll || []
//             };

//             // Process the bus data
//             const processedBuses = updatedOwner.busAll.map(bus => {
//               const driver = bus.driver ? {
//                 name: bus.driver.name || 'N/A',
//                 contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//                 licenseNumber: bus.driver.licenseNumber || 'N/A',
//                 experience: bus.driver.experience || 0
//               } : null;

//               const conductor = bus.conductor ? {
//                 name: bus.conductor.name || 'N/A',
//                 contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//               } : null;

//               return {
//                 ...bus,
//                 driver,
//                 conductor
//               };
//             });

//             console.log('Fetched and processed buses:', processedBuses);

//             setSelectedOwner(updatedOwner);
//             setSelectedOwnerBuses(processedBuses);
//             setShowBusManagement(true);
//             setBusSearchTerm('');
//           } else {
//             alert('Could not fetch bus data. Please try again.');
//           }
//         } catch (err) {
//           console.error('Error fetching bus details:', err);
//           alert('Failed to fetch bus details. Please try again.');
//         } finally {
//           setBusDetailsLoading(false);
//         }
//         return;
//       }

//       // If busAll data exists, process it
//       const processedBuses = owner.busAll.map(bus => {
//         const driver = bus.driver ? {
//           name: bus.driver.name || 'N/A',
//           contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//           licenseNumber: bus.driver.licenseNumber || 'N/A',
//           experience: bus.driver.experience || 0
//         } : null;

//         const conductor = bus.conductor ? {
//           name: bus.conductor.name || 'N/A',
//           contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//         } : null;

//         return {
//           ...bus,
//           driver,
//           conductor
//         };
//       });

//       console.log('Processed buses:', processedBuses);

//       setSelectedOwner(owner);
//       setSelectedOwnerBuses(processedBuses);
//       setShowBusManagement(true);
//       setBusSearchTerm('');
//     };

//     // Add this function after your other handler functions
//     const filteredBuses = selectedOwnerBuses.filter(bus =>
//       (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
//       (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
//     );

//     const handleRejectOwner = async (ownerId) => {
//       if (window.confirm('Are you sure you want to reject this bus owner?')) {
//         try {
//           setError(null);

//           // Debug log to check ownerId
//           console.log('Rejecting owner with ID:', ownerId);

//           // Make sure ownerId is a valid string
//           if (!ownerId || typeof ownerId !== 'string') {
//             throw new Error('Invalid owner ID');
//           }

//           const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

//           console.log('Reject response:', response);

//           if (response.success) {
//             setBusOwners(prevOwners =>
//               prevOwners.map(owner =>
//                 owner.id === ownerId ? {
//                   ...owner,
//                   isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
//                   adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
//                 } : owner
//               )
//             );
//             alert('Bus owner rejected successfully!');
//           } else {
//             throw new Error(response.message || 'Failed to reject bus owner');
//           }
//         } catch (err) {
//           console.error('Error rejecting bus owner:', err);
//           setError('Failed to reject bus owner. Please try again.');
//           alert('Failed to reject bus owner. Please try again.');
//         }
//       }
//     };

//     // Use busOwners directly as they're already filtered by the backend
//     const filteredOwners = busOwners;


//     const handleViewOwner = async (owner) => {
//       try {
//         const ownerData = await fetchBusOwnerById(owner.id);
//         setViewingOwner({
//           ...owner,
//           profileImage: ownerData.profileImage || owner.profileImage, // Add profile image
//           name: ownerData.name || owner.name,
//           company: ownerData.companyName || owner.company,
//           email: ownerData.email || owner.email,
//           phone: ownerData.phone || owner.phone,
//           isVerified: ownerData.isVerified,
//           isProfileComplete: ownerData.isProfileComplete,
//           isApprovedByAdmin: ownerData.isApprovedByAdmin,
//           activeBuses: ownerData.activeBuses,
//           driverCount: ownerData.driverCount,
//           conductorCount: ownerData.conductorCount
//         });
//       } catch (err) {
//         setViewingOwner(owner);
//         alert('Could not fetch latest owner details. Showing cached data.');
//       }
//     };

//     const handleEditOwner = (owner) => {
//       console.log("owner : ", owner)
//       setEditingOwner(owner.id);
//       setEditForm({
//         name: owner.name || '',
//         companyName: owner.company || '',
//         email: owner.email || '',
//         phone: owner.phone || '',
//         status: owner.status || 'Pending',
//         isApprovedByAdmin: owner.isApprovedByAdmin || false
//       });
//     };

//     const closeBusManagement = () => {
//       setShowBusManagement(false);
//       setSelectedOwnerBuses([]);
//       setSelectedOwner(null);
//       setBusSearchTerm('');
//       setBusDetailsLoading(false);
//     };

//     const handleSaveEdit = async () => {
//       try {
//         setError(null);
//         console.log("Editing owner ID:", editingOwner); // Debug log
//         console.log("editForm : ", editForm);

//         // Check if editingOwner is valid
//         if (!editingOwner || typeof editingOwner !== 'string') {
//           throw new Error('Invalid owner ID for editing');
//         }

//         const updateData = {
//           name: editForm.name,
//           email: editForm.email,
//           phone: editForm.phone,
//           companyName: editForm.companyName,
//           isVerified: editForm.status === 'Verified',
//           isApprovedByAdmin: editForm.isApprovedByAdmin
//         };

//         console.log('Sending update data:', updateData);

//         const response = await updateBusOwner(editingOwner, updateData, token);

//         console.log('Update response:', response);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === editingOwner ? {
//                 ...owner,
//                 name: response.data?.name || editForm.name,
//                 company: response.data?.companyName || editForm.companyName,
//                 email: response.data?.email || editForm.email,
//                 phone: response.data?.phone || editForm.phone,
//                 status: response.data?.isVerified ? 'Verified' : 'Pending',
//                 isVerified: response.data?.isVerified,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin,
//                 adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
//               } : owner
//             )
//           );

//           setEditingOwner(null);
//           setEditForm({});
//           alert('Bus owner updated successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to update bus owner');
//         }
//       } catch (err) {
//         console.error('Error updating bus owner:', err);
//         setError('Failed to update bus owner. Please try again.');
//         alert('Failed to update bus owner. Please try again.');
//       }
//     };

//     const handleCancelEdit = () => {
//       setEditingOwner(null);
//       setEditForm({});
//       setError(null);
//     };

//     const handleDeleteOwner = async (ownerId) => {
//       if (window.confirm('Are you sure you want to delete this bus owner?')) {
//         try {
//           setError(null);
//           const response = await deleteBusOwner(ownerId, token);

//           if (response.success) {
//             setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//             setTotalOwners(prev => prev - 1);
//             alert('Bus owner deleted successfully!');
//           } else {
//             throw new Error(response.message || 'Failed to delete bus owner');
//           }
//         } catch (err) {
//           console.error('Error deleting bus owner:', err);
//           setError('Failed to delete bus owner. Please try again.');
//           alert('Failed to delete bus owner. Please try again.');
//         }
//       }
//     };

//     const handleInputChange = (e) => {
//       const { name, value } = e.target;
//       setEditForm(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     };

//     const handleNewOwnerChange = (e) => {
//       const { name, value } = e.target;
//       setNewOwner(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     };

//     const handleAddOwner = async () => {
//       try {
//         setError(null);

//         if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
//           alert('Please fill in all required fields');
//           return;
//         }

//         const response = await createBusOwner(newOwner, token);

//         if (response.success) {
//           const newOwnerWithId = {
//             id: response.data.id,
//             serialNo: busOwners.length + 1,
//             profileImage: '',
//             name: response.data.name,
//             company: response.data.companyName,
//             email: response.data.email,
//             phone: response.data.phone,
//             buses: 0,
//             routes: 0,
//             joined: new Date(response.data.createdAt).toISOString().split('T')[0],
//             status: 'Pending',
//             adminApproval: 'Pending',
//             isVerified: false,
//             isApprovedByAdmin: false,
//             createdAt: response.data.createdAt
//           };

//           setBusOwners(prev => [newOwnerWithId, ...prev]);
//           setTotalOwners(prev => prev + 1);
//           setShowAddModal(false);
//           setNewOwner({
//             name: '',
//             companyName: '',
//             email: '',
//             phone: ''
//           });
//           alert('Bus owner added successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to add bus owner');
//         }
//       } catch (err) {
//         console.error('Error adding bus owner:', err);
//         setError('Failed to add bus owner. Please try again.');
//         alert('Failed to add bus owner. Please try again.');
//       }
//     };

//     const closeViewModal = () => {
//       setViewingOwner(null);
//     };

//     const closeAddModal = () => {
//       setShowAddModal(false);
//       setNewOwner({
//         name: '',
//         companyName: '',
//         email: '',
//         phone: ''
//       });
//       setError(null);
//     };

//     const handleRefresh = () => {
//       setCurrentPage(1);
//       fetchBusOwners();
//     };

//     // Pagination handlers
//     const handleNextPage = () => {
//       if (currentPage < totalPages) {
//         setCurrentPage(prev => prev + 1);
//       }
//     };

//     const handlePrevPage = () => {
//       if (currentPage > 1) {
//         setCurrentPage(prev => prev - 1);
//       }
//     };

//     const handlePageClick = (pageNumber) => {
//       setCurrentPage(pageNumber);
//     };

//     // Calculate stats
//     const currentPageOwners = busOwners;
//     const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
//     const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
//     const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

//     if (loading) {
//       return (
//         <div className="management-page">
//           <div className="loading-container">
//             <p>Loading bus owners...</p>
//           </div>
//         </div>
//       );
//     }
//     const handleAddBusClick = (owner) => {
//       setSelectedOwnerForBus(owner);
//       setShowAddBusModal(true);
//     };

//     // Add this function to handle bus added successfully
//     const handleBusAdded = () => {
//       // Refresh the bus owners list to update bus count
//       fetchBusOwners();
//       toast.success('Bus added successfully!');
//     };

//     // Add this function to close the add bus modal
//     const closeAddBusModal = () => {
//       setShowAddBusModal(false);
//       setSelectedOwnerForBus(null);
//     };

//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <h1>Bus Owner Management</h1>
//           <div className="header-actions">
//             <input
//               type="text"
//               placeholder="Search bus owners by name, company, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//             />
//             <button className="refresh-btn" onClick={handleRefresh}>
//               Refresh
//             </button>
//             <button className="add-btn" onClick={() => setShowAddModal(true)}>
//               + Add Owner
//             </button>
//           </div>
//         </div>

//         {error && (
//           <div className="error-message">
//             {error}
//           </div>
//         )}

//         {/* Debug info */}
//         <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//           Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
//         </div>

//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>Total Owners</h3>
//             <p>{totalOwners}</p>
//             <span>All registered owners</span>
//           </div>
//           <div className="stat-card">
//             <h3>Verified Owners</h3>
//             <p>{verifiedOwners}</p>
//             <span>Verified on page {currentPage}</span>
//           </div>
//           <div className="stat-card">
//             <h3>Approved Owners</h3>
//             <p>{approvedOwners}</p>
//             <span>Approved on page {currentPage}</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Buses</h3>
//             <p>{totalBuses}</p>
//             <span>active fleet</span>
//           </div>
//         </div>

//         <div className="table-container">
//           <table className="data-table">
//             <thead>
//               <tr>
//                 <th>No.</th>
//                 <th>Profile</th>
//                 <th>Owner Name</th>
//                 <th>Company</th>
//                 <th>Contact</th>
//                 <th>Buses</th>
//                 <th>Admin Approval</th>
//                 <th>Status</th> {/* Add Status column */}
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredOwners.map(owner => (
//                 <tr key={owner.id}>
//                   <td>{owner.serialNo}</td>
//                   <td>
//                     <div className="profile-image-cell">
//                       <img
//                         src={getFullImageUrl(owner.profileImage)}
//                         alt={owner.name || 'Bus Owner'}
//                         className="customer-avatar"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                           // e.target.src = defaultAvatar;
//                         }}
//                       />
//                     </div>
//                   </td>

//                   {/* Owner Name - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Owner Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.name || 'N/A'
//                     )}
//                   </td>

//                   {/* Company - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="companyName"
//                         value={editForm.companyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Company Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.company || 'N/A'
//                     )}
//                   </td>

//                   {/* Contact Info - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div>{owner.email || 'N/A'}</div>
//                         <div className="phone">{owner.phone || 'N/A'}</div>
//                       </div>
//                     )}
//                   </td>

//                   <td>{owner.buses}</td>

//                   {/* Admin Approval - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="isApprovedByAdmin"
//                         value={editForm.isApprovedByAdmin || false}
//                         onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="true">Approved</option>
//                         <option value="false">Pending</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   {/* Status - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || 'Pending'}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="Verified">Verified</option>
//                         <option value="Pending">Pending</option>
//                         <option value="Suspended">Suspended</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
//                         {owner.status || 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   {/* Actions - Different buttons when editing vs normal */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
//                         <button
//                           className="action-btn save"
//                           onClick={handleSaveEdit}
//                           style={{ backgroundColor: '#28a745', color: 'white' }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="action-btn cancel"
//                           onClick={handleCancelEdit}
//                           style={{ backgroundColor: '#6c757d', color: 'white' }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewOwner(owner)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditOwner(owner)}
//                         >
//                           Edit
//                         </button>

//                         <button
//                           className="action-btn add-bus"
//                           onClick={() => handleAddBusClick(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title="Add new bus for this owner"
//                         >
//                           + Add Bus
//                         </button>

//                         <button
//                           className="action-btn manage"
//                           onClick={() => handleManageBuses(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
//                         >
//                           Manage Buses
//                         </button>

//                         {!owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveOwner(owner.id)}
//                             style={{ backgroundColor: '#28a745' }}
//                           >
//                             Approve
//                           </button>
//                         )}
//                         {owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectOwner(owner.id)}
//                             style={{ backgroundColor: '#ffc107', color: '#000' }}
//                           >
//                             Reject
//                           </button>
//                         )}
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteOwner(owner.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {filteredOwners.length === 0 && !loading && (
//             <div className="no-data">
//               <p>No bus owners found matching your search.</p>
//             </div>
//           )}
//         </div>

//         {/* Pagination Component */}
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {Math.min(pageSize, busOwners.length)} of {totalOwners} bus owners
//             (Page {currentPage} of {totalPages})
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>

//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>

//             <button
//               className="pagination-btn"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages || totalPages === 0}
//             >
//               Next
//             </button>
//           </div>
//         </div>

//         {/* View Modal - Updated with profile image and address */}
//         {viewingOwner && (
//           <div className="modal-overlay" onClick={closeViewModal}>
//             <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>Bus Owner Details</h3>
//                 <button className="modal-close-btn" onClick={closeViewModal}>
//                   ×
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div className="customer-details">
//                   <div className="customer-profile-image">
//                     <img
//                       src={getFullImageUrl(viewingOwner.profileImage)}
//                       alt={viewingOwner.name || 'Bus Owner'}
//                       className="profile-image-large"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         // e.target.src = defaultAvatar;
//                       }}
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Serial No:</label>
//                     <span>{viewingOwner.serialNo}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>ID:</label>
//                     <span>#{viewingOwner.id}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Owner Name:</label>
//                     <span>{viewingOwner.name || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Company:</label>
//                     <span>{viewingOwner.company || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Email:</label>
//                     <span>{viewingOwner.email || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone:</label>
//                     <span>{viewingOwner.phone || 'N/A'}</span>
//                   </div>

//                   {/* Address Section */}
//                   <div className="detail-row">
//                     <label>Address:</label>
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                       {viewingOwner.address?.city && (
//                         <span>City: {viewingOwner.address.city}</span>
//                       )}
//                       {viewingOwner.address?.state && (
//                         <span>State: {viewingOwner.address.state}</span>
//                       )}
//                       {viewingOwner.address?.pincode && (
//                         <span>Pincode: {viewingOwner.address.pincode}</span>
//                       )}
//                       {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
//                         <span>N/A</span>
//                       )}
//                     </div>
//                   </div>

//                   <div className="detail-row">
//                     <label>Total Buses:</label>
//                     <span>{viewingOwner.buses || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Active Buses:</label>
//                     <span>{viewingOwner.activeBuses || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Drivers:</label>
//                     <span>{viewingOwner.driverCount || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Conductors:</label>
//                     <span>{viewingOwner.conductorCount || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Joined Date:</label>
//                     <span>{viewingOwner.joined}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Status:</label>
//                     <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
//                       {viewingOwner.status || 'Pending'}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Admin Approval:</label>
//                     <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                       {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Profile Complete:</label>
//                     <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Verified:</label>
//                     <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Bus Management Modal */}
//         {showBusManagement && selectedOwner && (
//           <div className="modal-overlay" onClick={closeBusManagement}>
//             <div className="modal-content1 bus-management-modal" style={{ maxWidth: "900px" }} onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>
//                   Bus Management - {selectedOwner.name}
//                   <span style={{ fontSize: '14px', color: '#666', marginLeft: '10px' }}>
//                     ({selectedOwner.company})
//                   </span>
//                 </h3>
//                 <button className="modal-close-btn" onClick={closeBusManagement}>
//                   ×
//                 </button>
//               </div>

//               <div className="modal-body">
//                 {/* Owner Summary */}
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   marginBottom: '20px',
//                   padding: '15px',
//                   backgroundColor: '#f8f9fa',
//                   borderRadius: '8px',
//                   border: '1px solid #dee2e6'
//                 }}>
//                   <div>
//                     <div style={{ fontSize: '16px', fontWeight: '600' }}>
//                       {selectedOwner.name}
//                     </div>
//                     <div style={{ fontSize: '14px', color: '#666' }}>
//                       {selectedOwner.company} • {selectedOwner.email}
//                     </div>
//                   </div>
//                   <div style={{ textAlign: 'right' }}>
//                     <div style={{ fontSize: '14px' }}>
//                       <strong>Total Buses:</strong> {selectedOwner.buses}
//                     </div>
//                     <div style={{ fontSize: '14px' }}>
//                       <strong>Active:</strong> {selectedOwner.activeBuses}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Bus Search */}
//                 <div style={{ marginBottom: '20px' }}>
//                   <input
//                     type="text"
//                     placeholder="Search buses by bus name, number, driver or conductor..."
//                     className="search-input"
//                     value={busSearchTerm}
//                     onChange={(e) => setBusSearchTerm(e.target.value)}
//                     style={{ width: '100%', padding: '10px 15px' }}
//                   />
//                 </div>

//                 {/* Loading State */}
//                 {busDetailsLoading ? (
//                   <div className="loading-container" style={{ textAlign: 'center', padding: '40px' }}>
//                     <p>Loading bus details...</p>
//                   </div>
//                 ) : (
//                   <>
//                     {/* Buses Table */}
//                     <div className="table-container" style={{ maxHeight: '400px', overflowY: 'auto' }}>
//                       <table className="data-table bus-management-table">
//                         <thead>
//                           <tr>
//                             <th>#</th>
//                             <th>Bus Details</th>
//                             <th>Registration</th>
//                             <th>Type & Category</th>
//                             <th>Seats</th>
//                             <th>Price</th>
//                             <th>Driver Details</th>
//                             <th>Conductor Details</th>
//                             <th>Status</th>

//                           </tr>
//                         </thead>
//                         <tbody>
//                           {selectedOwnerBuses.length > 0 ? (
//                             filteredBuses.map((bus, index) => (
//                               <tr key={bus._id}>
//                                 <td>{index + 1}</td>

//                                 {/* Bus Details */}
//                                 <td className="bus-info-cell">
//                                   <div style={{ fontWeight: '600' }}>
//                                     {bus.busName || 'N/A'}
//                                   </div>
//                                   <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
//                                     Operating: {bus.operatingDays?.join(', ') || 'N/A'}
//                                   </div>
//                                   {bus.amenities && bus.amenities.length > 0 && (
//                                     <div style={{ fontSize: '11px', color: '#17a2b8', marginTop: '2px' }}>
//                                       Amenities: {bus.amenities.slice(0, 2).join(', ')}
//                                       {bus.amenities.length > 2 && '...'}
//                                     </div>
//                                   )}
//                                 </td>

//                                 {/* Registration Number */}
//                                 <td>
//                                   <div style={{
//                                     fontWeight: 'bold',
//                                     color: '#007bff',
//                                     fontSize: '14px'
//                                   }}>
//                                     {bus.busNumber || 'N/A'}
//                                   </div>
//                                 </td>

//                                 {/* Type & Category */}
//                                 <td>
//                                   <div>{bus.busType || 'N/A'}</div>
//                                   <div style={{ fontSize: '12px', color: '#666' }}>
//                                     {bus.busCategory || 'N/A'}
//                                   </div>
//                                 </td>

//                                 {/* Seats */}
//                                 <td>
//                                   <div>
//                                     <span style={{ fontWeight: '600' }}>{bus.totalSeats || 0}</span> total
//                                   </div>
//                                   <div style={{
//                                     fontSize: '12px',
//                                     color: bus.availableSeats > 0 ? '#28a745' : '#dc3545'
//                                   }}>
//                                     <span style={{ fontWeight: '600' }}>{bus.availableSeats || 0}</span> available
//                                   </div>
//                                 </td>

//                                 {/* Price */}
//                                 <td>
//                                   <div style={{ fontWeight: '600', color: '#28a745' }}>
//                                     ₹{bus.basePrice || 0}
//                                   </div>
//                                 </td>

//                                 {/* Driver Details */}
//                                 <td className="staff-details">
//                                   {bus.driver ? (
//                                     <div>
//                                       <div className="staff-name">
//                                         {bus.driver.name || 'N/A'}
//                                       </div>
//                                       <div className="staff-contact">
//                                         📞 {bus.driver.contactNumber || 'N/A'}
//                                       </div>
//                                       {bus.driver.licenseNumber && (
//                                         <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
//                                           License: {bus.driver.licenseNumber}
//                                         </div>
//                                       )}
//                                       {bus.driver.experience > 0 && (
//                                         <div style={{ fontSize: '12px', color: '#666' }}>
//                                           Exp: {bus.driver.experience} yrs
//                                         </div>
//                                       )}
//                                     </div>
//                                   ) : (
//                                     <div className="no-staff">
//                                       No driver assigned
//                                     </div>
//                                   )}
//                                 </td>

//                                 {/* Conductor Details */}
//                                 <td className="staff-details">
//                                   {bus.conductor ? (
//                                     <div>
//                                       <div className="staff-name">
//                                         {bus.conductor.name || 'N/A'}
//                                       </div>
//                                       <div className="staff-contact">
//                                         📞 {bus.conductor.contactNumber || 'N/A'}
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     <div className="no-staff">
//                                       No conductor assigned
//                                     </div>
//                                   )}
//                                 </td>

//                                 {/* Status */}
//                                 <td>
//                                   <span className={bus.isActive ? 'bus-status-active' : 'bus-status-inactive'}>
//                                     {bus.isActive ? 'ACTIVE' : 'INACTIVE'}
//                                   </span>
//                                 </td>


//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
//                                 <div className="no-data">
//                                   <p>No bus data available.</p>
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>

//                     {/* Summary */}
//                     <div style={{
//                       marginTop: '20px',
//                       padding: '10px 15px',
//                       backgroundColor: '#f8f9fa',
//                       borderRadius: '6px',
//                       fontSize: '14px'
//                     }}>
//                       Showing {filteredBuses.length} of {selectedOwnerBuses.length} buses
//                       {busSearchTerm && ` matching "${busSearchTerm}"`}
//                     </div>
//                   </>
//                 )}
//               </div>

//               <div className="modal-footer">
//                 <button
//                   className="modal-close-btn secondary"
//                   onClick={closeBusManagement}
//                   style={{ padding: '8px 20px' }}
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Add Modal (unchanged) */}
//         {showAddModal && (
//           <div className="modal-overlay" onClick={closeAddModal}>
//             <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>Add New Bus Owner</h3>
//                 <button className="modal-close-btn" onClick={closeAddModal}>
//                   ×
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div className="customer-details">
//                   <div className="detail-row">
//                     <label>Owner Name *:</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={newOwner.name}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter owner name"
//                       required
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Company Name *:</label>
//                     <input
//                       type="text"
//                       name="companyName"
//                       value={newOwner.companyName}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter company name"
//                       required
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Email *:</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={newOwner.email}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter email address"
//                       required
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone *:</label>
//                     <input
//                       type="text"
//                       name="phone"
//                       value={newOwner.phone}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter phone number"
//                       required
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="action-btn cancel" onClick={closeAddModal}>
//                   Cancel
//                 </button>
//                 <button className="action-btn save" onClick={handleAddOwner}>
//                   Add Owner
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//          {showAddBusModal && selectedOwnerForBus && (
//         <AddBusModal 
//           ownerId={selectedOwnerForBus.id}
//           onClose={closeAddBusModal}
//           onBusAdded={handleBusAdded}
//         />
//       )}
//       </div>
//     );
//   };

//   const addBusStyles = `
// /* Add Bus Modal Styles */
// .add-bus-modal {
//   max-width: 1000px !important;
//   width: 95% !important;
//   max-height: 90vh;
//   overflow-y: auto;
// }

// .route-tabs {
//   display: flex;
//   border-bottom: 1px solid #dee2e6;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
// }

// .route-tab {
//   padding: 10px 15px;
//   background: none;
//   border: none;
//   border-bottom: 3px solid transparent;
//   cursor: pointer;
//   font-weight: 500;
//   color: #6c757d;
//   transition: all 0.3s;
//   white-space: nowrap;
// }

// .route-tab:hover:not(:disabled) {
//   color: #007bff;
// }

// .route-tab.active {
//   color: #007bff;
//   border-bottom-color: #007bff;
// }

// .route-tab:disabled {
//   opacity: 0.5;
//   cursor: not-allowed;
// }

// .tab-content {
//   min-height: 400px;
// }

// .form-section {
//   margin-bottom: 25px;
//   padding-bottom: 20px;
//   border-bottom: 1px solid #eee;
// }

// .form-section h4 {
//   margin-bottom: 15px;
//   color: #333;
// }

// .description {
//   color: #666;
//   margin-bottom: 20px;
//   font-size: 14px;
// }

// .form-row {
//   display: flex;
//   gap: 15px;
//   margin-bottom: 15px;
// }

// .form-group {
//   flex: 1;
// }

// .form-group.full-width {
//   flex: 2;
// }

// .form-group label {
//   display: block;
//   margin-bottom: 5px;
//   font-weight: 500;
//   color: #555;
// }

// .form-input {
//   width: 100%;
//   padding: 8px 12px;
//   border: 1px solid #ced4da;
//   border-radius: 4px;
//   font-size: 14px;
// }

// .form-input:focus {
//   outline: none;
//   border-color: #007bff;
//   box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
// }

// .form-group small {
//   display: block;
//   margin-top: 4px;
//   color: #6c757d;
//   font-size: 12px;
// }

// .amenities-checkboxes,
// .days-checkboxes {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-top: 5px;
// }

// .amenity-checkbox,
// .day-checkbox {
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   cursor: pointer;
//   padding: 5px 8px;
//   background: #f8f9fa;
//   border-radius: 4px;
//   border: 1px solid #dee2e6;
// }

// .amenity-checkbox:hover,
// .day-checkbox:hover {
//   background: #e9ecef;
// }

// .amenity-checkbox input,
// .day-checkbox input {
//   margin: 0;
// }

// .amenity-checkbox span,
// .day-checkbox span {
//   font-size: 14px;
// }

// /* Route Details */
// .route-details {
//   margin-top: 20px;
// }

// .route-info-card {
//   background: #f8f9fa;
//   border-radius: 8px;
//   padding: 15px;
//   margin-bottom: 20px;
//   border: 1px solid #dee2e6;
// }

// .route-info-row {
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 8px;
//   font-size: 14px;
// }

// .route-info-row .label {
//   font-weight: 500;
//   color: #555;
// }

// .route-info-row .value {
//   color: #333;
//   font-weight: 600;
// }

// /* Stops Timeline */
// .stops-timeline {
//   margin-top: 15px;
// }

// .stop-item {
//   display: flex;
//   align-items: flex-start;
//   margin-bottom: 15px;
//   padding-bottom: 15px;
//   border-bottom: 1px dashed #dee2e6;
// }

// .stop-item:last-child {
//   border-bottom: none;
//   margin-bottom: 0;
//   padding-bottom: 0;
// }

// .stop-marker {
//   position: relative;
//   margin-right: 15px;
// }

// .marker {
//   width: 30px;
//   height: 30px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: bold;
//   color: white;
//   font-size: 12px;
// }

// .marker.origin {
//   background: #4c51bf;
// }

// .marker.stop {
//   background: #667eea;
// }

// .marker.destination {
//   background: #764ba2;
// }

// .stop-line {
//   position: absolute;
//   left: 50%;
//   top: 30px;
//   bottom: -15px;
//   width: 2px;
//   background: #dee2e6;
//   transform: translateX(-50%);
// }

// .stop-item:last-child .stop-line {
//   display: none;
// }

// .stop-details {
//   flex: 1;
// }

// .stop-name {
//   font-weight: 600;
//   color: #333;
//   margin-bottom: 2px;
// }

// .stop-terminal {
//   font-size: 13px;
//   color: #666;
//   margin-bottom: 2px;
// }

// .stop-type {
//   font-size: 12px;
//   color: #6c757d;
//   text-transform: capitalize;
// }

// .stop-distance {
//   font-size: 12px;
//   color: #28a745;
//   margin-top: 2px;
// }

// /* Fare Calculator */
// .fare-calculator {
//   margin-top: 20px;
// }

// .fare-summary {
//   margin-top: 20px;
// }

// .summary-card {
//   background: #f8f9fa;
//   border-radius: 8px;
//   padding: 15px;
//   border: 1px solid #dee2e6;
// }

// .summary-card h5 {
//   margin-bottom: 15px;
//   color: #333;
// }

// .summary-row {
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 8px;
//   font-size: 14px;
// }

// .summary-row.highlighted {
//   font-weight: bold;
//   color: #28a745;
//   padding-top: 10px;
//   border-top: 1px solid #dee2e6;
//   margin-top: 10px;
// }

// .sample-fares {
//   margin-top: 20px;
// }

// .sample-fares-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
//   gap: 10px;
//   margin-top: 10px;
// }

// .sample-fare-item {
//   background: white;
//   border: 1px solid #dee2e6;
//   border-radius: 6px;
//   padding: 10px;
// }

// .fare-route {
//   font-weight: 600;
//   font-size: 13px;
//   margin-bottom: 5px;
//   color: #333;
// }

// .fare-details {
//   display: flex;
//   justify-content: space-between;
//   font-size: 12px;
// }

// .fare-details .distance {
//   color: #666;
// }

// .fare-details .price {
//   color: #28a745;
//   font-weight: 600;
// }

// /* Fare Matrix */
// .matrix-info {
//   margin-bottom: 20px;
// }

// .info-card {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 15px;
//   background: #f8f9fa;
//   border-radius: 8px;
//   padding: 15px;
//   border: 1px solid #dee2e6;
// }

// .info-item {
//   display: flex;
//   flex-direction: column;
// }

// .info-item .label {
//   font-size: 12px;
//   color: #666;
//   margin-bottom: 2px;
// }

// .info-item .value {
//   font-size: 16px;
//   font-weight: 600;
//   color: #333;
// }

// .fare-matrix-container {
//   margin: 20px 0;
//   overflow-x: auto;
// }

// .matrix-table-wrapper {
//   overflow-x: auto;
//   max-height: 400px;
//   overflow-y: auto;
// }

// .fare-matrix-table {
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 11px;
//   min-width: 600px;
// }

// .fare-matrix-table th {
//   background-color: #f8f9fa;
//   padding: 8px;
//   border: 1px solid #dee2e6;
//   text-align: center;
//   font-weight: 600;
//   position: sticky;
//   top: 0;
//   z-index: 10;
//   min-width: 120px;
// }

// .fare-matrix-table td {
//   padding: 5px;
//   border: 1px solid #dee2e6;
//   text-align: center;
//   vertical-align: middle;
// }

// .fare-matrix-table .from-cell {
//   background-color: #e9ecef;
//   font-weight: 600;
//   position: sticky;
//   left: 0;
//   z-index: 5;
//   min-width: 120px;
// }

// .stop-header {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// }

// .stop-header .stop-name {
//   font-size: 11px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   max-width: 100px;
// }

// .stop-header .stop-type {
//   font-size: 10px;
//   color: white;
//   background: #6c757d;
//   border-radius: 3px;
//   padding: 1px 4px;
//   margin-top: 2px;
// }

// .from-stop {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// }

// .fare-cell {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 2px;
// }

// .matrix-input {
//   width: 60px;
//   padding: 4px;
//   border: 1px solid #ced4da;
//   border-radius: 3px;
//   text-align: center;
//   font-size: 11px;
// }

// .matrix-input:focus {
//   outline: none;
//   border-color: #007bff;
// }

// .cell-info small {
//   color: #666;
//   font-size: 9px;
// }

// .na-cell {
//   color: #6c757d;
//   font-style: italic;
// }

// .price-cell.same-stop {
//   background-color: #f8f9fa;
// }

// .matrix-legend {
//   display: flex;
//   gap: 15px;
//   margin-top: 20px;
//   flex-wrap: wrap;
// }

// .legend-item {
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   font-size: 12px;
// }

// .legend-color {
//   width: 16px;
//   height: 16px;
//   border-radius: 50%;
// }

// .legend-color.origin {
//   background: #4c51bf;
// }

// .legend-color.stop {
//   background: #667eea;
// }

// .legend-color.destination {
//   background: #764ba2;
// }

// .legend-color.same-stop {
//   background: #f8f9fa;
//   border: 1px solid #dee2e6;
// }

// /* Seat Layout */
// .no-seats {
//   text-align: center;
//   padding: 40px;
// }

// .no-seats-icon {
//   font-size: 48px;
//   margin-bottom: 15px;
// }

// .no-seats p {
//   color: #666;
//   margin-bottom: 20px;
// }

// .seat-layout-preview {
//   border: 1px solid #dee2e6;
//   border-radius: 8px;
//   padding: 20px;
//   background-color: white;
// }

// .seat-layout-header {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 20px;
//   padding-bottom: 10px;
//   border-bottom: 1px solid #dee2e6;
// }

// .driver-section {
//   font-weight: 600;
//   color: #6c757d;
// }

// .layout-title {
//   font-size: 18px;
//   font-weight: 600;
//   color: #333;
// }

// .btn-small {
//   padding: 5px 10px;
//   font-size: 12px;
//   background: #6c757d;
//   color: white;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
// }

// .btn-small:hover {
//   opacity: 0.9;
// }

// .seats-grid {
//   display: flex;
//   flex-direction: column;
//   gap: 15px;
// }

// .seat-row {
//   display: flex;
//   align-items: center;
//   gap: 15px;
// }

// .row-number {
//   width: 60px;
//   font-weight: 600;
//   color: #495057;
//   font-size: 14px;
// }

// .seats-in-row {
//   display: flex;
//   gap: 8px;
//   flex: 1;
// }

// .seat {
//   width: 40px;
//   height: 40px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background-color: #28a745;
//   color: white;
//   border-radius: 4px;
//   font-weight: 600;
//   cursor: default;
//   font-size: 12px;
// }

// .seat.booked {
//   background-color: #dc3545;
// }

// .seat-legend {
//   display: flex;
//   gap: 20px;
//   margin-top: 20px;
//   padding-top: 15px;
//   border-top: 1px solid #dee2e6;
//   flex-wrap: wrap;
// }

// .seat-summary {
//   margin-top: 20px;
// }

// .summary-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
//   gap: 15px;
//   margin-top: 10px;
// }

// .summary-card {
//   padding: 15px;
//   background-color: #f8f9fa;
//   border-radius: 6px;
//   text-align: center;
//   border: 1px solid #dee2e6;
// }

// .summary-card .count {
//   display: block;
//   font-size: 24px;
//   font-weight: 700;
//   color: #007bff;
//   margin-bottom: 5px;
// }

// .summary-card .label {
//   font-size: 14px;
//   color: #6c757d;
// }

// .final-summary {
//   margin-top: 30px;
//   padding-top: 20px;
//   border-top: 2px solid #dee2e6;
// }

// .final-summary-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 15px;
//   margin-top: 10px;
// }

// .summary-item {
//   display: flex;
//   justify-content: space-between;
//   padding: 10px;
//   background: #f8f9fa;
//   border-radius: 6px;
//   border: 1px solid #dee2e6;
// }

// .summary-item .label {
//   font-weight: 500;
//   color: #555;
// }

// .summary-item .value {
//   font-weight: 600;
//   color: #333;
// }

// /* Form Actions */
// .form-actions {
//   display: flex;
//   justify-content: space-between;
//   margin-top: 30px;
//   padding-top: 20px;
//   border-top: 1px solid #dee2e6;
// }

// .btn {
//   padding: 8px 20px;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
//   font-weight: 500;
//   transition: all 0.3s;
// }

// .btn-primary {
//   background-color: #007bff;
//   color: white;
// }

// .btn-primary:hover:not(:disabled) {
//   background-color: #0056b3;
// }

// .btn-primary:disabled {
//   opacity: 0.5;
//   cursor: not-allowed;
// }

// .btn-outline {
//   background-color: transparent;
//   border: 1px solid #6c757d;
//   color: #6c757d;
// }

// .btn-outline:hover {
//   background-color: #6c757d;
//   color: white;
// }

// .btn-secondary {
//   background-color: #6c757d;
//   color: white;
// }

// .btn-secondary:hover {
//   background-color: #545b62;
// }

// .error-message {
//   background-color: #f8d7da;
//   color: #721c24;
//   padding: 10px 15px;
//   border-radius: 4px;
//   margin-top: 20px;
//   border: 1px solid #f5c6cb;
// }

// /* Responsive adjustments */
// @media (max-width: 768px) {
//   .form-row {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .route-tabs {
//     overflow-x: auto;
//   }

//   .info-card {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .seat-legend {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .form-actions {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .form-actions .btn {
//     width: 100%;
//   }
// }
// `;

//   export default BusOwnerManage;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//   getBusOwners,
//   getBusOwnerById,
//   createBusOwner,
//   updateBusOwner,
//   deleteBusOwner,
//   approveBusOwner,
//   addBusToOwner,
//   getSeatLayoutsByBustype,
//   getAllCategory
// } from '../../Services/Operations/ProductAPI';
// import {
//   getDriversByBusOwner,
//   getConductorsByBusOwner,
//   assignDriverToBus,
//   assignConductorToBus,
//   unassignDriverFromBus,
//   unassignConductorFromBus
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/BusFareChart.css';
// import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
// import BusManagementModal from './BusManagementModal'; // Import the new modal

// // const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
// //   const { token } = useSelector(state => state.user);
// //   const [activeTab, setActiveTab] = useState('basic');
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
// //   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
// //   // Add this with other state declarations
// //   const [blockedSeats, setBlockedSeats] = useState([]);

// //   // Bus Form State
// //   const [form, setForm] = useState({
// //     busNumber: '',
// //     busName: '',
// //     busType: 'AC',
// //     busCategory: 'Seater',
// //     amenities: []
// //   });

// //   // Trip Type State
// //   const [tripType, setTripType] = useState('oneWay');
// //   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

// //   // Route States
// //   const [routes, setRoutes] = useState([]);
// //   const [selectedRoute, setSelectedRoute] = useState(null);
// //   const [loadingRoutes, setLoadingRoutes] = useState(false);

// //   // Seat Layout States
// //   const [layoutTemplates, setLayoutTemplates] = useState([]);
// //   const [selectedTemplate, setSelectedTemplate] = useState(null);
// //   const [activeSeats, setActiveSeats] = useState([]);
// //   const [customSeatLabels, setCustomSeatLabels] = useState({});
// //   const [showLayoutModal, setShowLayoutModal] = useState(false);
// //   const [showTemplateModal, setShowTemplateModal] = useState(false);
// //   const [loadingLayouts, setLoadingLayouts] = useState(false);
// //   const [editingSeat, setEditingSeat] = useState(null);
// //   const [tempSeatLabel, setTempSeatLabel] = useState('');

// //   // Pricing States
// //   const [pricing, setPricing] = useState({
// //     basePrice: '',
// //     baseDistance: '',
// //     costPerKm: ''
// //   });

// //   // Fare Matrices
// //   const [fareMatrixUp, setFareMatrixUp] = useState([]);
// //   const [fareMatrixDown, setFareMatrixDown] = useState([]);

// //   // Operating Days
// //   const [operatingDays, setOperatingDays] = useState([
// //     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
// //   ]);

// //   // Image States
// //   const [selectedImages, setSelectedImages] = useState([]);
// //   const [selectedVideo, setSelectedVideo] = useState(null);

// //   // Constants
// //   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
// //   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
// //   const BUS_CLASSES = ['Economy', 'Premium', 'Luxury'];

// //   const AMENITIES_LIST = [
// //     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
// //     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
// //     'GPS Tracking', 'SOS Switch'
// //   ];

// //   const DAYS_OF_WEEK = [
// //     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
// //   ];

// //   // Fetch Routes
// //   useEffect(() => {
// //     const fetchRoutes = async () => {
// //       try {
// //         setLoadingRoutes(true);
// //         const response = await getAllBusownerAdminRoutes(token, 1, 100, '', ownerId);
// //         if (response && response.success && response.routes) {
// //           setRoutes(response.routes);
// //         }
// //       } catch (error) {
// //         console.error('Error fetching routes:', error);
// //         toast.error('Failed to fetch routes');
// //       } finally {
// //         setLoadingRoutes(false);
// //       }
// //     };

// //     fetchRoutes();
// //   }, [token, ownerId]);

// //   // Fetch configurations when category changes
// //   useEffect(() => {
// //     if (form.busCategory) {
// //       fetchAvailableConfigurations();
// //     }
// //   }, [form.busCategory, token]);

// //   const getCategoryMultiplier = () => {
// //     const multipliers = {
// //       'Seater': 1.0,
// //       'Sleeper': 1.5,
// //       'Seater+Sleeper': 1.3
// //     };
// //     return multipliers[form.busCategory] || 1.0;
// //   };

// //   const getStopColor = (type) => {
// //     switch (type) {
// //       case 'origin': return '#4c51bf';
// //       case 'destination': return '#40c057';
// //       default: return '#667eea';
// //     }
// //   };

// //   const fetchAvailableConfigurations = async () => {
// //     try {
// //       setLoadingLayouts(true);
// //       const response = await getAllCategory(token);

// //       if (response && response.success && response.data) {
// //         let relevantCategories = response.data;

// //         if (form.busCategory === 'Seater') {
// //           relevantCategories = response.data.filter(cat =>
// //             cat.availableSeatTypes?.includes('seat') ||
// //             cat.availableSeatTypes?.includes('seater')
// //           );
// //         } else if (form.busCategory === 'Sleeper') {
// //           relevantCategories = response.data.filter(cat =>
// //             cat.availableSeatTypes?.includes('sleeper')
// //           );
// //         } else if (form.busCategory === 'Seater+Sleeper') {
// //           relevantCategories = response.data.filter(cat =>
// //             cat.availableSeatTypes?.includes('seater+sleeper') ||
// //             cat.availableSeatTypes?.includes('seat+sleeper')
// //           );
// //         }

// //         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

// //         if (configs.length > 0) {
// //           setAvailableConfigurations(configs);
// //           setSelectedConfiguration(configs[0]);
// //           setLayoutTemplates([]);
// //         } else {
// //           setAvailableConfigurations([]);
// //           setLayoutTemplates([]);
// //           toast.info(`No configurations available for ${form.busCategory}`);
// //         }
// //       }
// //     } catch (error) {
// //       console.error('Error fetching configurations:', error);
// //       setAvailableConfigurations([]);
// //     } finally {
// //       setLoadingLayouts(false);
// //     }
// //   };

// //   const fetchLayouts = async (config) => {
// //     try {
// //       if (!config) return;

// //       setLoadingLayouts(true);

// //       let bustype = config.replace('x', '*');

// //       console.log(`Fetching layouts for bustype: ${bustype}`);

// //       const response = await getSeatLayoutsByBustype(bustype, token);

// //       if (response && response.success) {
// //         if (response.data && Array.isArray(response.data)) {
// //           let filteredLayouts = response.data;

// //           if (form.busCategory === 'Seater') {
// //             filteredLayouts = response.data.filter(layout =>
// //               layout.seatType === 'seat' || layout.seatType === 'seater'
// //             );
// //           } else if (form.busCategory === 'Sleeper') {
// //             filteredLayouts = response.data.filter(layout =>
// //               layout.seatType === 'sleeper'
// //             );
// //           } else if (form.busCategory === 'Seater+Sleeper') {
// //             filteredLayouts = response.data.filter(layout =>
// //               layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
// //             );
// //           }

// //           setLayoutTemplates(filteredLayouts);

// //           if (filteredLayouts.length === 0) {
// //             toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
// //           } else {
// //             toast.success(`Found ${filteredLayouts.length} layout(s) for ${config}`);
// //           }
// //         } else {
// //           setLayoutTemplates([]);
// //           toast.info(`No layouts found for ${config} configuration`);
// //         }
// //       } else {
// //         console.error('Failed to fetch layouts:', response);
// //         setLayoutTemplates([]);
// //         toast.error(response?.message || 'Failed to load seat layouts');
// //       }
// //     } catch (error) {
// //       console.error("Layout Fetch Error:", error);
// //       toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
// //       setLayoutTemplates([]);
// //     } finally {
// //       setLoadingLayouts(false);
// //     }
// //   };

// //   const handleCategoryChange = (category) => {
// //     setForm(prev => ({ ...prev, busCategory: category }));
// //     setSelectedTemplate(null);
// //     setActiveSeats([]);
// //     setLayoutTemplates([]);
// //     setCustomSeatLabels({});
// //   };

// //   const handleImageUpload = (event) => {
// //     const files = Array.from(event.target.files);
// //     const newImages = [];

// //     files.forEach(file => {
// //       const reader = new FileReader();
// //       reader.onload = (e) => {
// //         newImages.push({
// //           file: file,
// //           preview: e.target.result,
// //           name: file.name
// //         });

// //         if (newImages.length === files.length) {
// //           setSelectedImages(prev => [...prev, ...newImages]);
// //         }
// //       };
// //       reader.readAsDataURL(file);
// //     });
// //   };

// //   const removeImage = (index) => {
// //     setSelectedImages(prev => prev.filter((_, i) => i !== index));
// //   };

// //   const handleVideoUpload = (event) => {
// //     const file = event.target.files[0];
// //     if (file) {
// //       const reader = new FileReader();
// //       reader.onload = (e) => {
// //         setSelectedVideo({
// //           file: file,
// //           preview: e.target.result,
// //           name: file.name,
// //           size: file.size
// //         });
// //       };
// //       reader.readAsDataURL(file);
// //     }
// //   };

// //   const removeVideo = () => {
// //     setSelectedVideo(null);
// //   };

// //   const openTemplateSelector = () => {
// //     if (!form.busCategory) {
// //       toast.error('Please select a Bus Category first');
// //       return;
// //     }
// //     if (!selectedConfiguration) {
// //       toast.error('Please select a Bus Configuration first');
// //       return;
// //     }
// //     if (layoutTemplates.length === 0) {
// //       toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
// //       return;
// //     }
// //     setShowTemplateModal(true);
// //   };

// //   const handleSelectTemplate = (template) => {
// //     setSelectedTemplate(template);

// //     // START WITH ALL SEATS DISABLED
// //     setActiveSeats([]);
// //     setBlockedSeats([]); // <-- ADD THIS LINE
// //     setCustomSeatLabels({});

// //     setShowTemplateModal(false);
// //     setShowLayoutModal(true);

// //     toast.success(`Selected template: ${template.name}`);
// //   };

// //   const handleSeatPress = (seatObj) => {
// //     setEditingSeat(seatObj.seatNumber);
// //     if (activeSeats.includes(seatObj.seatNumber)) {
// //       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
// //     } else {
// //       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
// //     }
// //   };

// //   const autoRenumberSeats = () => {
// //     const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
// //       if (a.row === b.row) return a.column - b.column;
// //       return a.row - b.row;
// //     });

// //     let counter = 1;
// //     const newLabels = {};

// //     sortedSeats.forEach(s => {
// //       if (activeSeats.includes(s.seatNumber)) {
// //         newLabels[s.seatNumber] = String(counter++);
// //       }
// //     });

// //     setCustomSeatLabels(newLabels);
// //   };

// //   const toggleDay = (day) => {
// //     setOperatingDays(prev =>
// //       prev.includes(day)
// //         ? prev.filter(d => d !== day)
// //         : [...prev, day]
// //     );
// //   };

// //   const generateMatrixForRoute = (routeData) => {
// //     if (!routeData) return [];

// //     const baseP = parseFloat(pricing.basePrice) || 0;
// //     const baseD = parseFloat(pricing.baseDistance) || 0;
// //     const costK = parseFloat(pricing.costPerKm) || 0;
// //     const multiplier = getCategoryMultiplier();

// //     const sortedStops = [...(routeData.intermediateStops || [])]
// //       .sort((a, b) => a.sequence - b.sequence);

// //     const allStops = [
// //       {
// //         id: 'origin',
// //         name: routeData.origin?.city || 'Origin',
// //         distanceFromOrigin: 0,
// //         type: 'origin'
// //       },
// //       ...sortedStops.map((s, i) => ({
// //         id: s._id || `stop_${i}`,
// //         name: s.city || s.name || `Stop ${i + 1}`,
// //         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
// //         type: 'stop',
// //         sequence: s.sequence
// //       })),
// //       {
// //         id: 'destination',
// //         name: routeData.destination?.city || 'Destination',
// //         distanceFromOrigin: parseFloat(routeData.destination?.distanceFromOrigin) ||
// //           parseFloat(routeData.routeDetails?.totalDistance) || 0,
// //         type: 'destination'
// //       }
// //     ];

// //     const matrix = allStops.map((fromStop, i) => {
// //       const toCells = allStops.map((toStop, j) => {
// //         if (j > i) {
// //           const distance = parseFloat(
// //             (parseFloat(toStop.distanceFromOrigin) - parseFloat(fromStop.distanceFromOrigin)).toFixed(1)
// //           );
// //           let price = baseP;
// //           if (distance > baseD) {
// //             price += (distance - baseD) * costK;
// //           }
// //           price = Math.round(price * multiplier);

// //           return {
// //             toId: toStop.id,
// //             toName: toStop.name,
// //             distanceKm: distance,
// //             price: price
// //           };
// //         }
// //         return null;
// //       });

// //       return {
// //         fromId: fromStop.id,
// //         fromName: fromStop.name,
// //         fromType: fromStop.type,
// //         sequence: fromStop.sequence,
// //         toCells: toCells
// //       };
// //     });

// //     return matrix.filter(row => row.fromId !== 'destination');
// //   };

// //   const handleGenerateMatrix = () => {
// //     if (!selectedRoute) {
// //       toast.error('Please select a Route first.');
// //       return;
// //     }

// //     if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
// //       toast.error("The selected route does not have return journey details configured.");
// //       return;
// //     }

// //     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
// //       toast.error('Please fill all Pricing Fields.');
// //       return;
// //     }

// //     // Generate Up Matrix using main route details
// //     const matrixUp = generateMatrixForRoute(selectedRoute);
// //     setFareMatrixUp(matrixUp);

// //     // Generate Down Matrix using return journey details
// //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //       const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
// //       setFareMatrixDown(matrixDown);
// //     } else {
// //       setFareMatrixDown([]);
// //     }

// //     toast.success(tripType === 'roundTrip'
// //       ? "Both Fare Matrices Generated!"
// //       : "Fare Matrix Generated!"
// //     );
// //   };

// //   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
// //     const isUp = type === 'up';
// //     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

// //     const updatedMatrix = currentMatrix.map((row, rIndex) => {
// //       if (rIndex !== rowIndex) return row;
// //       const newToCells = [...row.toCells];
// //       if (newToCells[colIndex]) {
// //         newToCells[colIndex] = {
// //           ...newToCells[colIndex],
// //           price: parseInt(newPrice) || 0
// //         };
// //       }
// //       return { ...row, toCells: newToCells };
// //     });

// //     if (isUp) {
// //       setFareMatrixUp(updatedMatrix);
// //     } else {
// //       setFareMatrixDown(updatedMatrix);
// //     }
// //   };

// //   const getSeatPosition = (column) => {
// //     switch (parseInt(column)) {
// //       case 1: return 'window';
// //       case 2: return 'middle';
// //       case 3: return 'aisle';
// //       case 4: return 'window';
// //       default: return 'aisle';
// //     }
// //   };

// //   const calculateSeatPrice = (seat, basePrice, position) => {
// //     let price = parseFloat(basePrice) || 0;

// //     if (position === 'window') price *= 1.1;
// //     if (position === 'aisle') price *= 1.05;
// //     if (seat.row === 1) price *= 1.2;

// //     return Math.round(price);
// //   };

// //   const handleSubmitBus = async () => {
// //     try {
// //       setIsSubmitting(true);
// //       setError(null);

// //       // Validate required fields
// //       if (!form.busNumber) {
// //         throw new Error('Bus Number is required');
// //       }
// //       if (!form.busName) {
// //         throw new Error('Bus Name is required');
// //       }
// //       if (!form.busType) {
// //         throw new Error('Bus Type is required');
// //       }
// //       if (!form.busCategory) {
// //         throw new Error('Bus Category is required');
// //       }
// //       if (!selectedRoute) {
// //         throw new Error('Please select a route');
// //       }
// //       if (operatingDays.length === 0) {
// //         throw new Error('Please select at least one operating day');
// //       }
// //       if (!selectedTemplate) {
// //         throw new Error('Please configure seat layout');
// //       }
// //       if (fareMatrixUp.length === 0) {
// //         throw new Error('Please generate Fare Matrix');
// //       }

// //       const amenitiesArray = form.amenities || [];

// //       // CONSTRUCT SEATS PAYLOAD WITH GLOBALSEATINDEX - MATCHING BUS OWNER APP
// //       const finalSeatsPayload = selectedTemplate.seats
// //         .filter(s => activeSeats.includes(s.seatNumber))
// //         .map(s => {
// //           const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
// //           const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
// //           const isBlocked = blockedSeats.includes(s.seatNumber); // <-- ADD THIS LINE

// //           return {
// //             seatNumber: s.seatNumber,
// //             globalSeatIndex: finalGlobalIndex,
// //             row: s.row,
// //             column: s.column,
// //             seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
// //             position: s.position || getSeatPosition(s.column),
// //             isBlocked: isBlocked,           // <-- ADD THIS
// //             isAvailable: !isBlocked,        // <-- ADD THIS
// //           };
// //         });

// //       const seatConfigPayload = {
// //         busType: selectedTemplate.configuration || '2*2',
// //         totalSeats: activeSeats.length
// //       };

// //       // CONSTRUCT ROUTE PAYLOAD
// //       const routeSchedules = [];
// //       const routeIdToSave = selectedRoute._id || selectedRoute.id;

// //       routeSchedules.push({
// //         routeId: routeIdToSave,
// //         direction: 'UP',
// //         fareMatrix: fareMatrixUp,
// //         operatingDays: operatingDays,
// //         departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
// //         arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
// //       });

// //       if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //         routeSchedules.push({
// //           routeId: routeIdToSave,
// //           direction: 'DOWN',
// //           fareMatrix: fareMatrixDown,
// //           operatingDays: operatingDays,
// //           departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
// //           arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
// //         });
// //       }

// //       const fareDetails = {
// //         basePrice: parseFloat(pricing.basePrice) || 0,
// //         baseDistance: parseFloat(pricing.baseDistance) || 0,
// //         costPerKm: parseFloat(pricing.costPerKm) || 0
// //       };

// //       // CREATE FORMDATA
// //       const formData = new FormData();

// //       // Append basic fields
// //       formData.append('busNumber', form.busNumber.toUpperCase().trim());
// //       formData.append('busName', form.busName.trim());
// //       formData.append('busType', form.busType);
// //       formData.append('busCategory', form.busCategory);
// //       formData.append('totalSeats', String(activeSeats.length));
// //       formData.append('tripType', tripType);
// //       formData.append('busClass', 'Economy');

// //       // Append JSON strings for complex objects
// //       formData.append('amenities', JSON.stringify(amenitiesArray));
// //       formData.append('seats', JSON.stringify(finalSeatsPayload));
// //       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
// //       formData.append('routeSchedules', JSON.stringify(routeSchedules));
// //       formData.append('fareDetails', JSON.stringify(fareDetails));
// //       formData.append('operatingDays', JSON.stringify(operatingDays));

// //       // Append images
// //       selectedImages.forEach((img, index) => {
// //         if (img.file) {
// //           formData.append('images', img.file);
// //         }
// //       });

// //       // Append video if selected
// //       if (selectedVideo && selectedVideo.file) {
// //         formData.append('videos', selectedVideo.file);
// //       }

// //       console.log('Submitting bus with payload:', {
// //         busNumber: form.busNumber,
// //         busName: form.busName,
// //         busType: form.busType,
// //         busCategory: form.busCategory,
// //         totalSeats: activeSeats.length,
// //         tripType,
// //         routeSchedules: routeSchedules.length,
// //         seatsCount: finalSeatsPayload.length,
// //         seatsSample: finalSeatsPayload.slice(0, 2), // Show first 2 seats as sample
// //         imagesCount: selectedImages.length,
// //         hasVideo: !!selectedVideo
// //       });

// //       const response = await addBusToOwner(ownerId, formData, token);

// //       if (response && response.success) {
// //         toast.success(tripType === 'roundTrip'
// //           ? 'Bus added successfully with round trip routes!'
// //           : 'Bus added successfully!'
// //         );

// //         onBusAdded();
// //         onClose();
// //       } else {
// //         throw new Error(response?.message || 'Failed to add bus');
// //       }

// //     } catch (err) {
// //       console.error('Error adding bus:', err);
// //       setError(err.message || 'Failed to add bus');
// //       toast.error(err.message || 'Failed to add bus');
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const renderMatrix = (type) => {
// //     const isUp = type === 'up';
// //     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
// //     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

// //     if (!currentRoute || currentMatrix.length === 0) return null;

// //     const sortedStops = [...(currentRoute.intermediateStops || [])]
// //       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

// //     const allStops = [
// //       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
// //       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
// //       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
// //     ];

// //     return (
// //       <div className="matrix-section">
// //         <h5 className="matrix-title">
// //           {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
// //         </h5>
// //         <div className="matrix-container">
// //           <div className="matrix-table-wrapper">
// //             <table className="fare-matrix-table">
// //               <thead>
// //                 <tr>
// //                   <th className="corner-cell">From \ To</th>
// //                   {allStops.map((stop, i) => (
// //                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
// //                       <div className="stop-header">
// //                         <span className="stop-name">{stop.name}</span>
// //                         <span className="stop-type">{stop.type}</span>
// //                       </div>
// //                     </th>
// //                   ))}
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {currentMatrix.map((row, rowIndex) => (
// //                   <tr key={rowIndex}>
// //                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
// //                       <div className="from-stop">
// //                         <span className="stop-name">{row.fromName}</span>
// //                         <span className="stop-type">{row.fromType}</span>
// //                       </div>
// //                     </td>
// //                     {row.toCells.map((cell, colIndex) => {
// //                       if (cell) {
// //                         return (
// //                           <td key={colIndex} className="price-cell">
// //                             <div className="fare-cell">
// //                               <span className="distance">{cell.distanceKm} km</span>
// //                               <div className="price-input-group">
// //                                 <span className="currency">₹</span>
// //                                 <input
// //                                   type="number"
// //                                   className="matrix-input"
// //                                   value={cell.price}
// //                                   onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
// //                                   min="0"
// //                                   step="1"
// //                                 />
// //                               </div>
// //                             </div>
// //                           </td>
// //                         );
// //                       }
// //                       return (
// //                         <td key={colIndex} className="na-cell">
// //                           —
// //                         </td>
// //                       );
// //                     })}
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const renderSeatVisualizer = () => {
// //     if (!selectedTemplate) return null;

// //     const { seats, configuration } = selectedTemplate;

// //     let leftCount = 2, rightCount = 2;
// //     try {
// //       if (configuration && configuration.includes('*')) {
// //         const parts = configuration.split('*');
// //         leftCount = parseInt(parts[0]) || 2;
// //         rightCount = parseInt(parts[1]) || 2;
// //       }
// //     } catch (e) {
// //       leftCount = 2;
// //       rightCount = 2;
// //     }

// //     const totalConfigCols = leftCount + rightCount;

// //     const seatsByRow = {};
// //     seats.forEach(seat => {
// //       if (!seatsByRow[seat.row]) {
// //         seatsByRow[seat.row] = [];
// //       }
// //       seatsByRow[seat.row].push(seat);
// //     });

// //     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

// //     const rows = [];

// //     // const renderSeat = (seatObj) => {
// //     //   const isSelected = activeSeats.includes(seatObj.seatNumber);
// //     //   const isSleeper = seatObj.seatType === 'sleeper' || 
// //     //     seatObj.seatType === 'seat+sleeper' ||
// //     //     selectedTemplate.seatType === 'sleeper' || 
// //     //     selectedTemplate.seatType === 'seater+sleeper';

// //     //   const displayLabel = isSelected 
// //     //     ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber) 
// //     //     : "";

// //     //   return (
// //     //     <button
// //     //       key={seatObj.seatNumber}
// //     //       className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${isSelected ? 'selected' : 'inactive'}`}
// //     //       onClick={() => handleSeatPress(seatObj)}
// //     //       type="button"
// //     //     >
// //     //       <span className="seat-number">{displayLabel}</span>
// //     //     </button>
// //     //   );
// //     // };

// //     const renderSeat = (seatObj) => {
// //       const isSelected = activeSeats.includes(seatObj.seatNumber);
// //       const isBlocked = blockedSeats.includes(seatObj.seatNumber); // <-- ADD THIS LINE
// //       const isSleeper = seatObj.seatType === 'sleeper' ||
// //         seatObj.seatType === 'seat+sleeper' ||
// //         selectedTemplate.seatType === 'sleeper' ||
// //         selectedTemplate.seatType === 'seater+sleeper';

// //       const displayLabel = isSelected
// //         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
// //         : "";

// //       // Determine seat class for styling
// //       let seatClass = '';
// //       if (isSelected) {
// //         seatClass = isBlocked ? 'blocked' : 'selected'; // <-- ADD BLOCKED CLASS
// //       } else {
// //         seatClass = 'inactive';
// //       }

// //       return (
// //         <button
// //           key={seatObj.seatNumber}
// //           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
// //           onClick={() => handleSeatPress(seatObj)}
// //           type="button"
// //         >
// //           <span className="seat-number">{displayLabel}</span>
// //         </button>
// //       );
// //     };

// //     rowNumbers.forEach(rowNum => {
// //       const seatsInRow = seatsByRow[rowNum];

// //       const isBackRow = seatsInRow.some(s => s.position === 'back') ||
// //         seatsInRow.length > totalConfigCols;

// //       if (isBackRow) {
// //         const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
// //         rows.push(
// //           <div key={`row-${rowNum}`} className="seat-row back-row">
// //             <div className="seats-container">
// //               {sortedSeats.map(seat => renderSeat(seat))}
// //             </div>
// //           </div>
// //         );
// //       } else {
// //         const leftSeats = seatsInRow
// //           .filter(s => (s.column || 0) <= leftCount)
// //           .sort((a, b) => (a.column || 0) - (b.column || 0));

// //         const rightSeats = seatsInRow
// //           .filter(s => (s.column || 0) > leftCount)
// //           .sort((a, b) => (a.column || 0) - (b.column || 0));

// //         rows.push(
// //           <div key={`row-${rowNum}`} className="seat-row">
// //             <div className="left-seats">
// //               {leftSeats.map(seat => renderSeat(seat))}
// //             </div>
// //             <div className="aisle">Aisle</div>
// //             <div className="right-seats">
// //               {rightSeats.map(seat => renderSeat(seat))}
// //             </div>
// //           </div>
// //         );
// //       }
// //     });

// //     return (
// //       <div className="seat-layout-visualizer">
// //         <div className="bus-header">
// //           <div className="driver-area">Driver</div>
// //           <div className="bus-info">
// //             <span className="bus-config">{selectedTemplate.configuration}</span>
// //             <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
// //           </div>
// //         </div>
// //         <div className="bus-body">
// //           {rows}
// //         </div>
// //         <div className="seat-legend">
// //           <div className="legend-item">
// //             <div className="seat-sample selected"></div>
// //             <span>Active Seat ({activeSeats.length})</span>
// //           </div>
// //           <div className="legend-item">
// //             <div className="seat-sample inactive"></div>
// //             <span>Inactive Seat</span>
// //           </div>
// //           <div className="legend-item">
// //             <div className="seat-sample sleeper"></div>
// //             <span>Sleeper</span>
// //           </div>
// //         </div>
// //         <div className="seat-summary">
// //           <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const ProgressSteps = () => (
// //     <div className="progress-steps">
// //       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
// //         <div className="step-icon">1</div>
// //         <div className="step-label">Basic Info</div>
// //       </div>
// //       <div className="step-connector"></div>
// //       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
// //         <div className="step-icon">2</div>
// //         <div className="step-label">Route & Pricing</div>
// //       </div>
// //       <div className="step-connector"></div>
// //       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
// //         <div className="step-icon">3</div>
// //         <div className="step-label">Fare Matrix</div>
// //       </div>
// //       <div className="step-connector"></div>
// //       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
// //         <div className="step-icon">4</div>
// //         <div className="step-label">Seat Layout</div>
// //       </div>
// //     </div>
// //   );

// //   const renderBasicInfoTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Bus Information</h3>
// //         <p className="section-subtitle">Enter basic details about the bus</p>
// //       </div>

// //       <div className="form-grid">
// //         <div className="input-group">
// //           <label className="input-label">
// //             <span className="label-icon">🚌</span>
// //             Bus Number *
// //           </label>
// //           <input
// //             type="text"
// //             value={form.busNumber}
// //             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
// //             placeholder="e.g., WB01AB1234"
// //             className="modern-input"
// //             required
// //           />
// //         </div>

// //         <div className="input-group">
// //           <label className="input-label">
// //             <span className="label-icon">🏷️</span>
// //             Bus Name *
// //           </label>
// //           <input
// //             type="text"
// //             value={form.busName}
// //             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
// //             placeholder="e.g., Volvo Multi-Axle"
// //             className="modern-input"
// //             required
// //           />
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🖼️</span>
// //           Bus Images & Video
// //         </h4>
// //         <div className="images-upload-area">
// //           <input
// //             type="file"
// //             id="bus-images"
// //             multiple
// //             accept="image/*"
// //             onChange={handleImageUpload}
// //             className="image-upload-input"
// //             style={{ display: 'none' }}
// //           />
// //           <label htmlFor="bus-images" className="image-upload-label">
// //             <span className="upload-icon">📁</span>
// //             <span className="upload-text">Click to upload images</span>
// //             <span className="upload-hint">Upload multiple images (max 10)</span>
// //           </label>

// //           {selectedImages.length > 0 && (
// //             <div className="selected-images-preview">
// //               <h5>Selected Images ({selectedImages.length})</h5>
// //               <div className="images-grid">
// //                 {selectedImages.map((image, index) => (
// //                   <div key={index} className="image-preview-item">
// //                     <img
// //                       src={image.preview}
// //                       alt={`Bus ${index + 1}`}
// //                       className="preview-image"
// //                     />
// //                     <button
// //                       type="button"
// //                       className="remove-image-btn"
// //                       onClick={() => removeImage(index)}
// //                     >
// //                       ×
// //                     </button>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           )}

// //           <div className="video-upload-section" style={{ marginTop: '15px' }}>
// //             <input
// //               type="file"
// //               id="bus-video"
// //               accept="video/*"
// //               onChange={handleVideoUpload}
// //               className="video-upload-input"
// //               style={{ display: 'none' }}
// //             />
// //             <label htmlFor="bus-video" className="video-upload-label">
// //               <span className="upload-icon">🎥</span>
// //               <span className="upload-text">Click to upload video</span>
// //               <span className="upload-hint">Upload one video (optional)</span>
// //             </label>

// //             {selectedVideo && (
// //               <div className="selected-video-preview">
// //                 <div className="video-info">
// //                   <span className="video-name">{selectedVideo.name}</span>
// //                   <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
// //                 </div>
// //                 <button
// //                   type="button"
// //                   className="remove-video-btn"
// //                   onClick={removeVideo}
// //                 >
// //                   Remove
// //                 </button>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>

// //       <div className="form-row">
// //         <div className="form-group">
// //           <label className="input-label">
// //             <span className="label-icon">🔧</span>
// //             Bus Type *
// //           </label>
// //           <select
// //             value={form.busType}
// //             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
// //             className="modern-select"
// //           >
// //             {BUS_TYPES.map(type => (
// //               <option key={type} value={type}>{type}</option>
// //             ))}
// //           </select>
// //         </div>

// //         <div className="form-group">
// //           <label className="input-label">
// //             <span className="label-icon">📊</span>
// //             Bus Category *
// //           </label>
// //           <select
// //             value={form.busCategory}
// //             onChange={(e) => handleCategoryChange(e.target.value)}
// //             className="modern-select"
// //           >
// //             <option value="">Select Category</option>
// //             {BUS_CATEGORIES.map(cat => (
// //               <option key={cat} value={cat}>{cat}</option>
// //             ))}
// //           </select>
// //           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">✨</span>
// //           Amenities
// //         </h4>
// //         <div className="amenities-grid compact">
// //           {AMENITIES_LIST.map(amenity => (
// //             <label key={amenity} className="amenity-option compact">
// //               <input
// //                 type="checkbox"
// //                 checked={form.amenities.includes(amenity)}
// //                 onChange={(e) => {
// //                   if (e.target.checked) {
// //                     setForm(prev => ({
// //                       ...prev,
// //                       amenities: [...prev.amenities, amenity]
// //                     }));
// //                   } else {
// //                     setForm(prev => ({
// //                       ...prev,
// //                       amenities: prev.amenities.filter(a => a !== amenity)
// //                     }));
// //                   }
// //                 }}
// //                 className="amenity-checkbox"
// //               />
// //               <span className="amenity-content">
// //                 <span className="amenity-icon">✓</span>
// //                 <span className="amenity-label">{amenity}</span>
// //               </span>
// //             </label>
// //           ))}
// //         </div>
// //       </div>

// //       <div className="form-actions">
// //         <button
// //           className="modern-btn primary full-width"
// //           onClick={() => setActiveTab('route')}
// //           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
// //         >
// //           Continue to Route & Pricing
// //           <span className="btn-icon">→</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   const renderRouteTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Route & Pricing Configuration</h3>
// //         <p className="section-subtitle">Select routes and configure pricing for this bus</p>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🔄</span>
// //           Trip Type
// //         </h4>
// //         <div className="trip-type-container">
// //           <button
// //             type="button"
// //             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
// //             onClick={() => setTripType('oneWay')}
// //           >
// //             <span className="btn-icon">➡️</span>
// //             One Way
// //           </button>
// //           <button
// //             type="button"
// //             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
// //             onClick={() => setTripType('roundTrip')}
// //           >
// //             <span className="btn-icon">🔄</span>
// //             Round Trip
// //           </button>
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🗺️</span>
// //           Route Selection
// //         </h4>

// //         <div className="route-selector">
// //           <label className="input-label">Select Route *</label>
// //           <select
// //             value={selectedRoute?._id || ''}
// //             onChange={(e) => {
// //               const route = routes.find(r => r._id === e.target.value);
// //               setSelectedRoute(route);
// //               setFareMatrixUp([]);
// //               setFareMatrixDown([]);
// //             }}
// //             className="modern-select"
// //             disabled={loadingRoutes}
// //           >
// //             <option value="">Select Route</option>
// //             {routes.map(route => (
// //               <option key={route._id} value={route._id}>
// //                 {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''}) {route.isRoundTrip ? '[Round Trip]' : ''}
// //               </option>
// //             ))}
// //           </select>
// //           {selectedRoute && selectedRoute.isRoundTrip && (
// //             <small className="helper-text">This is a round trip route - both UP and DOWN matrices will be generated</small>
// //           )}
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">📅</span>
// //           Operating Days *
// //         </h4>
// //         <div className="days-grid compact">
// //           {DAYS_OF_WEEK.map(day => (
// //             <button
// //               key={day}
// //               type="button"
// //               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
// //               onClick={() => toggleDay(day)}
// //               title={day}
// //             >
// //               {day.substring(0, 3)}
// //             </button>
// //           ))}
// //         </div>
// //         <div className="selected-days">
// //           Selected: {operatingDays.length} days
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">💰</span>
// //           Pricing Configuration
// //         </h4>

// //         <div className="form-row">
// //           <div className="form-group">
// //             <label>Base Price (₹) *</label>
// //             <input
// //               type="number"
// //               value={pricing.basePrice}
// //               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
// //               placeholder="e.g., 100"
// //               className="modern-input"
// //               min="0"
// //               step="1"
// //             />
// //           </div>
// //           <div className="form-group">
// //             <label>Base Distance (km) *</label>
// //             <input
// //               type="number"
// //               value={pricing.baseDistance}
// //               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
// //               placeholder="e.g., 15"
// //               className="modern-input"
// //               min="0"
// //               step="0.1"
// //             />
// //           </div>
// //           <div className="form-group">
// //             <label>Cost per km (₹) *</label>
// //             <input
// //               type="number"
// //               value={pricing.costPerKm}
// //               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
// //               placeholder="e.g., 4"
// //               className="modern-input"
// //               min="0"
// //               step="0.1"
// //             />
// //           </div>
// //         </div>

// //         {selectedRoute && (
// //           <div className="pricing-summary">
// //             <div className="summary-item">
// //               <span>Category Multiplier:</span>
// //               <span className="value accent">{getCategoryMultiplier()}x</span>
// //             </div>
// //             <div className="summary-item">
// //               <span>Route Distance:</span>
// //               <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
// //             </div>
// //           </div>
// //         )}
// //       </div>

// //       <div className="form-actions">
// //         <button
// //           type="button"
// //           className="modern-btn outline"
// //           onClick={() => setActiveTab('basic')}
// //         >
// //           ← Back
// //         </button>
// //         <button
// //           type="button"
// //           className="modern-btn primary generate-matrix-btn"
// //           onClick={() => {
// //             handleGenerateMatrix();
// //             if (fareMatrixUp.length > 0) {
// //               setActiveTab('matrix');
// //             }
// //           }}
// //           disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
// //         >
// //           Generate Fare Matrix
// //           <span className="btn-icon">→</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   const renderMatrixTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Fare Matrix Configuration</h3>
// //         <p className="section-subtitle">Review and edit fares for each route</p>
// //       </div>

// //       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
// //         <div className="matrix-tabs">
// //           <button
// //             type="button"
// //             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
// //             onClick={() => setActiveMatrixTab('up')}
// //           >
// //             Up Route: {selectedRoute.routeName}
// //           </button>
// //           <button
// //             type="button"
// //             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
// //             onClick={() => setActiveMatrixTab('down')}
// //           >
// //             Down Route: Return Route
// //           </button>
// //         </div>
// //       )}

// //       {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
// //         <>
// //           {activeMatrixTab === 'up' && renderMatrix('up')}
// //           {activeMatrixTab === 'down' && renderMatrix('down')}
// //         </>
// //       ) : (
// //         renderMatrix('up')
// //       )}

// //       <div className="matrix-info">
// //         <div className="info-card">
// //           <div className="info-item">
// //             <span className="label">Total Stops:</span>
// //             <span className="value">
// //               {selectedRoute ?
// //                 (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
// //             </span>
// //           </div>
// //           <div className="info-item">
// //             <span className="label">Category Multiplier:</span>
// //             <span className="value accent">{getCategoryMultiplier()}x</span>
// //           </div>
// //           <div className="info-item">
// //             <span className="label">Base Price:</span>
// //             <span className="value">₹{pricing.basePrice}</span>
// //           </div>
// //           <div className="info-item">
// //             <span className="label">Cost/km:</span>
// //             <span className="value">₹{pricing.costPerKm}</span>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="form-actions">
// //         <button
// //           type="button"
// //           className="modern-btn outline"
// //           onClick={() => setActiveTab('route')}
// //         >
// //           ← Back to Pricing
// //         </button>
// //         <button
// //           type="button"
// //           className="modern-btn primary"
// //           onClick={() => setActiveTab('seats')}
// //           disabled={fareMatrixUp.length === 0}
// //         >
// //           Continue to Seat Layout
// //           <span className="btn-icon">→</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   const renderSeatLayoutTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Seat Layout Configuration</h3>
// //         <p className="section-subtitle">Configure seat layout for this bus</p>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🔧</span>
// //           Bus Configuration
// //         </h4>
// //         <div className="config-selector">
// //           <label className="input-label">Select Bus Configuration *</label>
// //           {loadingLayouts ? (
// //             <div className="loading-configs">
// //               <span>Loading configurations...</span>
// //             </div>
// //           ) : (
// //             <>
// //               <div className="config-buttons">
// //                 {availableConfigurations.map(config => (
// //                   <button
// //                     key={config}
// //                     type="button"
// //                     className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
// //                     onClick={() => {
// //                       setSelectedConfiguration(config);
// //                       setSelectedTemplate(null);
// //                       setActiveSeats([]);
// //                       setCustomSeatLabels({});
// //                       fetchLayouts(config);
// //                     }}
// //                   >
// //                     {config}
// //                   </button>
// //                 ))}
// //               </div>
// //               <small className="helper-text">
// //                 {form.busCategory} bus with {selectedConfiguration} configuration
// //               </small>
// //             </>
// //           )}
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">💺</span>
// //           Seat Layout Template
// //         </h4>

// //         {!selectedTemplate ? (
// //           <button
// //             type="button"
// //             className="modern-btn outline full-width"
// //             onClick={openTemplateSelector}
// //             disabled={loadingLayouts}
// //           >
// //             {loadingLayouts ? (
// //               <>
// //                 <span className="btn-icon">⏳</span>
// //                 Loading Layouts...
// //               </>
// //             ) : (
// //               <>
// //                 <span className="btn-icon">📋</span>
// //                 Select Layout Template
// //               </>
// //             )}
// //           </button>
// //         ) : (
// //           <div className="selected-template-info">
// //             <div className="template-details">
// //               <span className="template-name">{selectedTemplate.name}</span>
// //               <span className="template-config">{selectedTemplate.configuration}</span>
// //               <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
// //               <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
// //             </div>
// //             <button
// //               type="button"
// //               className="btn-small"
// //               onClick={() => {
// //                 setSelectedTemplate(null);
// //                 setActiveSeats([]);
// //                 setCustomSeatLabels({});
// //               }}
// //             >
// //               Change
// //             </button>
// //           </div>
// //         )}
// //       </div>

// //       {selectedTemplate && (
// //         <div className="section-card">
// //           <h4 className="card-title">
// //             <span className="title-icon">👁️</span>
// //             Seat Layout Visualizer
// //           </h4>
// //           <button
// //             type="button"
// //             className="view-layout-btn"
// //             onClick={() => setShowLayoutModal(true)}
// //           >
// //             View / Edit Seat Numbers
// //           </button>

// //           <div className="seat-summary">
// //             <div className="summary-item">
// //               <span>Total Seats in Template:</span>
// //               <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
// //             </div>
// //             <div className="summary-item">
// //               <span>Active Seats:</span>
// //               <span className="value accent">{activeSeats.length}</span>
// //             </div>
// //             <div className="summary-item">
// //               <span>Inactive Seats:</span>
// //               <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <div className="form-actions">
// //         <button
// //           type="button"
// //           className="modern-btn outline"
// //           onClick={() => setActiveTab('matrix')}
// //         >
// //           ← Back to Matrix
// //         </button>
// //         <button
// //           type="button"
// //           className="modern-btn primary"
// //           onClick={handleSubmitBus}
// //           disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
// //         >
// //           {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
// //           <span className="btn-icon">✓</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   // const renderLayoutModal = () => (
// //   //   <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
// //   //     <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
// //   //       <div className="modal-header">
// //   //         <h3>Edit Active Seats</h3>
// //   //         <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
// //   //       </div>
// //   //       <div className="modal-body">
// //   //         <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
// //   //         <div className="seat-legend">
// //   //           <div className="legend-item">
// //   //             <div className="seat-sample selected"></div>
// //   //             <span>Active</span>
// //   //           </div>
// //   //           <div className="legend-item">
// //   //             <div className="seat-sample inactive"></div>
// //   //             <span>Disabled</span>
// //   //           </div>
// //   //           <div className="legend-item">
// //   //             <div className="seat-sample sleeper"></div>
// //   //             <span>Sleeper</span>
// //   //           </div>
// //   //         </div>
// //   //         {renderSeatVisualizer()}
// //   //         <div className="layout-footer">
// //   //           <span>Total: {activeSeats.length}</span>
// //   //           <div className="footer-actions">
// //   //             <button className="auto-number-btn" onClick={autoRenumberSeats}>
// //   //               Auto-Number
// //   //             </button>
// //   //             <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
// //   //               Confirm
// //   //             </button>
// //   //           </div>
// //   //         </div>
// //   //       </div>
// //   //     </div>
// //   //   </div>
// //   // );
// //   const renderLayoutModal = () => (
// //     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
// //       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header">
// //           <h3>Edit Seat Numbers</h3>
// //           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
// //         </div>
// //         <div className="modal-body">
// //           <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
// //           <div className="seat-legend three-items">
// //             <div className="legend-item">
// //               <div className="seat-sample selected"></div>
// //               <span>Active</span>
// //             </div>
// //             <div className="legend-item">
// //               <div className="seat-sample blocked"></div>
// //               <span>Blocked</span>
// //             </div>
// //             <div className="legend-item">
// //               <div className="seat-sample inactive"></div>
// //               <span>Disabled</span>
// //             </div>
// //           </div>
// //           {renderSeatVisualizer()}
// //           <div className="layout-footer">
// //             <span>Total: {activeSeats.length}</span>
// //             <div className="footer-actions">
// //               <button className="auto-number-btn" onClick={autoRenumberSeats}>
// //                 Auto-Number
// //               </button>
// //               <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
// //                 Confirm
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   const renderTemplateModal = () => (
// //     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
// //       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header">
// //           <h3>Select Seat Layout Template</h3>
// //           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
// //         </div>
// //         <div className="modal-body">
// //           {loadingLayouts ? (
// //             <div className="loading-container">
// //               <p>Loading templates...</p>
// //             </div>
// //           ) : layoutTemplates.length === 0 ? (
// //             <div className="no-templates">
// //               <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
// //               <p className="hint">Available configurations with layouts:</p>
// //               <div className="available-configs">
// //                 {availableConfigurations.map(config => (
// //                   <span key={config} className="config-chip">{config}</span>
// //                 ))}
// //               </div>
// //               <p className="hint">Try selecting a different configuration</p>
// //             </div>
// //           ) : (
// //             <div className="templates-grid">
// //               {layoutTemplates.map(template => (
// //                 <button
// //                   type="button"
// //                   key={template._id}
// //                   className="template-card"
// //                   onClick={() => handleSelectTemplate(template)}
// //                 >
// //                   <h4 className="template-name">{template.name}</h4>
// //                   <div className="template-details">
// //                     <span className="config">Config: {template.configuration}</span>
// //                     <span className="seats">Seats: {template.totalSeats}</span>
// //                   </div>
// //                   <div className="template-preview">
// //                     <span className="rows">Rows: {template.rows}</span>
// //                     <span className="cols">Cols: {template.columns}</span>
// //                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
// //                   </div>
// //                 </button>
// //               ))}
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   // Seat Number Edit Modal
// //   // const renderSeatEditModal = () => (
// //   //   <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
// //   //     <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
// //   //       <div className="modal-header">
// //   //         <h3>Set Seat Label</h3>
// //   //       </div>
// //   //       <div className="modal-body">
// //   //         <input
// //   //           type="text"
// //   //           value={tempSeatLabel}
// //   //           onChange={(e) => setTempSeatLabel(e.target.value)}
// //   //           placeholder="e.g. 1 or 1A"
// //   //           className="seat-input"
// //   //           autoFocus
// //   //         />
// //   //       </div>
// //   //       <div className="modal-footer">
// //   //         <button
// //   //           className="cancel-btn"
// //   //           onClick={() => {
// //   //             setActiveSeats(activeSeats.filter(s => s !== editingSeat));
// //   //             setEditingSeat(null);
// //   //           }}
// //   //         >
// //   //           Disable
// //   //         </button>
// //   //         <button
// //   //           className="save-btn"
// //   //           onClick={() => {
// //   //             if (tempSeatLabel.trim() === '') {
// //   //               toast.error('Please enter a valid seat number');
// //   //               return;
// //   //             }
// //   //             if (!activeSeats.includes(editingSeat)) {
// //   //               setActiveSeats([...activeSeats, editingSeat]);
// //   //             }
// //   //             setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
// //   //             setEditingSeat(null);
// //   //           }}
// //   //         >
// //   //           Save
// //   //         </button>
// //   //       </div>
// //   //     </div>
// //   //   </div>
// //   // );

// //   const renderSeatEditModal = () => (
// //     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
// //       <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header">
// //           <h3>Set Seat Label</h3>
// //         </div>
// //         <div className="modal-body">
// //           <input
// //             type="text"
// //             value={tempSeatLabel}
// //             onChange={(e) => setTempSeatLabel(e.target.value)}
// //             placeholder="e.g. 1 or 1A"
// //             className="seat-input"
// //             autoFocus
// //           />
// //         </div>
// //         <div className="modal-footer three-buttons">
// //           {/* DISABLE BUTTON */}
// //           <button
// //             className="modal-action-btn disable-btn"
// //             onClick={() => {
// //               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
// //               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
// //               setEditingSeat(null);
// //             }}
// //           >
// //             Disable
// //           </button>

// //           {/* BLOCK BUTTON */}
// //           <button
// //             className="modal-action-btn block-btn"
// //             onClick={() => {
// //               if (tempSeatLabel.trim() === '') {
// //                 toast.error('Please enter a valid seat number');
// //                 return;
// //               }
// //               if (!activeSeats.includes(editingSeat)) {
// //                 setActiveSeats([...activeSeats, editingSeat]);
// //               }
// //               if (!blockedSeats.includes(editingSeat)) {
// //                 setBlockedSeats([...blockedSeats, editingSeat]);
// //               }
// //               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
// //               setEditingSeat(null);
// //             }}
// //           >
// //             Block
// //           </button>

// //           {/* ACTIVE (SAVE) BUTTON */}
// //           <button
// //             className="modal-action-btn active-btn"
// //             onClick={() => {
// //               if (tempSeatLabel.trim() === '') {
// //                 toast.error('Please enter a valid seat number');
// //                 return;
// //               }
// //               if (!activeSeats.includes(editingSeat)) {
// //                 setActiveSeats([...activeSeats, editingSeat]);
// //               }
// //               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
// //               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
// //               setEditingSeat(null);
// //             }}
// //           >
// //             Active
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <div className="modal-overlay modern" onClick={onClose}>
// //       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header modern">
// //           <div className="header-content">
// //             <h2 className="modal-title">
// //               <span className="title-icon">🚌</span>
// //               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
// //             </h2>
// //             <p className="modal-subtitle">Configure bus details with route selection</p>
// //           </div>
// //           <button className="modal-close-btn modern" onClick={onClose}>
// //             <span className="close-icon">×</span>
// //           </button>
// //         </div>

// //         <div className="modal-body modern">
// //           <ProgressSteps />

// //           <div className="tab-container">
// //             {activeTab === 'basic' && renderBasicInfoTab()}
// //             {activeTab === 'route' && renderRouteTab()}
// //             {activeTab === 'matrix' && renderMatrixTab()}
// //             {activeTab === 'seats' && renderSeatLayoutTab()}
// //           </div>

// //           {error && (
// //             <div className="error-message modern">
// //               <span className="error-icon">⚠️</span>
// //               {error}
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       {showLayoutModal && renderLayoutModal()}
// //       {showTemplateModal && renderTemplateModal()}
// //       {editingSeat && renderSeatEditModal()}
// //     </div>
// //   );
// // };

// const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
//   const { token } = useSelector(state => state.user);
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);

//   // ADD THIS: Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({
//     hours: 1,
//     minutes: 0
//   });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [routes, setRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Image States
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Constants
//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const BUS_CLASSES = ['Economy', 'Premium', 'Luxury'];

//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];

//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // ADD THIS: Validate booking time
//   const validateBookingTime = () => {
//     const totalMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//     if (totalMinutes < 0) {
//       toast.error('Booking close time cannot be negative');
//       return false;
//     }
//     if (bookingClosedBefore.hours > 24) {
//       toast.error('Booking close hours cannot exceed 24');
//       return false;
//     }
//     if (bookingClosedBefore.minutes > 59) {
//       toast.error('Minutes cannot exceed 59');
//       return false;
//     }
//     return true;
//   };

//   // ADD THIS: Handle booking time change
//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({
//       ...prev,
//       [field]: parseInt(value) || 0
//     }));
//   };

//   // Fetch Routes
//   useEffect(() => {
//     const fetchRoutes = async () => {
//       try {
//         setLoadingRoutes(true);
//         const response = await getAllBusownerAdminRoutes(token, 1, 100, '', ownerId);
//         console.log("getAllBusownerAdminRoutes : ", response)
//         if (response && response.success && response.routes) {
//           setRoutes(response.routes);
//         }
//       } catch (error) {
//         console.error('Error fetching routes:', error);
//         toast.error('Failed to fetch routes');
//       } finally {
//         setLoadingRoutes(false);
//       }
//     };

//     fetchRoutes();
//   }, [token, ownerId]);

//   // Fetch configurations when category changes
//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   const getCategoryMultiplier = () => {
//     const multipliers = {
//       'Seater': 1.0,
//       'Sleeper': 1.5,
//       'Seater+Sleeper': 1.3
//     };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);

//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;

//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') ||
//             cat.availableSeatTypes?.includes('seater')
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper')
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') ||
//             cat.availableSeatTypes?.includes('seat+sleeper')
//           );
//         }

//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           setSelectedConfiguration(configs[0]);
//           setLayoutTemplates([]);
//         } else {
//           setAvailableConfigurations([]);
//           setLayoutTemplates([]);
//           toast.info(`No configurations available for ${form.busCategory}`);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;

//       setLoadingLayouts(true);

//       let bustype = config.replace('x', '*');

//       console.log(`Fetching layouts for bustype: ${bustype}`);

//       const response = await getSeatLayoutsByBustype(bustype, token);

//       if (response && response.success) {
//         if (response.data && Array.isArray(response.data)) {
//           let filteredLayouts = response.data;

//           if (form.busCategory === 'Seater') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seat' || layout.seatType === 'seater'
//             );
//           } else if (form.busCategory === 'Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'sleeper'
//             );
//           } else if (form.busCategory === 'Seater+Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//             );
//           }

//           setLayoutTemplates(filteredLayouts);

//           if (filteredLayouts.length === 0) {
//             toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
//           } else {
//             toast.success(`Found ${filteredLayouts.length} layout(s) for ${config}`);
//           }
//         } else {
//           setLayoutTemplates([]);
//           toast.info(`No layouts found for ${config} configuration`);
//         }
//       } else {
//         console.error('Failed to fetch layouts:', response);
//         setLayoutTemplates([]);
//         toast.error(response?.message || 'Failed to load seat layouts');
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const handleCategoryChange = (category) => {
//     setForm(prev => ({ ...prev, busCategory: category }));
//     setSelectedTemplate(null);
//     setActiveSeats([]);
//     setLayoutTemplates([]);
//     setCustomSeatLabels({});
//   };

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];

//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({
//           file: file,
//           preview: e.target.result,
//           name: file.name
//         });

//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({
//           file: file,
//           preview: e.target.result,
//           name: file.name,
//           size: file.size
//         });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeVideo = () => {
//     setSelectedVideo(null);
//   };

//   const openTemplateSelector = () => {
//     if (!form.busCategory) {
//       toast.error('Please select a Bus Category first');
//       return;
//     }
//     if (!selectedConfiguration) {
//       toast.error('Please select a Bus Configuration first');
//       return;
//     }
//     if (layoutTemplates.length === 0) {
//       toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
//       return;
//     }
//     setShowTemplateModal(true);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setActiveSeats([]);
//     setBlockedSeats([]);
//     setCustomSeatLabels({});
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });

//     let counter = 1;
//     const newLabels = {};

//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });

//     setCustomSeatLabels(newLabels);
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day)
//         ? prev.filter(d => d !== day)
//         : [...prev, day]
//     );
//   };

//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     const sortedStops = [...(routeData.intermediateStops || [])]
//       .sort((a, b) => a.sequence - b.sequence);

//     const allStops = [
//       {
//         id: 'origin',
//         name: routeData.origin?.city || 'Origin',
//         distanceFromOrigin: 0,
//         type: 'origin'
//       },
//       ...sortedStops.map((s, i) => ({
//         id: s._id || `stop_${i}`,
//         name: s.city || s.name || `Stop ${i + 1}`,
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: 'stop',
//         sequence: s.sequence
//       })),
//       {
//         id: 'destination',
//         name: routeData.destination?.city || 'Destination',
//         distanceFromOrigin: parseFloat(routeData.destination?.distanceFromOrigin) ||
//           parseFloat(routeData.routeDetails?.totalDistance) || 0,
//         type: 'destination'
//       }
//     ];

//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (parseFloat(toStop.distanceFromOrigin) - parseFloat(fromStop.distanceFromOrigin)).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         sequence: fromStop.sequence,
//         toCells: toCells
//       };
//     });

//     return matrix.filter(row => row.fromId !== 'destination');
//   };

//   const handleGenerateMatrix = () => {
//     if (!selectedRoute) {
//       toast.error('Please select a Route first.');
//       return;
//     }

//     if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
//       toast.error("The selected route does not have return journey details configured.");
//       return;
//     }

//     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//       toast.error('Please fill all Pricing Fields.');
//       return;
//     }

//     const matrixUp = generateMatrixForRoute(selectedRoute);
//     setFareMatrixUp(matrixUp);

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//       setFareMatrixDown(matrixDown);
//     } else {
//       setFareMatrixDown([]);
//     }

//     toast.success(tripType === 'roundTrip'
//       ? "Both Fare Matrices Generated!"
//       : "Fare Matrix Generated!"
//     );
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = {
//           ...newToCells[colIndex],
//           price: parseInt(newPrice) || 0
//         };
//       }
//       return { ...row, toCells: newToCells };
//     });

//     if (isUp) {
//       setFareMatrixUp(updatedMatrix);
//     } else {
//       setFareMatrixDown(updatedMatrix);
//     }
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   const handleSubmitBus = async () => {
//     try {
//       setIsSubmitting(true);
//       setError(null);

//       // Validate booking time
//       if (!validateBookingTime()) {
//         setIsSubmitting(false);
//         return;
//       }

//       // Validate required fields
//       if (!form.busNumber) {
//         throw new Error('Bus Number is required');
//       }
//       if (!form.busName) {
//         throw new Error('Bus Name is required');
//       }
//       if (!form.busType) {
//         throw new Error('Bus Type is required');
//       }
//       if (!form.busCategory) {
//         throw new Error('Bus Category is required');
//       }
//       if (!selectedRoute) {
//         throw new Error('Please select a route');
//       }
//       if (operatingDays.length === 0) {
//         throw new Error('Please select at least one operating day');
//       }
//       if (!selectedTemplate) {
//         throw new Error('Please configure seat layout');
//       }
//       if (fareMatrixUp.length === 0) {
//         throw new Error('Please generate Fare Matrix');
//       }

//       const amenitiesArray = form.amenities || [];

//       const finalSeatsPayload = selectedTemplate.seats
//         .filter(s => activeSeats.includes(s.seatNumber))
//         .map(s => {
//           const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//           const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//           const isBlocked = blockedSeats.includes(s.seatNumber);

//           return {
//             seatNumber: s.seatNumber,
//             globalSeatIndex: finalGlobalIndex,
//             row: s.row,
//             column: s.column,
//             seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//             position: s.position || getSeatPosition(s.column),
//             isBlocked: isBlocked,
//             isAvailable: !isBlocked,
//           };
//         });

//       const seatConfigPayload = {
//         busType: selectedTemplate.configuration || '2*2',
//         totalSeats: activeSeats.length
//       };

//       const routeSchedules = [];
//       const routeIdToSave = selectedRoute._id || selectedRoute.id;

//       routeSchedules.push({
//         routeId: routeIdToSave,
//         direction: 'UP',
//         fareMatrix: fareMatrixUp,
//         operatingDays: operatingDays,
//         departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//         arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//       });

//       if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//         routeSchedules.push({
//           routeId: routeIdToSave,
//           direction: 'DOWN',
//           fareMatrix: fareMatrixDown,
//           operatingDays: operatingDays,
//           departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//           arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//         });
//       }

//       const fareDetails = {
//         basePrice: parseFloat(pricing.basePrice) || 0,
//         baseDistance: parseFloat(pricing.baseDistance) || 0,
//         costPerKm: parseFloat(pricing.costPerKm) || 0
//       };

//       const formData = new FormData();

//       formData.append('busNumber', form.busNumber.toUpperCase().trim());
//       formData.append('busName', form.busName.trim());
//       formData.append('busType', form.busType);
//       formData.append('busCategory', form.busCategory);
//       formData.append('totalSeats', String(activeSeats.length));
//       formData.append('tripType', tripType);
//       formData.append('busClass', 'Economy');

//       formData.append('amenities', JSON.stringify(amenitiesArray));
//       formData.append('seats', JSON.stringify(finalSeatsPayload));
//       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//       formData.append('routeSchedules', JSON.stringify(routeSchedules));
//       formData.append('fareDetails', JSON.stringify(fareDetails));
//       formData.append('operatingDays', JSON.stringify(operatingDays));

//       // ADD THIS: Append bookingClosedBefore
//       formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));

//       selectedImages.forEach((img, index) => {
//         if (img.file) {
//           formData.append('images', img.file);
//         }
//       });

//       if (selectedVideo && selectedVideo.file) {
//         formData.append('videos', selectedVideo.file);
//       }

//       console.log('Submitting bus with payload:', {
//         busNumber: form.busNumber,
//         busName: form.busName,
//         busType: form.busType,
//         busCategory: form.busCategory,
//         totalSeats: activeSeats.length,
//         tripType,
//         bookingClosedBefore: bookingClosedBefore,
//         routeSchedules: routeSchedules.length,
//         seatsCount: finalSeatsPayload.length,
//         imagesCount: selectedImages.length,
//         hasVideo: !!selectedVideo
//       });

//       const response = await addBusToOwner(ownerId, formData, token);

//       if (response && response.success) {
//         toast.success(tripType === 'roundTrip'
//           ? 'Bus added successfully with round trip routes!'
//           : 'Bus added successfully!'
//         );
//         onBusAdded();
//         onClose();
//       } else {
//         throw new Error(response?.message || 'Failed to add bus');
//       }

//     } catch (err) {
//       console.error('Error adding bus:', err);
//       setError(err.message || 'Failed to add bus');
//       toast.error(err.message || 'Failed to add bus');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || currentMatrix.length === 0) return null;

//     const sortedStops = [...(currentRoute.intermediateStops || [])]
//       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//     const allStops = [
//       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
//       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
//       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
//     ];

//     return (
//       // <div className="matrix-section">
//       //   <h5 className="matrix-title">
//       //     {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//       //   </h5>
//       //   <div className="matrix-container">
//       //     <div className="matrix-table-wrapper">
//       //       <table className="fare-matrix-table">
//       //         <thead>
//       //           <tr>
//       //             <th className="corner-cell" style={{ position: 'sticky', left: 0, zIndex: 3, backgroundColor: '#fff' }}>From \ To</th>
//       //             {allStops.map((stop, i) => (
//       //               <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//       //                 <div className="stop-header">
//       //                   <span className="stop-name">{stop.name}</span>
//       //                   <span className="stop-type">{stop.type}</span>
//       //                 </div>
//       //               </th>
//       //             ))}
//       //           </tr>
//       //         </thead>
//       //         <tbody>
//       //           {currentMatrix.map((row, rowIndex) => (
//       //             <tr key={rowIndex}>
//       //               <td className="from-cell" style={{
//       //                 backgroundColor: getStopColor(row.fromType),
//       //                 position: 'sticky',
//       //                 left: 0,
//       //                 zIndex: 2
//       //               }}
//       //               // style={{ backgroundColor: getStopColor(row.fromType) }}
//       //               >
//       //                 <div className="from-stop">
//       //                   <span className="stop-name">{row.fromName}</span>
//       //                   <span className="stop-type">{row.fromType}</span>
//       //                 </div>
//       //               </td>
//       //               {row.toCells.map((cell, colIndex) => {
//       //                 if (cell) {
//       //                   return (
//       //                     <td key={colIndex} className="price-cell">
//       //                       <div className="fare-cell">
//       //                         <span className="distance">{cell.distanceKm} km</span>
//       //                         <div className="price-input-group">
//       //                           <span className="currency">₹</span>
//       //                           <input
//       //                             type="number"
//       //                             className="matrix-input"
//       //                             value={cell.price}
//       //                             onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//       //                             min="0"
//       //                             step="1"
//       //                           />
//       //                         </div>
//       //                       </div>
//       //                     </td>
//       //                   );
//       //                 }
//       //                 return (
//       //                   <td key={colIndex} className="na-cell">
//       //                     —
//       //                   </td>
//       //                 );
//       //               })}
//       //             </tr>
//       //           ))}
//       //         </tbody>
//       //       </table>
//       //     </div>
//       //   </div>
//       // </div>
//       <div className="matrix-section">
//   <h5 className="matrix-title">
//     {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//   </h5>
//   <div className="matrix-container">
//     <div className="matrix-table-wrapper">
//       <table className="fare-matrix-table">
//         <thead>
//           <tr>
//             {/* Corner cell — sticky via CSS class only */}
//             <th className="corner-cell">From \ To</th>
//             {allStops.map((stop, i) => (
//               <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                 <div className="stop-header">
//                   <span className="stop-name">{stop.name}</span>
//                   <span className="stop-type">{stop.type}</span>
//                 </div>
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {currentMatrix.map((row, rowIndex) => (
//             <tr key={rowIndex}>
//               {/* From cell — sticky via CSS class, bg via inline */}
//               <td
//                 className="from-cell"
//                 style={{ backgroundColor: getStopColor(row.fromType) }}
//               >
//                 <div className="from-stop">
//                   <span className="stop-name">{row.fromName}</span>
//                   <span className="stop-type">{row.fromType}</span>
//                 </div>
//               </td>
//               {row.toCells.map((cell, colIndex) => {
//                 if (cell) {
//                   return (
//                     <td key={colIndex} className="price-cell">
//                       <div className="fare-cell">
//                         <span className="distance">{cell.distanceKm} km</span>
//                         <div className="price-input-group">
//                           <span className="currency">₹</span>
//                           <input
//                             type="number"
//                             className="matrix-input"
//                             value={cell.price}
//                             onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//                             min="0"
//                             step="1"
//                           />
//                         </div>
//                       </div>
//                     </td>
//                   );
//                 }
//                 return <td key={colIndex} className="na-cell">—</td>;
//               })}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   </div>
// </div>
//     );
//   };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return null;

//     const { seats, configuration } = selectedTemplate;

//     let leftCount = 2, rightCount = 2;
//     try {
//       if (configuration && configuration.includes('*')) {
//         const parts = configuration.split('*');
//         leftCount = parseInt(parts[0]) || 2;
//         rightCount = parseInt(parts[1]) || 2;
//       }
//     } catch (e) {
//       leftCount = 2;
//       rightCount = 2;
//     }

//     const totalConfigCols = leftCount + rightCount;

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) {
//         seatsByRow[seat.row] = [];
//       }
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const isSleeper = seatObj.seatType === 'sleeper' ||
//         seatObj.seatType === 'seat+sleeper' ||
//         selectedTemplate.seatType === 'sleeper' ||
//         selectedTemplate.seatType === 'seater+sleeper';

//       const displayLabel = isSelected
//         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
//         : "";

//       let seatClass = '';
//       if (isSelected) {
//         seatClass = isBlocked ? 'blocked' : 'selected';
//       } else {
//         seatClass = 'inactive';
//       }

//       return (
//         <button
//           key={seatObj.seatNumber}
//           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)}
//           type="button"
//         >
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];

//       const isBackRow = seatsInRow.some(s => s.position === 'back') ||
//         seatsInRow.length > totalConfigCols;

//       if (isBackRow) {
//         const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row back-row">
//             <div className="seats-container">
//               {sortedSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       } else {
//         const leftSeats = seatsInRow
//           .filter(s => (s.column || 0) <= leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         const rightSeats = seatsInRow
//           .filter(s => (s.column || 0) > leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row">
//             <div className="left-seats">
//               {leftSeats.map(seat => renderSeat(seat))}
//             </div>
//             <div className="aisle">Aisle</div>
//             <div className="right-seats">
//               {rightSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       }
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header">
//           <div className="driver-area">Driver</div>
//           <div className="bus-info">
//             <span className="bus-config">{selectedTemplate.configuration}</span>
//             <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
//           </div>
//         </div>
//         <div className="bus-body">
//           {rows}
//         </div>
//         <div className="seat-legend">
//           <div className="legend-item">
//             <div className="seat-sample selected"></div>
//             <span>Active Seat ({activeSeats.length})</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample inactive"></div>
//             <span>Inactive Seat</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample sleeper"></div>
//             <span>Sleeper</span>
//           </div>
//         </div>
//         <div className="seat-summary">
//           <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
//         </div>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">1</div>
//         <div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">2</div>
//         <div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">3</div>
//         <div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div>
//         <div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Bus Information</h3>
//         <p className="section-subtitle">Enter basic details about the bus</p>
//       </div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🚌</span>
//             Bus Number *
//           </label>
//           <input
//             type="text"
//             value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             placeholder="e.g., WB01AB1234"
//             className="modern-input"
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🏷️</span>
//             Bus Name *
//           </label>
//           <input
//             type="text"
//             value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             placeholder="e.g., Volvo Multi-Axle"
//             className="modern-input"
//             required
//           />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🖼️</span>
//           Bus Images & Video
//         </h4>
//         <div className="images-upload-area">
//           <input
//             type="file"
//             id="bus-images"
//             multiple
//             accept="image/*"
//             onChange={handleImageUpload}
//             className="image-upload-input"
//             style={{ display: 'none' }}
//           />
//           <label htmlFor="bus-images" className="image-upload-label">
//             <span className="upload-icon">📁</span>
//             <span className="upload-text">Click to upload images</span>
//             <span className="upload-hint">Upload multiple images (max 10)</span>
//           </label>

//           {selectedImages.length > 0 && (
//             <div className="selected-images-preview">
//               <h5>Selected Images ({selectedImages.length})</h5>
//               <div className="images-grid">
//                 {selectedImages.map((image, index) => (
//                   <div key={index} className="image-preview-item">
//                     <img
//                       src={image.preview}
//                       alt={`Bus ${index + 1}`}
//                       className="preview-image"
//                     />
//                     <button
//                       type="button"
//                       className="remove-image-btn"
//                       onClick={() => removeImage(index)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           <div className="video-upload-section" style={{ marginTop: '15px' }}>
//             <input
//               type="file"
//               id="bus-video"
//               accept="video/*"
//               onChange={handleVideoUpload}
//               className="video-upload-input"
//               style={{ display: 'none' }}
//             />
//             <label htmlFor="bus-video" className="video-upload-label">
//               <span className="upload-icon">🎥</span>
//               <span className="upload-text">Click to upload video</span>
//               <span className="upload-hint">Upload one video (optional)</span>
//             </label>

//             {selectedVideo && (
//               <div className="selected-video-preview">
//                 <div className="video-info">
//                   <span className="video-name">{selectedVideo.name}</span>
//                   <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
//                 </div>
//                 <button
//                   type="button"
//                   className="remove-video-btn"
//                   onClick={removeVideo}
//                 >
//                   Remove
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">🔧</span>
//             Bus Type *
//           </label>
//           <select
//             value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_TYPES.map(type => (
//               <option key={type} value={type}>{type}</option>
//             ))}
//           </select>
//         </div>

//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">📊</span>
//             Bus Category *
//           </label>
//           <select
//             value={form.busCategory}
//             onChange={(e) => handleCategoryChange(e.target.value)}
//             className="modern-select"
//           >
//             <option value="">Select Category</option>
//             {BUS_CATEGORIES.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
//         </div>
//       </div>

//       {/* ADD THIS: Booking Closed Before Section */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">⏰</span>
//           Booking Cut-off Time
//         </h4>

//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label className="input-label">Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="24"
//                 value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>

//           <div className="time-input-group">
//             <label className="input-label">Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="59"
//                 value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>


//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">✨</span>
//           Amenities
//         </h4>
//         <div className="amenities-grid compact">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-option compact">
//               <input
//                 type="checkbox"
//                 checked={form.amenities.includes(amenity)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: [...prev.amenities, amenity]
//                     }));
//                   } else {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: prev.amenities.filter(a => a !== amenity)
//                     }));
//                   }
//                 }}
//                 className="amenity-checkbox"
//               />
//               <span className="amenity-content">
//                 <span className="amenity-icon">✓</span>
//                 <span className="amenity-label">{amenity}</span>
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           className="modern-btn primary full-width"
//           onClick={() => setActiveTab('route')}
//           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
//         >
//           Continue to Route & Pricing
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Route & Pricing Configuration</h3>
//         <p className="section-subtitle">Select routes and configure pricing for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔄</span>
//           Trip Type
//         </h4>
//         <div className="trip-type-container">
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}
//           >
//             <span className="btn-icon">➡️</span>
//             One Way
//           </button>
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}
//           >
//             <span className="btn-icon">🔄</span>
//             Round Trip
//           </button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🗺️</span>
//           Route Selection
//         </h4>

//         <div className="route-selector">
//           <label className="input-label">Select Route *</label>
//           <select
//             value={selectedRoute?._id || ''}
//             onChange={(e) => {
//               const route = routes.find(r => r._id === e.target.value);
//               setSelectedRoute(route);
//               setFareMatrixUp([]);
//               setFareMatrixDown([]);
//             }}
//             className="modern-select"
//             disabled={loadingRoutes}
//           >
//             <option value="">Select Route</option>
//             {routes.map(route => (
//               <option key={route._id} value={route._id}>
//                 {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''}) {route.isRoundTrip ? '[Round Trip]' : ''}
//               </option>
//             ))}
//           </select>
//           {selectedRoute && selectedRoute.isRoundTrip && (
//             <small className="helper-text">This is a round trip route - both UP and DOWN matrices will be generated</small>
//           )}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📅</span>
//           Operating Days *
//         </h4>
//         <div className="days-grid compact">
//           {DAYS_OF_WEEK.map(day => (
//             <button
//               key={day}
//               type="button"
//               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}
//               title={day}
//             >
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//         <div className="selected-days">
//           Selected: {operatingDays.length} days
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💰</span>
//           Pricing Configuration
//         </h4>

//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>

//         {selectedRoute && (
//           <div className="pricing-summary">
//             <div className="summary-item">
//               <span>Category Multiplier:</span>
//               <span className="value accent">{getCategoryMultiplier()}x</span>
//             </div>
//             <div className="summary-item">
//               <span>Route Distance:</span>
//               <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('basic')}
//         >
//           ← Back
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary generate-matrix-btn"
//           onClick={() => {
//             handleGenerateMatrix();
//             if (fareMatrixUp.length > 0) {
//               setActiveTab('matrix');
//             }
//           }}
//           disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
//         >
//           Generate Fare Matrix
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Fare Matrix Configuration</h3>
//         <p className="section-subtitle">Review and edit fares for each route</p>
//       </div>

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}
//           >
//             Up Route: {selectedRoute.routeName}
//           </button>
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}
//           >
//             Down Route: Return Route
//           </button>
//         </div>
//       )}

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
//         <>
//           {activeMatrixTab === 'up' && renderMatrix('up')}
//           {activeMatrixTab === 'down' && renderMatrix('down')}
//         </>
//       ) : (
//         renderMatrix('up')
//       )}

//       <div className="matrix-info">
//         <div className="info-card">
//           <div className="info-item">
//             <span className="label">Total Stops:</span>
//             <span className="value">
//               {selectedRoute ?
//                 (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
//             </span>
//           </div>
//           <div className="info-item">
//             <span className="label">Category Multiplier:</span>
//             <span className="value accent">{getCategoryMultiplier()}x</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Base Price:</span>
//             <span className="value">₹{pricing.basePrice}</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Cost/km:</span>
//             <span className="value">₹{pricing.costPerKm}</span>
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('route')}
//         >
//           ← Back to Pricing
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={() => setActiveTab('seats')}
//           disabled={fareMatrixUp.length === 0}
//         >
//           Continue to Seat Layout
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Seat Layout Configuration</h3>
//         <p className="section-subtitle">Configure seat layout for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔧</span>
//           Bus Configuration
//         </h4>
//         <div className="config-selector">
//           <label className="input-label">Select Bus Configuration *</label>
//           {loadingLayouts ? (
//             <div className="loading-configs">
//               <span>Loading configurations...</span>
//             </div>
//           ) : (
//             <>
//               <div className="config-buttons">
//                 {availableConfigurations.map(config => (
//                   <button
//                     key={config}
//                     type="button"
//                     className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//                     onClick={() => {
//                       setSelectedConfiguration(config);
//                       setSelectedTemplate(null);
//                       setActiveSeats([]);
//                       setCustomSeatLabels({});
//                       fetchLayouts(config);
//                     }}
//                   >
//                     {config}
//                   </button>
//                 ))}
//               </div>
//               <small className="helper-text">
//                 {form.busCategory} bus with {selectedConfiguration} configuration
//               </small>
//             </>
//           )}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💺</span>
//           Seat Layout Template
//         </h4>

//         {!selectedTemplate ? (
//           <button
//             type="button"
//             className="modern-btn outline full-width"
//             onClick={openTemplateSelector}
//             disabled={loadingLayouts}
//           >
//             {loadingLayouts ? (
//               <>
//                 <span className="btn-icon">⏳</span>
//                 Loading Layouts...
//               </>
//             ) : (
//               <>
//                 <span className="btn-icon">📋</span>
//                 Select Layout Template
//               </>
//             )}
//           </button>
//         ) : (
//           <div className="selected-template-info">
//             <div className="template-details">
//               <span className="template-name">{selectedTemplate.name}</span>
//               <span className="template-config">{selectedTemplate.configuration}</span>
//               <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
//               <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
//             </div>
//             <button
//               type="button"
//               className="btn-small"
//               onClick={() => {
//                 setSelectedTemplate(null);
//                 setActiveSeats([]);
//                 setCustomSeatLabels({});
//               }}
//             >
//               Change
//             </button>
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">👁️</span>
//             Seat Layout Visualizer
//           </h4>
//           <button
//             type="button"
//             className="view-layout-btn"
//             onClick={() => setShowLayoutModal(true)}
//           >
//             View / Edit Seat Numbers
//           </button>

//           <div className="seat-summary">
//             <div className="summary-item">
//               <span>Total Seats in Template:</span>
//               <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
//             </div>
//             <div className="summary-item">
//               <span>Active Seats:</span>
//               <span className="value accent">{activeSeats.length}</span>
//             </div>
//             <div className="summary-item">
//               <span>Inactive Seats:</span>
//               <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('matrix')}
//         >
//           ← Back to Matrix
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={handleSubmitBus}
//           disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
//         >
//           {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
//           <span className="btn-icon">✓</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Seat Numbers</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
//           <div className="seat-legend three-items">
//             <div className="legend-item">
//               <div className="seat-sample selected"></div>
//               <span>Active</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample blocked"></div>
//               <span>Blocked</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample inactive"></div>
//               <span>Disabled</span>
//             </div>
//           </div>
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <span>Total: {activeSeats.length}</span>
//             <div className="footer-actions">
//               <button className="auto-number-btn" onClick={autoRenumberSeats}>
//                 Auto-Number
//               </button>
//               <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Seat Layout Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {loadingLayouts ? (
//             <div className="loading-container">
//               <p>Loading templates...</p>
//             </div>
//           ) : layoutTemplates.length === 0 ? (
//             <div className="no-templates">
//               <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
//               <p className="hint">Available configurations with layouts:</p>
//               <div className="available-configs">
//                 {availableConfigurations.map(config => (
//                   <span key={config} className="config-chip">{config}</span>
//                 ))}
//               </div>
//               <p className="hint">Try selecting a different configuration</p>
//             </div>
//           ) : (
//             <div className="templates-grid">
//               {layoutTemplates.map(template => (
//                 <button
//                   type="button"
//                   key={template._id}
//                   className="template-card"
//                   onClick={() => handleSelectTemplate(template)}
//                 >
//                   <h4 className="template-name">{template.name}</h4>
//                   <div className="template-details">
//                     <span className="config">Config: {template.configuration}</span>
//                     <span className="seats">Seats: {template.totalSeats}</span>
//                   </div>
//                   <div className="template-preview">
//                     <span className="rows">Rows: {template.rows}</span>
//                     <span className="cols">Cols: {template.columns}</span>
//                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Set Seat Label</h3>
//         </div>
//         <div className="modal-body">
//           <input
//             type="text"
//             value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="e.g. 1 or 1A"
//             className="seat-input"
//             autoFocus
//           />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button
//             className="modal-action-btn disable-btn"
//             onClick={() => {
//               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setEditingSeat(null);
//             }}
//           >
//             Disable
//           </button>

//           <button
//             className="modal-action-btn block-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               if (!blockedSeats.includes(editingSeat)) {
//                 setBlockedSeats([...blockedSeats, editingSeat]);
//               }
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Block
//           </button>

//           <button
//             className="modal-action-btn active-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Active
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">
//               <span className="title-icon">🚌</span>
//               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
//             </h2>
//             <p className="modal-subtitle">Configure bus details with route selection</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>
//             <span className="close-icon">×</span>
//           </button>
//         </div>

//         <div className="modal-body modern">
//           <ProgressSteps />

//           <div className="tab-container">
//             {activeTab === 'basic' && renderBasicInfoTab()}
//             {activeTab === 'route' && renderRouteTab()}
//             {activeTab === 'matrix' && renderMatrixTab()}
//             {activeTab === 'seats' && renderSeatLayoutTab()}
//           </div>

//           {error && (
//             <div className="error-message modern">
//               <span className="error-icon">⚠️</span>
//               {error}
//             </div>
//           )}
//         </div>
//       </div>

//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };

// const BusOwnerManage = () => {
//   const { token } = useSelector(state => state.user);
//   const [busOwners, setBusOwners] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingOwner, setEditingOwner] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingOwner, setViewingOwner] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showAddBusModal, setShowAddBusModal] = useState(false);
//   const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
//   const [busSearchTerm, setBusSearchTerm] = useState('');
//   const [newOwner, setNewOwner] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     companyName: ''
//   });
//   const [error, setError] = useState(null);

//   // Bus Management states - UPDATED for new modal
//   const [showBusManagement, setShowBusManagement] = useState(false);
//   const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
//   const [selectedOwner, setSelectedOwner] = useState(null);
//   const [busDetailsLoading, setBusDetailsLoading] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalOwners, setTotalOwners] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   const getFullImageUrl = (imagePath) => {
//     if (imagePath.startsWith('http')) {
//       return imagePath;
//     }
//     return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
//   };

//   useEffect(() => {
//     fetchBusOwners();
//   }, [currentPage]);



//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchBusOwners();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

//   const fetchBusOwners = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const response = await getBusOwners(token, currentPage, pageSize, searchTerm);

//       if (response && response.success && response.busOwners) {
//         const transformedOwners = response.busOwners.map((owner, index) => ({
//           id: owner._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: owner.profileImage || '',
//           name: owner.name || '',
//           company: owner.companyName || '',
//           email: owner.email || '',
//           phone: owner.phone || '',
//           buses: owner.busCount || 0,
//           routes: owner.routeCount || 0,
//           joined: new Date(owner.createdAt).toISOString().split('T')[0],
//           status: owner.isVerified ? 'Verified' : 'Pending',
//           adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
//           _id: owner._id,
//           isVerified: owner.isVerified,
//           isProfileComplete: owner.isProfileComplete,
//           isApprovedByAdmin: owner.isApprovedByAdmin,
//           activeBuses: owner.activeBuses || 0,
//           driverCount: owner.driverCount || 0,
//           conductorCount: owner.conductorCount || 0,
//           createdAt: owner.createdAt,
//           updatedAt: owner.updatedAt,
//           address: owner.address || {},
//           city: owner.address?.city || '',
//           state: owner.address?.state || owner.state || '',
//           pincode: owner.address?.pincode || '',
//           busAll: owner.busAll || []
//         }));

//         setBusOwners(transformedOwners);

//         if (response.totalPages) {
//           setTotalPages(response.totalPages);
//         }
//         if (response.total) {
//           setTotalOwners(response.total);
//         } else {
//           setTotalOwners(response.busOwners.length);
//         }
//       } else {
//         setError('No bus owners data found in response');
//         setBusOwners([]);
//         setTotalPages(1);
//         setTotalOwners(0);
//       }
//     } catch (err) {
//       console.error('Error fetching bus owners:', err);
//       setError('Failed to fetch bus owners. Please try again.');
//       setBusOwners([]);
//       setTotalPages(1);
//       setTotalOwners(0);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const fetchBusOwnerById = async (id) => {
//     try {
//       const response = await getBusOwnerById(id, token);
//       console.log("response.data : ", response.data)
//       return response.data || response;
//     } catch (err) {
//       console.error('Error fetching bus owner:', err);
//       throw err;
//     }
//   };

//   const handleApproveOwner = async (ownerId) => {
//     try {
//       setError(null);
//       const response = await approveBusOwner(ownerId, token);

//       if (response.success) {
//         setBusOwners(prevOwners =>
//           prevOwners.map(owner =>
//             owner.id === ownerId ? {
//               ...owner,
//               isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
//               adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending'
//             } : owner
//           )
//         );
//         toast.success('Bus owner approved successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to approve bus owner');
//       }
//     } catch (err) {
//       console.error('Error approving bus owner:', err);
//       setError('Failed to approve bus owner. Please try again.');
//       toast.error('Failed to approve bus owner. Please try again.');
//     }
//   };

//   const handleManageBuses = async (owner) => {
//     console.log("handleManageBuses ; ", owner)
//     if (owner.buses === 0) {
//       // alert('This owner has no buses registered.');
//       toast.error("This owner has no buses registered")
//       return;
//     }

//     console.log('Owner bus data:', owner);

//     // Check if busAll exists and has data
//     if (!owner.busAll || owner.busAll.length === 0) {
//       // If no bus data, try to fetch it separately
//       try {
//         setBusDetailsLoading(true);
//         const response = await getBusOwnerById(owner.id, token);

//         if (response.success && response.data && response.data.busAll) {
//           // Update the owner with bus data
//           const updatedOwner = {
//             ...owner,
//             busAll: response.data.busAll || []
//           };

//           // Process the bus data
//           const processedBuses = updatedOwner.busAll.map(bus => {
//             const driver = bus.driver ? {
//               name: bus.driver.name || 'N/A',
//               contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//               licenseNumber: bus.driver.licenseNumber || 'N/A',
//               experience: bus.driver.experience || 0
//             } : null;

//             const conductor = bus.conductor ? {
//               name: bus.conductor.name || 'N/A',
//               contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//             } : null;

//             return {
//               ...bus,
//               driver,
//               conductor
//             };
//           });

//           console.log('Fetched and processed buses:', processedBuses);

//           setSelectedOwner(updatedOwner);
//           setSelectedOwnerBuses(processedBuses);
//           setShowBusManagement(true);
//           setBusSearchTerm('');
//         } else {
//           alert('Could not fetch bus data. Please try again.');
//         }
//       } catch (err) {
//         console.error('Error fetching bus details:', err);
//         alert('Failed to fetch bus details. Please try again.');
//       } finally {
//         setBusDetailsLoading(false);
//       }
//       return;
//     }

//     // If busAll data exists, process it
//     const processedBuses = owner.busAll.map(bus => {
//       const driver = bus.driver ? {
//         name: bus.driver.name || 'N/A',
//         contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//         licenseNumber: bus.driver.licenseNumber || 'N/A',
//         experience: bus.driver.experience || 0
//       } : null;

//       const conductor = bus.conductor ? {
//         name: bus.conductor.name || 'N/A',
//         contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//       } : null;

//       return {
//         ...bus,
//         driver,
//         conductor
//       };
//     });

//     console.log('Processed buses:', processedBuses);

//     setSelectedOwner(owner);
//     setSelectedOwnerBuses(processedBuses);
//     setShowBusManagement(true);
//     setBusSearchTerm('');
//   };
//   // Add this function after your other handler functions
//   const filteredBuses = selectedOwnerBuses.filter(bus =>
//     (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
//     (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
//   );

//   const handleRejectOwner = async (ownerId) => {
//     if (window.confirm('Are you sure you want to reject this bus owner?')) {
//       try {
//         setError(null);

//         if (!ownerId || typeof ownerId !== 'string') {
//           throw new Error('Invalid owner ID');
//         }

//         const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === ownerId ? {
//                 ...owner,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
//                 adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
//               } : owner
//             )
//           );
//           toast.success('Bus owner rejected successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to reject bus owner');
//         }
//       } catch (err) {
//         console.error('Error rejecting bus owner:', err);
//         setError('Failed to reject bus owner. Please try again.');
//         toast.error('Failed to reject bus owner. Please try again.');
//       }
//     }
//   };

//   const filteredOwners = busOwners;

//   const handleViewOwner = async (owner) => {
//     try {
//       const ownerData = await fetchBusOwnerById(owner.id);
//       setViewingOwner({
//         ...owner,
//         profileImage: ownerData.profileImage || owner.profileImage,
//         name: ownerData.name || owner.name,
//         company: ownerData.companyName || owner.company,
//         email: ownerData.email || owner.email,
//         phone: ownerData.phone || owner.phone,
//         address: ownerData.address || owner.address,
//         isVerified: ownerData.isVerified,
//         isProfileComplete: ownerData.isProfileComplete,
//         isApprovedByAdmin: ownerData.isApprovedByAdmin,

//         // Stats (numbers for the stat cards)
//         busCount: ownerData.stats?.busCount || 0,      // ← renamed to busCount
//         activeBuses: ownerData.stats?.activeBuses || 0,
//         driverCount: ownerData.stats?.driverCount || 0,
//         conductorCount: ownerData.stats?.conductorCount || 0,

//         // Arrays for the detail sections
//         routes: ownerData.routes || [],
//         buses: ownerData.buses || [],                   // ← array only, no conflict

//         status: ownerData.isApprovedByAdmin ? 'Active' : 'Pending',
//         joined: ownerData.createdAt
//           ? new Date(ownerData.createdAt).toLocaleDateString()
//           : owner.joined,
//       });
//     } catch (err) {
//       setViewingOwner(owner);
//       toast.info('Could not fetch latest owner details. Showing cached data.');
//     }
//   };

//   const handleEditOwner = (owner) => {
//     setEditingOwner(owner.id);
//     setEditForm({
//       name: owner.name || '',
//       companyName: owner.company || '',
//       email: owner.email || '',
//       phone: owner.phone || '',
//       status: owner.status || 'Pending',
//       isApprovedByAdmin: owner.isApprovedByAdmin || false
//     });
//   };

//   const closeBusManagement = () => {
//     setShowBusManagement(false);
//     setSelectedOwnerBuses([]);
//     setSelectedOwner(null);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       if (!editingOwner || typeof editingOwner !== 'string') {
//         throw new Error('Invalid owner ID for editing');
//       }

//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phone: editForm.phone,
//         companyName: editForm.companyName,
//         isVerified: editForm.status === 'Verified',
//         isApprovedByAdmin: editForm.isApprovedByAdmin
//       };

//       const response = await updateBusOwner(editingOwner, updateData, token);

//       if (response.success) {
//         setBusOwners(prevOwners =>
//           prevOwners.map(owner =>
//             owner.id === editingOwner ? {
//               ...owner,
//               name: response.data?.name || editForm.name,
//               company: response.data?.companyName || editForm.companyName,
//               email: response.data?.email || editForm.email,
//               phone: response.data?.phone || editForm.phone,
//               status: response.data?.isVerified ? 'Verified' : 'Pending',
//               isVerified: response.data?.isVerified,
//               isApprovedByAdmin: response.data?.isApprovedByAdmin,
//               adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
//             } : owner
//           )
//         );

//         setEditingOwner(null);
//         setEditForm({});
//         toast.success('Bus owner updated successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to update bus owner');
//       }
//     } catch (err) {
//       console.error('Error updating bus owner:', err);
//       setError('Failed to update bus owner. Please try again.');
//       toast.error('Failed to update bus owner. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingOwner(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleDeleteOwner = async (ownerId) => {
//     if (window.confirm('Are you sure you want to delete this bus owner?')) {
//       try {
//         setError(null);
//         const response = await deleteBusOwner(ownerId, token);

//         if (response.success) {
//           setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//           setTotalOwners(prev => prev - 1);
//           toast.success('Bus owner deleted successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to delete bus owner');
//         }
//       } catch (err) {
//         console.error('Error deleting bus owner:', err);
//         setError('Failed to delete bus owner. Please try again.');
//         toast.error('Failed to delete bus owner. Please try again.');
//       }
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleNewOwnerChange = (e) => {
//     const { name, value } = e.target;
//     setNewOwner(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleAddOwner = async () => {
//     try {
//       setError(null);

//       if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
//         toast.error('Please fill in all required fields');
//         return;
//       }

//       const response = await createBusOwner(newOwner, token);
//       console.log("response............ : ", response)
//       if (response.success) {
//         const newOwnerWithId = {
//           id: response.data.id,
//           serialNo: busOwners.length + 1,
//           profileImage: '',
//           name: response.data.name,
//           company: response.data.companyName,
//           email: response.data.email,
//           phone: response.data.phone,
//           buses: 0,
//           routes: 0,
//           joined: new Date(response.data.createdAt).toISOString().split('T')[0],
//           status: 'Pending',
//           adminApproval: 'Pending',
//           isVerified: false,
//           isApprovedByAdmin: false,
//           createdAt: response.data.createdAt
//         };

//         setBusOwners(prev => [newOwnerWithId, ...prev]);
//         setTotalOwners(prev => prev + 1);
//         setShowAddModal(false);
//         setNewOwner({
//           name: '',
//           companyName: '',
//           email: '',
//           phone: ''
//         });
//         toast.success('Bus owner added successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to add bus owner');
//       }
//     } catch (err) {
//       console.error('Error adding bus owner:', err);

//       // Extract error message from the response
//       let errorMessage = 'Failed to add bus owner. Please try again.';

//       if (err.response?.data?.message) {
//         // Get the message from the API response
//         errorMessage = err.response.data.message;
//       } else if (err.message) {
//         errorMessage = err.message;
//       }

//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const closeViewModal = () => {
//     setViewingOwner(null);
//   };

//   const closeAddModal = () => {
//     setShowAddModal(false);
//     setNewOwner({
//       name: '',
//       companyName: '',
//       email: '',
//       phone: ''
//     });
//     setError(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     // The useEffect will trigger fetchBusOwners automatically
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const currentPageOwners = busOwners;
//   const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
//   const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
//   const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

//   if (loading && busOwners.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading bus owners...</p>
//         </div>
//       </div>
//     );
//   }

//   const handleAddBusClick = (owner) => {
//     setSelectedOwnerForBus(owner);
//     setShowAddBusModal(true);
//   };

//   const handleBusAdded = () => {
//     fetchBusOwners();
//     toast.success('Bus added successfully!');
//   };

//   const closeAddBusModal = () => {
//     setShowAddBusModal(false);
//     setSelectedOwnerForBus(null);
//   };

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Bus Owner Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search bus owners by name, company, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Owner
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Owners</h3>
//           <p>{totalOwners}</p>
//           <span>All registered owners</span>
//         </div>
//         <div className="stat-card">
//           <h3>Verified Owners</h3>
//           <p>{verifiedOwners}</p>
//           <span>Verified on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Approved Owners</h3>
//           <p>{approvedOwners}</p>
//           <span>Approved on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{totalBuses}</p>
//           <span>active fleet</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Profile</th>
//               <th>Owner Name</th>
//               <th>Company</th>
//               <th>Contact</th>
//               <th>Buses</th>
//               <th>Admin Approval</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOwners.length > 0 ? (
//               filteredOwners.map(owner => (
//                 <tr key={owner.id}>
//                   <td>{owner.serialNo}</td>
//                   <td>
//                     <div className="profile-image-cell">
//                       <img
//                         src={getFullImageUrl(owner.profileImage)}
//                         alt={owner.name || 'Bus Owner'}
//                         className="customer-avatar"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                         }}
//                       />
//                     </div>
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Owner Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.name || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="companyName"
//                         value={editForm.companyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Company Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.company || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div>{owner.email || 'N/A'}</div>
//                         <div className="phone">{owner.phone || 'N/A'}</div>
//                       </div>
//                     )}
//                   </td>

//                   <td>{owner.buses}</td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="isApprovedByAdmin"
//                         value={editForm.isApprovedByAdmin || false}
//                         onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="true">Approved</option>
//                         <option value="false">Pending</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || 'Pending'}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="Verified">Verified</option>
//                         <option value="Pending">Pending</option>
//                         <option value="Suspended">Suspended</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
//                         {owner.status || 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
//                         <button
//                           className="action-btn save"
//                           onClick={handleSaveEdit}
//                           style={{ backgroundColor: '#28a745', color: 'white' }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="action-btn cancel"
//                           onClick={handleCancelEdit}
//                           style={{ backgroundColor: '#6c757d', color: 'white' }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewOwner(owner)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditOwner(owner)}
//                         >
//                           Edit
//                         </button>

//                         <button
//                           className="action-btn add-bus"
//                           onClick={() => handleAddBusClick(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title="Add new bus for this owner"
//                         >
//                           + Add Bus
//                         </button>

//                         <button
//                           className="action-btn manage"
//                           onClick={() => handleManageBuses(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
//                         >
//                           Manage Buses
//                         </button>

//                         {!owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveOwner(owner.id)}
//                             style={{ backgroundColor: '#28a745' }}
//                           >
//                             Approve
//                           </button>
//                         )}
//                         {owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectOwner(owner.id)}
//                             style={{ backgroundColor: '#ffc107', color: '#000' }}
//                           >
//                             Reject
//                           </button>
//                         )}
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteOwner(owner.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="no-data">
//                   <p>No bus owners found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all bus owners
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {filteredOwners.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No bus owners found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {busOwners.length} of {totalOwners} bus owners
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages || totalPages === 0}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Modal */}
//       {/* {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Owner Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={getFullImageUrl(viewingOwner.profileImage)}
//                     alt={viewingOwner.name || 'Bus Owner'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Serial No:</label>
//                   <span>{viewingOwner.serialNo}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>ID:</label>
//                   <span>#{viewingOwner.id}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Owner Name:</label>
//                   <span>{viewingOwner.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Company:</label>
//                   <span>{viewingOwner.company || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingOwner.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingOwner.phone || 'N/A'}</span>
//                 </div>

//                 <div className="detail-row">
//                   <label>Address:</label>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                     {viewingOwner.address?.city && (
//                       <span>City: {viewingOwner.address.city}</span>
//                     )}
//                     {viewingOwner.address?.state && (
//                       <span>State: {viewingOwner.address.state}</span>
//                     )}
//                     {viewingOwner.address?.pincode && (
//                       <span>Pincode: {viewingOwner.address.pincode}</span>
//                     )}
//                     {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
//                       <span>N/A</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className="detail-row">
//                   <label>Total Buses:</label>
//                   <span>{viewingOwner.buses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Active Buses:</label>
//                   <span>{viewingOwner.activeBuses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Drivers:</label>
//                   <span>{viewingOwner.driverCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Conductors:</label>
//                   <span>{viewingOwner.conductorCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{viewingOwner.joined}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
//                     {viewingOwner.status || 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Admin Approval:</label>
//                   <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                     {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Profile Complete:</label>
//                   <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Verified:</label>
//                   <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}
//       {/* View Modal */}
//       {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modern-dashboard-modal" onClick={(e) => e.stopPropagation()}>

//             {/* Header with Glassmorphism */}
//             <header className="dashboard-header">
//               <div className="header-left">
//                 <div className="icon-box"><i className="fas fa-bus"></i></div>
//                 <div>
//                   <h3>Bus Owner Profile</h3>
//                   <span className="subtitle">Management Console</span>
//                 </div>
//               </div>
//               <button className="close-icon-btn" onClick={closeViewModal}>&times;</button>
//             </header>

//             <div className="dashboard-body">

//               {/* Top Section: Profile & Stats Combined */}
//               <section className="profile-overview-card">
//                 <div className="owner-brand">
//                   <div className="avatar-wrapper">
//                     <img
//                       src={getFullImageUrl(viewingOwner.profileImage)}
//                       alt="Profile"
//                       onError={(e) => { e.target.src = ''; }}
//                     />
//                     {viewingOwner.isVerified && <div className="verified-badge"><i className="fas fa-check"></i></div>}
//                   </div>
//                   <div className="brand-details">
//                     <h2>{viewingOwner.name || 'N/A'}</h2>
//                     <p className="owner-id-tag">ID: {viewingOwner.id}</p>
//                     <div className="quick-tags">
//                       <span className={`tag ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {viewingOwner.isApprovedByAdmin ? 'Verified Partner' : 'Pending Review'}
//                       </span>
//                       <span className="tag city-tag"><i className="fas fa-map-marker-alt"></i> {viewingOwner.address?.city}, {viewingOwner.address?.state}</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="stats-strip">
//                   <div className="stat-node">
//                     <label>Buses</label>
//                     <div className="value">{viewingOwner.busCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Drivers</label>
//                     <div className="value">{viewingOwner.driverCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Conductors</label>
//                     <div className="value">{viewingOwner.conductorCount || 0}</div>
//                   </div>
//                 </div>
//               </section>

//               {/* Horizontal Routes List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-route"></i> Active Routes</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.routes?.map((route, index) => (
//                     <div key={index} className="modern-row-card route-row">
//                       <div className="row-main-info">
//                         <div className="route-code">{route.routeNumber}</div>
//                         <div className="journey-stepper">
//                           <span className="">{route.origin?.city}</span>
//                           <div className="connector-line">
//                             <i className="fas fa-chevron-right"></i>
//                           </div>
//                           <span className="">{route.destination?.city}</span>
//                         </div>
//                       </div>
//                       <div className="row-meta-info">
//                         <div className="meta-item"><i className="fas fa-road"></i> {route.routeDetails?.totalDistance} km</div>
//                         <div className="meta-item"><i className="fas fa-clock"></i> {route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</div>
//                         <div className="meta-item bus-pill"><i className="fas fa-bus-alt"></i> {route.busCount} assigned</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </section>

//               {/* Horizontal Buses List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-shuttle-van"></i> Bus Details</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.buses?.map((bus, index) => (
//                     <div key={index} className="modern-row-card bus-row">
//                       <div className="bus-identity">
//                         <div className={`status-indicator ${bus.isActive ? 'online' : 'offline'}`}></div>
//                         <div>
//                           <strong>{bus.busName}</strong>
//                           <div className="plate-number">{bus.busNumber}</div>
//                         </div>
//                       </div>

//                       <div className="bus-specs-row">
//                         <span><i className="fas fa-chair"></i> {bus.totalSeats} Seats</span>
//                         <span><i className="fas fa-snowflake"></i> {bus.busType}</span>
//                       </div>

//                       <div className="bus-amenities-tags">
//                         {bus.amenities?.slice(0, 2).map((a, i) => <span key={i} className="mini-tag">{a}</span>)}
//                       </div>

//                       {/* <div className="bus-action-link">
//                   <button className="view-tracking-btn">Live Track</button>
//                 </div> */}
//                     </div>
//                   ))}
//                 </div>
//               </section>

//             </div>

//             <footer className="dashboard-footer">
//               <button className="btn-secondary" onClick={closeViewModal}>close</button>
//             </footer>
//           </div>
//         </div>
//       )}
//       {/* NEW - Modern Bus Management Modal */}
//       {showBusManagement && selectedOwner && (
//         <BusManagementModal
//           owner={selectedOwner}
//           buses={selectedOwnerBuses}
//           onClose={closeBusManagement}
//           onUpdate={fetchBusOwners}
//         />
//       )}

//       {/* Add Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={closeAddModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Bus Owner</h3>
//               <button className="modal-close-btn" onClick={closeAddModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Owner Name *:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={newOwner.name}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter owner name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Company Name *:</label>
//                   <input
//                     type="text"
//                     name="companyName"
//                     value={newOwner.companyName}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter company name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Email *:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={newOwner.email}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter email address"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone *:</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={newOwner.phone}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter phone number"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeAddModal}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleAddOwner}>
//                 Add Owner
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add Bus Modal */}
//       {showAddBusModal && selectedOwnerForBus && (
//         <AddBusModal
//           ownerId={selectedOwnerForBus.id}
//           onClose={closeAddBusModal}
//           onBusAdded={handleBusAdded}
//         />
//       )}
//     </div>
//   );
// };

// export default BusOwnerManage;


// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//   getBusOwners,
//   getBusOwnerById,
//   createBusOwner,
//   updateBusOwner,
//   deleteBusOwner,
//   approveBusOwner,
//   addBusToOwner,
//   getSeatLayoutsByBustype,
//   getAllCategory
// } from '../../Services/Operations/ProductAPI';
// import {
//   getDriversByBusOwner,
//   getConductorsByBusOwner,
//   assignDriverToBus,
//   assignConductorToBus,
//   unassignDriverFromBus,
//   unassignConductorFromBus
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/BusFareChart.css';
// import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
// import BusManagementModal from './BusManagementModal'; // Import the new modal
// import { useNavigate } from 'react-router-dom';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-avatar"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Profile</th>
//           <th>Owner Name</th>
//           <th>Company</th>
//           <th>Contact</th>
//           <th>Buses</th>
//           <th>Admin Approval</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modern-dashboard-modal skeleton">
//       <div className="dashboard-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="dashboard-body">
//         <div className="skeleton-profile-section"></div>
//         <div className="skeleton-stats-strip"></div>
//         <div className="skeleton-routes-section"></div>
//         <div className="skeleton-buses-section"></div>
//       </div>
//       <div className="dashboard-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const RouteSelector = ({ value, onChange, onAddNew, token, disabled, loadingRoutes, originCity, destinationCity }) => {
//   const [routes, setRoutes] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');

//   const fetchRoutes = async () => {
//     setIsLoading(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token,
//         1,
//         100,
//         searchTerm,
//         '', // busOwnerId - empty to get both admin and busowner routes
//         { originCity, destinationCity } // Pass filters
//       );
//       console.log("getAllBusownerAdminRoutes :::::::::::: ",response)
//       if (response && response.success && response.routes) {
//         setRoutes(response.routes);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (showDropdown) {
//       fetchRoutes();
//     }
//   }, [showDropdown, searchTerm, originCity, destinationCity]);

//   const handleSelect = (route) => {
//     onChange(route);
//     setShowDropdown(false);
//     setSearchTerm('');
//   };

//   return (
//     <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
//       <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//         <div style={{ flex: 1, position: 'relative' }}>
//           <input
//             type="text"
//             value={value ? value.routeName || value.masterRouteName : searchTerm}
//             onClick={() => setShowDropdown(!showDropdown)}
//             onChange={(e) => {
//               setSearchTerm(e.target.value);
//               setShowDropdown(true);
//               if (value) onChange(null);
//             }}
//             placeholder="Select or search route..."
//             className="modern-input"
//             disabled={disabled}
//             style={{ cursor: 'pointer' }}
//           />
//           {isLoading && (
//             <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//               <div className="spinner-small"></div>
//             </div>
//           )}
//         </div>
//         <button
//           type="button"
//           onClick={onAddNew}
//           className="btn btn-outline-primary"
//           style={{
//             padding: '8px 16px',
//             backgroundColor: '#28a745',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '5px',
//             whiteSpace: 'nowrap'
//           }}
//           onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
//           onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
//         >
//           <span style={{ fontSize: '18px', fontWeight: 'bold' }}>+</span> New Route
//         </button>
//       </div>

//       {showDropdown && (routes.length > 0 || searchTerm) && (
//         <div className="master-route-dropdown" style={{
//           position: 'absolute',
//           top: '100%',
//           left: 0,
//           right: 0,
//           background: 'white',
//           border: '1px solid #ddd',
//           borderRadius: '4px',
//           boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//           zIndex: 1000,
//           maxHeight: '300px',
//           overflowY: 'auto',
//           marginTop: '4px'
//         }}>
//           {routes.length === 0 ? (
//             <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
//               {originCity || destinationCity
//                 ? `No routes found for ${originCity || ''} → ${destinationCity || ''}. Click + to create one.`
//                 : 'No routes found. Click + to create one.'}
//             </div>
//           ) : (
//             routes.map((route) => (
//               <div
//                 key={route._id}
//                 className="dropdown-item"
//                 onClick={() => handleSelect(route)}
//                 style={{
//                   padding: '10px 12px',
//                   cursor: 'pointer',
//                   borderBottom: '1px solid #f0f0f0',
//                   transition: 'background-color 0.2s'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
//                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//               >
//                 <div style={{ fontWeight: '500', marginBottom: '4px' }}>
//                   {route.routeNumber || ''} - {route.routeName || route.masterRouteName || 'Route'}
//                   {route.creatorType === 'BusOwner' && (
//                     <span style={{
//                       marginLeft: '8px',
//                       fontSize: '10px',
//                       backgroundColor: '#ffc107',
//                       color: '#000',
//                       padding: '2px 6px',
//                       borderRadius: '4px'
//                     }}>
//                       Owner
//                     </span>
//                   )}
//                 </div>
//                 <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                   {route.origin?.city} → {route.destination?.city} •
//                   {route.isRoundTrip ? ' Round Trip' : ' One Way'} •
//                   {route.routeDetails?.totalDistance || 0} km
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       )}
//     </div>
//   );
// };
// const PlatformFeeConfig = ({ platformFee, onChange }) => {
//   return (
//     <div className="section-card">
//       <h4 className="card-title">
//         <span className="title-icon">💰</span>
//         Platform Fee Configuration
//       </h4>
      
//       <div className="platform-fee-container">
//         <div className="form-row">
//           <div className="form-group">
//             <label className="input-label">Fee Type</label>
//             <select
//               value={platformFee.type}
//               onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
//               className="modern-select"
//             >
//               <option value="fixed">Fixed Amount (₹)</option>
//               <option value="percentage">Percentage (%)</option>
//             </select>
//             <small className="helper-text">
//               {platformFee.type === 'fixed' 
//                 ? 'Charge a fixed amount per booking' 
//                 : 'Charge a percentage of the fare'}
//             </small>
//           </div>

//           {/* <div className="form-group">
//             <label className="input-label">
//               {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//             </label>
//             <input
//               type="number"
//               min="0"
//               step={platformFee.type === 'fixed' ? "1" : "0.1"}
//               value={platformFee.value}
//               onChange={(e) => onChange({ ...platformFee, value: parseFloat(e.target.value) || 0 })}
//               className="modern-input"
//               placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
//             />
            
//           </div> */}

//           <div className="form-group">
//   <label className="input-label">
//     {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//   </label>
//   <input
//     type="number"
//     min="0"
//     step={platformFee.type === 'fixed' ? "1" : "0.1"}
//     value={platformFee.value === 0 ? '' : platformFee.value}
//     onChange={(e) => {
//       const rawValue = e.target.value;
//       const value = rawValue === '' ? 0 : parseFloat(rawValue);
//       onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
//     }}
//     className="modern-input"
//     placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
//     style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//   />
// </div>

//           <div className="form-group">
//             <label className="input-label">Applicable On</label>
//             <select
//               value={platformFee.applicableOn}
//               onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
//               className="modern-select"
//             >
//               <option value="per_ticket">Per Ticket</option>
//               <option value="per_person">Per Person</option>
//               {/* <option value="total_booking">Total Booking Amount</option> */}
//             </select>
//             {/* <small className="helper-text">
//               {platformFee.applicableOn === 'per_ticket' && 'Fee applied on each ticket'}
//               {platformFee.applicableOn === 'per_seat' && 'Fee applied on each seat'}
//               {platformFee.applicableOn === 'total_booking' && 'Fee applied on total booking amount'}
//             </small> */}
//           </div>
//         </div>

//         {/* Preview/Calculation Example */}
//         {platformFee.value > 0 && (
//           <div className="fee-preview">
//             <div className="preview-title">Fee Calculation Preview:</div>
//             <div className="preview-details">
//               <span>
//                 {platformFee.type === 'fixed' 
//                   ? `₹${platformFee.value} ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
//                      platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`
//                   : `${platformFee.value}% of fare ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
//                      platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };
// const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);
//   const [cancellationTime, setCancellationTime] = useState({
//   hours: 1,
//   minutes: 0
// });

//    const [platformFee, setPlatformFee] = useState({
//     type: 'fixed',
//     value: 0,
//     applicableOn: 'per_ticket'
//   });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({
//     hours: 1,
//     minutes: 0
//   });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'Non-AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States - NEW: Source & Destination instead of RouteSelector
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Image States
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Add this new state alongside existing route states
// const [localRouteNameSearch, setLocalRouteNameSearch] = useState('');
// const [localRouteSearchLoading, setLocalRouteSearchLoading] = useState(false);

//   // Constants
//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // Add this function to handle cancellation time changes
// const handleCancellationTimeChange = (field, value) => {
//   setCancellationTime(prev => ({
//     ...prev,
//     [field]: parseInt(value) || 0
//   }));
// };

// // Add validation for cancellation time (add to validateBookingTime function or create new)
// const validateCancellationTime = () => {
//   const totalMinutes = (cancellationTime.hours * 60) + cancellationTime.minutes;
//   if (totalMinutes < 0) {
//     toast.error('Cancellation time cannot be negative');
//     return false;
//   }
//   if (cancellationTime.hours > 48) {
//     toast.error('Cancellation hours cannot exceed 48');
//     return false;
//   }
//   if (cancellationTime.minutes > 59) {
//     toast.error('Minutes cannot exceed 59');
//     return false;
//   }
  
//   // Optional: Validate against booking closed time
//   const bookingMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//   if (totalMinutes >= bookingMinutes) {
//     toast.warning('Cancellation time should be less than booking cut-off time for practical purposes');
//   }
//   return true;
// };

// // Add this new function alongside fetchRoutesBySourceDestination
// const fetchRoutesByLocalName = async (localName) => {
//   if (!localName || !localName.trim()) {
//     setAvailableRoutes([]);
//     return;
//   }

//   setLocalRouteSearchLoading(true);
//   setLoadingRoutes(true);
//   try {
//     const response = await getAllBusownerAdminRoutes(
//       token,
//       1,
//       50,
//       '',   // search
//       '',   // busOwnerId
//       {},   // no city filters
//       localName.trim()  // localRouteName ← NEW param
//     );

//     if (response && response.success && response.routes) {
//       setAvailableRoutes(response.routes);
//     } else {
//       setAvailableRoutes([]);
//     }
//   } catch (error) {
//     console.error('Error fetching routes by local name:', error);
//     toast.error('Failed to fetch routes');
//     setAvailableRoutes([]);
//   } finally {
//     setLocalRouteSearchLoading(false);
//     setLoadingRoutes(false);
//   }
// };

//   // Fetch routes based on source and destination
//   const fetchRoutesBySourceDestination = async () => {
//     if (!sourceCity || !destinationCity) {
//       setAvailableRoutes([]);
//       return;
//     }

//     setLoadingRoutes(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token,
//         1,
//         50,
//         '',
//         '',
//         { originCity: sourceCity, destinationCity: destinationCity }
//       );
      
//       if (response && response.success && response.routes) {
//         setAvailableRoutes(response.routes);
//       } else {
//         setAvailableRoutes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//       toast.error('Failed to fetch routes');
//       setAvailableRoutes([]);
//     } finally {
//       setLoadingRoutes(false);
//     }
//   };

//   // Add this useEffect alongside the existing city-based useEffect
// useEffect(() => {
//   const timer = setTimeout(() => {
//     if (localRouteNameSearch.trim()) {
//       // Clear city inputs when searching by local name
//       fetchRoutesByLocalName(localRouteNameSearch);
//     }
//   }, 500);
//   return () => clearTimeout(timer);
// }, [localRouteNameSearch]);

//   // Debounced fetch when source or destination changes
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   // Filter routes based on search term
//   const filteredRoutes = availableRoutes.filter(route =>
//     route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//     route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//   route.localRouteName?.toLowerCase().includes(routeSearchTerm.toLowerCase())  // ← ADD
//   );

//   const handleSelectRoute = (route) => {
//     setSelectedRoute(route);
//     setShowRouteDropdown(false);
//     setRouteSearchTerm('');
//     setFareMatrixUp([]);
//     setFareMatrixDown([]);
//   };

//   useEffect(() => {
//     const savedData = localStorage.getItem('pendingBusFormData');
//     if (savedData) {
//       const formData = JSON.parse(savedData);
//       if (window.confirm('You have unsaved bus data. Would you like to restore it?')) {
//         setForm(prev => ({
//           ...prev,
//           busNumber: formData.busNumber || '',
//           busName: formData.busName || '',
//           busType: formData.busType || 'AC',
//           busCategory: formData.busCategory || 'Seater',
//           amenities: formData.amenities || []
//         }));
//         setTripType(formData.tripType || 'oneWay');
//         setPricing(formData.pricing || { basePrice: '', baseDistance: '', costPerKm: '' });
//         setOperatingDays(formData.operatingDays || DAYS_OF_WEEK);
//         if (formData.bookingClosedBefore) {
//           setBookingClosedBefore(formData.bookingClosedBefore);
//         }
//         setSelectedConfiguration(formData.selectedConfiguration || '2*2');
//         localStorage.removeItem('pendingBusFormData');
//       } else {
//         localStorage.removeItem('pendingBusFormData');
//       }
//     }
//   }, []);

//   const handleAddNewRoute = () => {
//     const currentFormData = {
//       busNumber: form.busNumber,
//       busName: form.busName,
//       busType: form.busType,
//       busCategory: form.busCategory,
//       amenities: form.amenities,
//       tripType: tripType,
//       pricing: pricing,
//       operatingDays: operatingDays,
//       bookingClosedBefore: bookingClosedBefore,
//       selectedConfiguration: selectedConfiguration,
//     };
//     localStorage.setItem('pendingBusFormData', JSON.stringify(currentFormData));

//     toast.info('Redirecting to create route. Your current bus form data has been saved.');

//     navigate('/routes', {
//       state: {
//         returnTo: 'busowners',
//         ownerId: ownerId,
//         formData: currentFormData,
//         sourceCity: sourceCity,
//         destinationCity: destinationCity
//       }
//     });
//   };

//   const validateBookingTime = () => {
//     const totalMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//     if (totalMinutes < 0) {
//       toast.error('Booking close time cannot be negative');
//       return false;
//     }
//     if (bookingClosedBefore.hours > 24) {
//       toast.error('Booking close hours cannot exceed 24');
//       return false;
//     }
//     if (bookingClosedBefore.minutes > 59) {
//       toast.error('Minutes cannot exceed 59');
//       return false;
//     }
//     return true;
//   };

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({
//       ...prev,
//       [field]: parseInt(value) || 0
//     }));
//   };

//   // Fetch configurations when category changes
//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   const getCategoryMultiplier = () => {
//     const multipliers = {
//       'Seater': 1.0,
//       'Sleeper': 1.5,
//       'Seater+Sleeper': 1.3
//     };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);

//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;

//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') ||
//             cat.availableSeatTypes?.includes('seater')
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper')
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') ||
//             cat.availableSeatTypes?.includes('seat+sleeper')
//           );
//         }

//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           setSelectedConfiguration(configs[0]);
//           setLayoutTemplates([]);
//         } else {
//           setAvailableConfigurations([]);
//           setLayoutTemplates([]);
//           toast.info(`No configurations available for ${form.busCategory}`);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;

//       setLoadingLayouts(true);

//       let bustype = config.replace('x', '*');

//       const response = await getSeatLayoutsByBustype(bustype, token);

//       if (response && response.success) {
//         if (response.data && Array.isArray(response.data)) {
//           let filteredLayouts = response.data;

//           if (form.busCategory === 'Seater') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seat' || layout.seatType === 'seater'
//             );
//           } else if (form.busCategory === 'Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'sleeper'
//             );
//           } else if (form.busCategory === 'Seater+Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//             );
//           }

//           setLayoutTemplates(filteredLayouts);

//           if (filteredLayouts.length === 0) {
//             toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
//           }
//         } else {
//           setLayoutTemplates([]);
//           toast.info(`No layouts found for ${config} configuration`);
//         }
//       } else {
//         console.error('Failed to fetch layouts:', response);
//         setLayoutTemplates([]);
//         toast.error(response?.message || 'Failed to load seat layouts');
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const handleCategoryChange = (category) => {
//     setForm(prev => ({ ...prev, busCategory: category }));
//     setSelectedTemplate(null);
//     setActiveSeats([]);
//     setLayoutTemplates([]);
//     setCustomSeatLabels({});
//   };

//   // const handleImageUpload = (event) => {
//   //   const files = Array.from(event.target.files);
//   //   const newImages = [];

//   //   files.forEach(file => {
//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       newImages.push({
//   //         file: file,
//   //         preview: e.target.result,
//   //         name: file.name
//   //       });

//   //       if (newImages.length === files.length) {
//   //         setSelectedImages(prev => [...prev, ...newImages]);
//   //       }
//   //     };
//   //     reader.readAsDataURL(file);
//   //   });
//   // };

//   const handleImageUpload = (event) => {
//   const files = Array.from(event.target.files);
//   console.log('📸 Files selected for upload:', files.length);
  
//   const newImages = [];

//   files.forEach((file, index) => {
//     console.log(`File ${index + 1}: ${file.name} (${file.size} bytes, ${file.type})`);
    
//     // ✅ Ensure it's a valid file
//     if (!(file instanceof File)) {
//       console.error(`❌ File ${index + 1} is not a File object`);
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       newImages.push({
//         file: file, // Store the actual File object
//         preview: e.target.result, // Store preview URL for display
//         name: file.name,
//         size: file.size,
//         type: file.type
//       });

//       if (newImages.length === files.length) {
//         setSelectedImages(prev => [...prev, ...newImages]);
//         console.log(`✅ Added ${newImages.length} images. Total: ${selectedImages.length + newImages.length}`);
//       }
//     };
//     reader.onerror = (error) => {
//       console.error('❌ Error reading file:', error);
//     };
//     reader.readAsDataURL(file);
//   });
// };

//   const removeImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({
//           file: file,
//           preview: e.target.result,
//           name: file.name,
//           size: file.size
//         });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeVideo = () => {
//     setSelectedVideo(null);
//   };

//   const openTemplateSelector = () => {
//     if (!form.busCategory) {
//       toast.error('Please select a Bus Category first');
//       return;
//     }
//     if (!selectedConfiguration) {
//       toast.error('Please select a Bus Configuration first');
//       return;
//     }
//     if (layoutTemplates.length === 0) {
//       toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
//       return;
//     }
//     setShowTemplateModal(true);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setActiveSeats([]);
//     setBlockedSeats([]);
//     setCustomSeatLabels({});
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });

//     let counter = 1;
//     const newLabels = {};

//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });

//     setCustomSeatLabels(newLabels);
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day)
//         ? prev.filter(d => d !== day)
//         : [...prev, day]
//     );
//   };

// // const generateMatrixForRoute = (routeData) => {
// //   if (!routeData) return [];
 
// //   const baseP = parseFloat(pricing.basePrice) || 0;
// //   const baseD = parseFloat(pricing.baseDistance) || 0;
// //   const costK = parseFloat(pricing.costPerKm) || 0;
// //   const multiplier = getCategoryMultiplier();
 
// //   const sortedStops = [...(routeData.intermediateStops || [])]
// //     .sort((a, b) => a.sequence - b.sequence);
 
// //   // ✅ FIX 1: Store distances rounded to 1 decimal using integer math
// //   const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;
 
// //   const allStops = [
// //     {
// //       id: 'origin',
// //       name: routeData.origin?.city || 'Origin',
// //       distanceFromOrigin: 0,
// //       type: 'origin'
// //     },
// //     ...sortedStops.map((s, i) => ({
// //       id: s._id || `stop_${i}`,
// //       name: s.city || s.name || `Stop ${i + 1}`,
// //       distanceFromOrigin: toSafeDistance(s.distanceFromOrigin),
// //       type: 'stop',
// //       sequence: s.sequence
// //     })),
// //     {
// //       id: 'destination',
// //       name: routeData.destination?.city || 'Destination',
// //       distanceFromOrigin: toSafeDistance(
// //         routeData.destination?.distanceFromOrigin ||
// //         routeData.routeDetails?.totalDistance ||
// //         0
// //       ),
// //       type: 'destination'
// //     }
// //   ];
 
// //   const matrix = allStops.map((fromStop, i) => {
// //     const toCells = allStops.map((toStop, j) => {
// //       if (j > i) {
// //         // ✅ FIX 2: Use integer subtraction (×10) to avoid floating point drift
// //         // e.g., 178 - 0 = 178 exactly, not 177.9999...
// //         const fromInt = Math.round(fromStop.distanceFromOrigin * 10);
// //         const toInt   = Math.round(toStop.distanceFromOrigin * 10);
// //         const distance = (toInt - fromInt) / 10; // back to km with 1 decimal
 
// //         // ✅ FIX 3: Round extraDistance before multiplying to avoid drift
// //         let price = baseP;
// //         if (distance > baseD) {
// //           const extraDistance = Math.round((distance - baseD) * 10) / 10;
// //           price = baseP + (extraDistance * costK);
// //         }
 
// //         // ✅ FIX 4: Round AFTER applying multiplier
// //         price = Math.round(price * multiplier);
 
// //         return {
// //           toId: toStop.id,
// //           toName: toStop.name,
// //           distanceKm: distance,
// //           price: price
// //         };
// //       }
// //       return null;
// //     });
 
// //     return {
// //       fromId: fromStop.id,
// //       fromName: fromStop.name,
// //       fromType: fromStop.type,
// //       sequence: fromStop.sequence,
// //       toCells: toCells
// //     };
// //   });
 
// //   return matrix.filter(row => row.fromId !== 'destination');
// // };

// const generateMatrixForRoute = (routeData) => {
//   if (!routeData) return [];

//   const baseP = parseFloat(pricing.basePrice) || 0;
//   const baseD = parseFloat(pricing.baseDistance) || 0;
//   const costK = parseFloat(pricing.costPerKm) || 0;
//   const multiplier = getCategoryMultiplier();

//   const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;

//   const sortedStops = [...(routeData.intermediateStops || [])]
//     .sort((a, b) => a.sequence - b.sequence);

//   // Build raw stops
//   const rawStops = [
//     {
//       id: 'origin',
//       name: routeData.origin?.city || 'Origin',
//       rawDist: toSafeDistance(routeData.origin?.distanceFromOrigin || 0),
//       type: 'origin'
//     },
//     ...sortedStops.map((s, i) => ({
//       id: s._id || `stop_${i}`,
//       name: s.city || s.name || `Stop ${i + 1}`,
//       rawDist: toSafeDistance(s.distanceFromOrigin),
//       type: 'stop',
//       sequence: s.sequence
//     })),
//     {
//       id: 'destination',
//       name: routeData.destination?.city || 'Destination',
//       rawDist: toSafeDistance(
//         routeData.destination?.distanceFromOrigin ||
//         routeData.routeDetails?.totalDistance ||
//         0
//       ),
//       type: 'destination'
//     }
//   ];

//   // ✅ CORE FIX: Find min and max raw distances
//   const allRawDists = rawStops.map(s => s.rawDist);
//   const minDist = Math.min(...allRawDists);
//   const maxDist = Math.max(...allRawDists);

//   // Check if this is a descending route (DOWN) - origin has higher dist than destination
//   const originRaw = rawStops[0].rawDist;
//   const destRaw   = rawStops[rawStops.length - 1].rawDist;
//   const isDescending = destRaw < originRaw;

//   // Normalize every stop to 0-based ascending distance
//   const normalizedStops = rawStops.map(stop => ({
//     ...stop,
//     distanceFromOrigin: isDescending
//       ? toSafeDistance(maxDist - stop.rawDist)   // flip: high→0, low→high
//       : toSafeDistance(stop.rawDist - minDist)    // shift to 0-base
//   }));

//   // ✅ ALWAYS sort by normalized distance ascending — this is the key fix
//   // Without this sort, column indices don't match ascending distance order
//   // and j > i produces negative (toInt - fromInt) values
//   const allStops = normalizedStops.sort(
//     (a, b) => a.distanceFromOrigin - b.distanceFromOrigin
//   );

//   // Build matrix — with sorted stops, j > i ALWAYS means further stop
//   const matrix = allStops.map((fromStop, i) => {
//     const toCells = allStops.map((toStop, j) => {
//       if (j > i) {
//         const fromInt  = Math.round(fromStop.distanceFromOrigin * 10);
//         const toInt    = Math.round(toStop.distanceFromOrigin * 10);
//         // ✅ Math.abs as final safety — can never be negative after sort
//         const distance = Math.abs((toInt - fromInt) / 10);

//         let price = baseP;
//         if (distance > baseD) {
//           const extraDistance = Math.round((distance - baseD) * 10) / 10;
//           price = baseP + (extraDistance * costK);
//         }
//         price = Math.round(price * multiplier);

//         return {
//           toId: toStop.id,
//           toName: toStop.name,
//           distanceKm: distance,
//           price: price
//         };
//       }
//       return null;
//     });

//     return {
//       fromId: fromStop.id,
//       fromName: fromStop.name,
//       fromType: fromStop.type,
//       sequence: fromStop.sequence,
//       toCells: toCells
//     };
//   });

//   return matrix.filter(row => row.fromId !== 'destination');
// };

//   const handleGenerateMatrix = () => {
//     if (!selectedRoute) {
//       toast.error('Please select a Route first.');
//       return;
//     }

//     if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
//       toast.error("The selected route does not have return journey details configured.");
//       return;
//     }

//     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//       toast.error('Please fill all Pricing Fields.');
//       return;
//     }

//     const matrixUp = generateMatrixForRoute(selectedRoute);
//     setFareMatrixUp(matrixUp);

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//       setFareMatrixDown(matrixDown);
//     } else {
//       setFareMatrixDown([]);
//     }

//     toast.success(tripType === 'roundTrip'
//       ? "Both Fare Matrices Generated!"
//       : "Fare Matrix Generated!"
//     );
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = {
//           ...newToCells[colIndex],
//           price: parseInt(newPrice) || 0
//         };
//       }
//       return { ...row, toCells: newToCells };
//     });

//     if (isUp) {
//       setFareMatrixUp(updatedMatrix);
//     } else {
//       setFareMatrixDown(updatedMatrix);
//     }
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   // const handleSubmitBus = async () => {
//   //   try {
//   //     setIsSubmitting(true);
//   //     setError(null);

//   //     if (!validateBookingTime()) {
//   //       setIsSubmitting(false);
//   //       return;
//   //     }

//   //     if (!form.busNumber) throw new Error('Bus Number is required');
//   //     if (!form.busName) throw new Error('Bus Name is required');
//   //     if (!form.busType) throw new Error('Bus Type is required');
//   //     if (!form.busCategory) throw new Error('Bus Category is required');
//   //     if (!selectedRoute) throw new Error('Please select a route');
//   //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
//   //     if (!selectedTemplate) throw new Error('Please configure seat layout');
//   //     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

//   //     const amenitiesArray = form.amenities || [];

//   //     const finalSeatsPayload = selectedTemplate.seats
//   //       .filter(s => activeSeats.includes(s.seatNumber))
//   //       .map(s => {
//   //         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//   //         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//   //         const isBlocked = blockedSeats.includes(s.seatNumber);

//   //         return {
//   //           seatNumber: s.seatNumber,
//   //           globalSeatIndex: finalGlobalIndex,
//   //           row: s.row,
//   //           column: s.column,
//   //           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//   //           position: s.position || getSeatPosition(s.column),
//   //           isBlocked: isBlocked,
//   //           isAvailable: !isBlocked,
//   //         };
//   //       });

//   //     const seatConfigPayload = {
//   //       busType: selectedTemplate.configuration || '2*2',
//   //       totalSeats: activeSeats.length
//   //     };

//   //     const routeSchedules = [];
//   //     const routeIdToSave = selectedRoute._id || selectedRoute.id;

//   //     routeSchedules.push({
//   //       routeId: routeIdToSave,
//   //       direction: 'UP',
//   //       fareMatrix: fareMatrixUp,
//   //       operatingDays: operatingDays,
//   //       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//   //       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//   //     });

//   //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//   //       routeSchedules.push({
//   //         routeId: routeIdToSave,
//   //         direction: 'DOWN',
//   //         fareMatrix: fareMatrixDown,
//   //         operatingDays: operatingDays,
//   //         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//   //         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//   //       });
//   //     }

//   //     const fareDetails = {
//   //       basePrice: parseFloat(pricing.basePrice) || 0,
//   //       baseDistance: parseFloat(pricing.baseDistance) || 0,
//   //       costPerKm: parseFloat(pricing.costPerKm) || 0
//   //     };

//   //     const formData = new FormData();

//   //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//   //     formData.append('busName', form.busName.trim());
//   //     formData.append('busType', form.busType);
//   //     formData.append('busCategory', form.busCategory);
//   //     formData.append('totalSeats', String(activeSeats.length));
//   //     formData.append('tripType', tripType);
//   //     formData.append('busClass', 'Economy');

//   //     formData.append('amenities', JSON.stringify(amenitiesArray));
//   //     formData.append('seats', JSON.stringify(finalSeatsPayload));
//   //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//   //     formData.append('routeSchedules', JSON.stringify(routeSchedules));
//   //     formData.append('fareDetails', JSON.stringify(fareDetails));
//   //     formData.append('operatingDays', JSON.stringify(operatingDays));
//   //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));

//   //     selectedImages.forEach((img, index) => {
//   //       if (img.file) {
//   //         formData.append('images', img.file);
//   //       }
//   //     });

//   //     if (selectedVideo && selectedVideo.file) {
//   //       formData.append('videos', selectedVideo.file);
//   //     }

//   //     const response = await addBusToOwner(ownerId, formData, token);

//   //     if (response && response.success) {
//   //       toast.success(tripType === 'roundTrip'
//   //         ? 'Bus added successfully with round trip routes!'
//   //         : 'Bus added successfully!'
//   //       );
//   //       onBusAdded();
//   //       onClose();
//   //     } else {
//   //       throw new Error(response?.message || 'Failed to add bus');
//   //     }

//   //   } catch (err) {
//   //     console.error('Error adding bus:', err);
//   //     setError(err.message || 'Failed to add bus');
//   //     toast.error(err.message || 'Failed to add bus');
//   //   } finally {
//   //     setIsSubmitting(false);
//   //   }
//   // };

// //   const handleSubmitBus = async () => {
// //   try {
// //     setIsSubmitting(true);
// //     setError(null);

// //     if (!validateBookingTime()) {
// //       setIsSubmitting(false);
// //       return;
// //     }

// //         if (!validateCancellationTime()) {
// //       setIsSubmitting(false);
// //       return;
// //     }

// //     if (!form.busNumber) throw new Error('Bus Number is required');
// //     if (!form.busName) throw new Error('Bus Name is required');
// //     if (!form.busType) throw new Error('Bus Type is required');
// //     if (!form.busCategory) throw new Error('Bus Category is required');
// //     if (!selectedRoute) throw new Error('Please select a route');
// //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
// //     if (!selectedTemplate) throw new Error('Please configure seat layout');
// //     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

// //     const amenitiesArray = form.amenities || [];

// //     const finalSeatsPayload = selectedTemplate.seats
// //       .filter(s => activeSeats.includes(s.seatNumber))
// //       .map(s => {
// //         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
// //         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
// //         const isBlocked = blockedSeats.includes(s.seatNumber);

// //         return {
// //           seatNumber: s.seatNumber,
// //           globalSeatIndex: finalGlobalIndex,
// //           row: s.row,
// //           column: s.column,
// //           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
// //           position: s.position || getSeatPosition(s.column),
// //           isBlocked: isBlocked,
// //           isAvailable: !isBlocked,
// //         };
// //       });

// //     const seatConfigPayload = {
// //       busType: selectedTemplate.configuration || '2*2',
// //       totalSeats: activeSeats.length
// //     };

// //     const routeSchedules = [];
// //     const routeIdToSave = selectedRoute._id || selectedRoute.id;

// //     routeSchedules.push({
// //       routeId: routeIdToSave,
// //       direction: 'UP',
// //       fareMatrix: fareMatrixUp,
// //       operatingDays: operatingDays,
// //       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
// //       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
// //     });

// //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //       routeSchedules.push({
// //         routeId: routeIdToSave,
// //         direction: 'DOWN',
// //         fareMatrix: fareMatrixDown,
// //         operatingDays: operatingDays,
// //         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
// //         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
// //       });
// //     }

// //     const fareDetails = {
// //       basePrice: parseFloat(pricing.basePrice) || 0,
// //       baseDistance: parseFloat(pricing.baseDistance) || 0,
// //       costPerKm: parseFloat(pricing.costPerKm) || 0
// //     };

// //     // Platform Fee object
// //     const platformFeeData = {
// //       type: platformFee.type,
// //       value: platformFee.value,
// //       applicableOn: platformFee.applicableOn
// //     };

// //     const formData = new FormData();

// //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
// //     formData.append('busName', form.busName.trim());
// //     formData.append('busType', form.busType);
// //     formData.append('busCategory', form.busCategory);
// //     formData.append('totalSeats', String(activeSeats.length));
// //     formData.append('tripType', tripType);
// //     formData.append('busClass', 'Economy');

// //     formData.append('cancellationTime', JSON.stringify(cancellationTime));

// //     formData.append('amenities', JSON.stringify(amenitiesArray));
// //     formData.append('seats', JSON.stringify(finalSeatsPayload));
// //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
// //     formData.append('routeSchedules', JSON.stringify(routeSchedules));
// //     formData.append('fareDetails', JSON.stringify(fareDetails));
// //     formData.append('operatingDays', JSON.stringify(operatingDays));
// //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
    
// //     // Append platform fee data
// //     formData.append('platformFee', JSON.stringify(platformFeeData));

// //     selectedImages.forEach((img, index) => {
// //       if (img.file) {
// //         formData.append('images', img.file);
// //       }
// //     });

// //     if (selectedVideo && selectedVideo.file) {
// //       formData.append('videos', selectedVideo.file);
// //     }

// //     const response = await addBusToOwner(ownerId, formData, token);

// //     if (response && response.success) {
// //       toast.success(tripType === 'roundTrip'
// //         ? 'Bus added successfully with round trip routes!'
// //         : 'Bus added successfully!'
// //       );
// //       onBusAdded();
// //       onClose();
// //     } else {
// //       throw new Error(response?.message || 'Failed to add bus');
// //     }

// //   } catch (err) {
// //     console.error('Error adding bus:', err);
// //     setError(err.message || 'Failed to add bus');
// //     toast.error(err.message || 'Failed to add bus');
// //   } finally {
// //     setIsSubmitting(false);
// //   }
// // };

// const handleSubmitBus = async () => {
//   try {
//     setIsSubmitting(true);
//     setError(null);

//     // ✅ DEBUG: Log selected images before submit
//     console.log('=== SUBMIT BUS DEBUG ===');
//     console.log('Selected images count:', selectedImages.length);
//     console.log('Selected video:', selectedVideo ? selectedVideo.name : 'None');
    
//     if (selectedImages.length > 0) {
//       selectedImages.forEach((img, i) => {
//         console.log(`Image ${i + 1}:`, img.file ? `${img.file.name} (${img.file.size} bytes, ${img.file.type})` : 'No file object');
//       });
//     }

//     // Validation
//     if (!validateBookingTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//     if (!validateCancellationTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//     if (!form.busNumber) throw new Error('Bus Number is required');
//     if (!form.busName) throw new Error('Bus Name is required');
//     if (!form.busType) throw new Error('Bus Type is required');
//     if (!form.busCategory) throw new Error('Bus Category is required');
//     if (!selectedRoute) throw new Error('Please select a route');
//     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
//     if (!selectedTemplate) throw new Error('Please configure seat layout');
//     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

//     // ⚠️ Warning if no images (but don't block submission)
//     if (selectedImages.length === 0) {
//       toast.warning('No images selected. It\'s recommended to add bus images.');
//     }

//     // Prepare data
//     const amenitiesArray = form.amenities || [];

//     const finalSeatsPayload = selectedTemplate.seats
//       .filter(s => activeSeats.includes(s.seatNumber))
//       .map(s => {
//         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//         const isBlocked = blockedSeats.includes(s.seatNumber);

//         return {
//           seatNumber: s.seatNumber,
//           globalSeatIndex: finalGlobalIndex,
//           row: s.row,
//           column: s.column,
//           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//           position: s.position || getSeatPosition(s.column),
//           isBlocked: isBlocked,
//           isAvailable: !isBlocked,
//         };
//       });

//     const seatConfigPayload = {
//       busType: selectedTemplate.configuration || '2*2',
//       totalSeats: activeSeats.length
//     };

//     const routeSchedules = [];
//     const routeIdToSave = selectedRoute._id || selectedRoute.id;

//     routeSchedules.push({
//       routeId: routeIdToSave,
//       direction: 'UP',
//       fareMatrix: fareMatrixUp,
//       operatingDays: operatingDays,
//       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//     });

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       routeSchedules.push({
//         routeId: routeIdToSave,
//         direction: 'DOWN',
//         fareMatrix: fareMatrixDown,
//         operatingDays: operatingDays,
//         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//       });
//     }

//     const fareDetails = {
//       basePrice: parseFloat(pricing.basePrice) || 0,
//       baseDistance: parseFloat(pricing.baseDistance) || 0,
//       costPerKm: parseFloat(pricing.costPerKm) || 0
//     };

//     const platformFeeData = {
//       type: platformFee.type,
//       value: platformFee.value,
//       applicableOn: platformFee.applicableOn
//     };

//     // ✅ CREATE FORMDATA
//     const formData = new FormData();

//     // ✅ Append all text fields
//     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//     formData.append('busName', form.busName.trim());
//     formData.append('busType', form.busType);
//     formData.append('busCategory', form.busCategory);
//     formData.append('totalSeats', String(activeSeats.length));
//     formData.append('tripType', tripType);
//     formData.append('busClass', 'Economy');
//     formData.append('cancellationTime', JSON.stringify(cancellationTime));
//     formData.append('amenities', JSON.stringify(amenitiesArray));
//     formData.append('seats', JSON.stringify(finalSeatsPayload));
//     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//     formData.append('routeSchedules', JSON.stringify(routeSchedules));
//     formData.append('fareDetails', JSON.stringify(fareDetails));
//     formData.append('operatingDays', JSON.stringify(operatingDays));
//     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//     formData.append('platformFee', JSON.stringify(platformFeeData));

//     // ✅ APPEND IMAGES - Using for loop instead of forEach with await
//     console.log('📸 Appending images to FormData...');
//     let imageAppendedCount = 0;
    
//     // ✅ Use a simple for loop instead of forEach to avoid async issues
//     for (let i = 0; i < selectedImages.length; i++) {
//       const img = selectedImages[i];
//       if (img.file) {
//         // Make sure it's a valid File object
//         if (img.file instanceof File || img.file instanceof Blob) {
//           formData.append('images', img.file);
//           imageAppendedCount++;
//           console.log(`✅ Appended image ${i + 1}: ${img.file.name} (${img.file.size} bytes)`);
//         } else {
//           console.error(`❌ Image ${i + 1} is not a valid File object:`, img.file);
//         }
//       }
//     }

//     console.log(`📸 Total images appended: ${imageAppendedCount}`);

//     // ✅ APPEND VIDEOS
//     if (selectedVideo && selectedVideo.file) {
//       if (selectedVideo.file instanceof File || selectedVideo.file instanceof Blob) {
//         formData.append('videos', selectedVideo.file);
//         console.log(`🎬 Appended video: ${selectedVideo.file.name} (${selectedVideo.file.size} bytes)`);
//       } else {
//         console.error('❌ Video is not a valid File object:', selectedVideo.file);
//       }
//     }

//     // ✅ DEBUG: Log all FormData entries (for debugging)
//     console.log('=== FORMDATA ENTRIES ===');
//     for (let [key, value] of formData.entries()) {
//       if (key === 'images' || key === 'videos') {
//         console.log(`${key}: ${value.name} (${value.size} bytes, ${value.type})`);
//       } else {
//         const stringValue = typeof value === 'string' ? value : String(value);
//         console.log(`${key}: ${stringValue.substring(0, 100)}${stringValue.length > 100 ? '...' : ''}`);
//       }
//     }

//     // ✅ Log the actual FormData for debugging
//     console.log('FormData size:', formData.getAll('images').length, 'images');
    
//     // ✅ SEND REQUEST
//     const response = await addBusToOwner(ownerId, formData, token);

//     console.log('=== RESPONSE ===', response);

//     if (response && response.success) {
//       toast.success(tripType === 'roundTrip'
//         ? 'Bus added successfully with round trip routes!'
//         : 'Bus added successfully!'
//       );
//       onBusAdded();
//       onClose();
//     } else {
//       throw new Error(response?.message || 'Failed to add bus');
//     }

//   } catch (err) {
//     console.error('❌ Error adding bus:', err);
//     setError(err.message || 'Failed to add bus');
//     toast.error(err.message || 'Failed to add bus');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || currentMatrix.length === 0) return null;

//     const sortedStops = [...(currentRoute.intermediateStops || [])]
//       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//     const allStops = [
//       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
//       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
//       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
//     ];

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">
//           {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//         </h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="from-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th className="price-cell" key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                         <span className="stop-type">{stop.type}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td
//                       className="from-cell"
//                       style={{ backgroundColor: getStopColor(row.fromType) }}
//                     >
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                         <span className="stop-type">{row.fromType}</span>
//                       </div>
//                     </td>
//                     {row.toCells.map((cell, colIndex) => {
//                       if (cell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{cell.distanceKm} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="number"
//                                   className="matrix-input"
//                                   value={cell.price}
//                                   onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//                                   min="0"
//                                   step="1"
//                                 />
//                               </div>
//                             </div>
//                            </td>
//                         );
//                       }
//                       return <td key={colIndex} className="na-cell">—</td>;
//                     })}
//                    </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return null;

//     const { seats, configuration } = selectedTemplate;

//     let leftCount = 2, rightCount = 2;
//     try {
//       if (configuration && configuration.includes('*')) {
//         const parts = configuration.split('*');
//         leftCount = parseInt(parts[0]) || 2;
//         rightCount = parseInt(parts[1]) || 2;
//       }
//     } catch (e) {
//       leftCount = 2;
//       rightCount = 2;
//     }

//     const totalConfigCols = leftCount + rightCount;

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) {
//         seatsByRow[seat.row] = [];
//       }
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const isSleeper = seatObj.seatType === 'sleeper' ||
//         seatObj.seatType === 'seat+sleeper' ||
//         selectedTemplate.seatType === 'sleeper' ||
//         selectedTemplate.seatType === 'seater+sleeper';

//       const displayLabel = isSelected
//         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
//         : "";

//       let seatClass = '';
//       if (isSelected) {
//         seatClass = isBlocked ? 'blocked' : 'selected';
//       } else {
//         seatClass = 'inactive';
//       }

//       return (
//         <button
//           key={seatObj.seatNumber}
//           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)}
//           type="button"
//         >
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];

//       const isBackRow = seatsInRow.some(s => s.position === 'back') ||
//         seatsInRow.length > totalConfigCols;

//       if (isBackRow) {
//         const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row back-row">
//             <div className="seats-container">
//               {sortedSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       } else {
//         const leftSeats = seatsInRow
//           .filter(s => (s.column || 0) <= leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         const rightSeats = seatsInRow
//           .filter(s => (s.column || 0) > leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row">
//             <div className="left-seats">
//               {leftSeats.map(seat => renderSeat(seat))}
//             </div>
//             <div className="aisle">Aisle</div>
//             <div className="right-seats">
//               {rightSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       }
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header">
//           <div className="driver-area">Driver</div>
//           <div className="bus-info">
//             <span className="bus-config">{selectedTemplate.configuration}</span>
//             <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
//           </div>
//         </div>
//         <div className="bus-body">
//           {rows}
//         </div>
//         <div className="seat-legend">
//           <div className="legend-item">
//             <div className="seat-sample selected"></div>
//             <span>Active Seat ({activeSeats.length})</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample inactive"></div>
//             <span>Inactive Seat</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample sleeper"></div>
//             <span>Sleeper</span>
//           </div>
//         </div>
//         <div className="seat-summary">
//           <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
//         </div>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">1</div>
//         <div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">2</div>
//         <div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">3</div>
//         <div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div>
//         <div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Bus Information</h3>
//         <p className="section-subtitle">Enter basic details about the bus</p>
//       </div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🚌</span>
//             Bus Number *
//           </label>
//           <input
//             type="text"
//             value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             placeholder="e.g., WB01AB1234"
//             className="modern-input"
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🏷️</span>
//             Bus Name *
//           </label>
//           <input
//             type="text"
//             value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             placeholder="e.g., Volvo Multi-Axle"
//             className="modern-input"
//             required
//           />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🖼️</span>
//           Bus Images
//         </h4>
//         <div className="images-upload-area">
//           <input
//             type="file"
//             id="bus-images"
//             multiple
//             accept="image/*"
//             onChange={handleImageUpload}
//             className="image-upload-input"
//             style={{ display: 'none' }}
//           />
//           <label htmlFor="bus-images" className="image-upload-label">
//             <span className="upload-icon">📁</span>
//             <span className="upload-text">Click to upload images</span>
//             <span className="upload-hint">Upload multiple images (max 10)</span>
//           </label>

//           {selectedImages.length > 0 && (
//             <div className="selected-images-preview">
//               <h5>Selected Images ({selectedImages.length})</h5>
//               <div className="images-grid">
//                 {selectedImages.map((image, index) => (
//                   <div key={index} className="image-preview-item">
//                     <img
//                       src={image.preview}
//                       alt={`Bus ${index + 1}`}
//                       className="preview-image"
//                     />
//                     <button
//                       type="button"
//                       className="remove-image-btn"
//                       onClick={() => removeImage(index)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* <div className="video-upload-section" style={{ marginTop: '15px' }}>
//             <input
//               type="file"
//               id="bus-video"
//               accept="video/*"
//               onChange={handleVideoUpload}
//               className="video-upload-input"
//               style={{ display: 'none' }}
//             />
//             <label htmlFor="bus-video" className="video-upload-label">
//               <span className="upload-icon">🎥</span>
//               <span className="upload-text">Click to upload video</span>
//               <span className="upload-hint">Upload one video (optional)</span>
//             </label>

//             {selectedVideo && (
//               <div className="selected-video-preview">
//                 <div className="video-info">
//                   <span className="video-name">{selectedVideo.name}</span>
//                   <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
//                 </div>
//                 <button
//                   type="button"
//                   className="remove-video-btn"
//                   onClick={removeVideo}
//                 >
//                   Remove
//                 </button>
//               </div>
//             )}
//           </div> */}
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">🔧</span>
//             Bus Type *
//           </label>
//           <select
//             value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_TYPES.map(type => (
//               <option key={type} value={type}>{type}</option>
//             ))}
//           </select>
//         </div>

//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">📊</span>
//             Bus Category *
//           </label>
//           <select
//             value={form.busCategory}
//             onChange={(e) => handleCategoryChange(e.target.value)}
//             className="modern-select"
//           >
//             <option value="">Select Category</option>
//             {BUS_CATEGORIES.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">⏰</span>
//           Booking Cut-off Time
//         </h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label className="input-label">Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="24"
//                 value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label className="input-label">Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="59"
//                 value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//       </div>

// <div className="section-card">
//   <h4 className="card-title">
//     <span className="title-icon">⏰</span>
//     Cancellation Time
//   </h4>
//   <div className="booking-time-container">
//     <div className="time-input-group">
//       <label className="input-label">Hours before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="48"
//           value={cancellationTime.hours}
//           onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">hours</span>
//       </div>
//     </div>
//     <div className="time-input-group">
//       <label className="input-label">Minutes before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="59"
//           value={cancellationTime.minutes}
//           onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">minutes</span>
//       </div>
//     </div>
//   </div>
//   <small className="helper-text">
//     Cancellation allowed up to this time before departure
//   </small>
// </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">✨</span>
//           Amenities
//         </h4>
//         <div className="amenities-grid compact">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-option compact">
//               <input
//                 type="checkbox"
//                 checked={form.amenities.includes(amenity)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: [...prev.amenities, amenity]
//                     }));
//                   } else {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: prev.amenities.filter(a => a !== amenity)
//                     }));
//                   }
//                 }}
//                 className="amenity-checkbox"
//               />
//               <span className="amenity-content">
//                 <span className="amenity-icon">✓</span>
//                 <span className="amenity-label">{amenity}</span>
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           className="modern-btn primary full-width"
//           onClick={() => setActiveTab('route')}
//           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
//         >
//           Continue to Route & Pricing
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Route & Pricing Configuration</h3>
//         <p className="section-subtitle">Select source, destination and configure pricing for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔄</span>
//           Trip Type
//         </h4>
//         <div className="trip-type-container">
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}
//           >
//             <span className="btn-icon">➡️</span>
//             One Way
//           </button>
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}
//           >
//             <span className="btn-icon">🔄</span>
//             Round Trip
//           </button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📍</span>
//           Source & Destination
//         </h4>
        
//         <div className="form-row">
//           <div className="form-group">
//             <label className="input-label">Source City *</label>
//             <input
//               type="text"
//               value={sourceCity}
//               onChange={(e) => {
//                 setSourceCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter source city"
//               className="modern-input"
//             />
//           </div>
    
//           <div className="form-group">
//             <label className="input-label">Destination City *</label>
//             <input
//               type="text"
//               value={destinationCity}
//               onChange={(e) => {
//                 setDestinationCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter destination city"
//               className="modern-input"
//             />
//           </div>

//        {/* Replace the existing OR search form-group */}
// <div className="form-group" style={{ marginTop: '10px' }}>
//   <label className="input-label">— OR — Search by Local Route Name</label>
//   <div style={{ position: 'relative' }}>
//     <input
//       type="text"
//       value={localRouteNameSearch}
//       onChange={(e) => {
//         const val = e.target.value;
//         setLocalRouteNameSearch(val);
//         setSelectedRoute(null);
//         // Clear city fields when using local name search
//         if (val.trim()) {
//           setSourceCity('');
//           setDestinationCity('');
//         }
//       }}
//       placeholder="e.g. Panskura to Bagnan local name..."
//       className="modern-input"
//     />
//     {localRouteSearchLoading && (
//       <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//         <div className="spinner-small"></div>
//       </div>
//     )}
//   </div>
//   <small className="helper-text">
//     Search routes directly by local name without entering city filters
//   </small>
// </div>
//         </div>
//       </div>

//       {/* {sourceCity && destinationCity && ( */}
//       {(sourceCity && destinationCity || availableRoutes.length > 0) && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">🗺️</span>
//             Select Route
//           </h4>
          
//           <div className="route-selector">
//   <label className="input-label">Available Routes *</label>
//   <div className="route-dropdown-container">
//     <input
//       type="text"
//       value={selectedRoute ? `${selectedRoute.localRouteName ? `${selectedRoute.localRouteName} - ` : ''}${selectedRoute.routeName}` : routeSearchTerm}
//       onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//       onChange={(e) => {
//         setRouteSearchTerm(e.target.value);
//         setShowRouteDropdown(true);
//         if (selectedRoute) setSelectedRoute(null);
//       }}
//       placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//       className="modern-input"
//       disabled={loadingRoutes}
//       style={{ cursor: 'pointer' }}
//     />
//     {loadingRoutes && (
//       <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//         <div className="spinner-small"></div>
//       </div>
//     )}
    
//     {showRouteDropdown && availableRoutes.length > 0 && (
//       <div className="route-dropdown">
//         <div className="dropdown-search">
//           <input
//             type="text"
//             value={routeSearchTerm}
//             onChange={(e) => setRouteSearchTerm(e.target.value)}
//             placeholder="Search routes..."
//             className="dropdown-search-input"
//             autoFocus
//           />
//         </div>
//         <div className="dropdown-list">
//           {filteredRoutes.length === 0 ? (
//             <div className="dropdown-empty">No matching routes</div>
//           ) : (
//             filteredRoutes.map((route) => (
//               <div
//                 key={route._id}
//                 className="dropdown-item"
//                 onClick={() => handleSelectRoute(route)}
//               >
//                <div className="route-number">
//   {route.localRouteName ? (
//     <div className="route-name-stack">
//       <div className="local-route-name">{route.localRouteName}</div>
//       <div className="route-name">{route.routeName}</div>
//     </div>
//   ) : (
//     <div className="route-name">{route.routeName}</div>
//   )}
// </div>
//                 <div className="route-details">
//                   {route.origin?.city} → {route.destination?.city} • 
//                   {route.isRoundTrip ? ' Round Trip' : ' One Way'} • 
//                   {route.routeDetails?.totalDistance || 0} km
//                 </div>
//                 {route.creatorType === 'BusOwner' && (
//                   <span className="owner-badge">Owner</span>
//                 )}
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     )}
//   </div>
  
//   {availableRoutes.length === 0 && sourceCity && destinationCity && !loadingRoutes && (
//     <div className="no-routes-message">
//       <p>No routes found for {sourceCity} → {destinationCity}</p>
//       <button type="button" onClick={handleAddNewRoute} className="create-route-btn">
//         + Create New Route
//       </button>
//     </div>
//   )}
  
//   {selectedRoute && selectedRoute.isRoundTrip && (
//     <small className="helper-text">✓ Round trip route selected - both UP and DOWN matrices will be generated</small>
//   )}
// </div>
//         </div>
//       )}

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📅</span>
//           Operating Days *
//         </h4>
//         <div className="days-grid compact">
//           {DAYS_OF_WEEK.map(day => (
//             <button
//               key={day}
//               type="button"
//               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}
//               title={day}
//             >
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//         <div className="selected-days">
//           Selected: {operatingDays.length} days
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💰</span>
//           Pricing Configuration
//         </h4>

//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>

//         {selectedRoute && (
//           <div className="pricing-summary">
//             <div className="summary-item">
//               <span>Category Multiplier:</span>
//               <span className="value accent">{getCategoryMultiplier()}x</span>
//             </div>
//             <div className="summary-item">
//               <span>Route Distance:</span>
//               <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
//             </div>
//           </div>
//         )}
//       </div>

//        <PlatformFeeConfig 
//       platformFee={platformFee} 
//       onChange={setPlatformFee} 
//     />

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('basic')}
//         >
//           ← Back
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary generate-matrix-btn"
//           onClick={() => {
//             handleGenerateMatrix();
//             if (fareMatrixUp.length > 0) {
//               setActiveTab('matrix');
//             }
//           }}
//           disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
//         >
//           Generate Fare Matrix
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Fare Matrix Configuration</h3>
//         <p className="section-subtitle">Review and edit fares for each route</p>
//       </div>

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}
//           >
//             Up Route: {selectedRoute.routeName}
//           </button>
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}
//           >
//             Down Route: Return Route
//           </button>
//         </div>
//       )}

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
//         <>
//           {activeMatrixTab === 'up' && renderMatrix('up')}
//           {activeMatrixTab === 'down' && renderMatrix('down')}
//         </>
//       ) : (
//         renderMatrix('up')
//       )}

//       <div className="matrix-info">
//         <div className="info-card">
//           <div className="info-item">
//             <span className="label">Total Stops:</span>
//             <span className="value">
//               {selectedRoute ?
//                 (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
//             </span>
//           </div>
//           <div className="info-item">
//             <span className="label">Category Multiplier:</span>
//             <span className="value accent">{getCategoryMultiplier()}x</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Base Price:</span>
//             <span className="value">₹{pricing.basePrice}</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Cost/km:</span>
//             <span className="value">₹{pricing.costPerKm}</span>
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('route')}
//         >
//           ← Back to Pricing
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={() => setActiveTab('seats')}
//           disabled={fareMatrixUp.length === 0}
//         >
//           Continue to Seat Layout
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Seat Layout Configuration</h3>
//         <p className="section-subtitle">Configure seat layout for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔧</span>
//           Bus Configuration
//         </h4>
//         <div className="config-selector">
//           <label className="input-label">Select Bus Configuration *</label>
//           {loadingLayouts ? (
//             <div className="loading-configs">
//               <span>Loading configurations...</span>
//             </div>
//           ) : (
//             <>
//               <div className="config-buttons">
//                 {availableConfigurations.map(config => (
//                   <button
//                     key={config}
//                     type="button"
//                     className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//                     onClick={() => {
//                       setSelectedConfiguration(config);
//                       setSelectedTemplate(null);
//                       setActiveSeats([]);
//                       setCustomSeatLabels({});
//                       fetchLayouts(config);
//                     }}
//                   >
//                     {config}
//                   </button>
//                 ))}
//               </div>
//               <small className="helper-text">
//                 {form.busCategory} bus with {selectedConfiguration} configuration
//               </small>
//             </>
//           )}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💺</span>
//           Seat Layout Template
//         </h4>

//         {!selectedTemplate ? (
//           <button
//             type="button"
//             className="modern-btn outline full-width"
//             onClick={openTemplateSelector}
//             disabled={loadingLayouts}
//           >
//             {loadingLayouts ? (
//               <>
//                 <span className="btn-icon">⏳</span>
//                 Loading Layouts...
//               </>
//             ) : (
//               <>
//                 <span className="btn-icon">📋</span>
//                 Select Layout Template
//               </>
//             )}
//           </button>
//         ) : (
//           <div className="selected-template-info">
//             <div className="template-details">
//               <span className="template-name">{selectedTemplate.name}</span>
//               <span className="template-config">{selectedTemplate.configuration}</span>
//               <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
//               <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
//             </div>
//             <button
//               type="button"
//               className="btn-small"
//               onClick={() => {
//                 setSelectedTemplate(null);
//                 setActiveSeats([]);
//                 setCustomSeatLabels({});
//               }}
//             >
//               Change
//             </button>
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">👁️</span>
//             Seat Layout Visualizer
//           </h4>
//           <button
//             type="button"
//             className="view-layout-btn"
//             onClick={() => setShowLayoutModal(true)}
//           >
//             View / Edit Seat Numbers
//           </button>

//           <div className="seat-summary">
//             <div className="summary-item">
//               <span>Total Seats in Template:</span>
//               <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
//             </div>
//             <div className="summary-item">
//               <span>Active Seats:</span>
//               <span className="value accent">{activeSeats.length}</span>
//             </div>
//             <div className="summary-item">
//               <span>Inactive Seats:</span>
//               <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('matrix')}
//         >
//           ← Back to Matrix
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={handleSubmitBus}
//           disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
//         >
//           {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
//           <span className="btn-icon">✓</span>
//         </button>
//       </div>
//     </div>
//   );

//   // Layout Modal and other modals remain the same...
//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Seat Numbers</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
//           <div className="seat-legend three-items">
//             <div className="legend-item">
//               <div className="seat-sample selected"></div>
//               <span>Active</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample blocked"></div>
//               <span>Blocked</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample inactive"></div>
//               <span>Disabled</span>
//             </div>
//           </div>
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <span>Total: {activeSeats.length}</span>
//             <div className="footer-actions">
//               <button className="auto-number-btn" onClick={autoRenumberSeats}>
//                 Auto-Number
//               </button>
//               <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Seat Layout Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {loadingLayouts ? (
//             <div className="loading-container">
//               <p>Loading templates...</p>
//             </div>
//           ) : layoutTemplates.length === 0 ? (
//             <div className="no-templates">
//               <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
//               <p className="hint">Available configurations with layouts:</p>
//               <div className="available-configs">
//                 {availableConfigurations.map(config => (
//                   <span key={config} className="config-chip">{config}</span>
//                 ))}
//               </div>
//               <p className="hint">Try selecting a different configuration</p>
//             </div>
//           ) : (
//             <div className="templates-grid">
//               {layoutTemplates.map(template => (
//                 <button
//                   type="button"
//                   key={template._id}
//                   className="template-card"
//                   onClick={() => handleSelectTemplate(template)}
//                 >
//                   <h4 className="template-name">{template.name}</h4>
//                   <div className="template-details">
//                     <span className="config">Config: {template.configuration}</span>
//                     <span className="seats">Seats: {template.totalSeats}</span>
//                   </div>
//                   <div className="template-preview">
//                     <span className="rows">Rows: {template.rows}</span>
//                     <span className="cols">Cols: {template.columns}</span>
//                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" style={{    "max-width": "500px",
//     "max-height": "35vh"}} onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Set Seat Label</h3>
//         </div>
//         <div className="modal-body">
//           <input
//             type="text"
//             value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="e.g. 1 or 1A"
//             className="seat-input"
//             autoFocus
//           />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button
//             className="modal-action-btn active-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Active
//           </button>
          
//           <button
//             className="modal-action-btn block-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               if (!blockedSeats.includes(editingSeat)) {
//                 setBlockedSeats([...blockedSeats, editingSeat]);
//               }
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Block
//           </button>
//           <button
//             className="modal-action-btn disable-btn"
//             onClick={() => {
//               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setEditingSeat(null);
//             }}
//           >
//             Disable
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">
//               <span className="title-icon">🚌</span>
//               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
//             </h2>
//             <p className="modal-subtitle">Configure bus details with route selection</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>
//             <span className="close-icon">×</span>
//           </button>
//         </div>

//         <div className="modal-body modern">
//           <ProgressSteps />

//           <div className="tab-container">
//             {activeTab === 'basic' && renderBasicInfoTab()}
//             {activeTab === 'route' && renderRouteTab()}
//             {activeTab === 'matrix' && renderMatrixTab()}
//             {activeTab === 'seats' && renderSeatLayoutTab()}
//           </div>

//           {error && (
//             <div className="error-message modern">
//               <span className="error-icon">⚠️</span>
//               {error}
//             </div>
//           )}
//         </div>
//       </div>

//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };
// const BusOwnerManage = () => {
//   const { token } = useSelector(state => state.user);
//   const [busOwners, setBusOwners] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingOwner, setEditingOwner] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingOwner, setViewingOwner] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showAddBusModal, setShowAddBusModal] = useState(false);
//   const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
//   const [busSearchTerm, setBusSearchTerm] = useState('');
//   const [newOwner, setNewOwner] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     companyName: ''
//   });
//   const [error, setError] = useState(null);
//   const [busUpdateTrigger, setBusUpdateTrigger] = useState(0);

//   // Bus Management states - UPDATED for new modal
//   const [showBusManagement, setShowBusManagement] = useState(false);
//   const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
//   const [selectedOwner, setSelectedOwner] = useState(null);
//   const [busDetailsLoading, setBusDetailsLoading] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalOwners, setTotalOwners] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   const getFullImageUrl = (imagePath) => {
//     if (imagePath.startsWith('http')) {
//       return imagePath;
//     }
//     return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
//   };

//   useEffect(() => {
//     fetchBusOwners();
//   }, [currentPage]);



//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchBusOwners();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

// const refreshBusList = async () => {
//   if (!selectedOwner) return;
  
//   try {
//     setBusDetailsLoading(true);
//     const response = await getBusOwnerById(selectedOwner.id, token);
    
//     if (response.success && response.data) {
//       // Try busAll first, fall back to buses array
//       const busData = response.data.busAll || response.data.buses || [];
      
//       const processedBuses = busData.map(bus => {
//         const driver = bus.driver ? {
//           name: bus.driver.name || 'N/A',
//           contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//           licenseNumber: bus.driver.licenseNumber || 'N/A',
//           experience: bus.driver.experience || 0
//         } : null;

//         const conductor = bus.conductor ? {
//           name: bus.conductor.name || 'N/A',
//           contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//         } : null;

//         return { ...bus, driver, conductor };
//       });
      
//       // This updates the buses shown in BusManagementModal
//       setSelectedOwnerBuses(processedBuses);
      
//       setSelectedOwner(prev => ({
//         ...prev,
//         busAll: busData
//       }));
//     }
//   } catch (err) {
//     console.error('Error refreshing bus list:', err);
//     toast.error('Failed to refresh bus list');
//   } finally {
//     setBusDetailsLoading(false);
//   }
// };

//   const fetchBusOwners = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const response = await getBusOwners(token, currentPage, pageSize, searchTerm);
// console.log("getBusOwners : ",response)
//       if (response && response.success && response.busOwners) {
//         const transformedOwners = response.busOwners.map((owner, index) => ({
//           id: owner._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: owner.profileImage || '',
//           name: owner.name || '',
//           company: owner.companyName || '',
//           email: owner.email || '',
//           phone: owner.phone || '',
//           buses: owner.busCount || 0,
//           routes: owner.routeCount || 0,
//           joined: new Date(owner.createdAt).toISOString().split('T')[0],
//           status: owner.isVerified ? 'Verified' : 'Pending',
//           adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
//           _id: owner._id,
//           isVerified: owner.isVerified,
//           isProfileComplete: owner.isProfileComplete,
//           isApprovedByAdmin: owner.isApprovedByAdmin,
//           activeBuses: owner.activeBuses || 0,
//           driverCount: owner.driverCount || 0,
//           conductorCount: owner.conductorCount || 0,
//           createdAt: owner.createdAt,
//           updatedAt: owner.updatedAt,
//           address: owner.address || {},
//           city: owner.address?.city || '',
//           state: owner.address?.state || owner.state || '',
//           pincode: owner.address?.pincode || '',
//           busAll: owner.busAll || []
//         }));

//         setBusOwners(transformedOwners);

//         if (response.totalPages) {
//           setTotalPages(response.totalPages);
//         }
//         if (response.total) {
//           setTotalOwners(response.total);
//         } else {
//           setTotalOwners(response.busOwners.length);
//         }
//       } else {
//         setError('No bus owners data found in response');
//         setBusOwners([]);
//         setTotalPages(1);
//         setTotalOwners(0);
//       }
//     } catch (err) {
//       console.error('Error fetching bus owners:', err);
//       setError('Failed to fetch bus owners. Please try again.');
//       setBusOwners([]);
//       setTotalPages(1);
//       setTotalOwners(0);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const fetchBusOwnerById = async (id) => {
//     try {
//       const response = await getBusOwnerById(id, token);
//       console.log("response.data : ", response.data)
//       return response.data || response;
//     } catch (err) {
//       console.error('Error fetching bus owner:', err);
//       throw err;
//     }
//   };

// const handleApproveOwner = async (ownerId) => {
//   try {
//     setError(null);
//     const response = await approveBusOwner(ownerId, token);

//     if (response.success) {
//       setBusOwners(prevOwners =>
//         prevOwners.map(owner =>
//           owner.id === ownerId ? {
//             ...owner,
//             isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
//             adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending',
//             // Add these lines to update the status and verification
//             isVerified: response.data?.isVerified || true,
//             status: response.data?.isVerified ? 'Verified' : 'Pending'
//           } : owner
//         )
//       );
//       toast.success('Bus owner approved and verified successfully!');
//     } else {
//       throw new Error(response.message || 'Failed to approve bus owner');
//     }
//   } catch (err) {
//     console.error('Error approving bus owner:', err);
//     setError('Failed to approve bus owner. Please try again.');
//     toast.error('Failed to approve bus owner. Please try again.');
//   }
// };

//   const handleManageBuses = async (owner) => {
//     console.log("handleManageBuses ; ", owner)
//     if (owner.buses === 0) {
//       // alert('This owner has no buses registered.');
//       toast.error("This owner has no buses registered")
//       return;
//     }

//     console.log('Owner bus data:', owner);

//     // Check if busAll exists and has data
//     if (!owner.busAll || owner.busAll.length === 0) {
//       // If no bus data, try to fetch it separately
//       try {
//         setBusDetailsLoading(true);
//         const response = await getBusOwnerById(owner.id, token);

//         if (response.success && response.data && response.data.busAll) {
//           // Update the owner with bus data
//           const updatedOwner = {
//             ...owner,
//             busAll: response.data.busAll || []
//           };

//           // Process the bus data
//           const processedBuses = updatedOwner.busAll.map(bus => {
//             const driver = bus.driver ? {
//               name: bus.driver.name || 'N/A',
//               contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//               licenseNumber: bus.driver.licenseNumber || 'N/A',
//               experience: bus.driver.experience || 0
//             } : null;

//             const conductor = bus.conductor ? {
//               name: bus.conductor.name || 'N/A',
//               contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//             } : null;

//             return {
//               ...bus,
//               driver,
//               conductor
//             };
//           });

//           console.log('Fetched and processed buses:', processedBuses);

//           setSelectedOwner(updatedOwner);
//           setSelectedOwnerBuses(processedBuses);
//           setShowBusManagement(true);
//           setBusSearchTerm('');
//         } else {
//           alert('Could not fetch bus data. Please try again.');
//         }
//       } catch (err) {
//         console.error('Error fetching bus details:', err);
//         alert('Failed to fetch bus details. Please try again.');
//       } finally {
//         setBusDetailsLoading(false);
//       }
//       return;
//     }

//     // If busAll data exists, process it
//     const processedBuses = owner.busAll.map(bus => {
//       const driver = bus.driver ? {
//         name: bus.driver.name || 'N/A',
//         contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//         licenseNumber: bus.driver.licenseNumber || 'N/A',
//         experience: bus.driver.experience || 0
//       } : null;

//       const conductor = bus.conductor ? {
//         name: bus.conductor.name || 'N/A',
//         contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//       } : null;

//       return {
//         ...bus,
//         driver,
//         conductor
//       };
//     });

//     console.log('Processed buses:', processedBuses);

//     setSelectedOwner(owner);
//     setSelectedOwnerBuses(processedBuses);
//     setShowBusManagement(true);
//     setBusSearchTerm('');
//   };
//   // Add this function after your other handler functions
//   const filteredBuses = selectedOwnerBuses.filter(bus =>
//     (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
//     (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
//   );

//   const handleRejectOwner = async (ownerId) => {
//     if (window.confirm('Are you sure you want to reject this bus owner?')) {
//       try {
//         setError(null);

//         if (!ownerId || typeof ownerId !== 'string') {
//           throw new Error('Invalid owner ID');
//         }

//         const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === ownerId ? {
//                 ...owner,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
//                 adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
//               } : owner
//             )
//           );
//           toast.success('Bus owner rejected successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to reject bus owner');
//         }
//       } catch (err) {
//         console.error('Error rejecting bus owner:', err);
//         setError('Failed to reject bus owner. Please try again.');
//         toast.error('Failed to reject bus owner. Please try again.');
//       }
//     }
//   };

//   const filteredOwners = busOwners;

//   const handleViewOwner = async (owner) => {
//     try {
//       const ownerData = await fetchBusOwnerById(owner.id);
//       setViewingOwner({
//         ...owner,
//         profileImage: ownerData.profileImage || owner.profileImage,
//         name: ownerData.name || owner.name,
//         company: ownerData.companyName || owner.company,
//         email: ownerData.email || owner.email,
//         phone: ownerData.phone || owner.phone,
//         address: ownerData.address || owner.address,
//         isVerified: ownerData.isVerified,
//         isProfileComplete: ownerData.isProfileComplete,
//         isApprovedByAdmin: ownerData.isApprovedByAdmin,

//         // Stats (numbers for the stat cards)
//         busCount: ownerData.stats?.busCount || 0,      // ← renamed to busCount
//         activeBuses: ownerData.stats?.activeBuses || 0,
//         driverCount: ownerData.stats?.driverCount || 0,
//         conductorCount: ownerData.stats?.conductorCount || 0,

//         // Arrays for the detail sections
//         routes: ownerData.routes || [],
//         buses: ownerData.buses || [],                   // ← array only, no conflict

//         status: ownerData.isApprovedByAdmin ? 'Active' : 'Pending',
//         joined: ownerData.createdAt
//           ? new Date(ownerData.createdAt).toLocaleDateString()
//           : owner.joined,
//       });
//     } catch (err) {
//       setViewingOwner(owner);
//       toast.info('Could not fetch latest owner details. Showing cached data.');
//     }
//   };

//   const handleEditOwner = (owner) => {
//     setEditingOwner(owner.id);
//     setEditForm({
//       name: owner.name || '',
//       companyName: owner.company || '',
//       email: owner.email || '',
//       phone: owner.phone || '',
//       status: owner.status || 'Pending',
//       isApprovedByAdmin: owner.isApprovedByAdmin || false
//     });
//   };

//   const closeBusManagement = () => {
//     setShowBusManagement(false);
//     setSelectedOwnerBuses([]);
//     setSelectedOwner(null);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       if (!editingOwner || typeof editingOwner !== 'string') {
//         throw new Error('Invalid owner ID for editing');
//       }

//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phone: editForm.phone,
//         companyName: editForm.companyName,
//         isVerified: editForm.status === 'Verified',
//         isApprovedByAdmin: editForm.isApprovedByAdmin
//       };

//       const response = await updateBusOwner(editingOwner, updateData, token);

//       if (response.success) {
//         setBusOwners(prevOwners =>
//           prevOwners.map(owner =>
//             owner.id === editingOwner ? {
//               ...owner,
//               name: response.data?.name || editForm.name,
//               company: response.data?.companyName || editForm.companyName,
//               email: response.data?.email || editForm.email,
//               phone: response.data?.phone || editForm.phone,
//               status: response.data?.isVerified ? 'Verified' : 'Pending',
//               isVerified: response.data?.isVerified,
//               isApprovedByAdmin: response.data?.isApprovedByAdmin,
//               adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
//             } : owner
//           )
//         );

//         setEditingOwner(null);
//         setEditForm({});
//         toast.success('Bus owner updated successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to update bus owner');
//       }
//     } catch (err) {
//       console.error('Error updating bus owner:', err);
//       setError('Failed to update bus owner. Please try again.');
//       toast.error('Failed to update bus owner. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingOwner(null);
//     setEditForm({});
//     setError(null);
//   };

//   // const handleDeleteOwner = async (ownerId) => {
//   //   if (window.confirm('Are you sure you want to delete this bus owner?')) {
//   //     try {
//   //       setError(null);
//   //       const response = await deleteBusOwner(ownerId, token);

//   //       if (response.success) {
//   //         setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//   //         setTotalOwners(prev => prev - 1);
//   //         toast.success('Bus owner deleted successfully!');
//   //       } else {
//   //         throw new Error(response.message || 'Failed to delete bus owner');
//   //       }
//   //     } catch (err) {
//   //       console.error('Error deleting bus owner:', err);
//   //       setError('Failed to delete bus owner. Please try again.');
//   //       toast.error('Failed to delete bus owner. Please try again.');
//   //     }
//   //   }
//   // };

//   const handleDeleteOwner = async (ownerId) => {
//   if (window.confirm('Are you sure you want to delete this bus owner?')) {
//     try {
//       setError(null);
//       const response = await deleteBusOwner(ownerId, token);

//       if (response.success) {
//         setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//         setTotalOwners(prev => prev - 1);
//         toast.success('Bus owner deleted successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to delete bus owner');
//       }
//     } catch (err) {
//       console.error('Error deleting bus owner:', err);
      
//       // Extract the error message from the response
//       const errorMessage = err.response?.data?.message || err.message || 'Failed to delete bus owner. Please try again.';
      
//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   }
// };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleNewOwnerChange = (e) => {
//     const { name, value } = e.target;
//     setNewOwner(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleAddOwner = async () => {
//     try {
//       setError(null);

//       if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
//         toast.error('Please fill in all required fields');
//         return;
//       }

//       const response = await createBusOwner(newOwner, token);
//       console.log("response............ : ", response)
//       if (response.success) {
//         const newOwnerWithId = {
//           id: response.data.id,
//           serialNo: busOwners.length + 1,
//           profileImage: '',
//           name: response.data.name,
//           company: response.data.companyName,
//           email: response.data.email,
//           phone: response.data.phone,
//           buses: 0,
//           routes: 0,
//           joined: new Date(response.data.createdAt).toISOString().split('T')[0],
//           status: 'Pending',
//           adminApproval: 'Pending',
//           isVerified: false,
//           isApprovedByAdmin: false,
//           createdAt: response.data.createdAt
//         };

//         setBusOwners(prev => [newOwnerWithId, ...prev]);
//         setTotalOwners(prev => prev + 1);
//         setShowAddModal(false);
//         setNewOwner({
//           name: '',
//           companyName: '',
//           email: '',
//           phone: ''
//         });
//          setSearchTerm('');
//         toast.success('Bus owner added successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to add bus owner');
//       }
//     } catch (err) {
//       console.error('Error adding bus owner:', err);

//       // Extract error message from the response
//       let errorMessage = 'Failed to add bus owner. Please try again.';

//       if (err.response?.data?.message) {
//         // Get the message from the API response
//         errorMessage = err.response.data.message;
//       } else if (err.message) {
//         errorMessage = err.message;
//       }

//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const closeViewModal = () => {
//     setViewingOwner(null);
//   };

//   const closeAddModal = () => {
//     setShowAddModal(false);
//     setNewOwner({
//       name: '',
//       companyName: '',
//       email: '',
//       phone: ''
//     });
//     setError(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     // The useEffect will trigger fetchBusOwners automatically
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const currentPageOwners = busOwners;
//   const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
//   const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
//   const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

//   const handleAddBusClick = (owner) => {
//     setSelectedOwnerForBus(owner);
//     setShowAddBusModal(true);
//   };

//   const handleBusAdded = () => {
//     fetchBusOwners();
//     toast.success('Bus added successfully!');
//   };

//   const closeAddBusModal = () => {
//     setShowAddBusModal(false);
//     setSelectedOwnerForBus(null);
//   };

//   if (loading && busOwners.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Bus Owner Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search bus owners by name, company, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Owner
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Owners</h3>
//           <p>{totalOwners}</p>
//           <span>All registered owners</span>
//         </div>
//         <div className="stat-card">
//           <h3>Verified Owners</h3>
//           <p>{verifiedOwners}</p>
//           <span>Verified on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Approved Owners</h3>
//           <p>{approvedOwners}</p>
//           <span>Approved on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{totalBuses}</p>
//           <span>active fleet</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Profile</th>
//               <th>Owner Name</th>
//               <th>Company</th>
//               <th>Contact</th>
//               <th>Buses</th>
//               <th>Admin Approval</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOwners.length > 0 ? (
//               filteredOwners.map(owner => (
//                 <tr key={owner.id}>
//                   <td>{owner.serialNo}</td>
//                   <td>
//                     <div className="profile-image-cell">
//                       <img
//                         src={getFullImageUrl(owner.profileImage)}
//                         alt={owner.name || 'Bus Owner'}
//                         className="customer-avatar"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                         }}
//                       />
//                     </div>
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Owner Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.name || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="companyName"
//                         value={editForm.companyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Company Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.company || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div>{owner.email || 'N/A'}</div>
//                         <div className="phone">{owner.phone || 'N/A'}</div>
//                       </div>
//                     )}
//                   </td>

//                   <td>{owner.buses}</td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="isApprovedByAdmin"
//                         value={editForm.isApprovedByAdmin || false}
//                         onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="true">Approved</option>
//                         <option value="false">Pending</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || 'Pending'}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="Verified">Verified</option>
//                         <option value="Pending">Pending</option>
//                         <option value="Suspended">Suspended</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
//                         {owner.status || 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
//                         <button
//                           className="action-btn save"
//                           onClick={handleSaveEdit}
//                           style={{ backgroundColor: '#28a745', color: 'white' }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="action-btn cancel"
//                           onClick={handleCancelEdit}
//                           style={{ backgroundColor: '#6c757d', color: 'white' }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewOwner(owner)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditOwner(owner)}
//                         >
//                           Edit
//                         </button>

//                         <button
//                           className="action-btn add-bus"
//                           onClick={() => handleAddBusClick(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title="Add new bus for this owner"
//                         >
//                           + Add Bus
//                         </button>

//                         <button
//                           className="action-btn manage"
//                           onClick={() => handleManageBuses(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
//                         >
//                           Manage Buses
//                         </button>

//                         {!owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveOwner(owner.id)}
//                             style={{ backgroundColor: '#28a745' }}
//                           >
//                             Approve
//                           </button>
//                         )}
//                         {owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectOwner(owner.id)}
//                             style={{ backgroundColor: '#ffc107', color: '#000' }}
//                           >
//                             Reject
//                           </button>
//                         )}
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteOwner(owner.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="no-data">
//                   <p>No bus owners found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all bus owners
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {filteredOwners.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No bus owners found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {busOwners.length} of {totalOwners} bus owners
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages || totalPages === 0}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Modal */}
//       {/* {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Owner Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={getFullImageUrl(viewingOwner.profileImage)}
//                     alt={viewingOwner.name || 'Bus Owner'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Serial No:</label>
//                   <span>{viewingOwner.serialNo}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>ID:</label>
//                   <span>#{viewingOwner.id}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Owner Name:</label>
//                   <span>{viewingOwner.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Company:</label>
//                   <span>{viewingOwner.company || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingOwner.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingOwner.phone || 'N/A'}</span>
//                 </div>

//                 <div className="detail-row">
//                   <label>Address:</label>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                     {viewingOwner.address?.city && (
//                       <span>City: {viewingOwner.address.city}</span>
//                     )}
//                     {viewingOwner.address?.state && (
//                       <span>State: {viewingOwner.address.state}</span>
//                     )}
//                     {viewingOwner.address?.pincode && (
//                       <span>Pincode: {viewingOwner.address.pincode}</span>
//                     )}
//                     {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
//                       <span>N/A</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className="detail-row">
//                   <label>Total Buses:</label>
//                   <span>{viewingOwner.buses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Active Buses:</label>
//                   <span>{viewingOwner.activeBuses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Drivers:</label>
//                   <span>{viewingOwner.driverCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Conductors:</label>
//                   <span>{viewingOwner.conductorCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{viewingOwner.joined}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
//                     {viewingOwner.status || 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Admin Approval:</label>
//                   <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                     {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Profile Complete:</label>
//                   <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Verified:</label>
//                   <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}
//       {/* View Modal */}
//       {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modern-dashboard-modal" onClick={(e) => e.stopPropagation()}>

//             {/* Header with Glassmorphism */}
//             <header className="dashboard-header">
//               <div className="header-left">
//                 <div className="icon-box"><i className="fas fa-bus"></i></div>
//                 <div>
//                   <h3>Bus Owner Profile</h3>
//                   <span className="subtitle">Management Console</span>
//                 </div>
//               </div>
//               <button className="close-icon-btn" onClick={closeViewModal}>&times;</button>
//             </header>

//             <div className="dashboard-body">

//               {/* Top Section: Profile & Stats Combined */}
//               <section className="profile-overview-card">
//                 <div className="owner-brand">
//                   <div className="avatar-wrapper">
//                     <img
//                       src={getFullImageUrl(viewingOwner.profileImage)}
//                       alt="Profile"
//                       onError={(e) => { e.target.src = ''; }}
//                     />
//                     {viewingOwner.isVerified && <div className="verified-badge"><i className="fas fa-check"></i></div>}
//                   </div>
//                   <div className="brand-details">
//                     <h2>{viewingOwner.name || 'N/A'}</h2>
//                     <p className="owner-id-tag">ID: {viewingOwner.id}</p>
//                     <div className="quick-tags">
//                       <span className={`tag ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {viewingOwner.isApprovedByAdmin ? 'Verified Partner' : 'Pending Review'}
//                       </span>
//                       <span className="tag city-tag"><i className="fas fa-map-marker-alt"></i> {viewingOwner.address?.city}, {viewingOwner.address?.state}</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="stats-strip">
//                   <div className="stat-node">
//                     <label>Buses</label>
//                     <div className="value">{viewingOwner.busCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Drivers</label>
//                     <div className="value">{viewingOwner.driverCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Conductors</label>
//                     <div className="value">{viewingOwner.conductorCount || 0}</div>
//                   </div>
//                 </div>
//               </section>

//               {/* Horizontal Routes List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-route"></i> Active Routes</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.routes?.map((route, index) => (
//                     <div key={index} className="modern-row-card route-row">
//                       <div className="row-main-info">
//                         <div className="route-code">{route.routeNumber}</div>
//                         <div className="journey-stepper">
//                           <span className="">{route.origin?.city}</span>
//                           <div className="connector-line">
//                             <i className="fas fa-chevron-right"></i>
//                           </div>
//                           <span className="">{route.destination?.city}</span>
//                         </div>
//                       </div>
//                       <div className="row-meta-info">
//                         <div className="meta-item"><i className="fas fa-road"></i> {route.routeDetails?.totalDistance} km</div>
//                         <div className="meta-item"><i className="fas fa-clock"></i> {route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</div>
//                         <div className="meta-item bus-pill"><i className="fas fa-bus-alt"></i> {route.busCount} assigned</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </section>

//               {/* Horizontal Buses List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-shuttle-van"></i> Bus Details</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.buses?.map((bus, index) => (
//                     <div key={index} className="modern-row-card bus-row">
//                       <div className="bus-identity">
//                         <div className={`status-indicator ${bus.isActive ? 'online' : 'offline'}`}></div>
//                         <div>
//                           <strong>{bus.busName}</strong>
//                           <div className="plate-number">{bus.busNumber}</div>
//                         </div>
//                       </div>

//                       <div className="bus-specs-row">
//                         <span><i className="fas fa-chair"></i> {bus.totalSeats} Seats</span>
//                         <span><i className="fas fa-snowflake"></i> {bus.busType}</span>
//                       </div>

//                       <div className="bus-amenities-tags">
//                         {bus.amenities?.slice(0, 2).map((a, i) => <span key={i} className="mini-tag">{a}</span>)}
//                       </div>

//                       {/* <div className="bus-action-link">
//                   <button className="view-tracking-btn">Live Track</button>
//                 </div> */}
//                     </div>
//                   ))}
//                 </div>
//               </section>

//             </div>

//             <footer className="dashboard-footer">
//               <button className="btn-secondary" onClick={closeViewModal}>close</button>
//             </footer>
//           </div>
//         </div>
//       )}
//       {/* NEW - Modern Bus Management Modal */}
// {/* Update the BusManagementModal component call */}
// {showBusManagement && selectedOwner && (
//   <BusManagementModal
//     key={busUpdateTrigger} // Add this to force re-render
//     owner={selectedOwner}
//     buses={selectedOwnerBuses}
//     onClose={closeBusManagement}
//     onUpdate={async () => {
//       await refreshBusList();
//       await fetchBusOwners();
//     }}
//   />
// )}

//       {/* Add Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={closeAddModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Bus Owner</h3>
//               <button className="modal-close-btn" onClick={closeAddModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Owner Name *:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={newOwner.name}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter owner name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Company Name *:</label>
//                   <input
//                     type="text"
//                     name="companyName"
//                     value={newOwner.companyName}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter company name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Email *:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={newOwner.email}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter email address"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone *:</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={newOwner.phone}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter phone number"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeAddModal}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleAddOwner}>
//                 Add Owner
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add Bus Modal */}
//       {showAddBusModal && selectedOwnerForBus && (
//         <AddBusModal
//           ownerId={selectedOwnerForBus.id}
//           onClose={closeAddBusModal}
//           onBusAdded={handleBusAdded}
//         />
//       )}
//     </div>
//   );
// };

// export default BusOwnerManage;


// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//   getBusOwners,
//   getBusOwnerById,
//   createBusOwner,
//   updateBusOwner,
//   deleteBusOwner,
//   approveBusOwner,
//   addBusToOwner,
//   getSeatLayoutsByBustype,
//   getAllCategory
// } from '../../Services/Operations/ProductAPI';
// import {
//   getDriversByBusOwner,
//   getConductorsByBusOwner,
//   assignDriverToBus,
//   assignConductorToBus,
//   unassignDriverFromBus,
//   unassignConductorFromBus
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/BusFareChart.css';
// import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
// import BusManagementModal from './BusManagementModal'; // Import the new modal
// import { useNavigate } from 'react-router-dom';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-avatar"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Profile</th>
//           <th>Owner Name</th>
//           <th>Company</th>
//           <th>Contact</th>
//           <th>Buses</th>
//           <th>Admin Approval</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modern-dashboard-modal skeleton">
//       <div className="dashboard-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="dashboard-body">
//         <div className="skeleton-profile-section"></div>
//         <div className="skeleton-stats-strip"></div>
//         <div className="skeleton-routes-section"></div>
//         <div className="skeleton-buses-section"></div>
//       </div>
//       <div className="dashboard-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const RouteSelector = ({ value, onChange, onAddNew, token, disabled, loadingRoutes, originCity, destinationCity }) => {
//   const [routes, setRoutes] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');

//   const fetchRoutes = async () => {
//     setIsLoading(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token,
//         1,
//         100,
//         searchTerm,
//         '', // busOwnerId - empty to get both admin and busowner routes
//         { originCity, destinationCity } // Pass filters
//       );
//       console.log("getAllBusownerAdminRoutes :::::::::::: ",response)
//       if (response && response.success && response.routes) {
//         setRoutes(response.routes);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (showDropdown) {
//       fetchRoutes();
//     }
//   }, [showDropdown, searchTerm, originCity, destinationCity]);

//   const handleSelect = (route) => {
//     onChange(route);
//     setShowDropdown(false);
//     setSearchTerm('');
//   };

//   return (
//     <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
//       <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//         <div style={{ flex: 1, position: 'relative' }}>
//           <input
//             type="text"
//             value={value ? value.routeName || value.masterRouteName : searchTerm}
//             onClick={() => setShowDropdown(!showDropdown)}
//             onChange={(e) => {
//               setSearchTerm(e.target.value);
//               setShowDropdown(true);
//               if (value) onChange(null);
//             }}
//             placeholder="Select or search route..."
//             className="modern-input"
//             disabled={disabled}
//             style={{ cursor: 'pointer' }}
//           />
//           {isLoading && (
//             <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//               <div className="spinner-small"></div>
//             </div>
//           )}
//         </div>
//         <button
//           type="button"
//           onClick={onAddNew}
//           className="btn btn-outline-primary"
//           style={{
//             padding: '8px 16px',
//             backgroundColor: '#28a745',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '5px',
//             whiteSpace: 'nowrap'
//           }}
//           onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
//           onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
//         >
//           <span style={{ fontSize: '18px', fontWeight: 'bold' }}>+</span> New Route
//         </button>
//       </div>

//       {showDropdown && (routes.length > 0 || searchTerm) && (
//         <div className="master-route-dropdown" style={{
//           position: 'absolute',
//           top: '100%',
//           left: 0,
//           right: 0,
//           background: 'white',
//           border: '1px solid #ddd',
//           borderRadius: '4px',
//           boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//           zIndex: 1000,
//           maxHeight: '300px',
//           overflowY: 'auto',
//           marginTop: '4px'
//         }}>
//           {routes.length === 0 ? (
//             <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
//               {originCity || destinationCity
//                 ? `No routes found for ${originCity || ''} → ${destinationCity || ''}. Click + to create one.`
//                 : 'No routes found. Click + to create one.'}
//             </div>
//           ) : (
//             routes.map((route) => (
//               <div
//                 key={route._id}
//                 className="dropdown-item"
//                 onClick={() => handleSelect(route)}
//                 style={{
//                   padding: '10px 12px',
//                   cursor: 'pointer',
//                   borderBottom: '1px solid #f0f0f0',
//                   transition: 'background-color 0.2s'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
//                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//               >
//                 <div style={{ fontWeight: '500', marginBottom: '4px' }}>
//                   {route.routeNumber || ''} - {route.routeName || route.masterRouteName || 'Route'}
//                   {route.creatorType === 'BusOwner' && (
//                     <span style={{
//                       marginLeft: '8px',
//                       fontSize: '10px',
//                       backgroundColor: '#ffc107',
//                       color: '#000',
//                       padding: '2px 6px',
//                       borderRadius: '4px'
//                     }}>
//                       Owner
//                     </span>
//                   )}
//                 </div>
//                 <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                   {route.origin?.city} → {route.destination?.city} •
//                   {route.isRoundTrip ? ' Round Trip' : ' One Way'} •
//                   {route.routeDetails?.totalDistance || 0} km
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       )}
//     </div>
//   );
// };
// const PlatformFeeConfig = ({ platformFee, onChange }) => {
//   return (
//     <div className="section-card">
//       <h4 className="card-title">
//         <span className="title-icon">💰</span>
//         Platform Fee Configuration
//       </h4>
      
//       <div className="platform-fee-container">
//         <div className="form-row">
//           <div className="form-group">
//             <label className="input-label">Fee Type</label>
//             <select
//               value={platformFee.type}
//               onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
//               className="modern-select"
//             >
//               <option value="fixed">Fixed Amount (₹)</option>
//               <option value="percentage">Percentage (%)</option>
//             </select>
//             <small className="helper-text">
//               {platformFee.type === 'fixed' 
//                 ? 'Charge a fixed amount per booking' 
//                 : 'Charge a percentage of the fare'}
//             </small>
//           </div>

//           {/* <div className="form-group">
//             <label className="input-label">
//               {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//             </label>
//             <input
//               type="number"
//               min="0"
//               step={platformFee.type === 'fixed' ? "1" : "0.1"}
//               value={platformFee.value}
//               onChange={(e) => onChange({ ...platformFee, value: parseFloat(e.target.value) || 0 })}
//               className="modern-input"
//               placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
//             />
            
//           </div> */}

//           <div className="form-group">
//   <label className="input-label">
//     {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//   </label>
//   <input
//     type="number"
//     min="0"
//     step={platformFee.type === 'fixed' ? "1" : "0.1"}
//     value={platformFee.value === 0 ? '' : platformFee.value}
//     onChange={(e) => {
//       const rawValue = e.target.value;
//       const value = rawValue === '' ? 0 : parseFloat(rawValue);
//       onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
//     }}
//     className="modern-input"
//     placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
//     style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//   />
// </div>

//           <div className="form-group">
//             <label className="input-label">Applicable On</label>
//             <select
//               value={platformFee.applicableOn}
//               onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
//               className="modern-select"
//             >
//               <option value="per_ticket">Per Ticket</option>
//               <option value="per_person">Per Person</option>
//               {/* <option value="total_booking">Total Booking Amount</option> */}
//             </select>
//             {/* <small className="helper-text">
//               {platformFee.applicableOn === 'per_ticket' && 'Fee applied on each ticket'}
//               {platformFee.applicableOn === 'per_seat' && 'Fee applied on each seat'}
//               {platformFee.applicableOn === 'total_booking' && 'Fee applied on total booking amount'}
//             </small> */}
//           </div>
//         </div>

//         {/* Preview/Calculation Example */}
//         {platformFee.value > 0 && (
//           <div className="fee-preview">
//             <div className="preview-title">Fee Calculation Preview:</div>
//             <div className="preview-details">
//               <span>
//                 {platformFee.type === 'fixed' 
//                   ? `₹${platformFee.value} ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
//                      platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`
//                   : `${platformFee.value}% of fare ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
//                      platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };
// const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);
//   const [cancellationTime, setCancellationTime] = useState({
//   hours: 1,
//   minutes: 0
// });

//    const [platformFee, setPlatformFee] = useState({
//     type: 'fixed',
//     value: 0,
//     applicableOn: 'per_ticket'
//   });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({
//     hours: 1,
//     minutes: 0
//   });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'Non-AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States - NEW: Source & Destination instead of RouteSelector
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Image States
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Add this new state alongside existing route states
// const [localRouteNameSearch, setLocalRouteNameSearch] = useState('');
// const [localRouteSearchLoading, setLocalRouteSearchLoading] = useState(false);

//   // Constants
//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // Add this function to handle cancellation time changes
// const handleCancellationTimeChange = (field, value) => {
//   setCancellationTime(prev => ({
//     ...prev,
//     [field]: parseInt(value) || 0
//   }));
// };

// // Add validation for cancellation time (add to validateBookingTime function or create new)
// const validateCancellationTime = () => {
//   const totalMinutes = (cancellationTime.hours * 60) + cancellationTime.minutes;
//   if (totalMinutes < 0) {
//     toast.error('Cancellation time cannot be negative');
//     return false;
//   }
//   if (cancellationTime.hours > 48) {
//     toast.error('Cancellation hours cannot exceed 48');
//     return false;
//   }
//   if (cancellationTime.minutes > 59) {
//     toast.error('Minutes cannot exceed 59');
//     return false;
//   }
  
//   // Optional: Validate against booking closed time
//   const bookingMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//   if (totalMinutes >= bookingMinutes) {
//     toast.warning('Cancellation time should be less than booking cut-off time for practical purposes');
//   }
//   return true;
// };

// // Add this new function alongside fetchRoutesBySourceDestination
// const fetchRoutesByLocalName = async (localName) => {
//   if (!localName || !localName.trim()) {
//     setAvailableRoutes([]);
//     return;
//   }

//   setLocalRouteSearchLoading(true);
//   setLoadingRoutes(true);
//   try {
//     const response = await getAllBusownerAdminRoutes(
//       token,
//       1,
//       50,
//       '',   // search
//       '',   // busOwnerId
//       {},   // no city filters
//       localName.trim()  // localRouteName ← NEW param
//     );

//     if (response && response.success && response.routes) {
//       setAvailableRoutes(response.routes);
//     } else {
//       setAvailableRoutes([]);
//     }
//   } catch (error) {
//     console.error('Error fetching routes by local name:', error);
//     toast.error('Failed to fetch routes');
//     setAvailableRoutes([]);
//   } finally {
//     setLocalRouteSearchLoading(false);
//     setLoadingRoutes(false);
//   }
// };

//   // Fetch routes based on source and destination
//   const fetchRoutesBySourceDestination = async () => {
//     if (!sourceCity || !destinationCity) {
//       setAvailableRoutes([]);
//       return;
//     }

//     setLoadingRoutes(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token,
//         1,
//         50,
//         '',
//         '',
//         { originCity: sourceCity, destinationCity: destinationCity }
//       );
      
//       if (response && response.success && response.routes) {
//         setAvailableRoutes(response.routes);
//       } else {
//         setAvailableRoutes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//       toast.error('Failed to fetch routes');
//       setAvailableRoutes([]);
//     } finally {
//       setLoadingRoutes(false);
//     }
//   };

//   // Add this useEffect alongside the existing city-based useEffect
// useEffect(() => {
//   const timer = setTimeout(() => {
//     if (localRouteNameSearch.trim()) {
//       // Clear city inputs when searching by local name
//       fetchRoutesByLocalName(localRouteNameSearch);
//     }
//   }, 500);
//   return () => clearTimeout(timer);
// }, [localRouteNameSearch]);

//   // Debounced fetch when source or destination changes
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   // Filter routes based on search term
//   const filteredRoutes = availableRoutes.filter(route =>
//     route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//     route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//   route.localRouteName?.toLowerCase().includes(routeSearchTerm.toLowerCase())  // ← ADD
//   );

//   const handleSelectRoute = (route) => {
//     setSelectedRoute(route);
//     setShowRouteDropdown(false);
//     setRouteSearchTerm('');
//     setFareMatrixUp([]);
//     setFareMatrixDown([]);
//   };

//   useEffect(() => {
//     const savedData = localStorage.getItem('pendingBusFormData');
//     if (savedData) {
//       const formData = JSON.parse(savedData);
//       if (window.confirm('You have unsaved bus data. Would you like to restore it?')) {
//         setForm(prev => ({
//           ...prev,
//           busNumber: formData.busNumber || '',
//           busName: formData.busName || '',
//           busType: formData.busType || 'AC',
//           busCategory: formData.busCategory || 'Seater',
//           amenities: formData.amenities || []
//         }));
//         setTripType(formData.tripType || 'oneWay');
//         setPricing(formData.pricing || { basePrice: '', baseDistance: '', costPerKm: '' });
//         setOperatingDays(formData.operatingDays || DAYS_OF_WEEK);
//         if (formData.bookingClosedBefore) {
//           setBookingClosedBefore(formData.bookingClosedBefore);
//         }
//         setSelectedConfiguration(formData.selectedConfiguration || '2*2');
//         localStorage.removeItem('pendingBusFormData');
//       } else {
//         localStorage.removeItem('pendingBusFormData');
//       }
//     }
//   }, []);

//   const handleAddNewRoute = () => {
//     const currentFormData = {
//       busNumber: form.busNumber,
//       busName: form.busName,
//       busType: form.busType,
//       busCategory: form.busCategory,
//       amenities: form.amenities,
//       tripType: tripType,
//       pricing: pricing,
//       operatingDays: operatingDays,
//       bookingClosedBefore: bookingClosedBefore,
//       selectedConfiguration: selectedConfiguration,
//     };
//     localStorage.setItem('pendingBusFormData', JSON.stringify(currentFormData));

//     toast.info('Redirecting to create route. Your current bus form data has been saved.');

//     navigate('/routes', {
//       state: {
//         returnTo: 'busowners',
//         ownerId: ownerId,
//         formData: currentFormData,
//         sourceCity: sourceCity,
//         destinationCity: destinationCity
//       }
//     });
//   };

//   const validateBookingTime = () => {
//     const totalMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//     if (totalMinutes < 0) {
//       toast.error('Booking close time cannot be negative');
//       return false;
//     }
//     if (bookingClosedBefore.hours > 24) {
//       toast.error('Booking close hours cannot exceed 24');
//       return false;
//     }
//     if (bookingClosedBefore.minutes > 59) {
//       toast.error('Minutes cannot exceed 59');
//       return false;
//     }
//     return true;
//   };

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({
//       ...prev,
//       [field]: parseInt(value) || 0
//     }));
//   };

//   // Fetch configurations when category changes
//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   const getCategoryMultiplier = () => {
//     const multipliers = {
//       'Seater': 1.0,
//       'Sleeper': 1.5,
//       'Seater+Sleeper': 1.3
//     };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);

//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;

//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') ||
//             cat.availableSeatTypes?.includes('seater')
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper')
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') ||
//             cat.availableSeatTypes?.includes('seat+sleeper')
//           );
//         }

//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           setSelectedConfiguration(configs[0]);
//           setLayoutTemplates([]);
//         } else {
//           setAvailableConfigurations([]);
//           setLayoutTemplates([]);
//           toast.info(`No configurations available for ${form.busCategory}`);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;

//       setLoadingLayouts(true);

//       let bustype = config.replace('x', '*');

//       const response = await getSeatLayoutsByBustype(bustype, token);

//       if (response && response.success) {
//         if (response.data && Array.isArray(response.data)) {
//           let filteredLayouts = response.data;

//           if (form.busCategory === 'Seater') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seat' || layout.seatType === 'seater'
//             );
//           } else if (form.busCategory === 'Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'sleeper'
//             );
//           } else if (form.busCategory === 'Seater+Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//             );
//           }

//           setLayoutTemplates(filteredLayouts);

//           if (filteredLayouts.length === 0) {
//             toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
//           }
//         } else {
//           setLayoutTemplates([]);
//           toast.info(`No layouts found for ${config} configuration`);
//         }
//       } else {
//         console.error('Failed to fetch layouts:', response);
//         setLayoutTemplates([]);
//         toast.error(response?.message || 'Failed to load seat layouts');
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const handleCategoryChange = (category) => {
//     setForm(prev => ({ ...prev, busCategory: category }));
//     setSelectedTemplate(null);
//     setActiveSeats([]);
//     setLayoutTemplates([]);
//     setCustomSeatLabels({});
//   };

//   // const handleImageUpload = (event) => {
//   //   const files = Array.from(event.target.files);
//   //   const newImages = [];

//   //   files.forEach(file => {
//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       newImages.push({
//   //         file: file,
//   //         preview: e.target.result,
//   //         name: file.name
//   //       });

//   //       if (newImages.length === files.length) {
//   //         setSelectedImages(prev => [...prev, ...newImages]);
//   //       }
//   //     };
//   //     reader.readAsDataURL(file);
//   //   });
//   // };

//   const handleImageUpload = (event) => {
//   const files = Array.from(event.target.files);
//   console.log('📸 Files selected for upload:', files.length);
  
//   const newImages = [];

//   files.forEach((file, index) => {
//     console.log(`File ${index + 1}: ${file.name} (${file.size} bytes, ${file.type})`);
    
//     // ✅ Ensure it's a valid file
//     if (!(file instanceof File)) {
//       console.error(`❌ File ${index + 1} is not a File object`);
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       newImages.push({
//         file: file, // Store the actual File object
//         preview: e.target.result, // Store preview URL for display
//         name: file.name,
//         size: file.size,
//         type: file.type
//       });

//       if (newImages.length === files.length) {
//         setSelectedImages(prev => [...prev, ...newImages]);
//         console.log(`✅ Added ${newImages.length} images. Total: ${selectedImages.length + newImages.length}`);
//       }
//     };
//     reader.onerror = (error) => {
//       console.error('❌ Error reading file:', error);
//     };
//     reader.readAsDataURL(file);
//   });
// };

//   const removeImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({
//           file: file,
//           preview: e.target.result,
//           name: file.name,
//           size: file.size
//         });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeVideo = () => {
//     setSelectedVideo(null);
//   };

//   const openTemplateSelector = () => {
//     if (!form.busCategory) {
//       toast.error('Please select a Bus Category first');
//       return;
//     }
//     if (!selectedConfiguration) {
//       toast.error('Please select a Bus Configuration first');
//       return;
//     }
//     if (layoutTemplates.length === 0) {
//       toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
//       return;
//     }
//     setShowTemplateModal(true);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setActiveSeats([]);
//     setBlockedSeats([]);
//     setCustomSeatLabels({});
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });

//     let counter = 1;
//     const newLabels = {};

//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });

//     setCustomSeatLabels(newLabels);
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day)
//         ? prev.filter(d => d !== day)
//         : [...prev, day]
//     );
//   };

// // const generateMatrixForRoute = (routeData) => {
// //   if (!routeData) return [];
 
// //   const baseP = parseFloat(pricing.basePrice) || 0;
// //   const baseD = parseFloat(pricing.baseDistance) || 0;
// //   const costK = parseFloat(pricing.costPerKm) || 0;
// //   const multiplier = getCategoryMultiplier();
 
// //   const sortedStops = [...(routeData.intermediateStops || [])]
// //     .sort((a, b) => a.sequence - b.sequence);
 
// //   // ✅ FIX 1: Store distances rounded to 1 decimal using integer math
// //   const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;
 
// //   const allStops = [
// //     {
// //       id: 'origin',
// //       name: routeData.origin?.city || 'Origin',
// //       distanceFromOrigin: 0,
// //       type: 'origin'
// //     },
// //     ...sortedStops.map((s, i) => ({
// //       id: s._id || `stop_${i}`,
// //       name: s.city || s.name || `Stop ${i + 1}`,
// //       distanceFromOrigin: toSafeDistance(s.distanceFromOrigin),
// //       type: 'stop',
// //       sequence: s.sequence
// //     })),
// //     {
// //       id: 'destination',
// //       name: routeData.destination?.city || 'Destination',
// //       distanceFromOrigin: toSafeDistance(
// //         routeData.destination?.distanceFromOrigin ||
// //         routeData.routeDetails?.totalDistance ||
// //         0
// //       ),
// //       type: 'destination'
// //     }
// //   ];
 
// //   const matrix = allStops.map((fromStop, i) => {
// //     const toCells = allStops.map((toStop, j) => {
// //       if (j > i) {
// //         // ✅ FIX 2: Use integer subtraction (×10) to avoid floating point drift
// //         // e.g., 178 - 0 = 178 exactly, not 177.9999...
// //         const fromInt = Math.round(fromStop.distanceFromOrigin * 10);
// //         const toInt   = Math.round(toStop.distanceFromOrigin * 10);
// //         const distance = (toInt - fromInt) / 10; // back to km with 1 decimal
 
// //         // ✅ FIX 3: Round extraDistance before multiplying to avoid drift
// //         let price = baseP;
// //         if (distance > baseD) {
// //           const extraDistance = Math.round((distance - baseD) * 10) / 10;
// //           price = baseP + (extraDistance * costK);
// //         }
 
// //         // ✅ FIX 4: Round AFTER applying multiplier
// //         price = Math.round(price * multiplier);
 
// //         return {
// //           toId: toStop.id,
// //           toName: toStop.name,
// //           distanceKm: distance,
// //           price: price
// //         };
// //       }
// //       return null;
// //     });
 
// //     return {
// //       fromId: fromStop.id,
// //       fromName: fromStop.name,
// //       fromType: fromStop.type,
// //       sequence: fromStop.sequence,
// //       toCells: toCells
// //     };
// //   });
 
// //   return matrix.filter(row => row.fromId !== 'destination');
// // };

// const generateMatrixForRoute = (routeData) => {
//   if (!routeData) return [];

//   const baseP = parseFloat(pricing.basePrice) || 0;
//   const baseD = parseFloat(pricing.baseDistance) || 0;
//   const costK = parseFloat(pricing.costPerKm) || 0;
//   const multiplier = getCategoryMultiplier();

//   const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;

//   const sortedStops = [...(routeData.intermediateStops || [])]
//     .sort((a, b) => a.sequence - b.sequence);

//   // Build raw stops
//   const rawStops = [
//     {
//       id: 'origin',
//       name: routeData.origin?.city || 'Origin',
//       rawDist: toSafeDistance(routeData.origin?.distanceFromOrigin || 0),
//       type: 'origin'
//     },
//     ...sortedStops.map((s, i) => ({
//       id: s._id || `stop_${i}`,
//       name: s.city || s.name || `Stop ${i + 1}`,
//       rawDist: toSafeDistance(s.distanceFromOrigin),
//       type: 'stop',
//       sequence: s.sequence
//     })),
//     {
//       id: 'destination',
//       name: routeData.destination?.city || 'Destination',
//       rawDist: toSafeDistance(
//         routeData.destination?.distanceFromOrigin ||
//         routeData.routeDetails?.totalDistance ||
//         0
//       ),
//       type: 'destination'
//     }
//   ];

//   // ✅ CORE FIX: Find min and max raw distances
//   const allRawDists = rawStops.map(s => s.rawDist);
//   const minDist = Math.min(...allRawDists);
//   const maxDist = Math.max(...allRawDists);

//   // Check if this is a descending route (DOWN) - origin has higher dist than destination
//   const originRaw = rawStops[0].rawDist;
//   const destRaw   = rawStops[rawStops.length - 1].rawDist;
//   const isDescending = destRaw < originRaw;

//   // Normalize every stop to 0-based ascending distance
//   const normalizedStops = rawStops.map(stop => ({
//     ...stop,
//     distanceFromOrigin: isDescending
//       ? toSafeDistance(maxDist - stop.rawDist)   // flip: high→0, low→high
//       : toSafeDistance(stop.rawDist - minDist)    // shift to 0-base
//   }));

//   // ✅ ALWAYS sort by normalized distance ascending — this is the key fix
//   // Without this sort, column indices don't match ascending distance order
//   // and j > i produces negative (toInt - fromInt) values
//   const allStops = normalizedStops.sort(
//     (a, b) => a.distanceFromOrigin - b.distanceFromOrigin
//   );

//   // Build matrix — with sorted stops, j > i ALWAYS means further stop
//   const matrix = allStops.map((fromStop, i) => {
//     const toCells = allStops.map((toStop, j) => {
//       if (j > i) {
//         const fromInt  = Math.round(fromStop.distanceFromOrigin * 10);
//         const toInt    = Math.round(toStop.distanceFromOrigin * 10);
//         // ✅ Math.abs as final safety — can never be negative after sort
//         const distance = Math.abs((toInt - fromInt) / 10);

//         let price = baseP;
//         if (distance > baseD) {
//           const extraDistance = Math.round((distance - baseD) * 10) / 10;
//           price = baseP + (extraDistance * costK);
//         }
//         price = Math.round(price * multiplier);

//         return {
//           toId: toStop.id,
//           toName: toStop.name,
//           distanceKm: distance,
//           price: price
//         };
//       }
//       return null;
//     });

//     return {
//       fromId: fromStop.id,
//       fromName: fromStop.name,
//       fromType: fromStop.type,
//       sequence: fromStop.sequence,
//       toCells: toCells
//     };
//   });

//   return matrix.filter(row => row.fromId !== 'destination');
// };

//   const handleGenerateMatrix = () => {
//     if (!selectedRoute) {
//       toast.error('Please select a Route first.');
//       return;
//     }

//     if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
//       toast.error("The selected route does not have return journey details configured.");
//       return;
//     }

//     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//       toast.error('Please fill all Pricing Fields.');
//       return;
//     }

//     const matrixUp = generateMatrixForRoute(selectedRoute);
//     setFareMatrixUp(matrixUp);

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//       setFareMatrixDown(matrixDown);
//     } else {
//       setFareMatrixDown([]);
//     }

//     toast.success(tripType === 'roundTrip'
//       ? "Both Fare Matrices Generated!"
//       : "Fare Matrix Generated!"
//     );
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = {
//           ...newToCells[colIndex],
//           price: parseInt(newPrice) || 0
//         };
//       }
//       return { ...row, toCells: newToCells };
//     });

//     if (isUp) {
//       setFareMatrixUp(updatedMatrix);
//     } else {
//       setFareMatrixDown(updatedMatrix);
//     }
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   // const handleSubmitBus = async () => {
//   //   try {
//   //     setIsSubmitting(true);
//   //     setError(null);

//   //     if (!validateBookingTime()) {
//   //       setIsSubmitting(false);
//   //       return;
//   //     }

//   //     if (!form.busNumber) throw new Error('Bus Number is required');
//   //     if (!form.busName) throw new Error('Bus Name is required');
//   //     if (!form.busType) throw new Error('Bus Type is required');
//   //     if (!form.busCategory) throw new Error('Bus Category is required');
//   //     if (!selectedRoute) throw new Error('Please select a route');
//   //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
//   //     if (!selectedTemplate) throw new Error('Please configure seat layout');
//   //     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

//   //     const amenitiesArray = form.amenities || [];

//   //     const finalSeatsPayload = selectedTemplate.seats
//   //       .filter(s => activeSeats.includes(s.seatNumber))
//   //       .map(s => {
//   //         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//   //         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//   //         const isBlocked = blockedSeats.includes(s.seatNumber);

//   //         return {
//   //           seatNumber: s.seatNumber,
//   //           globalSeatIndex: finalGlobalIndex,
//   //           row: s.row,
//   //           column: s.column,
//   //           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//   //           position: s.position || getSeatPosition(s.column),
//   //           isBlocked: isBlocked,
//   //           isAvailable: !isBlocked,
//   //         };
//   //       });

//   //     const seatConfigPayload = {
//   //       busType: selectedTemplate.configuration || '2*2',
//   //       totalSeats: activeSeats.length
//   //     };

//   //     const routeSchedules = [];
//   //     const routeIdToSave = selectedRoute._id || selectedRoute.id;

//   //     routeSchedules.push({
//   //       routeId: routeIdToSave,
//   //       direction: 'UP',
//   //       fareMatrix: fareMatrixUp,
//   //       operatingDays: operatingDays,
//   //       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//   //       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//   //     });

//   //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//   //       routeSchedules.push({
//   //         routeId: routeIdToSave,
//   //         direction: 'DOWN',
//   //         fareMatrix: fareMatrixDown,
//   //         operatingDays: operatingDays,
//   //         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//   //         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//   //       });
//   //     }

//   //     const fareDetails = {
//   //       basePrice: parseFloat(pricing.basePrice) || 0,
//   //       baseDistance: parseFloat(pricing.baseDistance) || 0,
//   //       costPerKm: parseFloat(pricing.costPerKm) || 0
//   //     };

//   //     const formData = new FormData();

//   //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//   //     formData.append('busName', form.busName.trim());
//   //     formData.append('busType', form.busType);
//   //     formData.append('busCategory', form.busCategory);
//   //     formData.append('totalSeats', String(activeSeats.length));
//   //     formData.append('tripType', tripType);
//   //     formData.append('busClass', 'Economy');

//   //     formData.append('amenities', JSON.stringify(amenitiesArray));
//   //     formData.append('seats', JSON.stringify(finalSeatsPayload));
//   //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//   //     formData.append('routeSchedules', JSON.stringify(routeSchedules));
//   //     formData.append('fareDetails', JSON.stringify(fareDetails));
//   //     formData.append('operatingDays', JSON.stringify(operatingDays));
//   //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));

//   //     selectedImages.forEach((img, index) => {
//   //       if (img.file) {
//   //         formData.append('images', img.file);
//   //       }
//   //     });

//   //     if (selectedVideo && selectedVideo.file) {
//   //       formData.append('videos', selectedVideo.file);
//   //     }

//   //     const response = await addBusToOwner(ownerId, formData, token);

//   //     if (response && response.success) {
//   //       toast.success(tripType === 'roundTrip'
//   //         ? 'Bus added successfully with round trip routes!'
//   //         : 'Bus added successfully!'
//   //       );
//   //       onBusAdded();
//   //       onClose();
//   //     } else {
//   //       throw new Error(response?.message || 'Failed to add bus');
//   //     }

//   //   } catch (err) {
//   //     console.error('Error adding bus:', err);
//   //     setError(err.message || 'Failed to add bus');
//   //     toast.error(err.message || 'Failed to add bus');
//   //   } finally {
//   //     setIsSubmitting(false);
//   //   }
//   // };

// //   const handleSubmitBus = async () => {
// //   try {
// //     setIsSubmitting(true);
// //     setError(null);

// //     if (!validateBookingTime()) {
// //       setIsSubmitting(false);
// //       return;
// //     }

// //         if (!validateCancellationTime()) {
// //       setIsSubmitting(false);
// //       return;
// //     }

// //     if (!form.busNumber) throw new Error('Bus Number is required');
// //     if (!form.busName) throw new Error('Bus Name is required');
// //     if (!form.busType) throw new Error('Bus Type is required');
// //     if (!form.busCategory) throw new Error('Bus Category is required');
// //     if (!selectedRoute) throw new Error('Please select a route');
// //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
// //     if (!selectedTemplate) throw new Error('Please configure seat layout');
// //     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

// //     const amenitiesArray = form.amenities || [];

// //     const finalSeatsPayload = selectedTemplate.seats
// //       .filter(s => activeSeats.includes(s.seatNumber))
// //       .map(s => {
// //         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
// //         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
// //         const isBlocked = blockedSeats.includes(s.seatNumber);

// //         return {
// //           seatNumber: s.seatNumber,
// //           globalSeatIndex: finalGlobalIndex,
// //           row: s.row,
// //           column: s.column,
// //           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
// //           position: s.position || getSeatPosition(s.column),
// //           isBlocked: isBlocked,
// //           isAvailable: !isBlocked,
// //         };
// //       });

// //     const seatConfigPayload = {
// //       busType: selectedTemplate.configuration || '2*2',
// //       totalSeats: activeSeats.length
// //     };

// //     const routeSchedules = [];
// //     const routeIdToSave = selectedRoute._id || selectedRoute.id;

// //     routeSchedules.push({
// //       routeId: routeIdToSave,
// //       direction: 'UP',
// //       fareMatrix: fareMatrixUp,
// //       operatingDays: operatingDays,
// //       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
// //       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
// //     });

// //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //       routeSchedules.push({
// //         routeId: routeIdToSave,
// //         direction: 'DOWN',
// //         fareMatrix: fareMatrixDown,
// //         operatingDays: operatingDays,
// //         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
// //         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
// //       });
// //     }

// //     const fareDetails = {
// //       basePrice: parseFloat(pricing.basePrice) || 0,
// //       baseDistance: parseFloat(pricing.baseDistance) || 0,
// //       costPerKm: parseFloat(pricing.costPerKm) || 0
// //     };

// //     // Platform Fee object
// //     const platformFeeData = {
// //       type: platformFee.type,
// //       value: platformFee.value,
// //       applicableOn: platformFee.applicableOn
// //     };

// //     const formData = new FormData();

// //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
// //     formData.append('busName', form.busName.trim());
// //     formData.append('busType', form.busType);
// //     formData.append('busCategory', form.busCategory);
// //     formData.append('totalSeats', String(activeSeats.length));
// //     formData.append('tripType', tripType);
// //     formData.append('busClass', 'Economy');

// //     formData.append('cancellationTime', JSON.stringify(cancellationTime));

// //     formData.append('amenities', JSON.stringify(amenitiesArray));
// //     formData.append('seats', JSON.stringify(finalSeatsPayload));
// //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
// //     formData.append('routeSchedules', JSON.stringify(routeSchedules));
// //     formData.append('fareDetails', JSON.stringify(fareDetails));
// //     formData.append('operatingDays', JSON.stringify(operatingDays));
// //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
    
// //     // Append platform fee data
// //     formData.append('platformFee', JSON.stringify(platformFeeData));

// //     selectedImages.forEach((img, index) => {
// //       if (img.file) {
// //         formData.append('images', img.file);
// //       }
// //     });

// //     if (selectedVideo && selectedVideo.file) {
// //       formData.append('videos', selectedVideo.file);
// //     }

// //     const response = await addBusToOwner(ownerId, formData, token);

// //     if (response && response.success) {
// //       toast.success(tripType === 'roundTrip'
// //         ? 'Bus added successfully with round trip routes!'
// //         : 'Bus added successfully!'
// //       );
// //       onBusAdded();
// //       onClose();
// //     } else {
// //       throw new Error(response?.message || 'Failed to add bus');
// //     }

// //   } catch (err) {
// //     console.error('Error adding bus:', err);
// //     setError(err.message || 'Failed to add bus');
// //     toast.error(err.message || 'Failed to add bus');
// //   } finally {
// //     setIsSubmitting(false);
// //   }
// // };

// const handleSubmitBus = async () => {
//   try {
//     setIsSubmitting(true);
//     setError(null);

//     // ✅ DEBUG: Log selected images before submit
//     console.log('=== SUBMIT BUS DEBUG ===');
//     console.log('Selected images count:', selectedImages.length);
//     console.log('Selected video:', selectedVideo ? selectedVideo.name : 'None');
    
//     if (selectedImages.length > 0) {
//       selectedImages.forEach((img, i) => {
//         console.log(`Image ${i + 1}:`, img.file ? `${img.file.name} (${img.file.size} bytes, ${img.file.type})` : 'No file object');
//       });
//     }

//     // Validation
//     if (!validateBookingTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//     if (!validateCancellationTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//     if (!form.busNumber) throw new Error('Bus Number is required');
//     if (!form.busName) throw new Error('Bus Name is required');
//     if (!form.busType) throw new Error('Bus Type is required');
//     if (!form.busCategory) throw new Error('Bus Category is required');
//     if (!selectedRoute) throw new Error('Please select a route');
//     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
//     if (!selectedTemplate) throw new Error('Please configure seat layout');
//     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

//     // ⚠️ Warning if no images (but don't block submission)
//     if (selectedImages.length === 0) {
//       toast.warning('No images selected. It\'s recommended to add bus images.');
//     }

//     // Prepare data
//     const amenitiesArray = form.amenities || [];

//     const finalSeatsPayload = selectedTemplate.seats
//       .filter(s => activeSeats.includes(s.seatNumber))
//       .map(s => {
//         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//         const isBlocked = blockedSeats.includes(s.seatNumber);

//         return {
//           seatNumber: s.seatNumber,
//           globalSeatIndex: finalGlobalIndex,
//           row: s.row,
//           column: s.column,
//           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//           position: s.position || getSeatPosition(s.column),
//           isBlocked: isBlocked,
//           isAvailable: !isBlocked,
//         };
//       });

//     const seatConfigPayload = {
//       busType: selectedTemplate.configuration || '2*2',
//       totalSeats: activeSeats.length
//     };

//     const routeSchedules = [];
//     const routeIdToSave = selectedRoute._id || selectedRoute.id;

//     routeSchedules.push({
//       routeId: routeIdToSave,
//       direction: 'UP',
//       fareMatrix: fareMatrixUp,
//       operatingDays: operatingDays,
//       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//     });

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       routeSchedules.push({
//         routeId: routeIdToSave,
//         direction: 'DOWN',
//         fareMatrix: fareMatrixDown,
//         operatingDays: operatingDays,
//         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//       });
//     }

//     const fareDetails = {
//       basePrice: parseFloat(pricing.basePrice) || 0,
//       baseDistance: parseFloat(pricing.baseDistance) || 0,
//       costPerKm: parseFloat(pricing.costPerKm) || 0
//     };

//     const platformFeeData = {
//       type: platformFee.type,
//       value: platformFee.value,
//       applicableOn: platformFee.applicableOn
//     };

//     // ✅ CREATE FORMDATA
//     const formData = new FormData();

//     // ✅ Append all text fields
//     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//     formData.append('busName', form.busName.trim());
//     formData.append('busType', form.busType);
//     formData.append('busCategory', form.busCategory);
//     formData.append('totalSeats', String(activeSeats.length));
//     formData.append('tripType', tripType);
//     formData.append('busClass', 'Economy');
//     formData.append('cancellationTime', JSON.stringify(cancellationTime));
//     formData.append('amenities', JSON.stringify(amenitiesArray));
//     formData.append('seats', JSON.stringify(finalSeatsPayload));
//     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//     formData.append('routeSchedules', JSON.stringify(routeSchedules));
//     formData.append('fareDetails', JSON.stringify(fareDetails));
//     formData.append('operatingDays', JSON.stringify(operatingDays));
//     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//     formData.append('platformFee', JSON.stringify(platformFeeData));

//     // ✅ APPEND IMAGES - Using for loop instead of forEach with await
//     console.log('📸 Appending images to FormData...');
//     let imageAppendedCount = 0;
    
//     // ✅ Use a simple for loop instead of forEach to avoid async issues
//     for (let i = 0; i < selectedImages.length; i++) {
//       const img = selectedImages[i];
//       if (img.file) {
//         // Make sure it's a valid File object
//         if (img.file instanceof File || img.file instanceof Blob) {
//           formData.append('images', img.file);
//           imageAppendedCount++;
//           console.log(`✅ Appended image ${i + 1}: ${img.file.name} (${img.file.size} bytes)`);
//         } else {
//           console.error(`❌ Image ${i + 1} is not a valid File object:`, img.file);
//         }
//       }
//     }

//     console.log(`📸 Total images appended: ${imageAppendedCount}`);

//     // ✅ APPEND VIDEOS
//     if (selectedVideo && selectedVideo.file) {
//       if (selectedVideo.file instanceof File || selectedVideo.file instanceof Blob) {
//         formData.append('videos', selectedVideo.file);
//         console.log(`🎬 Appended video: ${selectedVideo.file.name} (${selectedVideo.file.size} bytes)`);
//       } else {
//         console.error('❌ Video is not a valid File object:', selectedVideo.file);
//       }
//     }

//     // ✅ DEBUG: Log all FormData entries (for debugging)
//     console.log('=== FORMDATA ENTRIES ===');
//     for (let [key, value] of formData.entries()) {
//       if (key === 'images' || key === 'videos') {
//         console.log(`${key}: ${value.name} (${value.size} bytes, ${value.type})`);
//       } else {
//         const stringValue = typeof value === 'string' ? value : String(value);
//         console.log(`${key}: ${stringValue.substring(0, 100)}${stringValue.length > 100 ? '...' : ''}`);
//       }
//     }

//     // ✅ Log the actual FormData for debugging
//     console.log('FormData size:', formData.getAll('images').length, 'images');
    
//     // ✅ SEND REQUEST
//     const response = await addBusToOwner(ownerId, formData, token);

//     console.log('=== RESPONSE ===', response);

//     if (response && response.success) {
//       toast.success(tripType === 'roundTrip'
//         ? 'Bus added successfully with round trip routes!'
//         : 'Bus added successfully!'
//       );
//       onBusAdded();
//       onClose();
//     } else {
//       throw new Error(response?.message || 'Failed to add bus');
//     }

//   } catch (err) {
//     console.error('❌ Error adding bus:', err);
//     setError(err.message || 'Failed to add bus');
//     toast.error(err.message || 'Failed to add bus');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || currentMatrix.length === 0) return null;

//     const sortedStops = [...(currentRoute.intermediateStops || [])]
//       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//     const allStops = [
//       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
//       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
//       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
//     ];

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">
//           {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//         </h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="from-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th className="price-cell" key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                         <span className="stop-type">{stop.type}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td
//                       className="from-cell"
//                       style={{ backgroundColor: getStopColor(row.fromType) }}
//                     >
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                         <span className="stop-type">{row.fromType}</span>
//                       </div>
//                     </td>
//                     {row.toCells.map((cell, colIndex) => {
//                       if (cell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{cell.distanceKm} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="number"
//                                   className="matrix-input"
//                                   value={cell.price}
//                                   onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//                                   min="0"
//                                   step="1"
//                                 />
//                               </div>
//                             </div>
//                            </td>
//                         );
//                       }
//                       return <td key={colIndex} className="na-cell">—</td>;
//                     })}
//                    </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return null;

//     const { seats, configuration } = selectedTemplate;

//     let leftCount = 2, rightCount = 2;
//     try {
//       if (configuration && configuration.includes('*')) {
//         const parts = configuration.split('*');
//         leftCount = parseInt(parts[0]) || 2;
//         rightCount = parseInt(parts[1]) || 2;
//       }
//     } catch (e) {
//       leftCount = 2;
//       rightCount = 2;
//     }

//     const totalConfigCols = leftCount + rightCount;

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) {
//         seatsByRow[seat.row] = [];
//       }
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const isSleeper = seatObj.seatType === 'sleeper' ||
//         seatObj.seatType === 'seat+sleeper' ||
//         selectedTemplate.seatType === 'sleeper' ||
//         selectedTemplate.seatType === 'seater+sleeper';

//       const displayLabel = isSelected
//         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
//         : "";

//       let seatClass = '';
//       if (isSelected) {
//         seatClass = isBlocked ? 'blocked' : 'selected';
//       } else {
//         seatClass = 'inactive';
//       }

//       return (
//         <button
//           key={seatObj.seatNumber}
//           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)}
//           type="button"
//         >
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];

//       const isBackRow = seatsInRow.some(s => s.position === 'back') ||
//         seatsInRow.length > totalConfigCols;

//       if (isBackRow) {
//         const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row back-row">
//             <div className="seats-container">
//               {sortedSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       } else {
//         const leftSeats = seatsInRow
//           .filter(s => (s.column || 0) <= leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         const rightSeats = seatsInRow
//           .filter(s => (s.column || 0) > leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row">
//             <div className="left-seats">
//               {leftSeats.map(seat => renderSeat(seat))}
//             </div>
//             <div className="aisle">Aisle</div>
//             <div className="right-seats">
//               {rightSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       }
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header">
//           <div className="driver-area">Driver</div>
//           <div className="bus-info">
//             <span className="bus-config">{selectedTemplate.configuration}</span>
//             <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
//           </div>
//         </div>
//         <div className="bus-body">
//           {rows}
//         </div>
//         <div className="seat-legend">
//           <div className="legend-item">
//             <div className="seat-sample selected"></div>
//             <span>Active Seat ({activeSeats.length})</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample inactive"></div>
//             <span>Inactive Seat</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample sleeper"></div>
//             <span>Sleeper</span>
//           </div>
//         </div>
//         <div className="seat-summary">
//           <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
//         </div>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">1</div>
//         <div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">2</div>
//         <div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">3</div>
//         <div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div>
//         <div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Bus Information</h3>
//         <p className="section-subtitle">Enter basic details about the bus</p>
//       </div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🚌</span>
//             Bus Number *
//           </label>
//           <input
//             type="text"
//             value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             placeholder="e.g., WB01AB1234"
//             className="modern-input"
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🏷️</span>
//             Bus Name *
//           </label>
//           <input
//             type="text"
//             value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             placeholder="e.g., Volvo Multi-Axle"
//             className="modern-input"
//             required
//           />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🖼️</span>
//           Bus Images
//         </h4>
//         <div className="images-upload-area">
//           <input
//             type="file"
//             id="bus-images"
//             multiple
//             accept="image/*"
//             onChange={handleImageUpload}
//             className="image-upload-input"
//             style={{ display: 'none' }}
//           />
//           <label htmlFor="bus-images" className="image-upload-label">
//             <span className="upload-icon">📁</span>
//             <span className="upload-text">Click to upload images</span>
//             <span className="upload-hint">Upload multiple images (max 10)</span>
//           </label>

//           {selectedImages.length > 0 && (
//             <div className="selected-images-preview">
//               <h5>Selected Images ({selectedImages.length})</h5>
//               <div className="images-grid">
//                 {selectedImages.map((image, index) => (
//                   <div key={index} className="image-preview-item">
//                     <img
//                       src={image.preview}
//                       alt={`Bus ${index + 1}`}
//                       className="preview-image"
//                     />
//                     <button
//                       type="button"
//                       className="remove-image-btn"
//                       onClick={() => removeImage(index)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* <div className="video-upload-section" style={{ marginTop: '15px' }}>
//             <input
//               type="file"
//               id="bus-video"
//               accept="video/*"
//               onChange={handleVideoUpload}
//               className="video-upload-input"
//               style={{ display: 'none' }}
//             />
//             <label htmlFor="bus-video" className="video-upload-label">
//               <span className="upload-icon">🎥</span>
//               <span className="upload-text">Click to upload video</span>
//               <span className="upload-hint">Upload one video (optional)</span>
//             </label>

//             {selectedVideo && (
//               <div className="selected-video-preview">
//                 <div className="video-info">
//                   <span className="video-name">{selectedVideo.name}</span>
//                   <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
//                 </div>
//                 <button
//                   type="button"
//                   className="remove-video-btn"
//                   onClick={removeVideo}
//                 >
//                   Remove
//                 </button>
//               </div>
//             )}
//           </div> */}
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">🔧</span>
//             Bus Type *
//           </label>
//           <select
//             value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_TYPES.map(type => (
//               <option key={type} value={type}>{type}</option>
//             ))}
//           </select>
//         </div>

//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">📊</span>
//             Bus Category *
//           </label>
//           <select
//             value={form.busCategory}
//             onChange={(e) => handleCategoryChange(e.target.value)}
//             className="modern-select"
//           >
//             <option value="">Select Category</option>
//             {BUS_CATEGORIES.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">⏰</span>
//           Booking Cut-off Time
//         </h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label className="input-label">Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="24"
//                 value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label className="input-label">Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="59"
//                 value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//       </div>

// <div className="section-card">
//   <h4 className="card-title">
//     <span className="title-icon">⏰</span>
//     Cancellation Time
//   </h4>
//   <div className="booking-time-container">
//     <div className="time-input-group">
//       <label className="input-label">Hours before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="48"
//           value={cancellationTime.hours}
//           onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">hours</span>
//       </div>
//     </div>
//     <div className="time-input-group">
//       <label className="input-label">Minutes before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="59"
//           value={cancellationTime.minutes}
//           onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">minutes</span>
//       </div>
//     </div>
//   </div>
//   <small className="helper-text">
//     Cancellation allowed up to this time before departure
//   </small>
// </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">✨</span>
//           Amenities
//         </h4>
//         <div className="amenities-grid compact">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-option compact">
//               <input
//                 type="checkbox"
//                 checked={form.amenities.includes(amenity)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: [...prev.amenities, amenity]
//                     }));
//                   } else {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: prev.amenities.filter(a => a !== amenity)
//                     }));
//                   }
//                 }}
//                 className="amenity-checkbox"
//               />
//               <span className="amenity-content">
//                 <span className="amenity-icon">✓</span>
//                 <span className="amenity-label">{amenity}</span>
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           className="modern-btn primary full-width"
//           onClick={() => setActiveTab('route')}
//           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
//         >
//           Continue to Route & Pricing
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Route & Pricing Configuration</h3>
//         <p className="section-subtitle">Select source, destination and configure pricing for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔄</span>
//           Trip Type
//         </h4>
//         <div className="trip-type-container">
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}
//           >
//             <span className="btn-icon">➡️</span>
//             One Way
//           </button>
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}
//           >
//             <span className="btn-icon">🔄</span>
//             Round Trip
//           </button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📍</span>
//           Source & Destination
//         </h4>
        
//         <div className="form-row">
//           <div className="form-group">
//             <label className="input-label">Source City *</label>
//             <input
//               type="text"
//               value={sourceCity}
//               onChange={(e) => {
//                 setSourceCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter source city"
//               className="modern-input"
//             />
//           </div>
    
//           <div className="form-group">
//             <label className="input-label">Destination City *</label>
//             <input
//               type="text"
//               value={destinationCity}
//               onChange={(e) => {
//                 setDestinationCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter destination city"
//               className="modern-input"
//             />
//           </div>

//        {/* Replace the existing OR search form-group */}
// <div className="form-group" style={{ marginTop: '10px' }}>
//   <label className="input-label">— OR — Search by Local Route Name</label>
//   <div style={{ position: 'relative' }}>
//     <input
//       type="text"
//       value={localRouteNameSearch}
//       onChange={(e) => {
//         const val = e.target.value;
//         setLocalRouteNameSearch(val);
//         setSelectedRoute(null);
//         // Clear city fields when using local name search
//         if (val.trim()) {
//           setSourceCity('');
//           setDestinationCity('');
//         }
//       }}
//       placeholder="e.g. Panskura to Bagnan local name..."
//       className="modern-input"
//     />
//     {localRouteSearchLoading && (
//       <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//         <div className="spinner-small"></div>
//       </div>
//     )}
//   </div>
//   <small className="helper-text">
//     Search routes directly by local name without entering city filters
//   </small>
// </div>
//         </div>
//       </div>

//       {/* {sourceCity && destinationCity && ( */}
//       {(sourceCity && destinationCity || availableRoutes.length > 0) && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">🗺️</span>
//             Select Route
//           </h4>
          
//           <div className="route-selector">
//   <label className="input-label">Available Routes *</label>
//   <div className="route-dropdown-container">
//     <input
//       type="text"
//       value={selectedRoute ? `${selectedRoute.localRouteName ? `${selectedRoute.localRouteName} - ` : ''}${selectedRoute.routeName}` : routeSearchTerm}
//       onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//       onChange={(e) => {
//         setRouteSearchTerm(e.target.value);
//         setShowRouteDropdown(true);
//         if (selectedRoute) setSelectedRoute(null);
//       }}
//       placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//       className="modern-input"
//       disabled={loadingRoutes}
//       style={{ cursor: 'pointer' }}
//     />
//     {loadingRoutes && (
//       <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//         <div className="spinner-small"></div>
//       </div>
//     )}
    
//     {showRouteDropdown && availableRoutes.length > 0 && (
//       <div className="route-dropdown">
//         <div className="dropdown-search">
//           <input
//             type="text"
//             value={routeSearchTerm}
//             onChange={(e) => setRouteSearchTerm(e.target.value)}
//             placeholder="Search routes..."
//             className="dropdown-search-input"
//             autoFocus
//           />
//         </div>
//         <div className="dropdown-list">
//           {filteredRoutes.length === 0 ? (
//             <div className="dropdown-empty">No matching routes</div>
//           ) : (
//             filteredRoutes.map((route) => (
//               <div
//                 key={route._id}
//                 className="dropdown-item"
//                 onClick={() => handleSelectRoute(route)}
//               >
//                <div className="route-number">
//   {route.localRouteName ? (
//     <div className="route-name-stack">
//       <div className="local-route-name">{route.localRouteName}</div>
//       <div className="route-name">{route.routeName}</div>
//     </div>
//   ) : (
//     <div className="route-name">{route.routeName}</div>
//   )}
// </div>
//                 <div className="route-details">
//                   {route.origin?.city} → {route.destination?.city} • 
//                   {route.isRoundTrip ? ' Round Trip' : ' One Way'} • 
//                   {route.routeDetails?.totalDistance || 0} km
//                 </div>
//                 {route.creatorType === 'BusOwner' && (
//                   <span className="owner-badge">Owner</span>
//                 )}
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     )}
//   </div>
  
//   {availableRoutes.length === 0 && sourceCity && destinationCity && !loadingRoutes && (
//     <div className="no-routes-message">
//       <p>No routes found for {sourceCity} → {destinationCity}</p>
//       <button type="button" onClick={handleAddNewRoute} className="create-route-btn">
//         + Create New Route
//       </button>
//     </div>
//   )}
  
//   {selectedRoute && selectedRoute.isRoundTrip && (
//     <small className="helper-text">✓ Round trip route selected - both UP and DOWN matrices will be generated</small>
//   )}
// </div>
//         </div>
//       )}

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📅</span>
//           Operating Days *
//         </h4>
//         <div className="days-grid compact">
//           {DAYS_OF_WEEK.map(day => (
//             <button
//               key={day}
//               type="button"
//               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}
//               title={day}
//             >
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//         <div className="selected-days">
//           Selected: {operatingDays.length} days
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💰</span>
//           Pricing Configuration
//         </h4>

//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>

//         {selectedRoute && (
//           <div className="pricing-summary">
//             <div className="summary-item">
//               <span>Category Multiplier:</span>
//               <span className="value accent">{getCategoryMultiplier()}x</span>
//             </div>
//             <div className="summary-item">
//               <span>Route Distance:</span>
//               <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
//             </div>
//           </div>
//         )}
//       </div>

//        <PlatformFeeConfig 
//       platformFee={platformFee} 
//       onChange={setPlatformFee} 
//     />

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('basic')}
//         >
//           ← Back
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary generate-matrix-btn"
//           onClick={() => {
//             handleGenerateMatrix();
//             if (fareMatrixUp.length > 0) {
//               setActiveTab('matrix');
//             }
//           }}
//           disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
//         >
//           Generate Fare Matrix
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Fare Matrix Configuration</h3>
//         <p className="section-subtitle">Review and edit fares for each route</p>
//       </div>

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}
//           >
//             Up Route: {selectedRoute.routeName}
//           </button>
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}
//           >
//             Down Route: Return Route
//           </button>
//         </div>
//       )}

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
//         <>
//           {activeMatrixTab === 'up' && renderMatrix('up')}
//           {activeMatrixTab === 'down' && renderMatrix('down')}
//         </>
//       ) : (
//         renderMatrix('up')
//       )}

//       <div className="matrix-info">
//         <div className="info-card">
//           <div className="info-item">
//             <span className="label">Total Stops:</span>
//             <span className="value">
//               {selectedRoute ?
//                 (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
//             </span>
//           </div>
//           <div className="info-item">
//             <span className="label">Category Multiplier:</span>
//             <span className="value accent">{getCategoryMultiplier()}x</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Base Price:</span>
//             <span className="value">₹{pricing.basePrice}</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Cost/km:</span>
//             <span className="value">₹{pricing.costPerKm}</span>
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('route')}
//         >
//           ← Back to Pricing
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={() => setActiveTab('seats')}
//           disabled={fareMatrixUp.length === 0}
//         >
//           Continue to Seat Layout
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Seat Layout Configuration</h3>
//         <p className="section-subtitle">Configure seat layout for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔧</span>
//           Bus Configuration
//         </h4>
//         <div className="config-selector">
//           <label className="input-label">Select Bus Configuration *</label>
//           {loadingLayouts ? (
//             <div className="loading-configs">
//               <span>Loading configurations...</span>
//             </div>
//           ) : (
//             <>
//               <div className="config-buttons">
//                 {availableConfigurations.map(config => (
//                   <button
//                     key={config}
//                     type="button"
//                     className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//                     onClick={() => {
//                       setSelectedConfiguration(config);
//                       setSelectedTemplate(null);
//                       setActiveSeats([]);
//                       setCustomSeatLabels({});
//                       fetchLayouts(config);
//                     }}
//                   >
//                     {config}
//                   </button>
//                 ))}
//               </div>
//               <small className="helper-text">
//                 {form.busCategory} bus with {selectedConfiguration} configuration
//               </small>
//             </>
//           )}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💺</span>
//           Seat Layout Template
//         </h4>

//         {!selectedTemplate ? (
//           <button
//             type="button"
//             className="modern-btn outline full-width"
//             onClick={openTemplateSelector}
//             disabled={loadingLayouts}
//           >
//             {loadingLayouts ? (
//               <>
//                 <span className="btn-icon">⏳</span>
//                 Loading Layouts...
//               </>
//             ) : (
//               <>
//                 <span className="btn-icon">📋</span>
//                 Select Layout Template
//               </>
//             )}
//           </button>
//         ) : (
//           <div className="selected-template-info">
//             <div className="template-details">
//               <span className="template-name">{selectedTemplate.name}</span>
//               <span className="template-config">{selectedTemplate.configuration}</span>
//               <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
//               <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
//             </div>
//             <button
//               type="button"
//               className="btn-small"
//               onClick={() => {
//                 setSelectedTemplate(null);
//                 setActiveSeats([]);
//                 setCustomSeatLabels({});
//               }}
//             >
//               Change
//             </button>
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">👁️</span>
//             Seat Layout Visualizer
//           </h4>
//           <button
//             type="button"
//             className="view-layout-btn"
//             onClick={() => setShowLayoutModal(true)}
//           >
//             View / Edit Seat Numbers
//           </button>

//           <div className="seat-summary">
//             <div className="summary-item">
//               <span>Total Seats in Template:</span>
//               <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
//             </div>
//             <div className="summary-item">
//               <span>Active Seats:</span>
//               <span className="value accent">{activeSeats.length}</span>
//             </div>
//             <div className="summary-item">
//               <span>Inactive Seats:</span>
//               <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('matrix')}
//         >
//           ← Back to Matrix
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={handleSubmitBus}
//           disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
//         >
//           {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
//           <span className="btn-icon">✓</span>
//         </button>
//       </div>
//     </div>
//   );

//   // Layout Modal and other modals remain the same...
//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Seat Numbers</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
//           <div className="seat-legend three-items">
//             <div className="legend-item">
//               <div className="seat-sample selected"></div>
//               <span>Active</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample blocked"></div>
//               <span>Blocked</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample inactive"></div>
//               <span>Disabled</span>
//             </div>
//           </div>
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <span>Total: {activeSeats.length}</span>
//             <div className="footer-actions">
//               <button className="auto-number-btn" onClick={autoRenumberSeats}>
//                 Auto-Number
//               </button>
//               <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Seat Layout Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {loadingLayouts ? (
//             <div className="loading-container">
//               <p>Loading templates...</p>
//             </div>
//           ) : layoutTemplates.length === 0 ? (
//             <div className="no-templates">
//               <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
//               <p className="hint">Available configurations with layouts:</p>
//               <div className="available-configs">
//                 {availableConfigurations.map(config => (
//                   <span key={config} className="config-chip">{config}</span>
//                 ))}
//               </div>
//               <p className="hint">Try selecting a different configuration</p>
//             </div>
//           ) : (
//             <div className="templates-grid">
//               {layoutTemplates.map(template => (
//                 <button
//                   type="button"
//                   key={template._id}
//                   className="template-card"
//                   onClick={() => handleSelectTemplate(template)}
//                 >
//                   <h4 className="template-name">{template.name}</h4>
//                   <div className="template-details">
//                     <span className="config">Config: {template.configuration}</span>
//                     <span className="seats">Seats: {template.totalSeats}</span>
//                   </div>
//                   <div className="template-preview">
//                     <span className="rows">Rows: {template.rows}</span>
//                     <span className="cols">Cols: {template.columns}</span>
//                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" style={{    "max-width": "500px",
//     "max-height": "35vh"}} onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Set Seat Label</h3>
//         </div>
//         <div className="modal-body">
//           <input
//             type="text"
//             value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="e.g. 1 or 1A"
//             className="seat-input"
//             autoFocus
//           />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button
//             className="modal-action-btn active-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Active
//           </button>
          
//           <button
//             className="modal-action-btn block-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               if (!blockedSeats.includes(editingSeat)) {
//                 setBlockedSeats([...blockedSeats, editingSeat]);
//               }
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Block
//           </button>
//           <button
//             className="modal-action-btn disable-btn"
//             onClick={() => {
//               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setEditingSeat(null);
//             }}
//           >
//             Disable
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">
//               <span className="title-icon">🚌</span>
//               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
//             </h2>
//             <p className="modal-subtitle">Configure bus details with route selection</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>
//             <span className="close-icon">×</span>
//           </button>
//         </div>

//         <div className="modal-body modern">
//           <ProgressSteps />

//           <div className="tab-container">
//             {activeTab === 'basic' && renderBasicInfoTab()}
//             {activeTab === 'route' && renderRouteTab()}
//             {activeTab === 'matrix' && renderMatrixTab()}
//             {activeTab === 'seats' && renderSeatLayoutTab()}
//           </div>

//           {error && (
//             <div className="error-message modern">
//               <span className="error-icon">⚠️</span>
//               {error}
//             </div>
//           )}
//         </div>
//       </div>

//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };
// const BusOwnerManage = () => {
//   const { token } = useSelector(state => state.user);
//   const [busOwners, setBusOwners] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingOwner, setEditingOwner] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingOwner, setViewingOwner] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showAddBusModal, setShowAddBusModal] = useState(false);
//   const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
//   const [busSearchTerm, setBusSearchTerm] = useState('');
//   const [newOwner, setNewOwner] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     companyName: ''
//   });
//   const [error, setError] = useState(null);
//   const [busUpdateTrigger, setBusUpdateTrigger] = useState(0);

//   // Bus Management states - UPDATED for new modal
//   const [showBusManagement, setShowBusManagement] = useState(false);
//   const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
//   const [selectedOwner, setSelectedOwner] = useState(null);
//   const [busDetailsLoading, setBusDetailsLoading] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalOwners, setTotalOwners] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   const getFullImageUrl = (imagePath) => {
//     if (imagePath.startsWith('http')) {
//       return imagePath;
//     }
//     return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
//   };

//   useEffect(() => {
//     fetchBusOwners();
//   }, [currentPage]);



//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchBusOwners();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

// const refreshBusList = async () => {
//   if (!selectedOwner) return;
  
//   try {
//     setBusDetailsLoading(true);
//     const response = await getBusOwnerById(selectedOwner.id, token);
    
//     if (response.success && response.data) {
//       // Try busAll first, fall back to buses array
//       const busData = response.data.busAll || response.data.buses || [];
      
//       const processedBuses = busData.map(bus => {
//         const driver = bus.driver ? {
//           name: bus.driver.name || 'N/A',
//           contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//           licenseNumber: bus.driver.licenseNumber || 'N/A',
//           experience: bus.driver.experience || 0
//         } : null;

//         const conductor = bus.conductor ? {
//           name: bus.conductor.name || 'N/A',
//           contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//         } : null;

//         return { ...bus, driver, conductor };
//       });
      
//       // This updates the buses shown in BusManagementModal
//       setSelectedOwnerBuses(processedBuses);
      
//       setSelectedOwner(prev => ({
//         ...prev,
//         busAll: busData
//       }));
//     }
//   } catch (err) {
//     console.error('Error refreshing bus list:', err);
//     toast.error('Failed to refresh bus list');
//   } finally {
//     setBusDetailsLoading(false);
//   }
// };

//   const fetchBusOwners = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const response = await getBusOwners(token, currentPage, pageSize, searchTerm);
// console.log("getBusOwners : ",response)
//       if (response && response.success && response.busOwners) {
//         const transformedOwners = response.busOwners.map((owner, index) => ({
//           id: owner._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: owner.profileImage || '',
//           name: owner.name || '',
//           company: owner.companyName || '',
//           email: owner.email || '',
//           phone: owner.phone || '',
//           buses: owner.busCount || 0,
//           routes: owner.routeCount || 0,
//           joined: new Date(owner.createdAt).toISOString().split('T')[0],
//           status: owner.isVerified ? 'Verified' : 'Pending',
//           adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
//           _id: owner._id,
//           isVerified: owner.isVerified,
//           isProfileComplete: owner.isProfileComplete,
//           isApprovedByAdmin: owner.isApprovedByAdmin,
//           activeBuses: owner.activeBuses || 0,
//           driverCount: owner.driverCount || 0,
//           conductorCount: owner.conductorCount || 0,
//           createdAt: owner.createdAt,
//           updatedAt: owner.updatedAt,
//           address: owner.address || {},
//           city: owner.address?.city || '',
//           state: owner.address?.state || owner.state || '',
//           pincode: owner.address?.pincode || '',
//           busAll: owner.busAll || []
//         }));

//         setBusOwners(transformedOwners);

//         if (response.totalPages) {
//           setTotalPages(response.totalPages);
//         }
//         if (response.total) {
//           setTotalOwners(response.total);
//         } else {
//           setTotalOwners(response.busOwners.length);
//         }
//       } else {
//         setError('No bus owners data found in response');
//         setBusOwners([]);
//         setTotalPages(1);
//         setTotalOwners(0);
//       }
//     } catch (err) {
//       console.error('Error fetching bus owners:', err);
//       setError('Failed to fetch bus owners. Please try again.');
//       setBusOwners([]);
//       setTotalPages(1);
//       setTotalOwners(0);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const fetchBusOwnerById = async (id) => {
//     try {
//       const response = await getBusOwnerById(id, token);
//       console.log("response.data : ", response.data)
//       return response.data || response;
//     } catch (err) {
//       console.error('Error fetching bus owner:', err);
//       throw err;
//     }
//   };

// const handleApproveOwner = async (ownerId) => {
//   try {
//     setError(null);
//     const response = await approveBusOwner(ownerId, token);

//     if (response.success) {
//       setBusOwners(prevOwners =>
//         prevOwners.map(owner =>
//           owner.id === ownerId ? {
//             ...owner,
//             isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
//             adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending',
//             // Add these lines to update the status and verification
//             isVerified: response.data?.isVerified || true,
//             status: response.data?.isVerified ? 'Verified' : 'Pending'
//           } : owner
//         )
//       );
//       toast.success('Bus owner approved and verified successfully!');
//     } else {
//       throw new Error(response.message || 'Failed to approve bus owner');
//     }
//   } catch (err) {
//     console.error('Error approving bus owner:', err);
//     setError('Failed to approve bus owner. Please try again.');
//     toast.error('Failed to approve bus owner. Please try again.');
//   }
// };

//   const handleManageBuses = async (owner) => {
//     console.log("handleManageBuses ; ", owner)
//     if (owner.buses === 0) {
//       // alert('This owner has no buses registered.');
//       toast.error("This owner has no buses registered")
//       return;
//     }

//     console.log('Owner bus data:', owner);

//     // Check if busAll exists and has data
//     if (!owner.busAll || owner.busAll.length === 0) {
//       // If no bus data, try to fetch it separately
//       try {
//         setBusDetailsLoading(true);
//         const response = await getBusOwnerById(owner.id, token);

//         if (response.success && response.data && response.data.busAll) {
//           // Update the owner with bus data
//           const updatedOwner = {
//             ...owner,
//             busAll: response.data.busAll || []
//           };

//           // Process the bus data
//           const processedBuses = updatedOwner.busAll.map(bus => {
//             const driver = bus.driver ? {
//               name: bus.driver.name || 'N/A',
//               contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//               licenseNumber: bus.driver.licenseNumber || 'N/A',
//               experience: bus.driver.experience || 0
//             } : null;

//             const conductor = bus.conductor ? {
//               name: bus.conductor.name || 'N/A',
//               contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//             } : null;

//             return {
//               ...bus,
//               driver,
//               conductor
//             };
//           });

//           console.log('Fetched and processed buses:', processedBuses);

//           setSelectedOwner(updatedOwner);
//           setSelectedOwnerBuses(processedBuses);
//           setShowBusManagement(true);
//           setBusSearchTerm('');
//         } else {
//           alert('Could not fetch bus data. Please try again.');
//         }
//       } catch (err) {
//         console.error('Error fetching bus details:', err);
//         alert('Failed to fetch bus details. Please try again.');
//       } finally {
//         setBusDetailsLoading(false);
//       }
//       return;
//     }

//     // If busAll data exists, process it
//     const processedBuses = owner.busAll.map(bus => {
//       const driver = bus.driver ? {
//         name: bus.driver.name || 'N/A',
//         contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//         licenseNumber: bus.driver.licenseNumber || 'N/A',
//         experience: bus.driver.experience || 0
//       } : null;

//       const conductor = bus.conductor ? {
//         name: bus.conductor.name || 'N/A',
//         contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//       } : null;

//       return {
//         ...bus,
//         driver,
//         conductor
//       };
//     });

//     console.log('Processed buses:', processedBuses);

//     setSelectedOwner(owner);
//     setSelectedOwnerBuses(processedBuses);
//     setShowBusManagement(true);
//     setBusSearchTerm('');
//   };
//   // Add this function after your other handler functions
//   const filteredBuses = selectedOwnerBuses.filter(bus =>
//     (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
//     (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
//   );

//   const handleRejectOwner = async (ownerId) => {
//     if (window.confirm('Are you sure you want to reject this bus owner?')) {
//       try {
//         setError(null);

//         if (!ownerId || typeof ownerId !== 'string') {
//           throw new Error('Invalid owner ID');
//         }

//         const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === ownerId ? {
//                 ...owner,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
//                 adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
//               } : owner
//             )
//           );
//           toast.success('Bus owner rejected successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to reject bus owner');
//         }
//       } catch (err) {
//         console.error('Error rejecting bus owner:', err);
//         setError('Failed to reject bus owner. Please try again.');
//         toast.error('Failed to reject bus owner. Please try again.');
//       }
//     }
//   };

//   const filteredOwners = busOwners;

//   const handleViewOwner = async (owner) => {
//     try {
//       const ownerData = await fetchBusOwnerById(owner.id);
//       setViewingOwner({
//         ...owner,
//         profileImage: ownerData.profileImage || owner.profileImage,
//         name: ownerData.name || owner.name,
//         company: ownerData.companyName || owner.company,
//         email: ownerData.email || owner.email,
//         phone: ownerData.phone || owner.phone,
//         address: ownerData.address || owner.address,
//         isVerified: ownerData.isVerified,
//         isProfileComplete: ownerData.isProfileComplete,
//         isApprovedByAdmin: ownerData.isApprovedByAdmin,

//         // Stats (numbers for the stat cards)
//         busCount: ownerData.stats?.busCount || 0,      // ← renamed to busCount
//         activeBuses: ownerData.stats?.activeBuses || 0,
//         driverCount: ownerData.stats?.driverCount || 0,
//         conductorCount: ownerData.stats?.conductorCount || 0,

//         // Arrays for the detail sections
//         routes: ownerData.routes || [],
//         buses: ownerData.buses || [],                   // ← array only, no conflict

//         status: ownerData.isApprovedByAdmin ? 'Active' : 'Pending',
//         joined: ownerData.createdAt
//           ? new Date(ownerData.createdAt).toLocaleDateString()
//           : owner.joined,
//       });
//     } catch (err) {
//       setViewingOwner(owner);
//       toast.info('Could not fetch latest owner details. Showing cached data.');
//     }
//   };

//   const handleEditOwner = (owner) => {
//     setEditingOwner(owner.id);
//     setEditForm({
//       name: owner.name || '',
//       companyName: owner.company || '',
//       email: owner.email || '',
//       phone: owner.phone || '',
//       status: owner.status || 'Pending',
//       isApprovedByAdmin: owner.isApprovedByAdmin || false
//     });
//   };

//   const closeBusManagement = () => {
//     setShowBusManagement(false);
//     setSelectedOwnerBuses([]);
//     setSelectedOwner(null);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       if (!editingOwner || typeof editingOwner !== 'string') {
//         throw new Error('Invalid owner ID for editing');
//       }

//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phone: editForm.phone,
//         companyName: editForm.companyName,
//         isVerified: editForm.status === 'Verified',
//         isApprovedByAdmin: editForm.isApprovedByAdmin
//       };

//       const response = await updateBusOwner(editingOwner, updateData, token);

//       if (response.success) {
//         setBusOwners(prevOwners =>
//           prevOwners.map(owner =>
//             owner.id === editingOwner ? {
//               ...owner,
//               name: response.data?.name || editForm.name,
//               company: response.data?.companyName || editForm.companyName,
//               email: response.data?.email || editForm.email,
//               phone: response.data?.phone || editForm.phone,
//               status: response.data?.isVerified ? 'Verified' : 'Pending',
//               isVerified: response.data?.isVerified,
//               isApprovedByAdmin: response.data?.isApprovedByAdmin,
//               adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
//             } : owner
//           )
//         );

//         setEditingOwner(null);
//         setEditForm({});
//         toast.success('Bus owner updated successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to update bus owner');
//       }
//     } catch (err) {
//       console.error('Error updating bus owner:', err);
//       setError('Failed to update bus owner. Please try again.');
//       toast.error('Failed to update bus owner. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingOwner(null);
//     setEditForm({});
//     setError(null);
//   };

//   // const handleDeleteOwner = async (ownerId) => {
//   //   if (window.confirm('Are you sure you want to delete this bus owner?')) {
//   //     try {
//   //       setError(null);
//   //       const response = await deleteBusOwner(ownerId, token);

//   //       if (response.success) {
//   //         setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//   //         setTotalOwners(prev => prev - 1);
//   //         toast.success('Bus owner deleted successfully!');
//   //       } else {
//   //         throw new Error(response.message || 'Failed to delete bus owner');
//   //       }
//   //     } catch (err) {
//   //       console.error('Error deleting bus owner:', err);
//   //       setError('Failed to delete bus owner. Please try again.');
//   //       toast.error('Failed to delete bus owner. Please try again.');
//   //     }
//   //   }
//   // };

//   const handleDeleteOwner = async (ownerId) => {
//   if (window.confirm('Are you sure you want to delete this bus owner?')) {
//     try {
//       setError(null);
//       const response = await deleteBusOwner(ownerId, token);

//       if (response.success) {
//         setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//         setTotalOwners(prev => prev - 1);
//         toast.success('Bus owner deleted successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to delete bus owner');
//       }
//     } catch (err) {
//       console.error('Error deleting bus owner:', err);
      
//       // Extract the error message from the response
//       const errorMessage = err.response?.data?.message || err.message || 'Failed to delete bus owner. Please try again.';
      
//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   }
// };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleNewOwnerChange = (e) => {
//     const { name, value } = e.target;
//     setNewOwner(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleAddOwner = async () => {
//     try {
//       setError(null);

//       if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
//         toast.error('Please fill in all required fields');
//         return;
//       }

//       const response = await createBusOwner(newOwner, token);
//       console.log("response............ : ", response)
//       if (response.success) {
//         const newOwnerWithId = {
//           id: response.data.id,
//           serialNo: busOwners.length + 1,
//           profileImage: '',
//           name: response.data.name,
//           company: response.data.companyName,
//           email: response.data.email,
//           phone: response.data.phone,
//           buses: 0,
//           routes: 0,
//           joined: new Date(response.data.createdAt).toISOString().split('T')[0],
//           status: 'Pending',
//           adminApproval: 'Pending',
//           isVerified: false,
//           isApprovedByAdmin: false,
//           createdAt: response.data.createdAt
//         };

//         setBusOwners(prev => [newOwnerWithId, ...prev]);
//         setTotalOwners(prev => prev + 1);
//         setShowAddModal(false);
//         setNewOwner({
//           name: '',
//           companyName: '',
//           email: '',
//           phone: ''
//         });
//          setSearchTerm('');
//         toast.success('Bus owner added successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to add bus owner');
//       }
//     } catch (err) {
//       console.error('Error adding bus owner:', err);

//       // Extract error message from the response
//       let errorMessage = 'Failed to add bus owner. Please try again.';

//       if (err.response?.data?.message) {
//         // Get the message from the API response
//         errorMessage = err.response.data.message;
//       } else if (err.message) {
//         errorMessage = err.message;
//       }

//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const closeViewModal = () => {
//     setViewingOwner(null);
//   };

//   const closeAddModal = () => {
//     setShowAddModal(false);
//     setNewOwner({
//       name: '',
//       companyName: '',
//       email: '',
//       phone: ''
//     });
//     setError(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     // The useEffect will trigger fetchBusOwners automatically
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const currentPageOwners = busOwners;
//   const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
//   const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
//   const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

//   const handleAddBusClick = (owner) => {
//     setSelectedOwnerForBus(owner);
//     setShowAddBusModal(true);
//   };

//   const handleBusAdded = () => {
//     fetchBusOwners();
//     toast.success('Bus added successfully!');
//   };

//   const closeAddBusModal = () => {
//     setShowAddBusModal(false);
//     setSelectedOwnerForBus(null);
//   };

//   if (loading && busOwners.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Bus Owner Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search bus owners by name, company, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Owner
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Owners</h3>
//           <p>{totalOwners}</p>
//           <span>All registered owners</span>
//         </div>
//         <div className="stat-card">
//           <h3>Verified Owners</h3>
//           <p>{verifiedOwners}</p>
//           <span>Verified on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Approved Owners</h3>
//           <p>{approvedOwners}</p>
//           <span>Approved on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{totalBuses}</p>
//           <span>active fleet</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Profile</th>
//               <th>Owner Name</th>
//               <th>Company</th>
//               <th>Contact</th>
//               <th>Buses</th>
//               <th>Admin Approval</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOwners.length > 0 ? (
//               filteredOwners.map(owner => (
//                 <tr key={owner.id}>
//                   <td>{owner.serialNo}</td>
//                   <td>
//                     <div className="profile-image-cell">
//                       <img
//                         src={getFullImageUrl(owner.profileImage)}
//                         alt={owner.name || 'Bus Owner'}
//                         className="customer-avatar"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                         }}
//                       />
//                     </div>
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Owner Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.name || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="companyName"
//                         value={editForm.companyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Company Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.company || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div>{owner.email || 'N/A'}</div>
//                         <div className="phone">{owner.phone || 'N/A'}</div>
//                       </div>
//                     )}
//                   </td>

//                   <td>{owner.buses}</td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="isApprovedByAdmin"
//                         value={editForm.isApprovedByAdmin || false}
//                         onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="true">Approved</option>
//                         <option value="false">Pending</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || 'Pending'}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="Verified">Verified</option>
//                         <option value="Pending">Pending</option>
//                         <option value="Suspended">Suspended</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
//                         {owner.status || 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
//                         <button
//                           className="action-btn save"
//                           onClick={handleSaveEdit}
//                           style={{ backgroundColor: '#28a745', color: 'white' }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="action-btn cancel"
//                           onClick={handleCancelEdit}
//                           style={{ backgroundColor: '#6c757d', color: 'white' }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewOwner(owner)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditOwner(owner)}
//                         >
//                           Edit
//                         </button>

//                         <button
//                           className="action-btn add-bus"
//                           onClick={() => handleAddBusClick(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title="Add new bus for this owner"
//                         >
//                           + Add Bus
//                         </button>

//                         <button
//                           className="action-btn manage"
//                           onClick={() => handleManageBuses(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
//                         >
//                           Manage Buses
//                         </button>

//                         {!owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveOwner(owner.id)}
//                             style={{ backgroundColor: '#28a745' }}
//                           >
//                             Approve
//                           </button>
//                         )}
//                         {owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectOwner(owner.id)}
//                             style={{ backgroundColor: '#ffc107', color: '#000' }}
//                           >
//                             Reject
//                           </button>
//                         )}
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteOwner(owner.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="no-data">
//                   <p>No bus owners found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all bus owners
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {filteredOwners.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No bus owners found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {busOwners.length} of {totalOwners} bus owners
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages || totalPages === 0}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Modal */}
//       {/* {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Owner Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={getFullImageUrl(viewingOwner.profileImage)}
//                     alt={viewingOwner.name || 'Bus Owner'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Serial No:</label>
//                   <span>{viewingOwner.serialNo}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>ID:</label>
//                   <span>#{viewingOwner.id}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Owner Name:</label>
//                   <span>{viewingOwner.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Company:</label>
//                   <span>{viewingOwner.company || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingOwner.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingOwner.phone || 'N/A'}</span>
//                 </div>

//                 <div className="detail-row">
//                   <label>Address:</label>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                     {viewingOwner.address?.city && (
//                       <span>City: {viewingOwner.address.city}</span>
//                     )}
//                     {viewingOwner.address?.state && (
//                       <span>State: {viewingOwner.address.state}</span>
//                     )}
//                     {viewingOwner.address?.pincode && (
//                       <span>Pincode: {viewingOwner.address.pincode}</span>
//                     )}
//                     {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
//                       <span>N/A</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className="detail-row">
//                   <label>Total Buses:</label>
//                   <span>{viewingOwner.buses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Active Buses:</label>
//                   <span>{viewingOwner.activeBuses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Drivers:</label>
//                   <span>{viewingOwner.driverCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Conductors:</label>
//                   <span>{viewingOwner.conductorCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{viewingOwner.joined}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
//                     {viewingOwner.status || 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Admin Approval:</label>
//                   <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                     {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Profile Complete:</label>
//                   <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Verified:</label>
//                   <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}
//       {/* View Modal */}
//       {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modern-dashboard-modal" onClick={(e) => e.stopPropagation()}>

//             {/* Header with Glassmorphism */}
//             <header className="dashboard-header">
//               <div className="header-left">
//                 <div className="icon-box"><i className="fas fa-bus"></i></div>
//                 <div>
//                   <h3>Bus Owner Profile</h3>
//                   <span className="subtitle">Management Console</span>
//                 </div>
//               </div>
//               <button className="close-icon-btn" onClick={closeViewModal}>&times;</button>
//             </header>

//             <div className="dashboard-body">

//               {/* Top Section: Profile & Stats Combined */}
//               <section className="profile-overview-card">
//                 <div className="owner-brand">
//                   <div className="avatar-wrapper">
//                     <img
//                       src={getFullImageUrl(viewingOwner.profileImage)}
//                       alt="Profile"
//                       onError={(e) => { e.target.src = ''; }}
//                     />
//                     {viewingOwner.isVerified && <div className="verified-badge"><i className="fas fa-check"></i></div>}
//                   </div>
//                   <div className="brand-details">
//                     <h2>{viewingOwner.name || 'N/A'}</h2>
//                     <p className="owner-id-tag">ID: {viewingOwner.id}</p>
//                     <div className="quick-tags">
//                       <span className={`tag ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {viewingOwner.isApprovedByAdmin ? 'Verified Partner' : 'Pending Review'}
//                       </span>
//                       <span className="tag city-tag"><i className="fas fa-map-marker-alt"></i> {viewingOwner.address?.city}, {viewingOwner.address?.state}</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="stats-strip">
//                   <div className="stat-node">
//                     <label>Buses</label>
//                     <div className="value">{viewingOwner.busCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Drivers</label>
//                     <div className="value">{viewingOwner.driverCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Conductors</label>
//                     <div className="value">{viewingOwner.conductorCount || 0}</div>
//                   </div>
//                 </div>
//               </section>

//               {/* Horizontal Routes List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-route"></i> Active Routes</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.routes?.map((route, index) => (
//                     <div key={index} className="modern-row-card route-row">
//                       <div className="row-main-info">
//                         <div className="route-code">{route.routeNumber}</div>
//                         <div className="journey-stepper">
//                           <span className="">{route.origin?.city}</span>
//                           <div className="connector-line">
//                             <i className="fas fa-chevron-right"></i>
//                           </div>
//                           <span className="">{route.destination?.city}</span>
//                         </div>
//                       </div>
//                       <div className="row-meta-info">
//                         <div className="meta-item"><i className="fas fa-road"></i> {route.routeDetails?.totalDistance} km</div>
//                         <div className="meta-item"><i className="fas fa-clock"></i> {route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</div>
//                         <div className="meta-item bus-pill"><i className="fas fa-bus-alt"></i> {route.busCount} assigned</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </section>

//               {/* Horizontal Buses List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-shuttle-van"></i> Bus Details</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.buses?.map((bus, index) => (
//                     <div key={index} className="modern-row-card bus-row">
//                       <div className="bus-identity">
//                         <div className={`status-indicator ${bus.isActive ? 'online' : 'offline'}`}></div>
//                         <div>
//                           <strong>{bus.busName}</strong>
//                           <div className="plate-number">{bus.busNumber}</div>
//                         </div>
//                       </div>

//                       <div className="bus-specs-row">
//                         <span><i className="fas fa-chair"></i> {bus.totalSeats} Seats</span>
//                         <span><i className="fas fa-snowflake"></i> {bus.busType}</span>
//                       </div>

//                       <div className="bus-amenities-tags">
//                         {bus.amenities?.slice(0, 2).map((a, i) => <span key={i} className="mini-tag">{a}</span>)}
//                       </div>

//                       {/* <div className="bus-action-link">
//                   <button className="view-tracking-btn">Live Track</button>
//                 </div> */}
//                     </div>
//                   ))}
//                 </div>
//               </section>

//             </div>

//             <footer className="dashboard-footer">
//               <button className="btn-secondary" onClick={closeViewModal}>close</button>
//             </footer>
//           </div>
//         </div>
//       )}
//       {/* NEW - Modern Bus Management Modal */}
// {/* Update the BusManagementModal component call */}
// {showBusManagement && selectedOwner && (
//   <BusManagementModal
//     key={busUpdateTrigger} // Add this to force re-render
//     owner={selectedOwner}
//     buses={selectedOwnerBuses}
//     onClose={closeBusManagement}
//     onUpdate={async () => {
//       await refreshBusList();
//       await fetchBusOwners();
//     }}
//   />
// )}

//       {/* Add Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={closeAddModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Bus Owner</h3>
//               <button className="modal-close-btn" onClick={closeAddModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Owner Name *:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={newOwner.name}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter owner name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Company Name *:</label>
//                   <input
//                     type="text"
//                     name="companyName"
//                     value={newOwner.companyName}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter company name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Email *:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={newOwner.email}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter email address"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone *:</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={newOwner.phone}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter phone number"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeAddModal}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleAddOwner}>
//                 Add Owner
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add Bus Modal */}
//       {showAddBusModal && selectedOwnerForBus && (
//         <AddBusModal
//           ownerId={selectedOwnerForBus.id}
//           onClose={closeAddBusModal}
//           onBusAdded={handleBusAdded}
//         />
//       )}
//     </div>
//   );
// };

// export default BusOwnerManage;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//   getBusOwners,
//   getBusOwnerById,
//   createBusOwner,
//   updateBusOwner,
//   deleteBusOwner,
//   approveBusOwner,
//   addBusToOwner,
//   getSeatLayoutsByBustype,
//   getAllCategory
// } from '../../Services/Operations/ProductAPI';
// import {
//   getDriversByBusOwner,
//   getConductorsByBusOwner,
//   assignDriverToBus,
//   assignConductorToBus,
//   unassignDriverFromBus,
//   unassignConductorFromBus
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/BusFareChart.css';
// import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';

// const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
//   const { token } = useSelector(state => state.user);
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   // Add this with your other states
// const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
// const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']); // Default

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     totalSeats: '',
//     amenities: [],
//     busClass: 'Economy',
//     images: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [routes, setRoutes] = useState([]);
//   const [selectedRouteUp, setSelectedRouteUp] = useState(null);
//   const [selectedRouteDown, setSelectedRouteDown] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false); // Add loading state

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Selected Images
//   const [selectedImages, setSelectedImages] = useState([]);

//   // Constants
//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const BUS_CLASSES = ['Economy', 'Premium', 'Luxury'];

//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle', 
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks', 
//     'GPS Tracking', 'SOS Switch'
//   ];

//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

// // Call this when component mounts or when category changes
// // Fetch configurations when category changes
// useEffect(() => {
//   if (form.busCategory) {
//     fetchAvailableConfigurations();
//   }
// }, [form.busCategory, token]);
//   // Helper Functions
//   const getCategoryMultiplier = () => {
//     const multipliers = {
//       'Seater': 1.0,
//       'Sleeper': 1.5,
//       'Seater+Sleeper': 1.3
//     };
//     return multipliers[form.busCategory] || 1.0;
//   };


//   const getStopColor = (type) => {
//     switch(type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   // Fetch Routes
//   useEffect(() => {
//     const fetchRoutes = async () => {
//       try {
//         setLoadingRoutes(true);
//         const response = await getAllBusownerAdminRoutes(token, 1, 100, '', ownerId);
//         if (response && response.success && response.routes) {
//           setRoutes(response.routes);
//         }
//       } catch (error) {
//         console.error('Error fetching routes:', error);
//         toast.error('Failed to fetch routes');
//       } finally {
//         setLoadingRoutes(false);
//       }
//     };

//     fetchRoutes();
//   }, [token, ownerId]);

// // Fetch Layout Templates based on selected configuration
// const fetchLayouts = async (config) => {
//   try {
//     if (!config) return;

//     setLoadingLayouts(true);

//     // Format the config for API (replace x with * if needed)
//     let bustype = config.replace('x', '*');

//     console.log(`Fetching layouts for bustype: ${bustype}`);

//     // Call the API with the bustype parameter
//     const response = await getSeatLayoutsByBustype(bustype, token);

//     console.log('Layout API Response:', response);

//     if (response && response.success) {
//       if (response.data && Array.isArray(response.data)) {
//         // Filter layouts by seat type if category is specific
//         let filteredLayouts = response.data;

//         if (form.busCategory === 'Seater') {
//           filteredLayouts = response.data.filter(layout => 
//             layout.seatType === 'seat' || layout.seatType === 'seater'
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           filteredLayouts = response.data.filter(layout => 
//             layout.seatType === 'sleeper'
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           filteredLayouts = response.data.filter(layout => 
//             layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//           );
//         }

//         setLayoutTemplates(filteredLayouts);

//         if (filteredLayouts.length === 0) {
//           toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
//         } else {
//           toast.success(`Found ${filteredLayouts.length} layout(s) for ${config}`);
//         }
//       } else {
//         setLayoutTemplates([]);
//         toast.info(`No layouts found for ${config} configuration`);
//       }
//     } else {
//       console.error('Failed to fetch layouts:', response);
//       setLayoutTemplates([]);
//       toast.error(response?.message || 'Failed to load seat layouts');
//     }
//   } catch (error) {
//     console.error("Layout Fetch Error:", error);
//     toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
//     setLayoutTemplates([]);
//   } finally {
//     setLoadingLayouts(false);
//   }
// };

// // Handle Category Change - only set category, don't fetch layouts
// const handleCategoryChange = (category) => {
//   setForm(prev => ({ ...prev, busCategory: category }));
//   // Reset selected template when category changes
//   setSelectedTemplate(null);
//   setActiveSeats([]);
//   setLayoutTemplates([]); // Clear templates
//   // Don't fetch layouts here - wait for configuration selection
// };

// const fetchAvailableConfigurations = async () => {
//   try {
//     setLoadingLayouts(true);
//     const response = await getAllCategory(token);

//     if (response && response.success && response.data) {
//       // Filter categories by selected bus category and available seat types
//       let relevantCategories = response.data;

//       if (form.busCategory === 'Seater') {
//         relevantCategories = response.data.filter(cat => 
//           cat.availableSeatTypes?.includes('seat') || 
//           cat.availableSeatTypes?.includes('seater')
//         );
//       } else if (form.busCategory === 'Sleeper') {
//         relevantCategories = response.data.filter(cat => 
//           cat.availableSeatTypes?.includes('sleeper')
//         );
//       } else if (form.busCategory === 'Seater+Sleeper') {
//         relevantCategories = response.data.filter(cat => 
//           cat.availableSeatTypes?.includes('seater+sleeper') || 
//           cat.availableSeatTypes?.includes('seat+sleeper')
//         );
//       }

//       // Extract configurations from filtered categories
//       const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//       if (configs.length > 0) {
//         setAvailableConfigurations(configs);
//         // Don't auto-fetch layouts - let user select configuration first
//         setSelectedConfiguration(configs[0]);
//         // Clear any existing templates
//         setLayoutTemplates([]);
//       } else {
//         setAvailableConfigurations([]);
//         setLayoutTemplates([]);
//         toast.info(`No configurations available for ${form.busCategory}`);
//       }
//     }
//   } catch (error) {
//     console.error('Error fetching configurations:', error);
//     setAvailableConfigurations([]);
//   } finally {
//     setLoadingLayouts(false);
//   }
// };

//   // Image Handlers
//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];

//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({
//           file: file,
//           preview: e.target.result,
//           name: file.name
//         });

//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

// // Template Selection
// const openTemplateSelector = () => {
//   if (!form.busCategory) {
//     toast.error('Please select a Bus Category first');
//     return;
//   }
//   if (!selectedConfiguration) {
//     toast.error('Please select a Bus Configuration first');
//     return;
//   }
//   if (layoutTemplates.length === 0) {
//     toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
//     return;
//   }
//   setShowTemplateModal(true);
// };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);

//     // Initialize all seats as active by default
//     const allSeatNumbers = template.seats.map(s => s.seatNumber);
//     setActiveSeats(allSeatNumbers);

//     setForm(prev => ({
//       ...prev,
//       totalSeats: String(template.totalSeats || allSeatNumbers.length)
//     }));

//     setShowTemplateModal(false);
//     setShowLayoutModal(true);

//     toast.success(`Selected template: ${template.name}`);
//   };

//   const toggleSeatSelection = (seatNumber) => {
//     if (activeSeats.includes(seatNumber)) {
//       setActiveSeats(activeSeats.filter(s => s !== seatNumber));
//     } else {
//       setActiveSeats([...activeSeats, seatNumber]);
//     }
//   };

//   // Toggle Operating Day
//   const toggleDay = (day) => {
//     setOperatingDays(prev => 
//       prev.includes(day) 
//         ? prev.filter(d => d !== day) 
//         : [...prev, day]
//     );
//   };

//   // Generate Fare Matrix for a route
//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     // Sort stops by sequence
//     const sortedStops = [...(routeData.intermediateStops || [])]
//       .sort((a, b) => a.sequence - b.sequence);

//     // Create all stops array
//     const allStops = [
//       { 
//         id: 'origin', 
//         name: routeData.origin?.city || 'Origin', 
//         distanceFromOrigin: 0,
//         type: 'origin'
//       },
//       ...sortedStops.map((s, i) => ({ 
//         id: s._id || `stop_${i}`, 
//         name: s.city || s.name || `Stop ${i+1}`, 
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: 'stop',
//         sequence: s.sequence
//       })),
//       { 
//         id: 'destination', 
//         name: routeData.destination?.city || 'Destination', 
//         distanceFromOrigin: parseFloat(routeData.destination?.distanceFromOrigin) || 
//                             parseFloat(routeData.routeDetails?.totalDistance) || 0,
//         type: 'destination'
//       }
//     ];

//     // Build matrix
//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (parseFloat(toStop.distanceFromOrigin) - parseFloat(fromStop.distanceFromOrigin)).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         sequence: fromStop.sequence,
//         toCells: toCells
//       };
//     });

//     // Remove destination row
//     return matrix.filter(row => row.fromId !== 'destination');
//   };

//   // Handle Generate Matrix
//   const handleGenerateMatrix = () => {
//     if (!selectedRouteUp) {
//       toast.error('Please select at least the Main/Up Route');
//       return;
//     }

//     if (tripType === 'roundTrip' && !selectedRouteDown) {
//       toast.error('Please select the Return/Down Route');
//       return;
//     }

//     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//       toast.error('Please fill all Pricing Fields');
//       return;
//     }

//     // Generate Up Matrix
//     const matrixUp = generateMatrixForRoute(selectedRouteUp);
//     setFareMatrixUp(matrixUp);

//     // Generate Down Matrix for Round Trip
//     if (tripType === 'roundTrip' && selectedRouteDown) {
//       const matrixDown = generateMatrixForRoute(selectedRouteDown);
//       setFareMatrixDown(matrixDown);
//     } else {
//       setFareMatrixDown([]);
//     }

//     toast.success(tripType === 'roundTrip' 
//       ? 'Both Fare Matrices Generated!' 
//       : 'Fare Matrix Generated!'
//     );
//   };

//   // Handle Price Change
//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = { 
//           ...newToCells[colIndex], 
//           price: parseInt(newPrice) || 0 
//         };
//       }
//       return { ...row, toCells: newToCells };
//     });

//     if (isUp) {
//       setFareMatrixUp(updatedMatrix);
//     } else {
//       setFareMatrixDown(updatedMatrix);
//     }
//   };

// // Handle Submit - FIXED for admin API compatibility
// const handleSubmitBus = async () => {
//   try {
//     setIsSubmitting(true);
//     setError(null);

//     // Validation
//     if (!form.busNumber) {
//       throw new Error('Bus Number is required');
//     }
//     if (!form.busName) {
//       throw new Error('Bus Name is required');
//     }
//     if (!form.busType) {
//       throw new Error('Bus Type is required');
//     }
//     if (!form.busCategory) {
//       throw new Error('Bus Category is required');
//     }
//     if (!selectedRouteUp) {
//       throw new Error('Please select at least one route');
//     }
//     if (tripType === 'roundTrip' && !selectedRouteDown) {
//       throw new Error('Please select return route for round trip');
//     }
//     if (operatingDays.length === 0) {
//       throw new Error('Please select at least one operating day');
//     }
//     if (!selectedTemplate) {
//       throw new Error('Please configure seat layout');
//     }
//     if (fareMatrixUp.length === 0) {
//       throw new Error('Please generate Fare Matrix');
//     }

//     // Process Amenities
//     const amenitiesArray = form.amenities || [];

//     // Process Seats - Map to the format expected by admin API
//     const finalSeatsPayload = selectedTemplate.seats
//       .filter(s => activeSeats.includes(s.seatNumber))
//       .map(s => ({
//         seatNumber: s.seatNumber,
//         row: s.row,
//         column: s.column,
//         seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//         position: s.position || getSeatPosition(s.column),
//         isActive: true,
//         price: calculateSeatPrice(s, pricing.basePrice, s.position)
//       }));

//     // Seat Configuration
//     const seatConfigPayload = {
//       busType: selectedTemplate.configuration || '2*2',
//       totalSeats: activeSeats.length,
//       seatsPerRow: selectedTemplate.seatsPerRow || 4,
//       totalRows: Math.ceil(activeSeats.length / (selectedTemplate.seatsPerRow || 4))
//     };

//     // Construct Route Schedules
//     const routeSchedules = [];

//     // Up Route
//     routeSchedules.push({
//       routeId: selectedRouteUp._id,
//       direction: 'UP',
//       fareMatrix: fareMatrixUp,
//       operatingDays: operatingDays,
//       departureTime: selectedRouteUp.departureTime || '08:00',
//       arrivalTime: selectedRouteUp.arrivalTime || '20:00'
//     });

//     // Down Route for Round Trip
//     if (tripType === 'roundTrip' && selectedRouteDown) {
//       routeSchedules.push({
//         routeId: selectedRouteDown._id,
//         direction: 'DOWN',
//         fareMatrix: fareMatrixDown,
//         operatingDays: operatingDays,
//         departureTime: selectedRouteDown.departureTime || '08:00',
//         arrivalTime: selectedRouteDown.arrivalTime || '20:00'
//       });
//     }

//     console.log("pricing : ",pricing)

//     // ADMIN API expects 'fare' object, not 'fareDetails'
//     const fare = {
//       basePrice: parseFloat(pricing.basePrice) || 0,
//       costPerKm: parseFloat(pricing.costPerKm) || 0,
//       fareMatrix: fareMatrixUp, // Primary fare matrix
//       seatTypeMultipliers: {
//         standard: 1.0,
//         premium: 1.2,
//         luxury: 1.5
//       }
//     };

//     // Create FormData for file upload
//     const formData = new FormData();

//     // Append basic fields
//     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//     formData.append('busName', form.busName.trim());
//     formData.append('busType', form.busType);
//     formData.append('busCategory', form.busCategory);
//     formData.append('totalSeats', activeSeats.length.toString());
//     formData.append('busClass', form.busClass || 'Economy');
//     formData.append('tripType', tripType);
//     formData.append('route', selectedRouteUp._id);
//     formData.append('isActive', 'true');

//     // Append JSON stringified data
//     formData.append('amenities', JSON.stringify(amenitiesArray));
//     formData.append('routeSchedules', JSON.stringify(routeSchedules)); // This will be parsed by backend
//     formData.append('seats', JSON.stringify(finalSeatsPayload));
//     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//     formData.append('fare', JSON.stringify(fare));
//     formData.append('operatingDays', JSON.stringify(operatingDays));

//     // Append images
//     selectedImages.forEach((img, index) => {
//       if (img.file) {
//         formData.append('images', img.file);
//       }
//     });

//     console.log('Submitting FormData to ADMIN API:');
//     for (let pair of formData.entries()) {
//       console.log(pair[0] + ': ' + (pair[0] === 'images' ? 'File' : pair[1].substring(0, 100) + '...'));
//     }

//     // Call ADMIN API with FormData
//     const response = await addBusToOwner(ownerId, formData, token);

//     if (response && response.success) {
//       toast.success(tripType === 'roundTrip' 
//         ? 'Bus added successfully with round trip routes!' 
//         : 'Bus added successfully!'
//       );

//       onBusAdded();
//       onClose();
//     } else {
//       throw new Error(response?.message || 'Failed to add bus');
//     }

//   } catch (err) {
//     console.error('Error adding bus:', err);
//     setError(err.message || 'Failed to add bus');
//     toast.error(err.message || 'Failed to add bus');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   // Helper function for seat position
//   const getSeatPosition = (column) => {
//     switch(parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   // Helper function for seat price
//   const calculateSeatPrice = (seat, basePrice, position) => {
//     let price = parseFloat(basePrice) || 0;

//     // Position multiplier
//     if (position === 'window') price *= 1.1;
//     if (position === 'aisle') price *= 1.05;

//     // Row multiplier (front rows premium)
//     if (seat.row === 1) price *= 1.2;

//     return Math.round(price);
//   };

//   // Render Fare Matrix
//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRouteUp : selectedRouteDown;

//     if (!currentRoute || currentMatrix.length === 0) return null;

//     // Get all stops for headers
//     const sortedStops = [...(currentRoute.intermediateStops || [])]
//       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//     const allStops = [
//       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
//       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
//       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
//     ];

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">
//           {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//         </h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="corner-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                         <span className="stop-type">{stop.type}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                         <span className="stop-type">{row.fromType}</span>
//                       </div>
//                     </td>
//                     {row.toCells.map((cell, colIndex) => {
//                       if (cell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{cell.distanceKm} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="number"
//                                   className="matrix-input"
//                                   value={cell.price}
//                                   onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//                                   min="0"
//                                   step="1"
//                                 />
//                               </div>
//                             </div>
//                           </td>
//                         );
//                       }
//                       return (
//                         <td key={colIndex} className="na-cell">
//                           —
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

// // Render Seat Layout Visualizer - FIXED VERSION
// const renderSeatVisualizer = () => {
//   if (!selectedTemplate) return null;

//   const { seats, configuration, seatType } = selectedTemplate;

//   // Parse configuration (e.g., "2*2")
//   let leftCount = 2, rightCount = 2;
//   try {
//     if (configuration && configuration.includes('*')) {
//       const parts = configuration.split('*');
//       leftCount = parseInt(parts[0]) || 2;
//       rightCount = parseInt(parts[1]) || 2;
//     }
//   } catch (e) {
//     leftCount = 2;
//     rightCount = 2;
//   }

//   const totalConfigCols = leftCount + rightCount;

//   // Group seats by row
//   const seatsByRow = {};
//   seats.forEach(seat => {
//     if (!seatsByRow[seat.row]) {
//       seatsByRow[seat.row] = [];
//     }
//     seatsByRow[seat.row].push(seat);
//   });

//   // Get all row numbers and sort them
//   const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

//   const rows = [];

//   // Helper to render seat
//   const renderSeat = (seatObj) => {
//     const isSelected = activeSeats.includes(seatObj.seatNumber);
//     const isSleeper = seatObj.seatType === 'sleeper' || 
//       seatObj.seatType === 'seat+sleeper' ||
//       selectedTemplate.seatType === 'sleeper' || 
//       selectedTemplate.seatType === 'seater+sleeper';

//     return (
//       <button
//         key={seatObj.seatNumber}
//         className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${isSelected ? 'selected' : ''}`}
//         onClick={() => toggleSeatSelection(seatObj.seatNumber)}
//         title={`Seat ${seatObj.seatNumber} - ${seatObj.position || 'Standard'}`}
//         type="button"
//       >
//         <span className="seat-number">{seatObj.seatNumber}</span>
//       </button>
//     );
//   };

//   // Build rows
//   rowNumbers.forEach(rowNum => {
//     const seatsInRow = seatsByRow[rowNum];

//     // Check if this is a back row (has more than totalConfigCols seats or position is 'back')
//     const isBackRow = seatsInRow.some(s => s.position === 'back') || 
//                       seatsInRow.length > totalConfigCols;

//     // Check if this is a front row
//     const isFrontRow = seatsInRow.some(s => s.position === 'front');

//     if (isBackRow) {
//       // Back row - seats in a straight line
//       const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row back-row">
//           <div className="row-label">
//             {isFrontRow ? 'Front' : isBackRow ? 'Back' : `Row ${rowNum}`}
//           </div>
//           <div className="seats-container">
//             {sortedSeats.map(seat => renderSeat(seat))}
//           </div>
//         </div>
//       );
//     } else {
//       // Normal row - split left and right with aisle
//       const leftSeats = seatsInRow
//         .filter(s => (s.column || 0) <= leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));

//       const rightSeats = seatsInRow
//         .filter(s => (s.column || 0) > leftCount)
//         .sort((a, b) => (a.column || 0) - (b.column || 0));

//       rows.push(
//         <div key={`row-${rowNum}`} className="seat-row">
//           <div className="row-label">Row {rowNum}</div>
//           <div className="left-seats">
//             {leftSeats.map(seat => renderSeat(seat))}
//           </div>
//           <div className="aisle">Aisle</div>
//           <div className="right-seats">
//             {rightSeats.map(seat => renderSeat(seat))}
//           </div>
//         </div>
//       );
//     }
//   });

//   return (
//     <div className="seat-layout-visualizer">
//       <div className="bus-header">
//         <div className="driver-area">Driver</div>
//         <div className="bus-info">
//           <span className="bus-config">{selectedTemplate.configuration}</span>
//           <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
//         </div>
//       </div>
//       <div className="bus-body">
//         {rows}
//       </div>
//       <div className="seat-legend">
//         <div className="legend-item">
//           <div className="seat-sample selected"></div>
//           <span>Active Seat ({activeSeats.length})</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample"></div>
//           <span>Inactive Seat</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample sleeper"></div>
//           <span>Sleeper</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample front"></div>
//           <span>Front</span>
//         </div>
//         <div className="legend-item">
//           <div className="seat-sample back"></div>
//           <span>Back</span>
//         </div>
//       </div>
//       <div className="seat-summary">
//         <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
//       </div>
//     </div>
//   );
// };

//   // Progress Steps Component
//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">1</div>
//         <div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">2</div>
//         <div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">3</div>
//         <div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div>
//         <div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   // Render Basic Info Tab
//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Bus Information</h3>
//         <p className="section-subtitle">Enter basic details about the bus</p>
//       </div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🚌</span>
//             Bus Number *
//           </label>
//           <input
//             type="text"
//             value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             placeholder="e.g., WB01AB1234"
//             className="modern-input"
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🏷️</span>
//             Bus Name *
//           </label>
//           <input
//             type="text"
//             value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             placeholder="e.g., Volvo Multi-Axle"
//             className="modern-input"
//             required
//           />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🖼️</span>
//           Bus Images
//         </h4>
//         <div className="images-upload-area">
//           <input
//             type="file"
//             id="bus-images"
//             multiple
//             accept="image/*"
//             onChange={handleImageUpload}
//             className="image-upload-input"
//             style={{ display: 'none' }}
//           />
//           <label htmlFor="bus-images" className="image-upload-label">
//             <span className="upload-icon">📁</span>
//             <span className="upload-text">Click to upload images</span>
//             <span className="upload-hint">Upload multiple images (max 10)</span>
//           </label>

//           {selectedImages.length > 0 && (
//             <div className="selected-images-preview">
//               <h5>Selected Images ({selectedImages.length})</h5>
//               <div className="images-grid">
//                 {selectedImages.map((image, index) => (
//                   <div key={index} className="image-preview-item">
//                     <img
//                       src={image.preview}
//                       alt={`Bus ${index + 1}`}
//                       className="preview-image"
//                     />
//                     <button
//                       type="button"
//                       className="remove-image-btn"
//                       onClick={() => removeImage(index)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">🔧</span>
//             Bus Type *
//           </label>
//           <select
//             value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_TYPES.map(type => (
//               <option key={type} value={type}>{type}</option>
//             ))}
//           </select>
//         </div>

//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">📊</span>
//             Bus Category *
//           </label>
//           <select
//             value={form.busCategory}
//             onChange={(e) => handleCategoryChange(e.target.value)}
//             className="modern-select"
//           >
//             <option value="">Select Category</option>
//             {BUS_CATEGORIES.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">💺</span>
//             Bus Class
//           </label>
//           <select
//             value={form.busClass}
//             onChange={(e) => setForm(prev => ({ ...prev, busClass: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_CLASSES.map(cls => (
//               <option key={cls} value={cls}>{cls}</option>
//             ))}
//           </select>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">✨</span>
//           Amenities
//         </h4>
//         <div className="amenities-grid compact">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-option compact">
//               <input
//                 type="checkbox"
//                 checked={form.amenities.includes(amenity)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: [...prev.amenities, amenity]
//                     }));
//                   } else {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: prev.amenities.filter(a => a !== amenity)
//                     }));
//                   }
//                 }}
//                 className="amenity-checkbox"
//               />
//               <span className="amenity-content">
//                 <span className="amenity-icon">✓</span>
//                 <span className="amenity-label">{amenity}</span>
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           className="modern-btn primary full-width"
//           onClick={() => setActiveTab('route')}
//           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
//         >
//           Continue to Route & Pricing
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   // Render Route & Pricing Tab
//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Route & Pricing Configuration</h3>
//         <p className="section-subtitle">Select routes and configure pricing for this bus</p>
//       </div>

//       {/* Trip Type Toggle */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔄</span>
//           Trip Type
//         </h4>
//         <div className="trip-type-container">
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}
//           >
//             <span className="btn-icon">➡️</span>
//             One Way
//           </button>
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}
//           >
//             <span className="btn-icon">🔄</span>
//             Round Trip
//           </button>
//         </div>
//       </div>

//       {/* Route Selection */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🗺️</span>
//           Route Selection {tripType === 'roundTrip' ? '(Up & Down)' : ''}
//         </h4>

//         <div className="route-selector">
//           <label className="input-label">Main Route (Up) *</label>
//           <select
//             value={selectedRouteUp?._id || ''}
//             onChange={(e) => {
//               const route = routes.find(r => r._id === e.target.value);
//               setSelectedRouteUp(route);
//               setFareMatrixUp([]);
//             }}
//             className="modern-select"
//             disabled={loadingRoutes}
//           >
//             <option value="">Select Up Route</option>
//             {routes.map(route => (
//               <option key={route._id} value={route._id}>
//                 {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''})
//               </option>
//             ))}
//           </select>
//         </div>

//         {tripType === 'roundTrip' && (
//           <div className="route-selector" style={{ marginTop: '15px' }}>
//             <label className="input-label">Return Route (Down) *</label>
//             <select
//               value={selectedRouteDown?._id || ''}
//               onChange={(e) => {
//                 const route = routes.find(r => r._id === e.target.value);
//                 setSelectedRouteDown(route);
//                 setFareMatrixDown([]);
//               }}
//               className="modern-select"
//               disabled={loadingRoutes}
//             >
//               <option value="">Select Down Route</option>
//               {routes.map(route => (
//                 <option key={route._id} value={route._id}>
//                   {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''})
//                 </option>
//               ))}
//             </select>
//           </div>
//         )}
//       </div>

//       {/* Operating Days */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📅</span>
//           Operating Days *
//         </h4>
//         <div className="days-grid compact">
//           {DAYS_OF_WEEK.map(day => (
//             <button
//               key={day}
//               type="button"
//               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}
//               title={day}
//             >
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//         <div className="selected-days">
//           Selected: {operatingDays.length} days
//         </div>
//       </div>

//       {/* Pricing Configuration */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💰</span>
//           Pricing Configuration
//         </h4>

//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>

//         {selectedRouteUp && (
//           <div className="pricing-summary">
//             <div className="summary-item">
//               <span>Category Multiplier:</span>
//               <span className="value accent">{getCategoryMultiplier()}x</span>
//             </div>
//             <div className="summary-item">
//               <span>Route Distance:</span>
//               <span className="value">{selectedRouteUp.routeDetails?.totalDistance || 0} km</span>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Generate Matrix Button */}
//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('basic')}
//         >
//           ← Back
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary generate-matrix-btn"
//           onClick={() => {
//             handleGenerateMatrix();
//             if (fareMatrixUp.length > 0) {
//               setActiveTab('matrix');
//             }
//           }}
//           disabled={!selectedRouteUp || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
//         >
//           Generate Fare Matrix
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   // Render Fare Matrix Tab
//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Fare Matrix Configuration</h3>
//         <p className="section-subtitle">Review and edit fares for each route</p>
//       </div>

//       {/* Matrix Tabs for Round Trip */}
//       {tripType === 'roundTrip' && (
//         <div className="matrix-tabs">
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}
//           >
//             Up Route: {selectedRouteUp?.routeName || 'Selected Route'}
//           </button>
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}
//           >
//             Down Route: {selectedRouteDown?.routeName || 'Selected Route'}
//           </button>
//         </div>
//       )}

//       {/* Render Matrix */}
//       {tripType === 'roundTrip' ? (
//         <>
//           {activeMatrixTab === 'up' && renderMatrix('up')}
//           {activeMatrixTab === 'down' && renderMatrix('down')}
//         </>
//       ) : (
//         renderMatrix('up')
//       )}

//       <div className="matrix-info">
//         <div className="info-card">
//           <div className="info-item">
//             <span className="label">Total Stops:</span>
//             <span className="value">
//               {selectedRouteUp ? 
//                 (selectedRouteUp.intermediateStops?.length || 0) + 2 : 0}
//             </span>
//           </div>
//           <div className="info-item">
//             <span className="label">Category Multiplier:</span>
//             <span className="value accent">{getCategoryMultiplier()}x</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Base Price:</span>
//             <span className="value">₹{pricing.basePrice}</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Cost/km:</span>
//             <span className="value">₹{pricing.costPerKm}</span>
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('route')}
//         >
//           ← Back to Pricing
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={() => setActiveTab('seats')}
//           disabled={fareMatrixUp.length === 0}
//         >
//           Continue to Seat Layout
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

// // Render Seat Layout Tab - COMPLETE UPDATED VERSION
// const renderSeatLayoutTab = () => (
//   <div className="tab-content-wrapper">
//     <div className="section-title">
//       <h3>Seat Layout Configuration</h3>
//       <p className="section-subtitle">Configure seat layout for this bus</p>
//     </div>

//     {/* Bus Configuration Selector */}
//     <div className="section-card">
//       <h4 className="card-title">
//         <span className="title-icon">🔧</span>
//         Bus Configuration
//       </h4>
//       <div className="config-selector">
//         <label className="input-label">Select Bus Configuration *</label>
//         {loadingLayouts ? (
//           <div className="loading-configs">
//             <span>Loading configurations...</span>
//           </div>
//         ) : (
//           <>

// <div className="config-buttons">
//   {availableConfigurations.map(config => {
//     // Check if this configuration might have layouts
//     const hasLayouts = true; // You could add logic here

//     return (
//       <button
//         key={config}
//         type="button"
//         className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//         onClick={() => {
//           setSelectedConfiguration(config);
//           setSelectedTemplate(null);
//           setActiveSeats([]);
//           fetchLayouts(config);
//         }}
//       >
//         {config}
//       </button>
//     );
//   })}
// </div>
//             <small className="helper-text">
//               {form.busCategory} bus with {selectedConfiguration} configuration
//             </small>
//           </>
//         )}
//       </div>
//     </div>

//     {/* Seat Template Selection */}
//     <div className="section-card">
//       <h4 className="card-title">
//         <span className="title-icon">💺</span>
//         Seat Layout Template
//       </h4>

//       {!selectedTemplate ? (
//         <button
//           type="button"
//           className="modern-btn outline full-width"
//           onClick={openTemplateSelector}
//           disabled={loadingLayouts}
//         >
//           {loadingLayouts ? (
//             <>
//               <span className="btn-icon">⏳</span>
//               Loading Layouts...
//             </>
//           ) : (
//             <>
//               <span className="btn-icon">📋</span>
//               Select Layout Template
//             </>
//           )}
//         </button>
//       ) : (
//         <div className="selected-template-info">
//           <div className="template-details">
//             <span className="template-name">{selectedTemplate.name}</span>
//             <span className="template-config">{selectedTemplate.configuration}</span>
//             <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
//             <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
//           </div>
//           <button
//             type="button"
//             className="btn-small"
//             onClick={() => {
//               setSelectedTemplate(null);
//               setActiveSeats([]);
//             }}
//           >
//             Change
//           </button>
//         </div>
//       )}
//     </div>

//     {/* Seat Visualizer */}
//     {selectedTemplate && (
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">👁️</span>
//           Seat Layout Visualizer
//         </h4>
//         <button
//           type="button"
//           className="view-layout-btn"
//           onClick={() => setShowLayoutModal(true)}
//         >
//           View / Edit Active Seats
//         </button>

//         <div className="seat-summary">
//           <div className="summary-item">
//             <span>Total Seats in Template:</span>
//             <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
//           </div>
//           <div className="summary-item">
//             <span>Active Seats:</span>
//             <span className="value accent">{activeSeats.length}</span>
//           </div>
//           <div className="summary-item">
//             <span>Inactive Seats:</span>
//             <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
//           </div>
//         </div>
//       </div>
//     )}

//     <div className="form-actions">
//       <button
//         type="button"
//         className="modern-btn outline"
//         onClick={() => setActiveTab('matrix')}
//       >
//         ← Back to Matrix
//       </button>
//       <button
//         type="button"
//         className="modern-btn primary"
//         onClick={handleSubmitBus}
//         disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
//       >
//         {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
//         <span className="btn-icon">✓</span>
//       </button>
//     </div>
//   </div>
// );

//   // Layout Modal
//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Active Seats</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {renderSeatVisualizer()}
//         </div>
//         <div className="modal-footer">
//           <button
//             type="button"
//             className="modern-btn primary"
//             onClick={() => setShowLayoutModal(false)}
//           >
//             Confirm Layout
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   // Template Selection Modal
//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Seat Layout Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {loadingLayouts ? (
//             <div className="loading-container">
//               <p>Loading templates...</p>
//             </div>
//           ) : layoutTemplates.length === 0 ? (
//   <div className="no-templates">
//     <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
//     <p className="hint">Available configurations with layouts:</p>
//     <div className="available-configs">
//       {availableConfigurations.map(config => (
//         <span key={config} className="config-chip">{config}</span>
//       ))}
//     </div>
//     <p className="hint">Try selecting a different configuration</p>
//   </div>
// )  : (
//             <div className="templates-grid">
//               {layoutTemplates.map(template => (
//                 <button
//                   type="button"
//                   key={template._id}
//                   className="template-card"
//                   onClick={() => handleSelectTemplate(template)}
//                 >
//                   <h4 className="template-name">{template.name}</h4>
//                   <div className="template-details">
//                     <span className="config">Config: {template.configuration}</span>
//                     <span className="seats">Seats: {template.totalSeats}</span>
//                   </div>
//                   <div className="template-preview">
//                     <span className="rows">Rows: {template.rows}</span>
//                     <span className="cols">Cols: {template.columns}</span>
//                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">
//               <span className="title-icon">🚌</span>
//               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
//             </h2>
//             <p className="modal-subtitle">Configure bus details with route selection</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>
//             <span className="close-icon">×</span>
//           </button>
//         </div>

//         <div className="modal-body modern">
//           <ProgressSteps />

//           <div className="tab-container">
//             {activeTab === 'basic' && renderBasicInfoTab()}
//             {activeTab === 'route' && renderRouteTab()}
//             {activeTab === 'matrix' && renderMatrixTab()}
//             {activeTab === 'seats' && renderSeatLayoutTab()}
//           </div>

//           {error && (
//             <div className="error-message modern">
//               <span className="error-icon">⚠️</span>
//               {error}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Modals */}
//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//     </div>
//   );
// };

//   const BusOwnerManage = () => {
//     const { token } = useSelector(state => state.user);
//     const [busOwners, setBusOwners] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [editingOwner, setEditingOwner] = useState(null);
//     const [editForm, setEditForm] = useState({});
//     const [viewingOwner, setViewingOwner] = useState(null);
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [showAddBusModal, setShowAddBusModal] = useState(false);
//     const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
//     const [newOwner, setNewOwner] = useState({
//       name: '',
//       email: '',
//       phone: '',
//       companyName: ''
//     });
//     const [error, setError] = useState(null);

//     // Bus Management states
//     const [showBusManagement, setShowBusManagement] = useState(false);
//     const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
//     const [selectedOwner, setSelectedOwner] = useState(null);
//     const [busSearchTerm, setBusSearchTerm] = useState('');
//     const [busDetailsLoading, setBusDetailsLoading] = useState(false);


//     // Pagination states
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalOwners, setTotalOwners] = useState(0);
//     const [pageSize] = useState(10);

//     // Helper function to get sequential number
//     const getSequentialNumber = (index) => {
//       return (currentPage - 1) * pageSize + index + 1;
//     };

//     // Helper function to get full image URL
//     const getFullImageUrl = (imagePath) => {
//       // if (!imagePath) return defaultAvatar;

//       // Check if it's already a full URL
//       if (imagePath.startsWith('http')) {
//         return imagePath;
//       }

//       // Add base URL for relative paths
//       return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
//     };

//     // Add this useEffect after your existing useEffect
//     useEffect(() => {
//       // Fetch bus owners when page changes
//       fetchBusOwners();
//     }, [currentPage]);

//     // Also update your existing useEffect for search
//     useEffect(() => {
//       // Reset to first page when search term changes
//       setCurrentPage(1);

//       // Use a timer to debounce the search
//       const timer = setTimeout(() => {
//         fetchBusOwners();
//       }, 500); // 500ms delay to avoid too many API calls

//       return () => clearTimeout(timer);
//     }, [searchTerm]);

//     const fetchBusOwners = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         console.log(`Fetching page ${currentPage} with limit ${pageSize}, search: ${searchTerm}`);

//         // Pass pagination parameters AND search term
//         const response = await getBusOwners(token, currentPage, pageSize, searchTerm);

//         if (response && response.success && response.busOwners) {
//           console.log(`Received ${response.busOwners.length} owners, total: ${response.total}`);

//           const transformedOwners = response.busOwners.map((owner, index) => ({
//             id: owner._id,
//             serialNo: getSequentialNumber(index),
//             profileImage: owner.profileImage || '',
//             name: owner.name || '',
//             company: owner.companyName || '',
//             email: owner.email || '',
//             phone: owner.phone || '',
//             buses: owner.busCount || 0,
//             routes: owner.routeCount || 0,
//             joined: new Date(owner.createdAt).toISOString().split('T')[0],
//             status: owner.isVerified ? 'Verified' : 'Pending',
//             adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
//             _id: owner._id,
//             isVerified: owner.isVerified,
//             isProfileComplete: owner.isProfileComplete,
//             isApprovedByAdmin: owner.isApprovedByAdmin,
//             activeBuses: owner.activeBuses || 0,
//             driverCount: owner.driverCount || 0,
//             conductorCount: owner.conductorCount || 0,
//             createdAt: owner.createdAt,
//             updatedAt: owner.updatedAt,
//             address: owner.address || {},
//             city: owner.address?.city || '',
//             state: owner.address?.state || owner.state || '',
//             pincode: owner.address?.pincode || '',
//             busAll: owner.busAll || []
//           }));

//           setBusOwners(transformedOwners);

//           // Set pagination info from API response
//           if (response.totalPages) {
//             setTotalPages(response.totalPages);
//           }
//           if (response.total) {
//             setTotalOwners(response.total);
//           } else {
//             setTotalOwners(response.busOwners.length);
//           }
//         } else {
//           setError('No bus owners data found in response');
//           setBusOwners([]);
//           setTotalPages(1);
//           setTotalOwners(0);
//         }
//       } catch (err) {
//         console.error('Error fetching bus owners:', err);
//         setError('Failed to fetch bus owners. Please try again.');
//         setBusOwners([]);
//         setTotalPages(1);
//         setTotalOwners(0);
//       } finally {
//         setLoading(false);
//       }
//     };

//     const handleSearchChange = (e) => {
//       const value = e.target.value;
//       setSearchTerm(value);
//       // Don't fetch here - let the useEffect handle it
//     };

//     // Add these handler functions to your component
//     const handleViewBusDetails = (bus) => {
//       alert(`Viewing bus details:\n\nBus Name: ${bus.busName}\nBus Number: ${bus.busNumber}\nType: ${bus.busType}\nTotal Seats: ${bus.totalSeats}\nAvailable Seats: ${bus.availableSeats}\nPrice: ₹${bus.basePrice}\nStatus: ${bus.isActive ? 'Active' : 'Inactive'}`);
//     };

//     const handleEditBus = (bus) => {
//       alert(`Edit functionality for bus: ${bus.busName} (${bus.busNumber}) would open here.`);
//     };

//     const handleToggleBusStatus = async (busId, activate) => {
//       const action = activate ? 'activate' : 'deactivate';
//       if (window.confirm(`Are you sure you want to ${action} this bus?`)) {
//         try {
//           // Call your API to update bus status
//           // const response = await updateBusStatus(busId, { isActive: activate }, token);
//           // if (response.success) {
//           //   // Update local state
//           //   setSelectedOwnerBuses(prev => 
//           //     prev.map(bus => 
//           //       bus._id === busId ? { ...bus, isActive: activate } : bus
//           //     )
//           //   );
//           //   alert(`Bus ${action}d successfully!`);
//           // }
//           alert(`Bus ${action}d successfully! (API call would be made here)`);
//         } catch (err) {
//           console.error(`Error ${action}ing bus:`, err);
//           alert(`Failed to ${action} bus. Please try again.`);
//         }
//       }
//     };

//     const busManagementStyles = `
//     .bus-management-modal {
//       max-width: 1200px !important;
//       width: 95% !important;
//       max-height: 85vh;
//       overflow-y: auto;
//     }

//     .bus-management-table {
//       font-size: 14px;
//     }

//     .bus-management-table th {
//       background-color: #f8f9fa;
//       position: sticky;
//       top: 0;
//       z-index: 10;
//     }

//     .bus-management-table td {
//       vertical-align: middle;
//     }

//     .staff-details {
//       min-width: 200px;
//     }

//     .staff-name {
//       font-weight: 600;
//       color: #333;
//     }

//     .staff-contact {
//       color: #666;
//       font-size: 13px;
//     }

//     .bus-info-cell {
//       min-width: 150px;
//     }

//     .no-staff {
//       color: #dc3545;
//       font-style: italic;
//       font-size: 13px;
//     }

//     .bus-status-active {
//       background-color: #d4edda;
//       color: #155724;
//       padding: 4px 8px;
//       border-radius: 4px;
//       font-size: 12px;
//       font-weight: 600;
//     }

//     .bus-status-inactive {
//       background-color: #f8d7da;
//       color: #721c24;
//       padding: 4px 8px;
//       border-radius: 4px;
//       font-size: 12px;
//       font-weight: 600;
//     }

//     .bus-actions {
//       display: flex;
//       gap: 5px;
//       flex-wrap: wrap;
//     }

//     .bus-action-btn {
//       padding: 4px 8px;
//       font-size: 12px;
//       border-radius: 4px;
//       border: none;
//       cursor: pointer;
//       transition: all 0.2s;
//     }

//     .bus-action-btn:hover {
//       opacity: 0.9;
//       transform: translateY(-1px);
//     }

//     .bus-action-view {
//       background-color: #17a2b8;
//       color: white;
//     }

//     .bus-action-edit {
//       background-color: #ffc107;
//       color: #000;
//     }

//     .bus-action-activate {
//       background-color: #28a745;
//       color: white;
//     }

//     .bus-action-deactivate {
//       background-color: #dc3545;
//       color: white;
//     }
//   `;

//     const fetchBusOwnerById = async (id) => {
//       try {
//         const response = await getBusOwnerById(id, token);
//         return response.data || response;
//       } catch (err) {
//         console.error('Error fetching bus owner:', err);
//         throw err;
//       }
//     };

//     const handleApproveOwner = async (ownerId) => {
//       try {
//         setError(null);
//         const response = await approveBusOwner(ownerId, token);
//         console.log("Approve response: ", response);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === ownerId ? {
//                 ...owner,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
//                 adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending'
//               } : owner
//             )
//           );
//           alert('Bus owner approved successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to approve bus owner');
//         }
//       } catch (err) {
//         console.error('Error approving bus owner:', err);
//         setError('Failed to approve bus owner. Please try again.');
//         alert('Failed to approve bus owner. Please try again.');
//       }
//     };

//     const handleManageBuses = async (owner) => {
//       console.log("handleManageBuses ; ", owner)
//       if (owner.buses === 0) {
//         // alert('This owner has no buses registered.');
//         toast.error("This owner has no buses registered")
//         return;
//       }

//       console.log('Owner bus data:', owner);

//       // Check if busAll exists and has data
//       if (!owner.busAll || owner.busAll.length === 0) {
//         // If no bus data, try to fetch it separately
//         try {
//           setBusDetailsLoading(true);
//           const response = await getBusOwnerById(owner.id, token);

//           if (response.success && response.data && response.data.busAll) {
//             // Update the owner with bus data
//             const updatedOwner = {
//               ...owner,
//               busAll: response.data.busAll || []
//             };

//             // Process the bus data
//             const processedBuses = updatedOwner.busAll.map(bus => {
//               const driver = bus.driver ? {
//                 name: bus.driver.name || 'N/A',
//                 contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//                 licenseNumber: bus.driver.licenseNumber || 'N/A',
//                 experience: bus.driver.experience || 0
//               } : null;

//               const conductor = bus.conductor ? {
//                 name: bus.conductor.name || 'N/A',
//                 contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//               } : null;

//               return {
//                 ...bus,
//                 driver,
//                 conductor
//               };
//             });

//             console.log('Fetched and processed buses:', processedBuses);

//             setSelectedOwner(updatedOwner);
//             setSelectedOwnerBuses(processedBuses);
//             setShowBusManagement(true);
//             setBusSearchTerm('');
//           } else {
//             alert('Could not fetch bus data. Please try again.');
//           }
//         } catch (err) {
//           console.error('Error fetching bus details:', err);
//           alert('Failed to fetch bus details. Please try again.');
//         } finally {
//           setBusDetailsLoading(false);
//         }
//         return;
//       }

//       // If busAll data exists, process it
//       const processedBuses = owner.busAll.map(bus => {
//         const driver = bus.driver ? {
//           name: bus.driver.name || 'N/A',
//           contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//           licenseNumber: bus.driver.licenseNumber || 'N/A',
//           experience: bus.driver.experience || 0
//         } : null;

//         const conductor = bus.conductor ? {
//           name: bus.conductor.name || 'N/A',
//           contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//         } : null;

//         return {
//           ...bus,
//           driver,
//           conductor
//         };
//       });

//       console.log('Processed buses:', processedBuses);

//       setSelectedOwner(owner);
//       setSelectedOwnerBuses(processedBuses);
//       setShowBusManagement(true);
//       setBusSearchTerm('');
//     };

//     // Add this function after your other handler functions
//     const filteredBuses = selectedOwnerBuses.filter(bus =>
//       (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//       (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
//       (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
//     );

//     const handleRejectOwner = async (ownerId) => {
//       if (window.confirm('Are you sure you want to reject this bus owner?')) {
//         try {
//           setError(null);

//           // Debug log to check ownerId
//           console.log('Rejecting owner with ID:', ownerId);

//           // Make sure ownerId is a valid string
//           if (!ownerId || typeof ownerId !== 'string') {
//             throw new Error('Invalid owner ID');
//           }

//           const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

//           console.log('Reject response:', response);

//           if (response.success) {
//             setBusOwners(prevOwners =>
//               prevOwners.map(owner =>
//                 owner.id === ownerId ? {
//                   ...owner,
//                   isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
//                   adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
//                 } : owner
//               )
//             );
//             alert('Bus owner rejected successfully!');
//           } else {
//             throw new Error(response.message || 'Failed to reject bus owner');
//           }
//         } catch (err) {
//           console.error('Error rejecting bus owner:', err);
//           setError('Failed to reject bus owner. Please try again.');
//           alert('Failed to reject bus owner. Please try again.');
//         }
//       }
//     };

//     // Use busOwners directly as they're already filtered by the backend
//     const filteredOwners = busOwners;


//     const handleViewOwner = async (owner) => {
//       try {
//         const ownerData = await fetchBusOwnerById(owner.id);
//         setViewingOwner({
//           ...owner,
//           profileImage: ownerData.profileImage || owner.profileImage, // Add profile image
//           name: ownerData.name || owner.name,
//           company: ownerData.companyName || owner.company,
//           email: ownerData.email || owner.email,
//           phone: ownerData.phone || owner.phone,
//           isVerified: ownerData.isVerified,
//           isProfileComplete: ownerData.isProfileComplete,
//           isApprovedByAdmin: ownerData.isApprovedByAdmin,
//           activeBuses: ownerData.activeBuses,
//           driverCount: ownerData.driverCount,
//           conductorCount: ownerData.conductorCount
//         });
//       } catch (err) {
//         setViewingOwner(owner);
//         alert('Could not fetch latest owner details. Showing cached data.');
//       }
//     };

//     const handleEditOwner = (owner) => {
//       console.log("owner : ", owner)
//       setEditingOwner(owner.id);
//       setEditForm({
//         name: owner.name || '',
//         companyName: owner.company || '',
//         email: owner.email || '',
//         phone: owner.phone || '',
//         status: owner.status || 'Pending',
//         isApprovedByAdmin: owner.isApprovedByAdmin || false
//       });
//     };

//     const closeBusManagement = () => {
//       setShowBusManagement(false);
//       setSelectedOwnerBuses([]);
//       setSelectedOwner(null);
//       setBusSearchTerm('');
//       setBusDetailsLoading(false);
//     };

//     const handleSaveEdit = async () => {
//       try {
//         setError(null);
//         console.log("Editing owner ID:", editingOwner); // Debug log
//         console.log("editForm : ", editForm);

//         // Check if editingOwner is valid
//         if (!editingOwner || typeof editingOwner !== 'string') {
//           throw new Error('Invalid owner ID for editing');
//         }

//         const updateData = {
//           name: editForm.name,
//           email: editForm.email,
//           phone: editForm.phone,
//           companyName: editForm.companyName,
//           isVerified: editForm.status === 'Verified',
//           isApprovedByAdmin: editForm.isApprovedByAdmin
//         };

//         console.log('Sending update data:', updateData);

//         const response = await updateBusOwner(editingOwner, updateData, token);

//         console.log('Update response:', response);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === editingOwner ? {
//                 ...owner,
//                 name: response.data?.name || editForm.name,
//                 company: response.data?.companyName || editForm.companyName,
//                 email: response.data?.email || editForm.email,
//                 phone: response.data?.phone || editForm.phone,
//                 status: response.data?.isVerified ? 'Verified' : 'Pending',
//                 isVerified: response.data?.isVerified,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin,
//                 adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
//               } : owner
//             )
//           );

//           setEditingOwner(null);
//           setEditForm({});
//           alert('Bus owner updated successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to update bus owner');
//         }
//       } catch (err) {
//         console.error('Error updating bus owner:', err);
//         setError('Failed to update bus owner. Please try again.');
//         alert('Failed to update bus owner. Please try again.');
//       }
//     };

//     const handleCancelEdit = () => {
//       setEditingOwner(null);
//       setEditForm({});
//       setError(null);
//     };

//     const handleDeleteOwner = async (ownerId) => {
//       if (window.confirm('Are you sure you want to delete this bus owner?')) {
//         try {
//           setError(null);
//           const response = await deleteBusOwner(ownerId, token);

//           if (response.success) {
//             setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//             setTotalOwners(prev => prev - 1);
//             alert('Bus owner deleted successfully!');
//           } else {
//             throw new Error(response.message || 'Failed to delete bus owner');
//           }
//         } catch (err) {
//           console.error('Error deleting bus owner:', err);
//           setError('Failed to delete bus owner. Please try again.');
//           alert('Failed to delete bus owner. Please try again.');
//         }
//       }
//     };

//     const handleInputChange = (e) => {
//       const { name, value } = e.target;
//       setEditForm(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     };

//     const handleNewOwnerChange = (e) => {
//       const { name, value } = e.target;
//       setNewOwner(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     };

//     const handleAddOwner = async () => {
//       try {
//         setError(null);

//         if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
//           alert('Please fill in all required fields');
//           return;
//         }

//         const response = await createBusOwner(newOwner, token);

//         if (response.success) {
//           const newOwnerWithId = {
//             id: response.data.id,
//             serialNo: busOwners.length + 1,
//             profileImage: '',
//             name: response.data.name,
//             company: response.data.companyName,
//             email: response.data.email,
//             phone: response.data.phone,
//             buses: 0,
//             routes: 0,
//             joined: new Date(response.data.createdAt).toISOString().split('T')[0],
//             status: 'Pending',
//             adminApproval: 'Pending',
//             isVerified: false,
//             isApprovedByAdmin: false,
//             createdAt: response.data.createdAt
//           };

//           setBusOwners(prev => [newOwnerWithId, ...prev]);
//           setTotalOwners(prev => prev + 1);
//           setShowAddModal(false);
//           setNewOwner({
//             name: '',
//             companyName: '',
//             email: '',
//             phone: ''
//           });
//           alert('Bus owner added successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to add bus owner');
//         }
//       } catch (err) {
//         console.error('Error adding bus owner:', err);
//         setError('Failed to add bus owner. Please try again.');
//         alert('Failed to add bus owner. Please try again.');
//       }
//     };

//     const closeViewModal = () => {
//       setViewingOwner(null);
//     };

//     const closeAddModal = () => {
//       setShowAddModal(false);
//       setNewOwner({
//         name: '',
//         companyName: '',
//         email: '',
//         phone: ''
//       });
//       setError(null);
//     };

//     const handleRefresh = () => {
//       setCurrentPage(1);
//       fetchBusOwners();
//     };

//     // Pagination handlers
//     const handleNextPage = () => {
//       if (currentPage < totalPages) {
//         setCurrentPage(prev => prev + 1);
//       }
//     };

//     const handlePrevPage = () => {
//       if (currentPage > 1) {
//         setCurrentPage(prev => prev - 1);
//       }
//     };

//     const handlePageClick = (pageNumber) => {
//       setCurrentPage(pageNumber);
//     };

//     // Calculate stats
//     const currentPageOwners = busOwners;
//     const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
//     const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
//     const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

//     if (loading) {
//       return (
//         <div className="management-page">
//           <div className="loading-container">
//             <p>Loading bus owners...</p>
//           </div>
//         </div>
//       );
//     }
//     const handleAddBusClick = (owner) => {
//       setSelectedOwnerForBus(owner);
//       setShowAddBusModal(true);
//     };

//     // Add this function to handle bus added successfully
//     const handleBusAdded = () => {
//       // Refresh the bus owners list to update bus count
//       fetchBusOwners();
//       toast.success('Bus added successfully!');
//     };

//     // Add this function to close the add bus modal
//     const closeAddBusModal = () => {
//       setShowAddBusModal(false);
//       setSelectedOwnerForBus(null);
//     };

//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <h1>Bus Owner Management</h1>
//           <div className="header-actions">
//             <input
//               type="text"
//               placeholder="Search bus owners by name, company, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//             />
//             <button className="refresh-btn" onClick={handleRefresh}>
//               Refresh
//             </button>
//             <button className="add-btn" onClick={() => setShowAddModal(true)}>
//               + Add Owner
//             </button>
//           </div>
//         </div>

//         {error && (
//           <div className="error-message">
//             {error}
//           </div>
//         )}

//         {/* Debug info */}
//         <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//           Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
//         </div>

//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>Total Owners</h3>
//             <p>{totalOwners}</p>
//             <span>All registered owners</span>
//           </div>
//           <div className="stat-card">
//             <h3>Verified Owners</h3>
//             <p>{verifiedOwners}</p>
//             <span>Verified on page {currentPage}</span>
//           </div>
//           <div className="stat-card">
//             <h3>Approved Owners</h3>
//             <p>{approvedOwners}</p>
//             <span>Approved on page {currentPage}</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Buses</h3>
//             <p>{totalBuses}</p>
//             <span>active fleet</span>
//           </div>
//         </div>

//         <div className="table-container">
//           <table className="data-table">
//             <thead>
//               <tr>
//                 <th>No.</th>
//                 <th>Profile</th>
//                 <th>Owner Name</th>
//                 <th>Company</th>
//                 <th>Contact</th>
//                 <th>Buses</th>
//                 <th>Admin Approval</th>
//                 <th>Status</th> {/* Add Status column */}
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredOwners.map(owner => (
//                 <tr key={owner.id}>
//                   <td>{owner.serialNo}</td>
//                   <td>
//                     <div className="profile-image-cell">
//                       <img
//                         src={getFullImageUrl(owner.profileImage)}
//                         alt={owner.name || 'Bus Owner'}
//                         className="customer-avatar"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                           // e.target.src = defaultAvatar;
//                         }}
//                       />
//                     </div>
//                   </td>

//                   {/* Owner Name - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Owner Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.name || 'N/A'
//                     )}
//                   </td>

//                   {/* Company - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="companyName"
//                         value={editForm.companyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Company Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.company || 'N/A'
//                     )}
//                   </td>

//                   {/* Contact Info - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div>{owner.email || 'N/A'}</div>
//                         <div className="phone">{owner.phone || 'N/A'}</div>
//                       </div>
//                     )}
//                   </td>

//                   <td>{owner.buses}</td>

//                   {/* Admin Approval - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="isApprovedByAdmin"
//                         value={editForm.isApprovedByAdmin || false}
//                         onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="true">Approved</option>
//                         <option value="false">Pending</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   {/* Status - Editable when in edit mode */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || 'Pending'}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="Verified">Verified</option>
//                         <option value="Pending">Pending</option>
//                         <option value="Suspended">Suspended</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
//                         {owner.status || 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   {/* Actions - Different buttons when editing vs normal */}
//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
//                         <button
//                           className="action-btn save"
//                           onClick={handleSaveEdit}
//                           style={{ backgroundColor: '#28a745', color: 'white' }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="action-btn cancel"
//                           onClick={handleCancelEdit}
//                           style={{ backgroundColor: '#6c757d', color: 'white' }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewOwner(owner)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditOwner(owner)}
//                         >
//                           Edit
//                         </button>

//                         <button
//                           className="action-btn add-bus"
//                           onClick={() => handleAddBusClick(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title="Add new bus for this owner"
//                         >
//                           + Add Bus
//                         </button>

//                         <button
//                           className="action-btn manage"
//                           onClick={() => handleManageBuses(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
//                         >
//                           Manage Buses
//                         </button>

//                         {!owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveOwner(owner.id)}
//                             style={{ backgroundColor: '#28a745' }}
//                           >
//                             Approve
//                           </button>
//                         )}
//                         {owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectOwner(owner.id)}
//                             style={{ backgroundColor: '#ffc107', color: '#000' }}
//                           >
//                             Reject
//                           </button>
//                         )}
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteOwner(owner.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {filteredOwners.length === 0 && !loading && (
//             <div className="no-data">
//               <p>No bus owners found matching your search.</p>
//             </div>
//           )}
//         </div>

//         {/* Pagination Component */}
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {Math.min(pageSize, busOwners.length)} of {totalOwners} bus owners
//             (Page {currentPage} of {totalPages})
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>

//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>

//             <button
//               className="pagination-btn"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages || totalPages === 0}
//             >
//               Next
//             </button>
//           </div>
//         </div>

//         {/* View Modal - Updated with profile image and address */}
//         {viewingOwner && (
//           <div className="modal-overlay" onClick={closeViewModal}>
//             <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>Bus Owner Details</h3>
//                 <button className="modal-close-btn" onClick={closeViewModal}>
//                   ×
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div className="customer-details">
//                   <div className="customer-profile-image">
//                     <img
//                       src={getFullImageUrl(viewingOwner.profileImage)}
//                       alt={viewingOwner.name || 'Bus Owner'}
//                       className="profile-image-large"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         // e.target.src = defaultAvatar;
//                       }}
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Serial No:</label>
//                     <span>{viewingOwner.serialNo}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>ID:</label>
//                     <span>#{viewingOwner.id}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Owner Name:</label>
//                     <span>{viewingOwner.name || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Company:</label>
//                     <span>{viewingOwner.company || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Email:</label>
//                     <span>{viewingOwner.email || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone:</label>
//                     <span>{viewingOwner.phone || 'N/A'}</span>
//                   </div>

//                   {/* Address Section */}
//                   <div className="detail-row">
//                     <label>Address:</label>
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                       {viewingOwner.address?.city && (
//                         <span>City: {viewingOwner.address.city}</span>
//                       )}
//                       {viewingOwner.address?.state && (
//                         <span>State: {viewingOwner.address.state}</span>
//                       )}
//                       {viewingOwner.address?.pincode && (
//                         <span>Pincode: {viewingOwner.address.pincode}</span>
//                       )}
//                       {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
//                         <span>N/A</span>
//                       )}
//                     </div>
//                   </div>

//                   <div className="detail-row">
//                     <label>Total Buses:</label>
//                     <span>{viewingOwner.buses || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Active Buses:</label>
//                     <span>{viewingOwner.activeBuses || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Drivers:</label>
//                     <span>{viewingOwner.driverCount || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Conductors:</label>
//                     <span>{viewingOwner.conductorCount || 0}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Joined Date:</label>
//                     <span>{viewingOwner.joined}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Status:</label>
//                     <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
//                       {viewingOwner.status || 'Pending'}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Admin Approval:</label>
//                     <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                       {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Profile Complete:</label>
//                     <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Verified:</label>
//                     <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Bus Management Modal */}
//         {showBusManagement && selectedOwner && (
//           <div className="modal-overlay" onClick={closeBusManagement}>
//             <div className="modal-content1 bus-management-modal" style={{ maxWidth: "900px" }} onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>
//                   Bus Management - {selectedOwner.name}
//                   <span style={{ fontSize: '14px', color: '#666', marginLeft: '10px' }}>
//                     ({selectedOwner.company})
//                   </span>
//                 </h3>
//                 <button className="modal-close-btn" onClick={closeBusManagement}>
//                   ×
//                 </button>
//               </div>

//               <div className="modal-body">
//                 {/* Owner Summary */}
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   marginBottom: '20px',
//                   padding: '15px',
//                   backgroundColor: '#f8f9fa',
//                   borderRadius: '8px',
//                   border: '1px solid #dee2e6'
//                 }}>
//                   <div>
//                     <div style={{ fontSize: '16px', fontWeight: '600' }}>
//                       {selectedOwner.name}
//                     </div>
//                     <div style={{ fontSize: '14px', color: '#666' }}>
//                       {selectedOwner.company} • {selectedOwner.email}
//                     </div>
//                   </div>
//                   <div style={{ textAlign: 'right' }}>
//                     <div style={{ fontSize: '14px' }}>
//                       <strong>Total Buses:</strong> {selectedOwner.buses}
//                     </div>
//                     <div style={{ fontSize: '14px' }}>
//                       <strong>Active:</strong> {selectedOwner.activeBuses}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Bus Search */}
//                 <div style={{ marginBottom: '20px' }}>
//                   <input
//                     type="text"
//                     placeholder="Search buses by bus name, number, driver or conductor..."
//                     className="search-input"
//                     value={busSearchTerm}
//                     onChange={(e) => setBusSearchTerm(e.target.value)}
//                     style={{ width: '100%', padding: '10px 15px' }}
//                   />
//                 </div>

//                 {/* Loading State */}
//                 {busDetailsLoading ? (
//                   <div className="loading-container" style={{ textAlign: 'center', padding: '40px' }}>
//                     <p>Loading bus details...</p>
//                   </div>
//                 ) : (
//                   <>
//                     {/* Buses Table */}
//                     <div className="table-container" style={{ maxHeight: '400px', overflowY: 'auto' }}>
//                       <table className="data-table bus-management-table">
//                         <thead>
//                           <tr>
//                             <th>#</th>
//                             <th>Bus Details</th>
//                             <th>Registration</th>
//                             <th>Type & Category</th>
//                             <th>Seats</th>
//                             <th>Price</th>
//                             <th>Driver Details</th>
//                             <th>Conductor Details</th>
//                             <th>Status</th>

//                           </tr>
//                         </thead>
//                         <tbody>
//                           {selectedOwnerBuses.length > 0 ? (
//                             filteredBuses.map((bus, index) => (
//                               <tr key={bus._id}>
//                                 <td>{index + 1}</td>

//                                 {/* Bus Details */}
//                                 <td className="bus-info-cell">
//                                   <div style={{ fontWeight: '600' }}>
//                                     {bus.busName || 'N/A'}
//                                   </div>
//                                   <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
//                                     Operating: {bus.operatingDays?.join(', ') || 'N/A'}
//                                   </div>
//                                   {bus.amenities && bus.amenities.length > 0 && (
//                                     <div style={{ fontSize: '11px', color: '#17a2b8', marginTop: '2px' }}>
//                                       Amenities: {bus.amenities.slice(0, 2).join(', ')}
//                                       {bus.amenities.length > 2 && '...'}
//                                     </div>
//                                   )}
//                                 </td>

//                                 {/* Registration Number */}
//                                 <td>
//                                   <div style={{
//                                     fontWeight: 'bold',
//                                     color: '#007bff',
//                                     fontSize: '14px'
//                                   }}>
//                                     {bus.busNumber || 'N/A'}
//                                   </div>
//                                 </td>

//                                 {/* Type & Category */}
//                                 <td>
//                                   <div>{bus.busType || 'N/A'}</div>
//                                   <div style={{ fontSize: '12px', color: '#666' }}>
//                                     {bus.busCategory || 'N/A'}
//                                   </div>
//                                 </td>

//                                 {/* Seats */}
//                                 <td>
//                                   <div>
//                                     <span style={{ fontWeight: '600' }}>{bus.totalSeats || 0}</span> total
//                                   </div>
//                                   <div style={{
//                                     fontSize: '12px',
//                                     color: bus.availableSeats > 0 ? '#28a745' : '#dc3545'
//                                   }}>
//                                     <span style={{ fontWeight: '600' }}>{bus.availableSeats || 0}</span> available
//                                   </div>
//                                 </td>

//                                 {/* Price */}
//                                 <td>
//                                   <div style={{ fontWeight: '600', color: '#28a745' }}>
//                                     ₹{bus.basePrice || 0}
//                                   </div>
//                                 </td>

//                                 {/* Driver Details */}
//                                 <td className="staff-details">
//                                   {bus.driver ? (
//                                     <div>
//                                       <div className="staff-name">
//                                         {bus.driver.name || 'N/A'}
//                                       </div>
//                                       <div className="staff-contact">
//                                         📞 {bus.driver.contactNumber || 'N/A'}
//                                       </div>
//                                       {bus.driver.licenseNumber && (
//                                         <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
//                                           License: {bus.driver.licenseNumber}
//                                         </div>
//                                       )}
//                                       {bus.driver.experience > 0 && (
//                                         <div style={{ fontSize: '12px', color: '#666' }}>
//                                           Exp: {bus.driver.experience} yrs
//                                         </div>
//                                       )}
//                                     </div>
//                                   ) : (
//                                     <div className="no-staff">
//                                       No driver assigned
//                                     </div>
//                                   )}
//                                 </td>

//                                 {/* Conductor Details */}
//                                 <td className="staff-details">
//                                   {bus.conductor ? (
//                                     <div>
//                                       <div className="staff-name">
//                                         {bus.conductor.name || 'N/A'}
//                                       </div>
//                                       <div className="staff-contact">
//                                         📞 {bus.conductor.contactNumber || 'N/A'}
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     <div className="no-staff">
//                                       No conductor assigned
//                                     </div>
//                                   )}
//                                 </td>

//                                 {/* Status */}
//                                 <td>
//                                   <span className={bus.isActive ? 'bus-status-active' : 'bus-status-inactive'}>
//                                     {bus.isActive ? 'ACTIVE' : 'INACTIVE'}
//                                   </span>
//                                 </td>


//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
//                                 <div className="no-data">
//                                   <p>No bus data available.</p>
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>

//                     {/* Summary */}
//                     <div style={{
//                       marginTop: '20px',
//                       padding: '10px 15px',
//                       backgroundColor: '#f8f9fa',
//                       borderRadius: '6px',
//                       fontSize: '14px'
//                     }}>
//                       Showing {filteredBuses.length} of {selectedOwnerBuses.length} buses
//                       {busSearchTerm && ` matching "${busSearchTerm}"`}
//                     </div>
//                   </>
//                 )}
//               </div>

//               <div className="modal-footer">
//                 <button
//                   className="modal-close-btn secondary"
//                   onClick={closeBusManagement}
//                   style={{ padding: '8px 20px' }}
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Add Modal (unchanged) */}
//         {showAddModal && (
//           <div className="modal-overlay" onClick={closeAddModal}>
//             <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>Add New Bus Owner</h3>
//                 <button className="modal-close-btn" onClick={closeAddModal}>
//                   ×
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div className="customer-details">
//                   <div className="detail-row">
//                     <label>Owner Name *:</label>
//                     <input
//                       type="text"
//                       name="name"
//                       value={newOwner.name}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter owner name"
//                       required
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Company Name *:</label>
//                     <input
//                       type="text"
//                       name="companyName"
//                       value={newOwner.companyName}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter company name"
//                       required
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Email *:</label>
//                     <input
//                       type="email"
//                       name="email"
//                       value={newOwner.email}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter email address"
//                       required
//                     />
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone *:</label>
//                     <input
//                       type="text"
//                       name="phone"
//                       value={newOwner.phone}
//                       onChange={handleNewOwnerChange}
//                       className="edit-input"
//                       placeholder="Enter phone number"
//                       required
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="action-btn cancel" onClick={closeAddModal}>
//                   Cancel
//                 </button>
//                 <button className="action-btn save" onClick={handleAddOwner}>
//                   Add Owner
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//          {showAddBusModal && selectedOwnerForBus && (
//         <AddBusModal 
//           ownerId={selectedOwnerForBus.id}
//           onClose={closeAddBusModal}
//           onBusAdded={handleBusAdded}
//         />
//       )}
//       </div>
//     );
//   };

//   const addBusStyles = `
// /* Add Bus Modal Styles */
// .add-bus-modal {
//   max-width: 1000px !important;
//   width: 95% !important;
//   max-height: 90vh;
//   overflow-y: auto;
// }

// .route-tabs {
//   display: flex;
//   border-bottom: 1px solid #dee2e6;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
// }

// .route-tab {
//   padding: 10px 15px;
//   background: none;
//   border: none;
//   border-bottom: 3px solid transparent;
//   cursor: pointer;
//   font-weight: 500;
//   color: #6c757d;
//   transition: all 0.3s;
//   white-space: nowrap;
// }

// .route-tab:hover:not(:disabled) {
//   color: #007bff;
// }

// .route-tab.active {
//   color: #007bff;
//   border-bottom-color: #007bff;
// }

// .route-tab:disabled {
//   opacity: 0.5;
//   cursor: not-allowed;
// }

// .tab-content {
//   min-height: 400px;
// }

// .form-section {
//   margin-bottom: 25px;
//   padding-bottom: 20px;
//   border-bottom: 1px solid #eee;
// }

// .form-section h4 {
//   margin-bottom: 15px;
//   color: #333;
// }

// .description {
//   color: #666;
//   margin-bottom: 20px;
//   font-size: 14px;
// }

// .form-row {
//   display: flex;
//   gap: 15px;
//   margin-bottom: 15px;
// }

// .form-group {
//   flex: 1;
// }

// .form-group.full-width {
//   flex: 2;
// }

// .form-group label {
//   display: block;
//   margin-bottom: 5px;
//   font-weight: 500;
//   color: #555;
// }

// .form-input {
//   width: 100%;
//   padding: 8px 12px;
//   border: 1px solid #ced4da;
//   border-radius: 4px;
//   font-size: 14px;
// }

// .form-input:focus {
//   outline: none;
//   border-color: #007bff;
//   box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
// }

// .form-group small {
//   display: block;
//   margin-top: 4px;
//   color: #6c757d;
//   font-size: 12px;
// }

// .amenities-checkboxes,
// .days-checkboxes {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-top: 5px;
// }

// .amenity-checkbox,
// .day-checkbox {
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   cursor: pointer;
//   padding: 5px 8px;
//   background: #f8f9fa;
//   border-radius: 4px;
//   border: 1px solid #dee2e6;
// }

// .amenity-checkbox:hover,
// .day-checkbox:hover {
//   background: #e9ecef;
// }

// .amenity-checkbox input,
// .day-checkbox input {
//   margin: 0;
// }

// .amenity-checkbox span,
// .day-checkbox span {
//   font-size: 14px;
// }

// /* Route Details */
// .route-details {
//   margin-top: 20px;
// }

// .route-info-card {
//   background: #f8f9fa;
//   border-radius: 8px;
//   padding: 15px;
//   margin-bottom: 20px;
//   border: 1px solid #dee2e6;
// }

// .route-info-row {
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 8px;
//   font-size: 14px;
// }

// .route-info-row .label {
//   font-weight: 500;
//   color: #555;
// }

// .route-info-row .value {
//   color: #333;
//   font-weight: 600;
// }

// /* Stops Timeline */
// .stops-timeline {
//   margin-top: 15px;
// }

// .stop-item {
//   display: flex;
//   align-items: flex-start;
//   margin-bottom: 15px;
//   padding-bottom: 15px;
//   border-bottom: 1px dashed #dee2e6;
// }

// .stop-item:last-child {
//   border-bottom: none;
//   margin-bottom: 0;
//   padding-bottom: 0;
// }

// .stop-marker {
//   position: relative;
//   margin-right: 15px;
// }

// .marker {
//   width: 30px;
//   height: 30px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: bold;
//   color: white;
//   font-size: 12px;
// }

// .marker.origin {
//   background: #4c51bf;
// }

// .marker.stop {
//   background: #667eea;
// }

// .marker.destination {
//   background: #764ba2;
// }

// .stop-line {
//   position: absolute;
//   left: 50%;
//   top: 30px;
//   bottom: -15px;
//   width: 2px;
//   background: #dee2e6;
//   transform: translateX(-50%);
// }

// .stop-item:last-child .stop-line {
//   display: none;
// }

// .stop-details {
//   flex: 1;
// }

// .stop-name {
//   font-weight: 600;
//   color: #333;
//   margin-bottom: 2px;
// }

// .stop-terminal {
//   font-size: 13px;
//   color: #666;
//   margin-bottom: 2px;
// }

// .stop-type {
//   font-size: 12px;
//   color: #6c757d;
//   text-transform: capitalize;
// }

// .stop-distance {
//   font-size: 12px;
//   color: #28a745;
//   margin-top: 2px;
// }

// /* Fare Calculator */
// .fare-calculator {
//   margin-top: 20px;
// }

// .fare-summary {
//   margin-top: 20px;
// }

// .summary-card {
//   background: #f8f9fa;
//   border-radius: 8px;
//   padding: 15px;
//   border: 1px solid #dee2e6;
// }

// .summary-card h5 {
//   margin-bottom: 15px;
//   color: #333;
// }

// .summary-row {
//   display: flex;
//   justify-content: space-between;
//   margin-bottom: 8px;
//   font-size: 14px;
// }

// .summary-row.highlighted {
//   font-weight: bold;
//   color: #28a745;
//   padding-top: 10px;
//   border-top: 1px solid #dee2e6;
//   margin-top: 10px;
// }

// .sample-fares {
//   margin-top: 20px;
// }

// .sample-fares-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
//   gap: 10px;
//   margin-top: 10px;
// }

// .sample-fare-item {
//   background: white;
//   border: 1px solid #dee2e6;
//   border-radius: 6px;
//   padding: 10px;
// }

// .fare-route {
//   font-weight: 600;
//   font-size: 13px;
//   margin-bottom: 5px;
//   color: #333;
// }

// .fare-details {
//   display: flex;
//   justify-content: space-between;
//   font-size: 12px;
// }

// .fare-details .distance {
//   color: #666;
// }

// .fare-details .price {
//   color: #28a745;
//   font-weight: 600;
// }

// /* Fare Matrix */
// .matrix-info {
//   margin-bottom: 20px;
// }

// .info-card {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 15px;
//   background: #f8f9fa;
//   border-radius: 8px;
//   padding: 15px;
//   border: 1px solid #dee2e6;
// }

// .info-item {
//   display: flex;
//   flex-direction: column;
// }

// .info-item .label {
//   font-size: 12px;
//   color: #666;
//   margin-bottom: 2px;
// }

// .info-item .value {
//   font-size: 16px;
//   font-weight: 600;
//   color: #333;
// }

// .fare-matrix-container {
//   margin: 20px 0;
//   overflow-x: auto;
// }

// .matrix-table-wrapper {
//   overflow-x: auto;
//   max-height: 400px;
//   overflow-y: auto;
// }

// .fare-matrix-table {
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 11px;
//   min-width: 600px;
// }

// .fare-matrix-table th {
//   background-color: #f8f9fa;
//   padding: 8px;
//   border: 1px solid #dee2e6;
//   text-align: center;
//   font-weight: 600;
//   position: sticky;
//   top: 0;
//   z-index: 10;
//   min-width: 120px;
// }

// .fare-matrix-table td {
//   padding: 5px;
//   border: 1px solid #dee2e6;
//   text-align: center;
//   vertical-align: middle;
// }

// .fare-matrix-table .from-cell {
//   background-color: #e9ecef;
//   font-weight: 600;
//   position: sticky;
//   left: 0;
//   z-index: 5;
//   min-width: 120px;
// }

// .stop-header {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// }

// .stop-header .stop-name {
//   font-size: 11px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   max-width: 100px;
// }

// .stop-header .stop-type {
//   font-size: 10px;
//   color: white;
//   background: #6c757d;
//   border-radius: 3px;
//   padding: 1px 4px;
//   margin-top: 2px;
// }

// .from-stop {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// }

// .fare-cell {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 2px;
// }

// .matrix-input {
//   width: 60px;
//   padding: 4px;
//   border: 1px solid #ced4da;
//   border-radius: 3px;
//   text-align: center;
//   font-size: 11px;
// }

// .matrix-input:focus {
//   outline: none;
//   border-color: #007bff;
// }

// .cell-info small {
//   color: #666;
//   font-size: 9px;
// }

// .na-cell {
//   color: #6c757d;
//   font-style: italic;
// }

// .price-cell.same-stop {
//   background-color: #f8f9fa;
// }

// .matrix-legend {
//   display: flex;
//   gap: 15px;
//   margin-top: 20px;
//   flex-wrap: wrap;
// }

// .legend-item {
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   font-size: 12px;
// }

// .legend-color {
//   width: 16px;
//   height: 16px;
//   border-radius: 50%;
// }

// .legend-color.origin {
//   background: #4c51bf;
// }

// .legend-color.stop {
//   background: #667eea;
// }

// .legend-color.destination {
//   background: #764ba2;
// }

// .legend-color.same-stop {
//   background: #f8f9fa;
//   border: 1px solid #dee2e6;
// }

// /* Seat Layout */
// .no-seats {
//   text-align: center;
//   padding: 40px;
// }

// .no-seats-icon {
//   font-size: 48px;
//   margin-bottom: 15px;
// }

// .no-seats p {
//   color: #666;
//   margin-bottom: 20px;
// }

// .seat-layout-preview {
//   border: 1px solid #dee2e6;
//   border-radius: 8px;
//   padding: 20px;
//   background-color: white;
// }

// .seat-layout-header {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 20px;
//   padding-bottom: 10px;
//   border-bottom: 1px solid #dee2e6;
// }

// .driver-section {
//   font-weight: 600;
//   color: #6c757d;
// }

// .layout-title {
//   font-size: 18px;
//   font-weight: 600;
//   color: #333;
// }

// .btn-small {
//   padding: 5px 10px;
//   font-size: 12px;
//   background: #6c757d;
//   color: white;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
// }

// .btn-small:hover {
//   opacity: 0.9;
// }

// .seats-grid {
//   display: flex;
//   flex-direction: column;
//   gap: 15px;
// }

// .seat-row {
//   display: flex;
//   align-items: center;
//   gap: 15px;
// }

// .row-number {
//   width: 60px;
//   font-weight: 600;
//   color: #495057;
//   font-size: 14px;
// }

// .seats-in-row {
//   display: flex;
//   gap: 8px;
//   flex: 1;
// }

// .seat {
//   width: 40px;
//   height: 40px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background-color: #28a745;
//   color: white;
//   border-radius: 4px;
//   font-weight: 600;
//   cursor: default;
//   font-size: 12px;
// }

// .seat.booked {
//   background-color: #dc3545;
// }

// .seat-legend {
//   display: flex;
//   gap: 20px;
//   margin-top: 20px;
//   padding-top: 15px;
//   border-top: 1px solid #dee2e6;
//   flex-wrap: wrap;
// }

// .seat-summary {
//   margin-top: 20px;
// }

// .summary-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
//   gap: 15px;
//   margin-top: 10px;
// }

// .summary-card {
//   padding: 15px;
//   background-color: #f8f9fa;
//   border-radius: 6px;
//   text-align: center;
//   border: 1px solid #dee2e6;
// }

// .summary-card .count {
//   display: block;
//   font-size: 24px;
//   font-weight: 700;
//   color: #007bff;
//   margin-bottom: 5px;
// }

// .summary-card .label {
//   font-size: 14px;
//   color: #6c757d;
// }

// .final-summary {
//   margin-top: 30px;
//   padding-top: 20px;
//   border-top: 2px solid #dee2e6;
// }

// .final-summary-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 15px;
//   margin-top: 10px;
// }

// .summary-item {
//   display: flex;
//   justify-content: space-between;
//   padding: 10px;
//   background: #f8f9fa;
//   border-radius: 6px;
//   border: 1px solid #dee2e6;
// }

// .summary-item .label {
//   font-weight: 500;
//   color: #555;
// }

// .summary-item .value {
//   font-weight: 600;
//   color: #333;
// }

// /* Form Actions */
// .form-actions {
//   display: flex;
//   justify-content: space-between;
//   margin-top: 30px;
//   padding-top: 20px;
//   border-top: 1px solid #dee2e6;
// }

// .btn {
//   padding: 8px 20px;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
//   font-weight: 500;
//   transition: all 0.3s;
// }

// .btn-primary {
//   background-color: #007bff;
//   color: white;
// }

// .btn-primary:hover:not(:disabled) {
//   background-color: #0056b3;
// }

// .btn-primary:disabled {
//   opacity: 0.5;
//   cursor: not-allowed;
// }

// .btn-outline {
//   background-color: transparent;
//   border: 1px solid #6c757d;
//   color: #6c757d;
// }

// .btn-outline:hover {
//   background-color: #6c757d;
//   color: white;
// }

// .btn-secondary {
//   background-color: #6c757d;
//   color: white;
// }

// .btn-secondary:hover {
//   background-color: #545b62;
// }

// .error-message {
//   background-color: #f8d7da;
//   color: #721c24;
//   padding: 10px 15px;
//   border-radius: 4px;
//   margin-top: 20px;
//   border: 1px solid #f5c6cb;
// }

// /* Responsive adjustments */
// @media (max-width: 768px) {
//   .form-row {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .route-tabs {
//     overflow-x: auto;
//   }

//   .info-card {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .seat-legend {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .form-actions {
//     flex-direction: column;
//     gap: 10px;
//   }

//   .form-actions .btn {
//     width: 100%;
//   }
// }
// `;

//   export default BusOwnerManage;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//   getBusOwners,
//   getBusOwnerById,
//   createBusOwner,
//   updateBusOwner,
//   deleteBusOwner,
//   approveBusOwner,
//   addBusToOwner,
//   getSeatLayoutsByBustype,
//   getAllCategory
// } from '../../Services/Operations/ProductAPI';
// import {
//   getDriversByBusOwner,
//   getConductorsByBusOwner,
//   assignDriverToBus,
//   assignConductorToBus,
//   unassignDriverFromBus,
//   unassignConductorFromBus
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/BusFareChart.css';
// import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
// import BusManagementModal from './BusManagementModal'; // Import the new modal

// // const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
// //   const { token } = useSelector(state => state.user);
// //   const [activeTab, setActiveTab] = useState('basic');
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
// //   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
// //   // Add this with other state declarations
// //   const [blockedSeats, setBlockedSeats] = useState([]);

// //   // Bus Form State
// //   const [form, setForm] = useState({
// //     busNumber: '',
// //     busName: '',
// //     busType: 'AC',
// //     busCategory: 'Seater',
// //     amenities: []
// //   });

// //   // Trip Type State
// //   const [tripType, setTripType] = useState('oneWay');
// //   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

// //   // Route States
// //   const [routes, setRoutes] = useState([]);
// //   const [selectedRoute, setSelectedRoute] = useState(null);
// //   const [loadingRoutes, setLoadingRoutes] = useState(false);

// //   // Seat Layout States
// //   const [layoutTemplates, setLayoutTemplates] = useState([]);
// //   const [selectedTemplate, setSelectedTemplate] = useState(null);
// //   const [activeSeats, setActiveSeats] = useState([]);
// //   const [customSeatLabels, setCustomSeatLabels] = useState({});
// //   const [showLayoutModal, setShowLayoutModal] = useState(false);
// //   const [showTemplateModal, setShowTemplateModal] = useState(false);
// //   const [loadingLayouts, setLoadingLayouts] = useState(false);
// //   const [editingSeat, setEditingSeat] = useState(null);
// //   const [tempSeatLabel, setTempSeatLabel] = useState('');

// //   // Pricing States
// //   const [pricing, setPricing] = useState({
// //     basePrice: '',
// //     baseDistance: '',
// //     costPerKm: ''
// //   });

// //   // Fare Matrices
// //   const [fareMatrixUp, setFareMatrixUp] = useState([]);
// //   const [fareMatrixDown, setFareMatrixDown] = useState([]);

// //   // Operating Days
// //   const [operatingDays, setOperatingDays] = useState([
// //     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
// //   ]);

// //   // Image States
// //   const [selectedImages, setSelectedImages] = useState([]);
// //   const [selectedVideo, setSelectedVideo] = useState(null);

// //   // Constants
// //   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
// //   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
// //   const BUS_CLASSES = ['Economy', 'Premium', 'Luxury'];

// //   const AMENITIES_LIST = [
// //     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
// //     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
// //     'GPS Tracking', 'SOS Switch'
// //   ];

// //   const DAYS_OF_WEEK = [
// //     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
// //   ];

// //   // Fetch Routes
// //   useEffect(() => {
// //     const fetchRoutes = async () => {
// //       try {
// //         setLoadingRoutes(true);
// //         const response = await getAllBusownerAdminRoutes(token, 1, 100, '', ownerId);
// //         if (response && response.success && response.routes) {
// //           setRoutes(response.routes);
// //         }
// //       } catch (error) {
// //         console.error('Error fetching routes:', error);
// //         toast.error('Failed to fetch routes');
// //       } finally {
// //         setLoadingRoutes(false);
// //       }
// //     };

// //     fetchRoutes();
// //   }, [token, ownerId]);

// //   // Fetch configurations when category changes
// //   useEffect(() => {
// //     if (form.busCategory) {
// //       fetchAvailableConfigurations();
// //     }
// //   }, [form.busCategory, token]);

// //   const getCategoryMultiplier = () => {
// //     const multipliers = {
// //       'Seater': 1.0,
// //       'Sleeper': 1.5,
// //       'Seater+Sleeper': 1.3
// //     };
// //     return multipliers[form.busCategory] || 1.0;
// //   };

// //   const getStopColor = (type) => {
// //     switch (type) {
// //       case 'origin': return '#4c51bf';
// //       case 'destination': return '#40c057';
// //       default: return '#667eea';
// //     }
// //   };

// //   const fetchAvailableConfigurations = async () => {
// //     try {
// //       setLoadingLayouts(true);
// //       const response = await getAllCategory(token);

// //       if (response && response.success && response.data) {
// //         let relevantCategories = response.data;

// //         if (form.busCategory === 'Seater') {
// //           relevantCategories = response.data.filter(cat =>
// //             cat.availableSeatTypes?.includes('seat') ||
// //             cat.availableSeatTypes?.includes('seater')
// //           );
// //         } else if (form.busCategory === 'Sleeper') {
// //           relevantCategories = response.data.filter(cat =>
// //             cat.availableSeatTypes?.includes('sleeper')
// //           );
// //         } else if (form.busCategory === 'Seater+Sleeper') {
// //           relevantCategories = response.data.filter(cat =>
// //             cat.availableSeatTypes?.includes('seater+sleeper') ||
// //             cat.availableSeatTypes?.includes('seat+sleeper')
// //           );
// //         }

// //         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

// //         if (configs.length > 0) {
// //           setAvailableConfigurations(configs);
// //           setSelectedConfiguration(configs[0]);
// //           setLayoutTemplates([]);
// //         } else {
// //           setAvailableConfigurations([]);
// //           setLayoutTemplates([]);
// //           toast.info(`No configurations available for ${form.busCategory}`);
// //         }
// //       }
// //     } catch (error) {
// //       console.error('Error fetching configurations:', error);
// //       setAvailableConfigurations([]);
// //     } finally {
// //       setLoadingLayouts(false);
// //     }
// //   };

// //   const fetchLayouts = async (config) => {
// //     try {
// //       if (!config) return;

// //       setLoadingLayouts(true);

// //       let bustype = config.replace('x', '*');

// //       console.log(`Fetching layouts for bustype: ${bustype}`);

// //       const response = await getSeatLayoutsByBustype(bustype, token);

// //       if (response && response.success) {
// //         if (response.data && Array.isArray(response.data)) {
// //           let filteredLayouts = response.data;

// //           if (form.busCategory === 'Seater') {
// //             filteredLayouts = response.data.filter(layout =>
// //               layout.seatType === 'seat' || layout.seatType === 'seater'
// //             );
// //           } else if (form.busCategory === 'Sleeper') {
// //             filteredLayouts = response.data.filter(layout =>
// //               layout.seatType === 'sleeper'
// //             );
// //           } else if (form.busCategory === 'Seater+Sleeper') {
// //             filteredLayouts = response.data.filter(layout =>
// //               layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
// //             );
// //           }

// //           setLayoutTemplates(filteredLayouts);

// //           if (filteredLayouts.length === 0) {
// //             toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
// //           } else {
// //             toast.success(`Found ${filteredLayouts.length} layout(s) for ${config}`);
// //           }
// //         } else {
// //           setLayoutTemplates([]);
// //           toast.info(`No layouts found for ${config} configuration`);
// //         }
// //       } else {
// //         console.error('Failed to fetch layouts:', response);
// //         setLayoutTemplates([]);
// //         toast.error(response?.message || 'Failed to load seat layouts');
// //       }
// //     } catch (error) {
// //       console.error("Layout Fetch Error:", error);
// //       toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
// //       setLayoutTemplates([]);
// //     } finally {
// //       setLoadingLayouts(false);
// //     }
// //   };

// //   const handleCategoryChange = (category) => {
// //     setForm(prev => ({ ...prev, busCategory: category }));
// //     setSelectedTemplate(null);
// //     setActiveSeats([]);
// //     setLayoutTemplates([]);
// //     setCustomSeatLabels({});
// //   };

// //   const handleImageUpload = (event) => {
// //     const files = Array.from(event.target.files);
// //     const newImages = [];

// //     files.forEach(file => {
// //       const reader = new FileReader();
// //       reader.onload = (e) => {
// //         newImages.push({
// //           file: file,
// //           preview: e.target.result,
// //           name: file.name
// //         });

// //         if (newImages.length === files.length) {
// //           setSelectedImages(prev => [...prev, ...newImages]);
// //         }
// //       };
// //       reader.readAsDataURL(file);
// //     });
// //   };

// //   const removeImage = (index) => {
// //     setSelectedImages(prev => prev.filter((_, i) => i !== index));
// //   };

// //   const handleVideoUpload = (event) => {
// //     const file = event.target.files[0];
// //     if (file) {
// //       const reader = new FileReader();
// //       reader.onload = (e) => {
// //         setSelectedVideo({
// //           file: file,
// //           preview: e.target.result,
// //           name: file.name,
// //           size: file.size
// //         });
// //       };
// //       reader.readAsDataURL(file);
// //     }
// //   };

// //   const removeVideo = () => {
// //     setSelectedVideo(null);
// //   };

// //   const openTemplateSelector = () => {
// //     if (!form.busCategory) {
// //       toast.error('Please select a Bus Category first');
// //       return;
// //     }
// //     if (!selectedConfiguration) {
// //       toast.error('Please select a Bus Configuration first');
// //       return;
// //     }
// //     if (layoutTemplates.length === 0) {
// //       toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
// //       return;
// //     }
// //     setShowTemplateModal(true);
// //   };

// //   const handleSelectTemplate = (template) => {
// //     setSelectedTemplate(template);

// //     // START WITH ALL SEATS DISABLED
// //     setActiveSeats([]);
// //     setBlockedSeats([]); // <-- ADD THIS LINE
// //     setCustomSeatLabels({});

// //     setShowTemplateModal(false);
// //     setShowLayoutModal(true);

// //     toast.success(`Selected template: ${template.name}`);
// //   };

// //   const handleSeatPress = (seatObj) => {
// //     setEditingSeat(seatObj.seatNumber);
// //     if (activeSeats.includes(seatObj.seatNumber)) {
// //       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
// //     } else {
// //       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
// //     }
// //   };

// //   const autoRenumberSeats = () => {
// //     const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
// //       if (a.row === b.row) return a.column - b.column;
// //       return a.row - b.row;
// //     });

// //     let counter = 1;
// //     const newLabels = {};

// //     sortedSeats.forEach(s => {
// //       if (activeSeats.includes(s.seatNumber)) {
// //         newLabels[s.seatNumber] = String(counter++);
// //       }
// //     });

// //     setCustomSeatLabels(newLabels);
// //   };

// //   const toggleDay = (day) => {
// //     setOperatingDays(prev =>
// //       prev.includes(day)
// //         ? prev.filter(d => d !== day)
// //         : [...prev, day]
// //     );
// //   };

// //   const generateMatrixForRoute = (routeData) => {
// //     if (!routeData) return [];

// //     const baseP = parseFloat(pricing.basePrice) || 0;
// //     const baseD = parseFloat(pricing.baseDistance) || 0;
// //     const costK = parseFloat(pricing.costPerKm) || 0;
// //     const multiplier = getCategoryMultiplier();

// //     const sortedStops = [...(routeData.intermediateStops || [])]
// //       .sort((a, b) => a.sequence - b.sequence);

// //     const allStops = [
// //       {
// //         id: 'origin',
// //         name: routeData.origin?.city || 'Origin',
// //         distanceFromOrigin: 0,
// //         type: 'origin'
// //       },
// //       ...sortedStops.map((s, i) => ({
// //         id: s._id || `stop_${i}`,
// //         name: s.city || s.name || `Stop ${i + 1}`,
// //         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
// //         type: 'stop',
// //         sequence: s.sequence
// //       })),
// //       {
// //         id: 'destination',
// //         name: routeData.destination?.city || 'Destination',
// //         distanceFromOrigin: parseFloat(routeData.destination?.distanceFromOrigin) ||
// //           parseFloat(routeData.routeDetails?.totalDistance) || 0,
// //         type: 'destination'
// //       }
// //     ];

// //     const matrix = allStops.map((fromStop, i) => {
// //       const toCells = allStops.map((toStop, j) => {
// //         if (j > i) {
// //           const distance = parseFloat(
// //             (parseFloat(toStop.distanceFromOrigin) - parseFloat(fromStop.distanceFromOrigin)).toFixed(1)
// //           );
// //           let price = baseP;
// //           if (distance > baseD) {
// //             price += (distance - baseD) * costK;
// //           }
// //           price = Math.round(price * multiplier);

// //           return {
// //             toId: toStop.id,
// //             toName: toStop.name,
// //             distanceKm: distance,
// //             price: price
// //           };
// //         }
// //         return null;
// //       });

// //       return {
// //         fromId: fromStop.id,
// //         fromName: fromStop.name,
// //         fromType: fromStop.type,
// //         sequence: fromStop.sequence,
// //         toCells: toCells
// //       };
// //     });

// //     return matrix.filter(row => row.fromId !== 'destination');
// //   };

// //   const handleGenerateMatrix = () => {
// //     if (!selectedRoute) {
// //       toast.error('Please select a Route first.');
// //       return;
// //     }

// //     if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
// //       toast.error("The selected route does not have return journey details configured.");
// //       return;
// //     }

// //     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
// //       toast.error('Please fill all Pricing Fields.');
// //       return;
// //     }

// //     // Generate Up Matrix using main route details
// //     const matrixUp = generateMatrixForRoute(selectedRoute);
// //     setFareMatrixUp(matrixUp);

// //     // Generate Down Matrix using return journey details
// //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //       const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
// //       setFareMatrixDown(matrixDown);
// //     } else {
// //       setFareMatrixDown([]);
// //     }

// //     toast.success(tripType === 'roundTrip'
// //       ? "Both Fare Matrices Generated!"
// //       : "Fare Matrix Generated!"
// //     );
// //   };

// //   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
// //     const isUp = type === 'up';
// //     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

// //     const updatedMatrix = currentMatrix.map((row, rIndex) => {
// //       if (rIndex !== rowIndex) return row;
// //       const newToCells = [...row.toCells];
// //       if (newToCells[colIndex]) {
// //         newToCells[colIndex] = {
// //           ...newToCells[colIndex],
// //           price: parseInt(newPrice) || 0
// //         };
// //       }
// //       return { ...row, toCells: newToCells };
// //     });

// //     if (isUp) {
// //       setFareMatrixUp(updatedMatrix);
// //     } else {
// //       setFareMatrixDown(updatedMatrix);
// //     }
// //   };

// //   const getSeatPosition = (column) => {
// //     switch (parseInt(column)) {
// //       case 1: return 'window';
// //       case 2: return 'middle';
// //       case 3: return 'aisle';
// //       case 4: return 'window';
// //       default: return 'aisle';
// //     }
// //   };

// //   const calculateSeatPrice = (seat, basePrice, position) => {
// //     let price = parseFloat(basePrice) || 0;

// //     if (position === 'window') price *= 1.1;
// //     if (position === 'aisle') price *= 1.05;
// //     if (seat.row === 1) price *= 1.2;

// //     return Math.round(price);
// //   };

// //   const handleSubmitBus = async () => {
// //     try {
// //       setIsSubmitting(true);
// //       setError(null);

// //       // Validate required fields
// //       if (!form.busNumber) {
// //         throw new Error('Bus Number is required');
// //       }
// //       if (!form.busName) {
// //         throw new Error('Bus Name is required');
// //       }
// //       if (!form.busType) {
// //         throw new Error('Bus Type is required');
// //       }
// //       if (!form.busCategory) {
// //         throw new Error('Bus Category is required');
// //       }
// //       if (!selectedRoute) {
// //         throw new Error('Please select a route');
// //       }
// //       if (operatingDays.length === 0) {
// //         throw new Error('Please select at least one operating day');
// //       }
// //       if (!selectedTemplate) {
// //         throw new Error('Please configure seat layout');
// //       }
// //       if (fareMatrixUp.length === 0) {
// //         throw new Error('Please generate Fare Matrix');
// //       }

// //       const amenitiesArray = form.amenities || [];

// //       // CONSTRUCT SEATS PAYLOAD WITH GLOBALSEATINDEX - MATCHING BUS OWNER APP
// //       const finalSeatsPayload = selectedTemplate.seats
// //         .filter(s => activeSeats.includes(s.seatNumber))
// //         .map(s => {
// //           const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
// //           const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
// //           const isBlocked = blockedSeats.includes(s.seatNumber); // <-- ADD THIS LINE

// //           return {
// //             seatNumber: s.seatNumber,
// //             globalSeatIndex: finalGlobalIndex,
// //             row: s.row,
// //             column: s.column,
// //             seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
// //             position: s.position || getSeatPosition(s.column),
// //             isBlocked: isBlocked,           // <-- ADD THIS
// //             isAvailable: !isBlocked,        // <-- ADD THIS
// //           };
// //         });

// //       const seatConfigPayload = {
// //         busType: selectedTemplate.configuration || '2*2',
// //         totalSeats: activeSeats.length
// //       };

// //       // CONSTRUCT ROUTE PAYLOAD
// //       const routeSchedules = [];
// //       const routeIdToSave = selectedRoute._id || selectedRoute.id;

// //       routeSchedules.push({
// //         routeId: routeIdToSave,
// //         direction: 'UP',
// //         fareMatrix: fareMatrixUp,
// //         operatingDays: operatingDays,
// //         departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
// //         arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
// //       });

// //       if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //         routeSchedules.push({
// //           routeId: routeIdToSave,
// //           direction: 'DOWN',
// //           fareMatrix: fareMatrixDown,
// //           operatingDays: operatingDays,
// //           departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
// //           arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
// //         });
// //       }

// //       const fareDetails = {
// //         basePrice: parseFloat(pricing.basePrice) || 0,
// //         baseDistance: parseFloat(pricing.baseDistance) || 0,
// //         costPerKm: parseFloat(pricing.costPerKm) || 0
// //       };

// //       // CREATE FORMDATA
// //       const formData = new FormData();

// //       // Append basic fields
// //       formData.append('busNumber', form.busNumber.toUpperCase().trim());
// //       formData.append('busName', form.busName.trim());
// //       formData.append('busType', form.busType);
// //       formData.append('busCategory', form.busCategory);
// //       formData.append('totalSeats', String(activeSeats.length));
// //       formData.append('tripType', tripType);
// //       formData.append('busClass', 'Economy');

// //       // Append JSON strings for complex objects
// //       formData.append('amenities', JSON.stringify(amenitiesArray));
// //       formData.append('seats', JSON.stringify(finalSeatsPayload));
// //       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
// //       formData.append('routeSchedules', JSON.stringify(routeSchedules));
// //       formData.append('fareDetails', JSON.stringify(fareDetails));
// //       formData.append('operatingDays', JSON.stringify(operatingDays));

// //       // Append images
// //       selectedImages.forEach((img, index) => {
// //         if (img.file) {
// //           formData.append('images', img.file);
// //         }
// //       });

// //       // Append video if selected
// //       if (selectedVideo && selectedVideo.file) {
// //         formData.append('videos', selectedVideo.file);
// //       }

// //       console.log('Submitting bus with payload:', {
// //         busNumber: form.busNumber,
// //         busName: form.busName,
// //         busType: form.busType,
// //         busCategory: form.busCategory,
// //         totalSeats: activeSeats.length,
// //         tripType,
// //         routeSchedules: routeSchedules.length,
// //         seatsCount: finalSeatsPayload.length,
// //         seatsSample: finalSeatsPayload.slice(0, 2), // Show first 2 seats as sample
// //         imagesCount: selectedImages.length,
// //         hasVideo: !!selectedVideo
// //       });

// //       const response = await addBusToOwner(ownerId, formData, token);

// //       if (response && response.success) {
// //         toast.success(tripType === 'roundTrip'
// //           ? 'Bus added successfully with round trip routes!'
// //           : 'Bus added successfully!'
// //         );

// //         onBusAdded();
// //         onClose();
// //       } else {
// //         throw new Error(response?.message || 'Failed to add bus');
// //       }

// //     } catch (err) {
// //       console.error('Error adding bus:', err);
// //       setError(err.message || 'Failed to add bus');
// //       toast.error(err.message || 'Failed to add bus');
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const renderMatrix = (type) => {
// //     const isUp = type === 'up';
// //     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
// //     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

// //     if (!currentRoute || currentMatrix.length === 0) return null;

// //     const sortedStops = [...(currentRoute.intermediateStops || [])]
// //       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

// //     const allStops = [
// //       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
// //       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
// //       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
// //     ];

// //     return (
// //       <div className="matrix-section">
// //         <h5 className="matrix-title">
// //           {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
// //         </h5>
// //         <div className="matrix-container">
// //           <div className="matrix-table-wrapper">
// //             <table className="fare-matrix-table">
// //               <thead>
// //                 <tr>
// //                   <th className="corner-cell">From \ To</th>
// //                   {allStops.map((stop, i) => (
// //                     <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
// //                       <div className="stop-header">
// //                         <span className="stop-name">{stop.name}</span>
// //                         <span className="stop-type">{stop.type}</span>
// //                       </div>
// //                     </th>
// //                   ))}
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {currentMatrix.map((row, rowIndex) => (
// //                   <tr key={rowIndex}>
// //                     <td className="from-cell" style={{ backgroundColor: getStopColor(row.fromType) }}>
// //                       <div className="from-stop">
// //                         <span className="stop-name">{row.fromName}</span>
// //                         <span className="stop-type">{row.fromType}</span>
// //                       </div>
// //                     </td>
// //                     {row.toCells.map((cell, colIndex) => {
// //                       if (cell) {
// //                         return (
// //                           <td key={colIndex} className="price-cell">
// //                             <div className="fare-cell">
// //                               <span className="distance">{cell.distanceKm} km</span>
// //                               <div className="price-input-group">
// //                                 <span className="currency">₹</span>
// //                                 <input
// //                                   type="number"
// //                                   className="matrix-input"
// //                                   value={cell.price}
// //                                   onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
// //                                   min="0"
// //                                   step="1"
// //                                 />
// //                               </div>
// //                             </div>
// //                           </td>
// //                         );
// //                       }
// //                       return (
// //                         <td key={colIndex} className="na-cell">
// //                           —
// //                         </td>
// //                       );
// //                     })}
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const renderSeatVisualizer = () => {
// //     if (!selectedTemplate) return null;

// //     const { seats, configuration } = selectedTemplate;

// //     let leftCount = 2, rightCount = 2;
// //     try {
// //       if (configuration && configuration.includes('*')) {
// //         const parts = configuration.split('*');
// //         leftCount = parseInt(parts[0]) || 2;
// //         rightCount = parseInt(parts[1]) || 2;
// //       }
// //     } catch (e) {
// //       leftCount = 2;
// //       rightCount = 2;
// //     }

// //     const totalConfigCols = leftCount + rightCount;

// //     const seatsByRow = {};
// //     seats.forEach(seat => {
// //       if (!seatsByRow[seat.row]) {
// //         seatsByRow[seat.row] = [];
// //       }
// //       seatsByRow[seat.row].push(seat);
// //     });

// //     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

// //     const rows = [];

// //     // const renderSeat = (seatObj) => {
// //     //   const isSelected = activeSeats.includes(seatObj.seatNumber);
// //     //   const isSleeper = seatObj.seatType === 'sleeper' || 
// //     //     seatObj.seatType === 'seat+sleeper' ||
// //     //     selectedTemplate.seatType === 'sleeper' || 
// //     //     selectedTemplate.seatType === 'seater+sleeper';

// //     //   const displayLabel = isSelected 
// //     //     ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber) 
// //     //     : "";

// //     //   return (
// //     //     <button
// //     //       key={seatObj.seatNumber}
// //     //       className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${isSelected ? 'selected' : 'inactive'}`}
// //     //       onClick={() => handleSeatPress(seatObj)}
// //     //       type="button"
// //     //     >
// //     //       <span className="seat-number">{displayLabel}</span>
// //     //     </button>
// //     //   );
// //     // };

// //     const renderSeat = (seatObj) => {
// //       const isSelected = activeSeats.includes(seatObj.seatNumber);
// //       const isBlocked = blockedSeats.includes(seatObj.seatNumber); // <-- ADD THIS LINE
// //       const isSleeper = seatObj.seatType === 'sleeper' ||
// //         seatObj.seatType === 'seat+sleeper' ||
// //         selectedTemplate.seatType === 'sleeper' ||
// //         selectedTemplate.seatType === 'seater+sleeper';

// //       const displayLabel = isSelected
// //         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
// //         : "";

// //       // Determine seat class for styling
// //       let seatClass = '';
// //       if (isSelected) {
// //         seatClass = isBlocked ? 'blocked' : 'selected'; // <-- ADD BLOCKED CLASS
// //       } else {
// //         seatClass = 'inactive';
// //       }

// //       return (
// //         <button
// //           key={seatObj.seatNumber}
// //           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
// //           onClick={() => handleSeatPress(seatObj)}
// //           type="button"
// //         >
// //           <span className="seat-number">{displayLabel}</span>
// //         </button>
// //       );
// //     };

// //     rowNumbers.forEach(rowNum => {
// //       const seatsInRow = seatsByRow[rowNum];

// //       const isBackRow = seatsInRow.some(s => s.position === 'back') ||
// //         seatsInRow.length > totalConfigCols;

// //       if (isBackRow) {
// //         const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
// //         rows.push(
// //           <div key={`row-${rowNum}`} className="seat-row back-row">
// //             <div className="seats-container">
// //               {sortedSeats.map(seat => renderSeat(seat))}
// //             </div>
// //           </div>
// //         );
// //       } else {
// //         const leftSeats = seatsInRow
// //           .filter(s => (s.column || 0) <= leftCount)
// //           .sort((a, b) => (a.column || 0) - (b.column || 0));

// //         const rightSeats = seatsInRow
// //           .filter(s => (s.column || 0) > leftCount)
// //           .sort((a, b) => (a.column || 0) - (b.column || 0));

// //         rows.push(
// //           <div key={`row-${rowNum}`} className="seat-row">
// //             <div className="left-seats">
// //               {leftSeats.map(seat => renderSeat(seat))}
// //             </div>
// //             <div className="aisle">Aisle</div>
// //             <div className="right-seats">
// //               {rightSeats.map(seat => renderSeat(seat))}
// //             </div>
// //           </div>
// //         );
// //       }
// //     });

// //     return (
// //       <div className="seat-layout-visualizer">
// //         <div className="bus-header">
// //           <div className="driver-area">Driver</div>
// //           <div className="bus-info">
// //             <span className="bus-config">{selectedTemplate.configuration}</span>
// //             <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
// //           </div>
// //         </div>
// //         <div className="bus-body">
// //           {rows}
// //         </div>
// //         <div className="seat-legend">
// //           <div className="legend-item">
// //             <div className="seat-sample selected"></div>
// //             <span>Active Seat ({activeSeats.length})</span>
// //           </div>
// //           <div className="legend-item">
// //             <div className="seat-sample inactive"></div>
// //             <span>Inactive Seat</span>
// //           </div>
// //           <div className="legend-item">
// //             <div className="seat-sample sleeper"></div>
// //             <span>Sleeper</span>
// //           </div>
// //         </div>
// //         <div className="seat-summary">
// //           <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const ProgressSteps = () => (
// //     <div className="progress-steps">
// //       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
// //         <div className="step-icon">1</div>
// //         <div className="step-label">Basic Info</div>
// //       </div>
// //       <div className="step-connector"></div>
// //       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
// //         <div className="step-icon">2</div>
// //         <div className="step-label">Route & Pricing</div>
// //       </div>
// //       <div className="step-connector"></div>
// //       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
// //         <div className="step-icon">3</div>
// //         <div className="step-label">Fare Matrix</div>
// //       </div>
// //       <div className="step-connector"></div>
// //       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
// //         <div className="step-icon">4</div>
// //         <div className="step-label">Seat Layout</div>
// //       </div>
// //     </div>
// //   );

// //   const renderBasicInfoTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Bus Information</h3>
// //         <p className="section-subtitle">Enter basic details about the bus</p>
// //       </div>

// //       <div className="form-grid">
// //         <div className="input-group">
// //           <label className="input-label">
// //             <span className="label-icon">🚌</span>
// //             Bus Number *
// //           </label>
// //           <input
// //             type="text"
// //             value={form.busNumber}
// //             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
// //             placeholder="e.g., WB01AB1234"
// //             className="modern-input"
// //             required
// //           />
// //         </div>

// //         <div className="input-group">
// //           <label className="input-label">
// //             <span className="label-icon">🏷️</span>
// //             Bus Name *
// //           </label>
// //           <input
// //             type="text"
// //             value={form.busName}
// //             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
// //             placeholder="e.g., Volvo Multi-Axle"
// //             className="modern-input"
// //             required
// //           />
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🖼️</span>
// //           Bus Images & Video
// //         </h4>
// //         <div className="images-upload-area">
// //           <input
// //             type="file"
// //             id="bus-images"
// //             multiple
// //             accept="image/*"
// //             onChange={handleImageUpload}
// //             className="image-upload-input"
// //             style={{ display: 'none' }}
// //           />
// //           <label htmlFor="bus-images" className="image-upload-label">
// //             <span className="upload-icon">📁</span>
// //             <span className="upload-text">Click to upload images</span>
// //             <span className="upload-hint">Upload multiple images (max 10)</span>
// //           </label>

// //           {selectedImages.length > 0 && (
// //             <div className="selected-images-preview">
// //               <h5>Selected Images ({selectedImages.length})</h5>
// //               <div className="images-grid">
// //                 {selectedImages.map((image, index) => (
// //                   <div key={index} className="image-preview-item">
// //                     <img
// //                       src={image.preview}
// //                       alt={`Bus ${index + 1}`}
// //                       className="preview-image"
// //                     />
// //                     <button
// //                       type="button"
// //                       className="remove-image-btn"
// //                       onClick={() => removeImage(index)}
// //                     >
// //                       ×
// //                     </button>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           )}

// //           <div className="video-upload-section" style={{ marginTop: '15px' }}>
// //             <input
// //               type="file"
// //               id="bus-video"
// //               accept="video/*"
// //               onChange={handleVideoUpload}
// //               className="video-upload-input"
// //               style={{ display: 'none' }}
// //             />
// //             <label htmlFor="bus-video" className="video-upload-label">
// //               <span className="upload-icon">🎥</span>
// //               <span className="upload-text">Click to upload video</span>
// //               <span className="upload-hint">Upload one video (optional)</span>
// //             </label>

// //             {selectedVideo && (
// //               <div className="selected-video-preview">
// //                 <div className="video-info">
// //                   <span className="video-name">{selectedVideo.name}</span>
// //                   <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
// //                 </div>
// //                 <button
// //                   type="button"
// //                   className="remove-video-btn"
// //                   onClick={removeVideo}
// //                 >
// //                   Remove
// //                 </button>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>

// //       <div className="form-row">
// //         <div className="form-group">
// //           <label className="input-label">
// //             <span className="label-icon">🔧</span>
// //             Bus Type *
// //           </label>
// //           <select
// //             value={form.busType}
// //             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
// //             className="modern-select"
// //           >
// //             {BUS_TYPES.map(type => (
// //               <option key={type} value={type}>{type}</option>
// //             ))}
// //           </select>
// //         </div>

// //         <div className="form-group">
// //           <label className="input-label">
// //             <span className="label-icon">📊</span>
// //             Bus Category *
// //           </label>
// //           <select
// //             value={form.busCategory}
// //             onChange={(e) => handleCategoryChange(e.target.value)}
// //             className="modern-select"
// //           >
// //             <option value="">Select Category</option>
// //             {BUS_CATEGORIES.map(cat => (
// //               <option key={cat} value={cat}>{cat}</option>
// //             ))}
// //           </select>
// //           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">✨</span>
// //           Amenities
// //         </h4>
// //         <div className="amenities-grid compact">
// //           {AMENITIES_LIST.map(amenity => (
// //             <label key={amenity} className="amenity-option compact">
// //               <input
// //                 type="checkbox"
// //                 checked={form.amenities.includes(amenity)}
// //                 onChange={(e) => {
// //                   if (e.target.checked) {
// //                     setForm(prev => ({
// //                       ...prev,
// //                       amenities: [...prev.amenities, amenity]
// //                     }));
// //                   } else {
// //                     setForm(prev => ({
// //                       ...prev,
// //                       amenities: prev.amenities.filter(a => a !== amenity)
// //                     }));
// //                   }
// //                 }}
// //                 className="amenity-checkbox"
// //               />
// //               <span className="amenity-content">
// //                 <span className="amenity-icon">✓</span>
// //                 <span className="amenity-label">{amenity}</span>
// //               </span>
// //             </label>
// //           ))}
// //         </div>
// //       </div>

// //       <div className="form-actions">
// //         <button
// //           className="modern-btn primary full-width"
// //           onClick={() => setActiveTab('route')}
// //           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
// //         >
// //           Continue to Route & Pricing
// //           <span className="btn-icon">→</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   const renderRouteTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Route & Pricing Configuration</h3>
// //         <p className="section-subtitle">Select routes and configure pricing for this bus</p>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🔄</span>
// //           Trip Type
// //         </h4>
// //         <div className="trip-type-container">
// //           <button
// //             type="button"
// //             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
// //             onClick={() => setTripType('oneWay')}
// //           >
// //             <span className="btn-icon">➡️</span>
// //             One Way
// //           </button>
// //           <button
// //             type="button"
// //             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
// //             onClick={() => setTripType('roundTrip')}
// //           >
// //             <span className="btn-icon">🔄</span>
// //             Round Trip
// //           </button>
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🗺️</span>
// //           Route Selection
// //         </h4>

// //         <div className="route-selector">
// //           <label className="input-label">Select Route *</label>
// //           <select
// //             value={selectedRoute?._id || ''}
// //             onChange={(e) => {
// //               const route = routes.find(r => r._id === e.target.value);
// //               setSelectedRoute(route);
// //               setFareMatrixUp([]);
// //               setFareMatrixDown([]);
// //             }}
// //             className="modern-select"
// //             disabled={loadingRoutes}
// //           >
// //             <option value="">Select Route</option>
// //             {routes.map(route => (
// //               <option key={route._id} value={route._id}>
// //                 {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''}) {route.isRoundTrip ? '[Round Trip]' : ''}
// //               </option>
// //             ))}
// //           </select>
// //           {selectedRoute && selectedRoute.isRoundTrip && (
// //             <small className="helper-text">This is a round trip route - both UP and DOWN matrices will be generated</small>
// //           )}
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">📅</span>
// //           Operating Days *
// //         </h4>
// //         <div className="days-grid compact">
// //           {DAYS_OF_WEEK.map(day => (
// //             <button
// //               key={day}
// //               type="button"
// //               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
// //               onClick={() => toggleDay(day)}
// //               title={day}
// //             >
// //               {day.substring(0, 3)}
// //             </button>
// //           ))}
// //         </div>
// //         <div className="selected-days">
// //           Selected: {operatingDays.length} days
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">💰</span>
// //           Pricing Configuration
// //         </h4>

// //         <div className="form-row">
// //           <div className="form-group">
// //             <label>Base Price (₹) *</label>
// //             <input
// //               type="number"
// //               value={pricing.basePrice}
// //               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
// //               placeholder="e.g., 100"
// //               className="modern-input"
// //               min="0"
// //               step="1"
// //             />
// //           </div>
// //           <div className="form-group">
// //             <label>Base Distance (km) *</label>
// //             <input
// //               type="number"
// //               value={pricing.baseDistance}
// //               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
// //               placeholder="e.g., 15"
// //               className="modern-input"
// //               min="0"
// //               step="0.1"
// //             />
// //           </div>
// //           <div className="form-group">
// //             <label>Cost per km (₹) *</label>
// //             <input
// //               type="number"
// //               value={pricing.costPerKm}
// //               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
// //               placeholder="e.g., 4"
// //               className="modern-input"
// //               min="0"
// //               step="0.1"
// //             />
// //           </div>
// //         </div>

// //         {selectedRoute && (
// //           <div className="pricing-summary">
// //             <div className="summary-item">
// //               <span>Category Multiplier:</span>
// //               <span className="value accent">{getCategoryMultiplier()}x</span>
// //             </div>
// //             <div className="summary-item">
// //               <span>Route Distance:</span>
// //               <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
// //             </div>
// //           </div>
// //         )}
// //       </div>

// //       <div className="form-actions">
// //         <button
// //           type="button"
// //           className="modern-btn outline"
// //           onClick={() => setActiveTab('basic')}
// //         >
// //           ← Back
// //         </button>
// //         <button
// //           type="button"
// //           className="modern-btn primary generate-matrix-btn"
// //           onClick={() => {
// //             handleGenerateMatrix();
// //             if (fareMatrixUp.length > 0) {
// //               setActiveTab('matrix');
// //             }
// //           }}
// //           disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
// //         >
// //           Generate Fare Matrix
// //           <span className="btn-icon">→</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   const renderMatrixTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Fare Matrix Configuration</h3>
// //         <p className="section-subtitle">Review and edit fares for each route</p>
// //       </div>

// //       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
// //         <div className="matrix-tabs">
// //           <button
// //             type="button"
// //             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
// //             onClick={() => setActiveMatrixTab('up')}
// //           >
// //             Up Route: {selectedRoute.routeName}
// //           </button>
// //           <button
// //             type="button"
// //             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
// //             onClick={() => setActiveMatrixTab('down')}
// //           >
// //             Down Route: Return Route
// //           </button>
// //         </div>
// //       )}

// //       {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
// //         <>
// //           {activeMatrixTab === 'up' && renderMatrix('up')}
// //           {activeMatrixTab === 'down' && renderMatrix('down')}
// //         </>
// //       ) : (
// //         renderMatrix('up')
// //       )}

// //       <div className="matrix-info">
// //         <div className="info-card">
// //           <div className="info-item">
// //             <span className="label">Total Stops:</span>
// //             <span className="value">
// //               {selectedRoute ?
// //                 (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
// //             </span>
// //           </div>
// //           <div className="info-item">
// //             <span className="label">Category Multiplier:</span>
// //             <span className="value accent">{getCategoryMultiplier()}x</span>
// //           </div>
// //           <div className="info-item">
// //             <span className="label">Base Price:</span>
// //             <span className="value">₹{pricing.basePrice}</span>
// //           </div>
// //           <div className="info-item">
// //             <span className="label">Cost/km:</span>
// //             <span className="value">₹{pricing.costPerKm}</span>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="form-actions">
// //         <button
// //           type="button"
// //           className="modern-btn outline"
// //           onClick={() => setActiveTab('route')}
// //         >
// //           ← Back to Pricing
// //         </button>
// //         <button
// //           type="button"
// //           className="modern-btn primary"
// //           onClick={() => setActiveTab('seats')}
// //           disabled={fareMatrixUp.length === 0}
// //         >
// //           Continue to Seat Layout
// //           <span className="btn-icon">→</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   const renderSeatLayoutTab = () => (
// //     <div className="tab-content-wrapper">
// //       <div className="section-title">
// //         <h3>Seat Layout Configuration</h3>
// //         <p className="section-subtitle">Configure seat layout for this bus</p>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">🔧</span>
// //           Bus Configuration
// //         </h4>
// //         <div className="config-selector">
// //           <label className="input-label">Select Bus Configuration *</label>
// //           {loadingLayouts ? (
// //             <div className="loading-configs">
// //               <span>Loading configurations...</span>
// //             </div>
// //           ) : (
// //             <>
// //               <div className="config-buttons">
// //                 {availableConfigurations.map(config => (
// //                   <button
// //                     key={config}
// //                     type="button"
// //                     className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
// //                     onClick={() => {
// //                       setSelectedConfiguration(config);
// //                       setSelectedTemplate(null);
// //                       setActiveSeats([]);
// //                       setCustomSeatLabels({});
// //                       fetchLayouts(config);
// //                     }}
// //                   >
// //                     {config}
// //                   </button>
// //                 ))}
// //               </div>
// //               <small className="helper-text">
// //                 {form.busCategory} bus with {selectedConfiguration} configuration
// //               </small>
// //             </>
// //           )}
// //         </div>
// //       </div>

// //       <div className="section-card">
// //         <h4 className="card-title">
// //           <span className="title-icon">💺</span>
// //           Seat Layout Template
// //         </h4>

// //         {!selectedTemplate ? (
// //           <button
// //             type="button"
// //             className="modern-btn outline full-width"
// //             onClick={openTemplateSelector}
// //             disabled={loadingLayouts}
// //           >
// //             {loadingLayouts ? (
// //               <>
// //                 <span className="btn-icon">⏳</span>
// //                 Loading Layouts...
// //               </>
// //             ) : (
// //               <>
// //                 <span className="btn-icon">📋</span>
// //                 Select Layout Template
// //               </>
// //             )}
// //           </button>
// //         ) : (
// //           <div className="selected-template-info">
// //             <div className="template-details">
// //               <span className="template-name">{selectedTemplate.name}</span>
// //               <span className="template-config">{selectedTemplate.configuration}</span>
// //               <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
// //               <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
// //             </div>
// //             <button
// //               type="button"
// //               className="btn-small"
// //               onClick={() => {
// //                 setSelectedTemplate(null);
// //                 setActiveSeats([]);
// //                 setCustomSeatLabels({});
// //               }}
// //             >
// //               Change
// //             </button>
// //           </div>
// //         )}
// //       </div>

// //       {selectedTemplate && (
// //         <div className="section-card">
// //           <h4 className="card-title">
// //             <span className="title-icon">👁️</span>
// //             Seat Layout Visualizer
// //           </h4>
// //           <button
// //             type="button"
// //             className="view-layout-btn"
// //             onClick={() => setShowLayoutModal(true)}
// //           >
// //             View / Edit Seat Numbers
// //           </button>

// //           <div className="seat-summary">
// //             <div className="summary-item">
// //               <span>Total Seats in Template:</span>
// //               <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
// //             </div>
// //             <div className="summary-item">
// //               <span>Active Seats:</span>
// //               <span className="value accent">{activeSeats.length}</span>
// //             </div>
// //             <div className="summary-item">
// //               <span>Inactive Seats:</span>
// //               <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <div className="form-actions">
// //         <button
// //           type="button"
// //           className="modern-btn outline"
// //           onClick={() => setActiveTab('matrix')}
// //         >
// //           ← Back to Matrix
// //         </button>
// //         <button
// //           type="button"
// //           className="modern-btn primary"
// //           onClick={handleSubmitBus}
// //           disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
// //         >
// //           {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
// //           <span className="btn-icon">✓</span>
// //         </button>
// //       </div>
// //     </div>
// //   );

// //   // const renderLayoutModal = () => (
// //   //   <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
// //   //     <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
// //   //       <div className="modal-header">
// //   //         <h3>Edit Active Seats</h3>
// //   //         <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
// //   //       </div>
// //   //       <div className="modal-body">
// //   //         <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
// //   //         <div className="seat-legend">
// //   //           <div className="legend-item">
// //   //             <div className="seat-sample selected"></div>
// //   //             <span>Active</span>
// //   //           </div>
// //   //           <div className="legend-item">
// //   //             <div className="seat-sample inactive"></div>
// //   //             <span>Disabled</span>
// //   //           </div>
// //   //           <div className="legend-item">
// //   //             <div className="seat-sample sleeper"></div>
// //   //             <span>Sleeper</span>
// //   //           </div>
// //   //         </div>
// //   //         {renderSeatVisualizer()}
// //   //         <div className="layout-footer">
// //   //           <span>Total: {activeSeats.length}</span>
// //   //           <div className="footer-actions">
// //   //             <button className="auto-number-btn" onClick={autoRenumberSeats}>
// //   //               Auto-Number
// //   //             </button>
// //   //             <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
// //   //               Confirm
// //   //             </button>
// //   //           </div>
// //   //         </div>
// //   //       </div>
// //   //     </div>
// //   //   </div>
// //   // );
// //   const renderLayoutModal = () => (
// //     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
// //       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header">
// //           <h3>Edit Seat Numbers</h3>
// //           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
// //         </div>
// //         <div className="modal-body">
// //           <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
// //           <div className="seat-legend three-items">
// //             <div className="legend-item">
// //               <div className="seat-sample selected"></div>
// //               <span>Active</span>
// //             </div>
// //             <div className="legend-item">
// //               <div className="seat-sample blocked"></div>
// //               <span>Blocked</span>
// //             </div>
// //             <div className="legend-item">
// //               <div className="seat-sample inactive"></div>
// //               <span>Disabled</span>
// //             </div>
// //           </div>
// //           {renderSeatVisualizer()}
// //           <div className="layout-footer">
// //             <span>Total: {activeSeats.length}</span>
// //             <div className="footer-actions">
// //               <button className="auto-number-btn" onClick={autoRenumberSeats}>
// //                 Auto-Number
// //               </button>
// //               <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
// //                 Confirm
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   const renderTemplateModal = () => (
// //     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
// //       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header">
// //           <h3>Select Seat Layout Template</h3>
// //           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
// //         </div>
// //         <div className="modal-body">
// //           {loadingLayouts ? (
// //             <div className="loading-container">
// //               <p>Loading templates...</p>
// //             </div>
// //           ) : layoutTemplates.length === 0 ? (
// //             <div className="no-templates">
// //               <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
// //               <p className="hint">Available configurations with layouts:</p>
// //               <div className="available-configs">
// //                 {availableConfigurations.map(config => (
// //                   <span key={config} className="config-chip">{config}</span>
// //                 ))}
// //               </div>
// //               <p className="hint">Try selecting a different configuration</p>
// //             </div>
// //           ) : (
// //             <div className="templates-grid">
// //               {layoutTemplates.map(template => (
// //                 <button
// //                   type="button"
// //                   key={template._id}
// //                   className="template-card"
// //                   onClick={() => handleSelectTemplate(template)}
// //                 >
// //                   <h4 className="template-name">{template.name}</h4>
// //                   <div className="template-details">
// //                     <span className="config">Config: {template.configuration}</span>
// //                     <span className="seats">Seats: {template.totalSeats}</span>
// //                   </div>
// //                   <div className="template-preview">
// //                     <span className="rows">Rows: {template.rows}</span>
// //                     <span className="cols">Cols: {template.columns}</span>
// //                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
// //                   </div>
// //                 </button>
// //               ))}
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   // Seat Number Edit Modal
// //   // const renderSeatEditModal = () => (
// //   //   <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
// //   //     <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
// //   //       <div className="modal-header">
// //   //         <h3>Set Seat Label</h3>
// //   //       </div>
// //   //       <div className="modal-body">
// //   //         <input
// //   //           type="text"
// //   //           value={tempSeatLabel}
// //   //           onChange={(e) => setTempSeatLabel(e.target.value)}
// //   //           placeholder="e.g. 1 or 1A"
// //   //           className="seat-input"
// //   //           autoFocus
// //   //         />
// //   //       </div>
// //   //       <div className="modal-footer">
// //   //         <button
// //   //           className="cancel-btn"
// //   //           onClick={() => {
// //   //             setActiveSeats(activeSeats.filter(s => s !== editingSeat));
// //   //             setEditingSeat(null);
// //   //           }}
// //   //         >
// //   //           Disable
// //   //         </button>
// //   //         <button
// //   //           className="save-btn"
// //   //           onClick={() => {
// //   //             if (tempSeatLabel.trim() === '') {
// //   //               toast.error('Please enter a valid seat number');
// //   //               return;
// //   //             }
// //   //             if (!activeSeats.includes(editingSeat)) {
// //   //               setActiveSeats([...activeSeats, editingSeat]);
// //   //             }
// //   //             setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
// //   //             setEditingSeat(null);
// //   //           }}
// //   //         >
// //   //           Save
// //   //         </button>
// //   //       </div>
// //   //     </div>
// //   //   </div>
// //   // );

// //   const renderSeatEditModal = () => (
// //     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
// //       <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header">
// //           <h3>Set Seat Label</h3>
// //         </div>
// //         <div className="modal-body">
// //           <input
// //             type="text"
// //             value={tempSeatLabel}
// //             onChange={(e) => setTempSeatLabel(e.target.value)}
// //             placeholder="e.g. 1 or 1A"
// //             className="seat-input"
// //             autoFocus
// //           />
// //         </div>
// //         <div className="modal-footer three-buttons">
// //           {/* DISABLE BUTTON */}
// //           <button
// //             className="modal-action-btn disable-btn"
// //             onClick={() => {
// //               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
// //               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
// //               setEditingSeat(null);
// //             }}
// //           >
// //             Disable
// //           </button>

// //           {/* BLOCK BUTTON */}
// //           <button
// //             className="modal-action-btn block-btn"
// //             onClick={() => {
// //               if (tempSeatLabel.trim() === '') {
// //                 toast.error('Please enter a valid seat number');
// //                 return;
// //               }
// //               if (!activeSeats.includes(editingSeat)) {
// //                 setActiveSeats([...activeSeats, editingSeat]);
// //               }
// //               if (!blockedSeats.includes(editingSeat)) {
// //                 setBlockedSeats([...blockedSeats, editingSeat]);
// //               }
// //               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
// //               setEditingSeat(null);
// //             }}
// //           >
// //             Block
// //           </button>

// //           {/* ACTIVE (SAVE) BUTTON */}
// //           <button
// //             className="modal-action-btn active-btn"
// //             onClick={() => {
// //               if (tempSeatLabel.trim() === '') {
// //                 toast.error('Please enter a valid seat number');
// //                 return;
// //               }
// //               if (!activeSeats.includes(editingSeat)) {
// //                 setActiveSeats([...activeSeats, editingSeat]);
// //               }
// //               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
// //               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
// //               setEditingSeat(null);
// //             }}
// //           >
// //             Active
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <div className="modal-overlay modern" onClick={onClose}>
// //       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
// //         <div className="modal-header modern">
// //           <div className="header-content">
// //             <h2 className="modal-title">
// //               <span className="title-icon">🚌</span>
// //               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
// //             </h2>
// //             <p className="modal-subtitle">Configure bus details with route selection</p>
// //           </div>
// //           <button className="modal-close-btn modern" onClick={onClose}>
// //             <span className="close-icon">×</span>
// //           </button>
// //         </div>

// //         <div className="modal-body modern">
// //           <ProgressSteps />

// //           <div className="tab-container">
// //             {activeTab === 'basic' && renderBasicInfoTab()}
// //             {activeTab === 'route' && renderRouteTab()}
// //             {activeTab === 'matrix' && renderMatrixTab()}
// //             {activeTab === 'seats' && renderSeatLayoutTab()}
// //           </div>

// //           {error && (
// //             <div className="error-message modern">
// //               <span className="error-icon">⚠️</span>
// //               {error}
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       {showLayoutModal && renderLayoutModal()}
// //       {showTemplateModal && renderTemplateModal()}
// //       {editingSeat && renderSeatEditModal()}
// //     </div>
// //   );
// // };

// const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
//   const { token } = useSelector(state => state.user);
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);

//   // ADD THIS: Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({
//     hours: 1,
//     minutes: 0
//   });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States
//   const [routes, setRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Image States
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Constants
//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const BUS_CLASSES = ['Economy', 'Premium', 'Luxury'];

//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];

//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // ADD THIS: Validate booking time
//   const validateBookingTime = () => {
//     const totalMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//     if (totalMinutes < 0) {
//       toast.error('Booking close time cannot be negative');
//       return false;
//     }
//     if (bookingClosedBefore.hours > 24) {
//       toast.error('Booking close hours cannot exceed 24');
//       return false;
//     }
//     if (bookingClosedBefore.minutes > 59) {
//       toast.error('Minutes cannot exceed 59');
//       return false;
//     }
//     return true;
//   };

//   // ADD THIS: Handle booking time change
//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({
//       ...prev,
//       [field]: parseInt(value) || 0
//     }));
//   };

//   // Fetch Routes
//   useEffect(() => {
//     const fetchRoutes = async () => {
//       try {
//         setLoadingRoutes(true);
//         const response = await getAllBusownerAdminRoutes(token, 1, 100, '', ownerId);
//         console.log("getAllBusownerAdminRoutes : ", response)
//         if (response && response.success && response.routes) {
//           setRoutes(response.routes);
//         }
//       } catch (error) {
//         console.error('Error fetching routes:', error);
//         toast.error('Failed to fetch routes');
//       } finally {
//         setLoadingRoutes(false);
//       }
//     };

//     fetchRoutes();
//   }, [token, ownerId]);

//   // Fetch configurations when category changes
//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   const getCategoryMultiplier = () => {
//     const multipliers = {
//       'Seater': 1.0,
//       'Sleeper': 1.5,
//       'Seater+Sleeper': 1.3
//     };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);

//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;

//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') ||
//             cat.availableSeatTypes?.includes('seater')
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper')
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') ||
//             cat.availableSeatTypes?.includes('seat+sleeper')
//           );
//         }

//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           setSelectedConfiguration(configs[0]);
//           setLayoutTemplates([]);
//         } else {
//           setAvailableConfigurations([]);
//           setLayoutTemplates([]);
//           toast.info(`No configurations available for ${form.busCategory}`);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;

//       setLoadingLayouts(true);

//       let bustype = config.replace('x', '*');

//       console.log(`Fetching layouts for bustype: ${bustype}`);

//       const response = await getSeatLayoutsByBustype(bustype, token);

//       if (response && response.success) {
//         if (response.data && Array.isArray(response.data)) {
//           let filteredLayouts = response.data;

//           if (form.busCategory === 'Seater') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seat' || layout.seatType === 'seater'
//             );
//           } else if (form.busCategory === 'Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'sleeper'
//             );
//           } else if (form.busCategory === 'Seater+Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//             );
//           }

//           setLayoutTemplates(filteredLayouts);

//           if (filteredLayouts.length === 0) {
//             toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
//           } else {
//             toast.success(`Found ${filteredLayouts.length} layout(s) for ${config}`);
//           }
//         } else {
//           setLayoutTemplates([]);
//           toast.info(`No layouts found for ${config} configuration`);
//         }
//       } else {
//         console.error('Failed to fetch layouts:', response);
//         setLayoutTemplates([]);
//         toast.error(response?.message || 'Failed to load seat layouts');
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const handleCategoryChange = (category) => {
//     setForm(prev => ({ ...prev, busCategory: category }));
//     setSelectedTemplate(null);
//     setActiveSeats([]);
//     setLayoutTemplates([]);
//     setCustomSeatLabels({});
//   };

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImages = [];

//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         newImages.push({
//           file: file,
//           preview: e.target.result,
//           name: file.name
//         });

//         if (newImages.length === files.length) {
//           setSelectedImages(prev => [...prev, ...newImages]);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const removeImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({
//           file: file,
//           preview: e.target.result,
//           name: file.name,
//           size: file.size
//         });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeVideo = () => {
//     setSelectedVideo(null);
//   };

//   const openTemplateSelector = () => {
//     if (!form.busCategory) {
//       toast.error('Please select a Bus Category first');
//       return;
//     }
//     if (!selectedConfiguration) {
//       toast.error('Please select a Bus Configuration first');
//       return;
//     }
//     if (layoutTemplates.length === 0) {
//       toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
//       return;
//     }
//     setShowTemplateModal(true);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setActiveSeats([]);
//     setBlockedSeats([]);
//     setCustomSeatLabels({});
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });

//     let counter = 1;
//     const newLabels = {};

//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });

//     setCustomSeatLabels(newLabels);
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day)
//         ? prev.filter(d => d !== day)
//         : [...prev, day]
//     );
//   };

//   const generateMatrixForRoute = (routeData) => {
//     if (!routeData) return [];

//     const baseP = parseFloat(pricing.basePrice) || 0;
//     const baseD = parseFloat(pricing.baseDistance) || 0;
//     const costK = parseFloat(pricing.costPerKm) || 0;
//     const multiplier = getCategoryMultiplier();

//     const sortedStops = [...(routeData.intermediateStops || [])]
//       .sort((a, b) => a.sequence - b.sequence);

//     const allStops = [
//       {
//         id: 'origin',
//         name: routeData.origin?.city || 'Origin',
//         distanceFromOrigin: 0,
//         type: 'origin'
//       },
//       ...sortedStops.map((s, i) => ({
//         id: s._id || `stop_${i}`,
//         name: s.city || s.name || `Stop ${i + 1}`,
//         distanceFromOrigin: parseFloat(s.distanceFromOrigin) || 0,
//         type: 'stop',
//         sequence: s.sequence
//       })),
//       {
//         id: 'destination',
//         name: routeData.destination?.city || 'Destination',
//         distanceFromOrigin: parseFloat(routeData.destination?.distanceFromOrigin) ||
//           parseFloat(routeData.routeDetails?.totalDistance) || 0,
//         type: 'destination'
//       }
//     ];

//     const matrix = allStops.map((fromStop, i) => {
//       const toCells = allStops.map((toStop, j) => {
//         if (j > i) {
//           const distance = parseFloat(
//             (parseFloat(toStop.distanceFromOrigin) - parseFloat(fromStop.distanceFromOrigin)).toFixed(1)
//           );
//           let price = baseP;
//           if (distance > baseD) {
//             price += (distance - baseD) * costK;
//           }
//           price = Math.round(price * multiplier);

//           return {
//             toId: toStop.id,
//             toName: toStop.name,
//             distanceKm: distance,
//             price: price
//           };
//         }
//         return null;
//       });

//       return {
//         fromId: fromStop.id,
//         fromName: fromStop.name,
//         fromType: fromStop.type,
//         sequence: fromStop.sequence,
//         toCells: toCells
//       };
//     });

//     return matrix.filter(row => row.fromId !== 'destination');
//   };

//   const handleGenerateMatrix = () => {
//     if (!selectedRoute) {
//       toast.error('Please select a Route first.');
//       return;
//     }

//     if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
//       toast.error("The selected route does not have return journey details configured.");
//       return;
//     }

//     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//       toast.error('Please fill all Pricing Fields.');
//       return;
//     }

//     const matrixUp = generateMatrixForRoute(selectedRoute);
//     setFareMatrixUp(matrixUp);

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//       setFareMatrixDown(matrixDown);
//     } else {
//       setFareMatrixDown([]);
//     }

//     toast.success(tripType === 'roundTrip'
//       ? "Both Fare Matrices Generated!"
//       : "Fare Matrix Generated!"
//     );
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = {
//           ...newToCells[colIndex],
//           price: parseInt(newPrice) || 0
//         };
//       }
//       return { ...row, toCells: newToCells };
//     });

//     if (isUp) {
//       setFareMatrixUp(updatedMatrix);
//     } else {
//       setFareMatrixDown(updatedMatrix);
//     }
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   const handleSubmitBus = async () => {
//     try {
//       setIsSubmitting(true);
//       setError(null);

//       // Validate booking time
//       if (!validateBookingTime()) {
//         setIsSubmitting(false);
//         return;
//       }

//       // Validate required fields
//       if (!form.busNumber) {
//         throw new Error('Bus Number is required');
//       }
//       if (!form.busName) {
//         throw new Error('Bus Name is required');
//       }
//       if (!form.busType) {
//         throw new Error('Bus Type is required');
//       }
//       if (!form.busCategory) {
//         throw new Error('Bus Category is required');
//       }
//       if (!selectedRoute) {
//         throw new Error('Please select a route');
//       }
//       if (operatingDays.length === 0) {
//         throw new Error('Please select at least one operating day');
//       }
//       if (!selectedTemplate) {
//         throw new Error('Please configure seat layout');
//       }
//       if (fareMatrixUp.length === 0) {
//         throw new Error('Please generate Fare Matrix');
//       }

//       const amenitiesArray = form.amenities || [];

//       const finalSeatsPayload = selectedTemplate.seats
//         .filter(s => activeSeats.includes(s.seatNumber))
//         .map(s => {
//           const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//           const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//           const isBlocked = blockedSeats.includes(s.seatNumber);

//           return {
//             seatNumber: s.seatNumber,
//             globalSeatIndex: finalGlobalIndex,
//             row: s.row,
//             column: s.column,
//             seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//             position: s.position || getSeatPosition(s.column),
//             isBlocked: isBlocked,
//             isAvailable: !isBlocked,
//           };
//         });

//       const seatConfigPayload = {
//         busType: selectedTemplate.configuration || '2*2',
//         totalSeats: activeSeats.length
//       };

//       const routeSchedules = [];
//       const routeIdToSave = selectedRoute._id || selectedRoute.id;

//       routeSchedules.push({
//         routeId: routeIdToSave,
//         direction: 'UP',
//         fareMatrix: fareMatrixUp,
//         operatingDays: operatingDays,
//         departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//         arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//       });

//       if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//         routeSchedules.push({
//           routeId: routeIdToSave,
//           direction: 'DOWN',
//           fareMatrix: fareMatrixDown,
//           operatingDays: operatingDays,
//           departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//           arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//         });
//       }

//       const fareDetails = {
//         basePrice: parseFloat(pricing.basePrice) || 0,
//         baseDistance: parseFloat(pricing.baseDistance) || 0,
//         costPerKm: parseFloat(pricing.costPerKm) || 0
//       };

//       const formData = new FormData();

//       formData.append('busNumber', form.busNumber.toUpperCase().trim());
//       formData.append('busName', form.busName.trim());
//       formData.append('busType', form.busType);
//       formData.append('busCategory', form.busCategory);
//       formData.append('totalSeats', String(activeSeats.length));
//       formData.append('tripType', tripType);
//       formData.append('busClass', 'Economy');

//       formData.append('amenities', JSON.stringify(amenitiesArray));
//       formData.append('seats', JSON.stringify(finalSeatsPayload));
//       formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//       formData.append('routeSchedules', JSON.stringify(routeSchedules));
//       formData.append('fareDetails', JSON.stringify(fareDetails));
//       formData.append('operatingDays', JSON.stringify(operatingDays));

//       // ADD THIS: Append bookingClosedBefore
//       formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));

//       selectedImages.forEach((img, index) => {
//         if (img.file) {
//           formData.append('images', img.file);
//         }
//       });

//       if (selectedVideo && selectedVideo.file) {
//         formData.append('videos', selectedVideo.file);
//       }

//       console.log('Submitting bus with payload:', {
//         busNumber: form.busNumber,
//         busName: form.busName,
//         busType: form.busType,
//         busCategory: form.busCategory,
//         totalSeats: activeSeats.length,
//         tripType,
//         bookingClosedBefore: bookingClosedBefore,
//         routeSchedules: routeSchedules.length,
//         seatsCount: finalSeatsPayload.length,
//         imagesCount: selectedImages.length,
//         hasVideo: !!selectedVideo
//       });

//       const response = await addBusToOwner(ownerId, formData, token);

//       if (response && response.success) {
//         toast.success(tripType === 'roundTrip'
//           ? 'Bus added successfully with round trip routes!'
//           : 'Bus added successfully!'
//         );
//         onBusAdded();
//         onClose();
//       } else {
//         throw new Error(response?.message || 'Failed to add bus');
//       }

//     } catch (err) {
//       console.error('Error adding bus:', err);
//       setError(err.message || 'Failed to add bus');
//       toast.error(err.message || 'Failed to add bus');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || currentMatrix.length === 0) return null;

//     const sortedStops = [...(currentRoute.intermediateStops || [])]
//       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//     const allStops = [
//       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
//       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
//       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
//     ];

//     return (
//       // <div className="matrix-section">
//       //   <h5 className="matrix-title">
//       //     {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//       //   </h5>
//       //   <div className="matrix-container">
//       //     <div className="matrix-table-wrapper">
//       //       <table className="fare-matrix-table">
//       //         <thead>
//       //           <tr>
//       //             <th className="corner-cell" style={{ position: 'sticky', left: 0, zIndex: 3, backgroundColor: '#fff' }}>From \ To</th>
//       //             {allStops.map((stop, i) => (
//       //               <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//       //                 <div className="stop-header">
//       //                   <span className="stop-name">{stop.name}</span>
//       //                   <span className="stop-type">{stop.type}</span>
//       //                 </div>
//       //               </th>
//       //             ))}
//       //           </tr>
//       //         </thead>
//       //         <tbody>
//       //           {currentMatrix.map((row, rowIndex) => (
//       //             <tr key={rowIndex}>
//       //               <td className="from-cell" style={{
//       //                 backgroundColor: getStopColor(row.fromType),
//       //                 position: 'sticky',
//       //                 left: 0,
//       //                 zIndex: 2
//       //               }}
//       //               // style={{ backgroundColor: getStopColor(row.fromType) }}
//       //               >
//       //                 <div className="from-stop">
//       //                   <span className="stop-name">{row.fromName}</span>
//       //                   <span className="stop-type">{row.fromType}</span>
//       //                 </div>
//       //               </td>
//       //               {row.toCells.map((cell, colIndex) => {
//       //                 if (cell) {
//       //                   return (
//       //                     <td key={colIndex} className="price-cell">
//       //                       <div className="fare-cell">
//       //                         <span className="distance">{cell.distanceKm} km</span>
//       //                         <div className="price-input-group">
//       //                           <span className="currency">₹</span>
//       //                           <input
//       //                             type="number"
//       //                             className="matrix-input"
//       //                             value={cell.price}
//       //                             onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//       //                             min="0"
//       //                             step="1"
//       //                           />
//       //                         </div>
//       //                       </div>
//       //                     </td>
//       //                   );
//       //                 }
//       //                 return (
//       //                   <td key={colIndex} className="na-cell">
//       //                     —
//       //                   </td>
//       //                 );
//       //               })}
//       //             </tr>
//       //           ))}
//       //         </tbody>
//       //       </table>
//       //     </div>
//       //   </div>
//       // </div>
//       <div className="matrix-section">
//   <h5 className="matrix-title">
//     {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//   </h5>
//   <div className="matrix-container">
//     <div className="matrix-table-wrapper">
//       <table className="fare-matrix-table">
//         <thead>
//           <tr>
//             {/* Corner cell — sticky via CSS class only */}
//             <th className="corner-cell">From \ To</th>
//             {allStops.map((stop, i) => (
//               <th key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                 <div className="stop-header">
//                   <span className="stop-name">{stop.name}</span>
//                   <span className="stop-type">{stop.type}</span>
//                 </div>
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {currentMatrix.map((row, rowIndex) => (
//             <tr key={rowIndex}>
//               {/* From cell — sticky via CSS class, bg via inline */}
//               <td
//                 className="from-cell"
//                 style={{ backgroundColor: getStopColor(row.fromType) }}
//               >
//                 <div className="from-stop">
//                   <span className="stop-name">{row.fromName}</span>
//                   <span className="stop-type">{row.fromType}</span>
//                 </div>
//               </td>
//               {row.toCells.map((cell, colIndex) => {
//                 if (cell) {
//                   return (
//                     <td key={colIndex} className="price-cell">
//                       <div className="fare-cell">
//                         <span className="distance">{cell.distanceKm} km</span>
//                         <div className="price-input-group">
//                           <span className="currency">₹</span>
//                           <input
//                             type="number"
//                             className="matrix-input"
//                             value={cell.price}
//                             onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//                             min="0"
//                             step="1"
//                           />
//                         </div>
//                       </div>
//                     </td>
//                   );
//                 }
//                 return <td key={colIndex} className="na-cell">—</td>;
//               })}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   </div>
// </div>
//     );
//   };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return null;

//     const { seats, configuration } = selectedTemplate;

//     let leftCount = 2, rightCount = 2;
//     try {
//       if (configuration && configuration.includes('*')) {
//         const parts = configuration.split('*');
//         leftCount = parseInt(parts[0]) || 2;
//         rightCount = parseInt(parts[1]) || 2;
//       }
//     } catch (e) {
//       leftCount = 2;
//       rightCount = 2;
//     }

//     const totalConfigCols = leftCount + rightCount;

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) {
//         seatsByRow[seat.row] = [];
//       }
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const isSleeper = seatObj.seatType === 'sleeper' ||
//         seatObj.seatType === 'seat+sleeper' ||
//         selectedTemplate.seatType === 'sleeper' ||
//         selectedTemplate.seatType === 'seater+sleeper';

//       const displayLabel = isSelected
//         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
//         : "";

//       let seatClass = '';
//       if (isSelected) {
//         seatClass = isBlocked ? 'blocked' : 'selected';
//       } else {
//         seatClass = 'inactive';
//       }

//       return (
//         <button
//           key={seatObj.seatNumber}
//           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)}
//           type="button"
//         >
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];

//       const isBackRow = seatsInRow.some(s => s.position === 'back') ||
//         seatsInRow.length > totalConfigCols;

//       if (isBackRow) {
//         const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row back-row">
//             <div className="seats-container">
//               {sortedSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       } else {
//         const leftSeats = seatsInRow
//           .filter(s => (s.column || 0) <= leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         const rightSeats = seatsInRow
//           .filter(s => (s.column || 0) > leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row">
//             <div className="left-seats">
//               {leftSeats.map(seat => renderSeat(seat))}
//             </div>
//             <div className="aisle">Aisle</div>
//             <div className="right-seats">
//               {rightSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       }
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header">
//           <div className="driver-area">Driver</div>
//           <div className="bus-info">
//             <span className="bus-config">{selectedTemplate.configuration}</span>
//             <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
//           </div>
//         </div>
//         <div className="bus-body">
//           {rows}
//         </div>
//         <div className="seat-legend">
//           <div className="legend-item">
//             <div className="seat-sample selected"></div>
//             <span>Active Seat ({activeSeats.length})</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample inactive"></div>
//             <span>Inactive Seat</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample sleeper"></div>
//             <span>Sleeper</span>
//           </div>
//         </div>
//         <div className="seat-summary">
//           <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
//         </div>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">1</div>
//         <div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">2</div>
//         <div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">3</div>
//         <div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div>
//         <div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Bus Information</h3>
//         <p className="section-subtitle">Enter basic details about the bus</p>
//       </div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🚌</span>
//             Bus Number *
//           </label>
//           <input
//             type="text"
//             value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             placeholder="e.g., WB01AB1234"
//             className="modern-input"
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🏷️</span>
//             Bus Name *
//           </label>
//           <input
//             type="text"
//             value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             placeholder="e.g., Volvo Multi-Axle"
//             className="modern-input"
//             required
//           />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🖼️</span>
//           Bus Images & Video
//         </h4>
//         <div className="images-upload-area">
//           <input
//             type="file"
//             id="bus-images"
//             multiple
//             accept="image/*"
//             onChange={handleImageUpload}
//             className="image-upload-input"
//             style={{ display: 'none' }}
//           />
//           <label htmlFor="bus-images" className="image-upload-label">
//             <span className="upload-icon">📁</span>
//             <span className="upload-text">Click to upload images</span>
//             <span className="upload-hint">Upload multiple images (max 10)</span>
//           </label>

//           {selectedImages.length > 0 && (
//             <div className="selected-images-preview">
//               <h5>Selected Images ({selectedImages.length})</h5>
//               <div className="images-grid">
//                 {selectedImages.map((image, index) => (
//                   <div key={index} className="image-preview-item">
//                     <img
//                       src={image.preview}
//                       alt={`Bus ${index + 1}`}
//                       className="preview-image"
//                     />
//                     <button
//                       type="button"
//                       className="remove-image-btn"
//                       onClick={() => removeImage(index)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           <div className="video-upload-section" style={{ marginTop: '15px' }}>
//             <input
//               type="file"
//               id="bus-video"
//               accept="video/*"
//               onChange={handleVideoUpload}
//               className="video-upload-input"
//               style={{ display: 'none' }}
//             />
//             <label htmlFor="bus-video" className="video-upload-label">
//               <span className="upload-icon">🎥</span>
//               <span className="upload-text">Click to upload video</span>
//               <span className="upload-hint">Upload one video (optional)</span>
//             </label>

//             {selectedVideo && (
//               <div className="selected-video-preview">
//                 <div className="video-info">
//                   <span className="video-name">{selectedVideo.name}</span>
//                   <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
//                 </div>
//                 <button
//                   type="button"
//                   className="remove-video-btn"
//                   onClick={removeVideo}
//                 >
//                   Remove
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">🔧</span>
//             Bus Type *
//           </label>
//           <select
//             value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_TYPES.map(type => (
//               <option key={type} value={type}>{type}</option>
//             ))}
//           </select>
//         </div>

//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">📊</span>
//             Bus Category *
//           </label>
//           <select
//             value={form.busCategory}
//             onChange={(e) => handleCategoryChange(e.target.value)}
//             className="modern-select"
//           >
//             <option value="">Select Category</option>
//             {BUS_CATEGORIES.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
//         </div>
//       </div>

//       {/* ADD THIS: Booking Closed Before Section */}
//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">⏰</span>
//           Booking Cut-off Time
//         </h4>

//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label className="input-label">Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="24"
//                 value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>

//           <div className="time-input-group">
//             <label className="input-label">Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="59"
//                 value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>


//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">✨</span>
//           Amenities
//         </h4>
//         <div className="amenities-grid compact">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-option compact">
//               <input
//                 type="checkbox"
//                 checked={form.amenities.includes(amenity)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: [...prev.amenities, amenity]
//                     }));
//                   } else {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: prev.amenities.filter(a => a !== amenity)
//                     }));
//                   }
//                 }}
//                 className="amenity-checkbox"
//               />
//               <span className="amenity-content">
//                 <span className="amenity-icon">✓</span>
//                 <span className="amenity-label">{amenity}</span>
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           className="modern-btn primary full-width"
//           onClick={() => setActiveTab('route')}
//           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
//         >
//           Continue to Route & Pricing
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Route & Pricing Configuration</h3>
//         <p className="section-subtitle">Select routes and configure pricing for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔄</span>
//           Trip Type
//         </h4>
//         <div className="trip-type-container">
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}
//           >
//             <span className="btn-icon">➡️</span>
//             One Way
//           </button>
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}
//           >
//             <span className="btn-icon">🔄</span>
//             Round Trip
//           </button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🗺️</span>
//           Route Selection
//         </h4>

//         <div className="route-selector">
//           <label className="input-label">Select Route *</label>
//           <select
//             value={selectedRoute?._id || ''}
//             onChange={(e) => {
//               const route = routes.find(r => r._id === e.target.value);
//               setSelectedRoute(route);
//               setFareMatrixUp([]);
//               setFareMatrixDown([]);
//             }}
//             className="modern-select"
//             disabled={loadingRoutes}
//           >
//             <option value="">Select Route</option>
//             {routes.map(route => (
//               <option key={route._id} value={route._id}>
//                 {route.routeNumber || ''} - {route.routeName || ''} ({route.origin?.city || ''} → {route.destination?.city || ''}) {route.isRoundTrip ? '[Round Trip]' : ''}
//               </option>
//             ))}
//           </select>
//           {selectedRoute && selectedRoute.isRoundTrip && (
//             <small className="helper-text">This is a round trip route - both UP and DOWN matrices will be generated</small>
//           )}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📅</span>
//           Operating Days *
//         </h4>
//         <div className="days-grid compact">
//           {DAYS_OF_WEEK.map(day => (
//             <button
//               key={day}
//               type="button"
//               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}
//               title={day}
//             >
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//         <div className="selected-days">
//           Selected: {operatingDays.length} days
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💰</span>
//           Pricing Configuration
//         </h4>

//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>

//         {selectedRoute && (
//           <div className="pricing-summary">
//             <div className="summary-item">
//               <span>Category Multiplier:</span>
//               <span className="value accent">{getCategoryMultiplier()}x</span>
//             </div>
//             <div className="summary-item">
//               <span>Route Distance:</span>
//               <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('basic')}
//         >
//           ← Back
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary generate-matrix-btn"
//           onClick={() => {
//             handleGenerateMatrix();
//             if (fareMatrixUp.length > 0) {
//               setActiveTab('matrix');
//             }
//           }}
//           disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
//         >
//           Generate Fare Matrix
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Fare Matrix Configuration</h3>
//         <p className="section-subtitle">Review and edit fares for each route</p>
//       </div>

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}
//           >
//             Up Route: {selectedRoute.routeName}
//           </button>
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}
//           >
//             Down Route: Return Route
//           </button>
//         </div>
//       )}

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
//         <>
//           {activeMatrixTab === 'up' && renderMatrix('up')}
//           {activeMatrixTab === 'down' && renderMatrix('down')}
//         </>
//       ) : (
//         renderMatrix('up')
//       )}

//       <div className="matrix-info">
//         <div className="info-card">
//           <div className="info-item">
//             <span className="label">Total Stops:</span>
//             <span className="value">
//               {selectedRoute ?
//                 (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
//             </span>
//           </div>
//           <div className="info-item">
//             <span className="label">Category Multiplier:</span>
//             <span className="value accent">{getCategoryMultiplier()}x</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Base Price:</span>
//             <span className="value">₹{pricing.basePrice}</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Cost/km:</span>
//             <span className="value">₹{pricing.costPerKm}</span>
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('route')}
//         >
//           ← Back to Pricing
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={() => setActiveTab('seats')}
//           disabled={fareMatrixUp.length === 0}
//         >
//           Continue to Seat Layout
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Seat Layout Configuration</h3>
//         <p className="section-subtitle">Configure seat layout for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔧</span>
//           Bus Configuration
//         </h4>
//         <div className="config-selector">
//           <label className="input-label">Select Bus Configuration *</label>
//           {loadingLayouts ? (
//             <div className="loading-configs">
//               <span>Loading configurations...</span>
//             </div>
//           ) : (
//             <>
//               <div className="config-buttons">
//                 {availableConfigurations.map(config => (
//                   <button
//                     key={config}
//                     type="button"
//                     className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//                     onClick={() => {
//                       setSelectedConfiguration(config);
//                       setSelectedTemplate(null);
//                       setActiveSeats([]);
//                       setCustomSeatLabels({});
//                       fetchLayouts(config);
//                     }}
//                   >
//                     {config}
//                   </button>
//                 ))}
//               </div>
//               <small className="helper-text">
//                 {form.busCategory} bus with {selectedConfiguration} configuration
//               </small>
//             </>
//           )}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💺</span>
//           Seat Layout Template
//         </h4>

//         {!selectedTemplate ? (
//           <button
//             type="button"
//             className="modern-btn outline full-width"
//             onClick={openTemplateSelector}
//             disabled={loadingLayouts}
//           >
//             {loadingLayouts ? (
//               <>
//                 <span className="btn-icon">⏳</span>
//                 Loading Layouts...
//               </>
//             ) : (
//               <>
//                 <span className="btn-icon">📋</span>
//                 Select Layout Template
//               </>
//             )}
//           </button>
//         ) : (
//           <div className="selected-template-info">
//             <div className="template-details">
//               <span className="template-name">{selectedTemplate.name}</span>
//               <span className="template-config">{selectedTemplate.configuration}</span>
//               <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
//               <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
//             </div>
//             <button
//               type="button"
//               className="btn-small"
//               onClick={() => {
//                 setSelectedTemplate(null);
//                 setActiveSeats([]);
//                 setCustomSeatLabels({});
//               }}
//             >
//               Change
//             </button>
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">👁️</span>
//             Seat Layout Visualizer
//           </h4>
//           <button
//             type="button"
//             className="view-layout-btn"
//             onClick={() => setShowLayoutModal(true)}
//           >
//             View / Edit Seat Numbers
//           </button>

//           <div className="seat-summary">
//             <div className="summary-item">
//               <span>Total Seats in Template:</span>
//               <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
//             </div>
//             <div className="summary-item">
//               <span>Active Seats:</span>
//               <span className="value accent">{activeSeats.length}</span>
//             </div>
//             <div className="summary-item">
//               <span>Inactive Seats:</span>
//               <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('matrix')}
//         >
//           ← Back to Matrix
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={handleSubmitBus}
//           disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
//         >
//           {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
//           <span className="btn-icon">✓</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Seat Numbers</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
//           <div className="seat-legend three-items">
//             <div className="legend-item">
//               <div className="seat-sample selected"></div>
//               <span>Active</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample blocked"></div>
//               <span>Blocked</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample inactive"></div>
//               <span>Disabled</span>
//             </div>
//           </div>
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <span>Total: {activeSeats.length}</span>
//             <div className="footer-actions">
//               <button className="auto-number-btn" onClick={autoRenumberSeats}>
//                 Auto-Number
//               </button>
//               <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Seat Layout Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {loadingLayouts ? (
//             <div className="loading-container">
//               <p>Loading templates...</p>
//             </div>
//           ) : layoutTemplates.length === 0 ? (
//             <div className="no-templates">
//               <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
//               <p className="hint">Available configurations with layouts:</p>
//               <div className="available-configs">
//                 {availableConfigurations.map(config => (
//                   <span key={config} className="config-chip">{config}</span>
//                 ))}
//               </div>
//               <p className="hint">Try selecting a different configuration</p>
//             </div>
//           ) : (
//             <div className="templates-grid">
//               {layoutTemplates.map(template => (
//                 <button
//                   type="button"
//                   key={template._id}
//                   className="template-card"
//                   onClick={() => handleSelectTemplate(template)}
//                 >
//                   <h4 className="template-name">{template.name}</h4>
//                   <div className="template-details">
//                     <span className="config">Config: {template.configuration}</span>
//                     <span className="seats">Seats: {template.totalSeats}</span>
//                   </div>
//                   <div className="template-preview">
//                     <span className="rows">Rows: {template.rows}</span>
//                     <span className="cols">Cols: {template.columns}</span>
//                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Set Seat Label</h3>
//         </div>
//         <div className="modal-body">
//           <input
//             type="text"
//             value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="e.g. 1 or 1A"
//             className="seat-input"
//             autoFocus
//           />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button
//             className="modal-action-btn disable-btn"
//             onClick={() => {
//               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setEditingSeat(null);
//             }}
//           >
//             Disable
//           </button>

//           <button
//             className="modal-action-btn block-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               if (!blockedSeats.includes(editingSeat)) {
//                 setBlockedSeats([...blockedSeats, editingSeat]);
//               }
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Block
//           </button>

//           <button
//             className="modal-action-btn active-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Active
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">
//               <span className="title-icon">🚌</span>
//               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
//             </h2>
//             <p className="modal-subtitle">Configure bus details with route selection</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>
//             <span className="close-icon">×</span>
//           </button>
//         </div>

//         <div className="modal-body modern">
//           <ProgressSteps />

//           <div className="tab-container">
//             {activeTab === 'basic' && renderBasicInfoTab()}
//             {activeTab === 'route' && renderRouteTab()}
//             {activeTab === 'matrix' && renderMatrixTab()}
//             {activeTab === 'seats' && renderSeatLayoutTab()}
//           </div>

//           {error && (
//             <div className="error-message modern">
//               <span className="error-icon">⚠️</span>
//               {error}
//             </div>
//           )}
//         </div>
//       </div>

//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };

// const BusOwnerManage = () => {
//   const { token } = useSelector(state => state.user);
//   const [busOwners, setBusOwners] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingOwner, setEditingOwner] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingOwner, setViewingOwner] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showAddBusModal, setShowAddBusModal] = useState(false);
//   const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
//   const [busSearchTerm, setBusSearchTerm] = useState('');
//   const [newOwner, setNewOwner] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     companyName: ''
//   });
//   const [error, setError] = useState(null);

//   // Bus Management states - UPDATED for new modal
//   const [showBusManagement, setShowBusManagement] = useState(false);
//   const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
//   const [selectedOwner, setSelectedOwner] = useState(null);
//   const [busDetailsLoading, setBusDetailsLoading] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalOwners, setTotalOwners] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   const getFullImageUrl = (imagePath) => {
//     if (imagePath.startsWith('http')) {
//       return imagePath;
//     }
//     return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
//   };

//   useEffect(() => {
//     fetchBusOwners();
//   }, [currentPage]);



//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchBusOwners();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

//   const fetchBusOwners = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const response = await getBusOwners(token, currentPage, pageSize, searchTerm);

//       if (response && response.success && response.busOwners) {
//         const transformedOwners = response.busOwners.map((owner, index) => ({
//           id: owner._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: owner.profileImage || '',
//           name: owner.name || '',
//           company: owner.companyName || '',
//           email: owner.email || '',
//           phone: owner.phone || '',
//           buses: owner.busCount || 0,
//           routes: owner.routeCount || 0,
//           joined: new Date(owner.createdAt).toISOString().split('T')[0],
//           status: owner.isVerified ? 'Verified' : 'Pending',
//           adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
//           _id: owner._id,
//           isVerified: owner.isVerified,
//           isProfileComplete: owner.isProfileComplete,
//           isApprovedByAdmin: owner.isApprovedByAdmin,
//           activeBuses: owner.activeBuses || 0,
//           driverCount: owner.driverCount || 0,
//           conductorCount: owner.conductorCount || 0,
//           createdAt: owner.createdAt,
//           updatedAt: owner.updatedAt,
//           address: owner.address || {},
//           city: owner.address?.city || '',
//           state: owner.address?.state || owner.state || '',
//           pincode: owner.address?.pincode || '',
//           busAll: owner.busAll || []
//         }));

//         setBusOwners(transformedOwners);

//         if (response.totalPages) {
//           setTotalPages(response.totalPages);
//         }
//         if (response.total) {
//           setTotalOwners(response.total);
//         } else {
//           setTotalOwners(response.busOwners.length);
//         }
//       } else {
//         setError('No bus owners data found in response');
//         setBusOwners([]);
//         setTotalPages(1);
//         setTotalOwners(0);
//       }
//     } catch (err) {
//       console.error('Error fetching bus owners:', err);
//       setError('Failed to fetch bus owners. Please try again.');
//       setBusOwners([]);
//       setTotalPages(1);
//       setTotalOwners(0);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const fetchBusOwnerById = async (id) => {
//     try {
//       const response = await getBusOwnerById(id, token);
//       console.log("response.data : ", response.data)
//       return response.data || response;
//     } catch (err) {
//       console.error('Error fetching bus owner:', err);
//       throw err;
//     }
//   };

//   const handleApproveOwner = async (ownerId) => {
//     try {
//       setError(null);
//       const response = await approveBusOwner(ownerId, token);

//       if (response.success) {
//         setBusOwners(prevOwners =>
//           prevOwners.map(owner =>
//             owner.id === ownerId ? {
//               ...owner,
//               isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
//               adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending'
//             } : owner
//           )
//         );
//         toast.success('Bus owner approved successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to approve bus owner');
//       }
//     } catch (err) {
//       console.error('Error approving bus owner:', err);
//       setError('Failed to approve bus owner. Please try again.');
//       toast.error('Failed to approve bus owner. Please try again.');
//     }
//   };

//   const handleManageBuses = async (owner) => {
//     console.log("handleManageBuses ; ", owner)
//     if (owner.buses === 0) {
//       // alert('This owner has no buses registered.');
//       toast.error("This owner has no buses registered")
//       return;
//     }

//     console.log('Owner bus data:', owner);

//     // Check if busAll exists and has data
//     if (!owner.busAll || owner.busAll.length === 0) {
//       // If no bus data, try to fetch it separately
//       try {
//         setBusDetailsLoading(true);
//         const response = await getBusOwnerById(owner.id, token);

//         if (response.success && response.data && response.data.busAll) {
//           // Update the owner with bus data
//           const updatedOwner = {
//             ...owner,
//             busAll: response.data.busAll || []
//           };

//           // Process the bus data
//           const processedBuses = updatedOwner.busAll.map(bus => {
//             const driver = bus.driver ? {
//               name: bus.driver.name || 'N/A',
//               contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//               licenseNumber: bus.driver.licenseNumber || 'N/A',
//               experience: bus.driver.experience || 0
//             } : null;

//             const conductor = bus.conductor ? {
//               name: bus.conductor.name || 'N/A',
//               contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//             } : null;

//             return {
//               ...bus,
//               driver,
//               conductor
//             };
//           });

//           console.log('Fetched and processed buses:', processedBuses);

//           setSelectedOwner(updatedOwner);
//           setSelectedOwnerBuses(processedBuses);
//           setShowBusManagement(true);
//           setBusSearchTerm('');
//         } else {
//           alert('Could not fetch bus data. Please try again.');
//         }
//       } catch (err) {
//         console.error('Error fetching bus details:', err);
//         alert('Failed to fetch bus details. Please try again.');
//       } finally {
//         setBusDetailsLoading(false);
//       }
//       return;
//     }

//     // If busAll data exists, process it
//     const processedBuses = owner.busAll.map(bus => {
//       const driver = bus.driver ? {
//         name: bus.driver.name || 'N/A',
//         contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//         licenseNumber: bus.driver.licenseNumber || 'N/A',
//         experience: bus.driver.experience || 0
//       } : null;

//       const conductor = bus.conductor ? {
//         name: bus.conductor.name || 'N/A',
//         contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//       } : null;

//       return {
//         ...bus,
//         driver,
//         conductor
//       };
//     });

//     console.log('Processed buses:', processedBuses);

//     setSelectedOwner(owner);
//     setSelectedOwnerBuses(processedBuses);
//     setShowBusManagement(true);
//     setBusSearchTerm('');
//   };
//   // Add this function after your other handler functions
//   const filteredBuses = selectedOwnerBuses.filter(bus =>
//     (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
//     (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
//   );

//   const handleRejectOwner = async (ownerId) => {
//     if (window.confirm('Are you sure you want to reject this bus owner?')) {
//       try {
//         setError(null);

//         if (!ownerId || typeof ownerId !== 'string') {
//           throw new Error('Invalid owner ID');
//         }

//         const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === ownerId ? {
//                 ...owner,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
//                 adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
//               } : owner
//             )
//           );
//           toast.success('Bus owner rejected successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to reject bus owner');
//         }
//       } catch (err) {
//         console.error('Error rejecting bus owner:', err);
//         setError('Failed to reject bus owner. Please try again.');
//         toast.error('Failed to reject bus owner. Please try again.');
//       }
//     }
//   };

//   const filteredOwners = busOwners;

//   const handleViewOwner = async (owner) => {
//     try {
//       const ownerData = await fetchBusOwnerById(owner.id);
//       setViewingOwner({
//         ...owner,
//         profileImage: ownerData.profileImage || owner.profileImage,
//         name: ownerData.name || owner.name,
//         company: ownerData.companyName || owner.company,
//         email: ownerData.email || owner.email,
//         phone: ownerData.phone || owner.phone,
//         address: ownerData.address || owner.address,
//         isVerified: ownerData.isVerified,
//         isProfileComplete: ownerData.isProfileComplete,
//         isApprovedByAdmin: ownerData.isApprovedByAdmin,

//         // Stats (numbers for the stat cards)
//         busCount: ownerData.stats?.busCount || 0,      // ← renamed to busCount
//         activeBuses: ownerData.stats?.activeBuses || 0,
//         driverCount: ownerData.stats?.driverCount || 0,
//         conductorCount: ownerData.stats?.conductorCount || 0,

//         // Arrays for the detail sections
//         routes: ownerData.routes || [],
//         buses: ownerData.buses || [],                   // ← array only, no conflict

//         status: ownerData.isApprovedByAdmin ? 'Active' : 'Pending',
//         joined: ownerData.createdAt
//           ? new Date(ownerData.createdAt).toLocaleDateString()
//           : owner.joined,
//       });
//     } catch (err) {
//       setViewingOwner(owner);
//       toast.info('Could not fetch latest owner details. Showing cached data.');
//     }
//   };

//   const handleEditOwner = (owner) => {
//     setEditingOwner(owner.id);
//     setEditForm({
//       name: owner.name || '',
//       companyName: owner.company || '',
//       email: owner.email || '',
//       phone: owner.phone || '',
//       status: owner.status || 'Pending',
//       isApprovedByAdmin: owner.isApprovedByAdmin || false
//     });
//   };

//   const closeBusManagement = () => {
//     setShowBusManagement(false);
//     setSelectedOwnerBuses([]);
//     setSelectedOwner(null);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       if (!editingOwner || typeof editingOwner !== 'string') {
//         throw new Error('Invalid owner ID for editing');
//       }

//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phone: editForm.phone,
//         companyName: editForm.companyName,
//         isVerified: editForm.status === 'Verified',
//         isApprovedByAdmin: editForm.isApprovedByAdmin
//       };

//       const response = await updateBusOwner(editingOwner, updateData, token);

//       if (response.success) {
//         setBusOwners(prevOwners =>
//           prevOwners.map(owner =>
//             owner.id === editingOwner ? {
//               ...owner,
//               name: response.data?.name || editForm.name,
//               company: response.data?.companyName || editForm.companyName,
//               email: response.data?.email || editForm.email,
//               phone: response.data?.phone || editForm.phone,
//               status: response.data?.isVerified ? 'Verified' : 'Pending',
//               isVerified: response.data?.isVerified,
//               isApprovedByAdmin: response.data?.isApprovedByAdmin,
//               adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
//             } : owner
//           )
//         );

//         setEditingOwner(null);
//         setEditForm({});
//         toast.success('Bus owner updated successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to update bus owner');
//       }
//     } catch (err) {
//       console.error('Error updating bus owner:', err);
//       setError('Failed to update bus owner. Please try again.');
//       toast.error('Failed to update bus owner. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingOwner(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleDeleteOwner = async (ownerId) => {
//     if (window.confirm('Are you sure you want to delete this bus owner?')) {
//       try {
//         setError(null);
//         const response = await deleteBusOwner(ownerId, token);

//         if (response.success) {
//           setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//           setTotalOwners(prev => prev - 1);
//           toast.success('Bus owner deleted successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to delete bus owner');
//         }
//       } catch (err) {
//         console.error('Error deleting bus owner:', err);
//         setError('Failed to delete bus owner. Please try again.');
//         toast.error('Failed to delete bus owner. Please try again.');
//       }
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleNewOwnerChange = (e) => {
//     const { name, value } = e.target;
//     setNewOwner(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleAddOwner = async () => {
//     try {
//       setError(null);

//       if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
//         toast.error('Please fill in all required fields');
//         return;
//       }

//       const response = await createBusOwner(newOwner, token);
//       console.log("response............ : ", response)
//       if (response.success) {
//         const newOwnerWithId = {
//           id: response.data.id,
//           serialNo: busOwners.length + 1,
//           profileImage: '',
//           name: response.data.name,
//           company: response.data.companyName,
//           email: response.data.email,
//           phone: response.data.phone,
//           buses: 0,
//           routes: 0,
//           joined: new Date(response.data.createdAt).toISOString().split('T')[0],
//           status: 'Pending',
//           adminApproval: 'Pending',
//           isVerified: false,
//           isApprovedByAdmin: false,
//           createdAt: response.data.createdAt
//         };

//         setBusOwners(prev => [newOwnerWithId, ...prev]);
//         setTotalOwners(prev => prev + 1);
//         setShowAddModal(false);
//         setNewOwner({
//           name: '',
//           companyName: '',
//           email: '',
//           phone: ''
//         });
//         toast.success('Bus owner added successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to add bus owner');
//       }
//     } catch (err) {
//       console.error('Error adding bus owner:', err);

//       // Extract error message from the response
//       let errorMessage = 'Failed to add bus owner. Please try again.';

//       if (err.response?.data?.message) {
//         // Get the message from the API response
//         errorMessage = err.response.data.message;
//       } else if (err.message) {
//         errorMessage = err.message;
//       }

//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const closeViewModal = () => {
//     setViewingOwner(null);
//   };

//   const closeAddModal = () => {
//     setShowAddModal(false);
//     setNewOwner({
//       name: '',
//       companyName: '',
//       email: '',
//       phone: ''
//     });
//     setError(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     // The useEffect will trigger fetchBusOwners automatically
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const currentPageOwners = busOwners;
//   const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
//   const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
//   const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

//   if (loading && busOwners.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading bus owners...</p>
//         </div>
//       </div>
//     );
//   }

//   const handleAddBusClick = (owner) => {
//     setSelectedOwnerForBus(owner);
//     setShowAddBusModal(true);
//   };

//   const handleBusAdded = () => {
//     fetchBusOwners();
//     toast.success('Bus added successfully!');
//   };

//   const closeAddBusModal = () => {
//     setShowAddBusModal(false);
//     setSelectedOwnerForBus(null);
//   };

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Bus Owner Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search bus owners by name, company, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Owner
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Owners</h3>
//           <p>{totalOwners}</p>
//           <span>All registered owners</span>
//         </div>
//         <div className="stat-card">
//           <h3>Verified Owners</h3>
//           <p>{verifiedOwners}</p>
//           <span>Verified on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Approved Owners</h3>
//           <p>{approvedOwners}</p>
//           <span>Approved on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{totalBuses}</p>
//           <span>active fleet</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Profile</th>
//               <th>Owner Name</th>
//               <th>Company</th>
//               <th>Contact</th>
//               <th>Buses</th>
//               <th>Admin Approval</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOwners.length > 0 ? (
//               filteredOwners.map(owner => (
//                 <tr key={owner.id}>
//                   <td>{owner.serialNo}</td>
//                   <td>
//                     <div className="profile-image-cell">
//                       <img
//                         src={getFullImageUrl(owner.profileImage)}
//                         alt={owner.name || 'Bus Owner'}
//                         className="customer-avatar"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                         }}
//                       />
//                     </div>
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Owner Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.name || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="companyName"
//                         value={editForm.companyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Company Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.company || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div>{owner.email || 'N/A'}</div>
//                         <div className="phone">{owner.phone || 'N/A'}</div>
//                       </div>
//                     )}
//                   </td>

//                   <td>{owner.buses}</td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="isApprovedByAdmin"
//                         value={editForm.isApprovedByAdmin || false}
//                         onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="true">Approved</option>
//                         <option value="false">Pending</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || 'Pending'}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="Verified">Verified</option>
//                         <option value="Pending">Pending</option>
//                         <option value="Suspended">Suspended</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
//                         {owner.status || 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
//                         <button
//                           className="action-btn save"
//                           onClick={handleSaveEdit}
//                           style={{ backgroundColor: '#28a745', color: 'white' }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="action-btn cancel"
//                           onClick={handleCancelEdit}
//                           style={{ backgroundColor: '#6c757d', color: 'white' }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewOwner(owner)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditOwner(owner)}
//                         >
//                           Edit
//                         </button>

//                         <button
//                           className="action-btn add-bus"
//                           onClick={() => handleAddBusClick(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title="Add new bus for this owner"
//                         >
//                           + Add Bus
//                         </button>

//                         <button
//                           className="action-btn manage"
//                           onClick={() => handleManageBuses(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
//                         >
//                           Manage Buses
//                         </button>

//                         {!owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveOwner(owner.id)}
//                             style={{ backgroundColor: '#28a745' }}
//                           >
//                             Approve
//                           </button>
//                         )}
//                         {owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectOwner(owner.id)}
//                             style={{ backgroundColor: '#ffc107', color: '#000' }}
//                           >
//                             Reject
//                           </button>
//                         )}
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteOwner(owner.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="no-data">
//                   <p>No bus owners found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all bus owners
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {filteredOwners.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No bus owners found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {busOwners.length} of {totalOwners} bus owners
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages || totalPages === 0}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Modal */}
//       {/* {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Owner Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={getFullImageUrl(viewingOwner.profileImage)}
//                     alt={viewingOwner.name || 'Bus Owner'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Serial No:</label>
//                   <span>{viewingOwner.serialNo}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>ID:</label>
//                   <span>#{viewingOwner.id}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Owner Name:</label>
//                   <span>{viewingOwner.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Company:</label>
//                   <span>{viewingOwner.company || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingOwner.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingOwner.phone || 'N/A'}</span>
//                 </div>

//                 <div className="detail-row">
//                   <label>Address:</label>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                     {viewingOwner.address?.city && (
//                       <span>City: {viewingOwner.address.city}</span>
//                     )}
//                     {viewingOwner.address?.state && (
//                       <span>State: {viewingOwner.address.state}</span>
//                     )}
//                     {viewingOwner.address?.pincode && (
//                       <span>Pincode: {viewingOwner.address.pincode}</span>
//                     )}
//                     {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
//                       <span>N/A</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className="detail-row">
//                   <label>Total Buses:</label>
//                   <span>{viewingOwner.buses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Active Buses:</label>
//                   <span>{viewingOwner.activeBuses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Drivers:</label>
//                   <span>{viewingOwner.driverCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Conductors:</label>
//                   <span>{viewingOwner.conductorCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{viewingOwner.joined}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
//                     {viewingOwner.status || 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Admin Approval:</label>
//                   <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                     {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Profile Complete:</label>
//                   <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Verified:</label>
//                   <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}
//       {/* View Modal */}
//       {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modern-dashboard-modal" onClick={(e) => e.stopPropagation()}>

//             {/* Header with Glassmorphism */}
//             <header className="dashboard-header">
//               <div className="header-left">
//                 <div className="icon-box"><i className="fas fa-bus"></i></div>
//                 <div>
//                   <h3>Bus Owner Profile</h3>
//                   <span className="subtitle">Management Console</span>
//                 </div>
//               </div>
//               <button className="close-icon-btn" onClick={closeViewModal}>&times;</button>
//             </header>

//             <div className="dashboard-body">

//               {/* Top Section: Profile & Stats Combined */}
//               <section className="profile-overview-card">
//                 <div className="owner-brand">
//                   <div className="avatar-wrapper">
//                     <img
//                       src={getFullImageUrl(viewingOwner.profileImage)}
//                       alt="Profile"
//                       onError={(e) => { e.target.src = ''; }}
//                     />
//                     {viewingOwner.isVerified && <div className="verified-badge"><i className="fas fa-check"></i></div>}
//                   </div>
//                   <div className="brand-details">
//                     <h2>{viewingOwner.name || 'N/A'}</h2>
//                     <p className="owner-id-tag">ID: {viewingOwner.id}</p>
//                     <div className="quick-tags">
//                       <span className={`tag ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {viewingOwner.isApprovedByAdmin ? 'Verified Partner' : 'Pending Review'}
//                       </span>
//                       <span className="tag city-tag"><i className="fas fa-map-marker-alt"></i> {viewingOwner.address?.city}, {viewingOwner.address?.state}</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="stats-strip">
//                   <div className="stat-node">
//                     <label>Buses</label>
//                     <div className="value">{viewingOwner.busCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Drivers</label>
//                     <div className="value">{viewingOwner.driverCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Conductors</label>
//                     <div className="value">{viewingOwner.conductorCount || 0}</div>
//                   </div>
//                 </div>
//               </section>

//               {/* Horizontal Routes List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-route"></i> Active Routes</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.routes?.map((route, index) => (
//                     <div key={index} className="modern-row-card route-row">
//                       <div className="row-main-info">
//                         <div className="route-code">{route.routeNumber}</div>
//                         <div className="journey-stepper">
//                           <span className="">{route.origin?.city}</span>
//                           <div className="connector-line">
//                             <i className="fas fa-chevron-right"></i>
//                           </div>
//                           <span className="">{route.destination?.city}</span>
//                         </div>
//                       </div>
//                       <div className="row-meta-info">
//                         <div className="meta-item"><i className="fas fa-road"></i> {route.routeDetails?.totalDistance} km</div>
//                         <div className="meta-item"><i className="fas fa-clock"></i> {route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</div>
//                         <div className="meta-item bus-pill"><i className="fas fa-bus-alt"></i> {route.busCount} assigned</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </section>

//               {/* Horizontal Buses List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-shuttle-van"></i> Bus Details</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.buses?.map((bus, index) => (
//                     <div key={index} className="modern-row-card bus-row">
//                       <div className="bus-identity">
//                         <div className={`status-indicator ${bus.isActive ? 'online' : 'offline'}`}></div>
//                         <div>
//                           <strong>{bus.busName}</strong>
//                           <div className="plate-number">{bus.busNumber}</div>
//                         </div>
//                       </div>

//                       <div className="bus-specs-row">
//                         <span><i className="fas fa-chair"></i> {bus.totalSeats} Seats</span>
//                         <span><i className="fas fa-snowflake"></i> {bus.busType}</span>
//                       </div>

//                       <div className="bus-amenities-tags">
//                         {bus.amenities?.slice(0, 2).map((a, i) => <span key={i} className="mini-tag">{a}</span>)}
//                       </div>

//                       {/* <div className="bus-action-link">
//                   <button className="view-tracking-btn">Live Track</button>
//                 </div> */}
//                     </div>
//                   ))}
//                 </div>
//               </section>

//             </div>

//             <footer className="dashboard-footer">
//               <button className="btn-secondary" onClick={closeViewModal}>close</button>
//             </footer>
//           </div>
//         </div>
//       )}
//       {/* NEW - Modern Bus Management Modal */}
//       {showBusManagement && selectedOwner && (
//         <BusManagementModal
//           owner={selectedOwner}
//           buses={selectedOwnerBuses}
//           onClose={closeBusManagement}
//           onUpdate={fetchBusOwners}
//         />
//       )}

//       {/* Add Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={closeAddModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Bus Owner</h3>
//               <button className="modal-close-btn" onClick={closeAddModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Owner Name *:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={newOwner.name}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter owner name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Company Name *:</label>
//                   <input
//                     type="text"
//                     name="companyName"
//                     value={newOwner.companyName}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter company name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Email *:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={newOwner.email}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter email address"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone *:</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={newOwner.phone}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter phone number"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeAddModal}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleAddOwner}>
//                 Add Owner
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add Bus Modal */}
//       {showAddBusModal && selectedOwnerForBus && (
//         <AddBusModal
//           ownerId={selectedOwnerForBus.id}
//           onClose={closeAddBusModal}
//           onBusAdded={handleBusAdded}
//         />
//       )}
//     </div>
//   );
// };

// export default BusOwnerManage;


// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//   getBusOwners,
//   getBusOwnerById,
//   createBusOwner,
//   updateBusOwner,
//   deleteBusOwner,
//   approveBusOwner,
//   addBusToOwner,
//   getSeatLayoutsByBustype,
//   getAllCategory
// } from '../../Services/Operations/ProductAPI';
// import {
//   getDriversByBusOwner,
//   getConductorsByBusOwner,
//   assignDriverToBus,
//   assignConductorToBus,
//   unassignDriverFromBus,
//   unassignConductorFromBus
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/BusFareChart.css';
// import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
// import BusManagementModal from './BusManagementModal'; // Import the new modal
// import { useNavigate } from 'react-router-dom';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-avatar"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Profile</th>
//           <th>Owner Name</th>
//           <th>Company</th>
//           <th>Contact</th>
//           <th>Buses</th>
//           <th>Admin Approval</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modern-dashboard-modal skeleton">
//       <div className="dashboard-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="dashboard-body">
//         <div className="skeleton-profile-section"></div>
//         <div className="skeleton-stats-strip"></div>
//         <div className="skeleton-routes-section"></div>
//         <div className="skeleton-buses-section"></div>
//       </div>
//       <div className="dashboard-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const RouteSelector = ({ value, onChange, onAddNew, token, disabled, loadingRoutes, originCity, destinationCity }) => {
//   const [routes, setRoutes] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');

//   const fetchRoutes = async () => {
//     setIsLoading(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token,
//         1,
//         100,
//         searchTerm,
//         '', // busOwnerId - empty to get both admin and busowner routes
//         { originCity, destinationCity } // Pass filters
//       );
//       console.log("getAllBusownerAdminRoutes :::::::::::: ",response)
//       if (response && response.success && response.routes) {
//         setRoutes(response.routes);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (showDropdown) {
//       fetchRoutes();
//     }
//   }, [showDropdown, searchTerm, originCity, destinationCity]);

//   const handleSelect = (route) => {
//     onChange(route);
//     setShowDropdown(false);
//     setSearchTerm('');
//   };

//   return (
//     <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
//       <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//         <div style={{ flex: 1, position: 'relative' }}>
//           <input
//             type="text"
//             value={value ? value.routeName || value.masterRouteName : searchTerm}
//             onClick={() => setShowDropdown(!showDropdown)}
//             onChange={(e) => {
//               setSearchTerm(e.target.value);
//               setShowDropdown(true);
//               if (value) onChange(null);
//             }}
//             placeholder="Select or search route..."
//             className="modern-input"
//             disabled={disabled}
//             style={{ cursor: 'pointer' }}
//           />
//           {isLoading && (
//             <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//               <div className="spinner-small"></div>
//             </div>
//           )}
//         </div>
//         <button
//           type="button"
//           onClick={onAddNew}
//           className="btn btn-outline-primary"
//           style={{
//             padding: '8px 16px',
//             backgroundColor: '#28a745',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '5px',
//             whiteSpace: 'nowrap'
//           }}
//           onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
//           onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
//         >
//           <span style={{ fontSize: '18px', fontWeight: 'bold' }}>+</span> New Route
//         </button>
//       </div>

//       {showDropdown && (routes.length > 0 || searchTerm) && (
//         <div className="master-route-dropdown" style={{
//           position: 'absolute',
//           top: '100%',
//           left: 0,
//           right: 0,
//           background: 'white',
//           border: '1px solid #ddd',
//           borderRadius: '4px',
//           boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//           zIndex: 1000,
//           maxHeight: '300px',
//           overflowY: 'auto',
//           marginTop: '4px'
//         }}>
//           {routes.length === 0 ? (
//             <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
//               {originCity || destinationCity
//                 ? `No routes found for ${originCity || ''} → ${destinationCity || ''}. Click + to create one.`
//                 : 'No routes found. Click + to create one.'}
//             </div>
//           ) : (
//             routes.map((route) => (
//               <div
//                 key={route._id}
//                 className="dropdown-item"
//                 onClick={() => handleSelect(route)}
//                 style={{
//                   padding: '10px 12px',
//                   cursor: 'pointer',
//                   borderBottom: '1px solid #f0f0f0',
//                   transition: 'background-color 0.2s'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
//                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//               >
//                 <div style={{ fontWeight: '500', marginBottom: '4px' }}>
//                   {route.routeNumber || ''} - {route.routeName || route.masterRouteName || 'Route'}
//                   {route.creatorType === 'BusOwner' && (
//                     <span style={{
//                       marginLeft: '8px',
//                       fontSize: '10px',
//                       backgroundColor: '#ffc107',
//                       color: '#000',
//                       padding: '2px 6px',
//                       borderRadius: '4px'
//                     }}>
//                       Owner
//                     </span>
//                   )}
//                 </div>
//                 <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                   {route.origin?.city} → {route.destination?.city} •
//                   {route.isRoundTrip ? ' Round Trip' : ' One Way'} •
//                   {route.routeDetails?.totalDistance || 0} km
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       )}
//     </div>
//   );
// };
// const PlatformFeeConfig = ({ platformFee, onChange }) => {
//   return (
//     <div className="section-card">
//       <h4 className="card-title">
//         <span className="title-icon">💰</span>
//         Platform Fee Configuration
//       </h4>
      
//       <div className="platform-fee-container">
//         <div className="form-row">
//           <div className="form-group">
//             <label className="input-label">Fee Type</label>
//             <select
//               value={platformFee.type}
//               onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
//               className="modern-select"
//             >
//               <option value="fixed">Fixed Amount (₹)</option>
//               <option value="percentage">Percentage (%)</option>
//             </select>
//             <small className="helper-text">
//               {platformFee.type === 'fixed' 
//                 ? 'Charge a fixed amount per booking' 
//                 : 'Charge a percentage of the fare'}
//             </small>
//           </div>

//           {/* <div className="form-group">
//             <label className="input-label">
//               {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//             </label>
//             <input
//               type="number"
//               min="0"
//               step={platformFee.type === 'fixed' ? "1" : "0.1"}
//               value={platformFee.value}
//               onChange={(e) => onChange({ ...platformFee, value: parseFloat(e.target.value) || 0 })}
//               className="modern-input"
//               placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
//             />
            
//           </div> */}

//           <div className="form-group">
//   <label className="input-label">
//     {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
//   </label>
//   <input
//     type="number"
//     min="0"
//     step={platformFee.type === 'fixed' ? "1" : "0.1"}
//     value={platformFee.value === 0 ? '' : platformFee.value}
//     onChange={(e) => {
//       const rawValue = e.target.value;
//       const value = rawValue === '' ? 0 : parseFloat(rawValue);
//       onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
//     }}
//     className="modern-input"
//     placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
//     style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
//   />
// </div>

//           <div className="form-group">
//             <label className="input-label">Applicable On</label>
//             <select
//               value={platformFee.applicableOn}
//               onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
//               className="modern-select"
//             >
//               <option value="per_ticket">Per Ticket</option>
//               <option value="per_person">Per Person</option>
//               {/* <option value="total_booking">Total Booking Amount</option> */}
//             </select>
//             {/* <small className="helper-text">
//               {platformFee.applicableOn === 'per_ticket' && 'Fee applied on each ticket'}
//               {platformFee.applicableOn === 'per_seat' && 'Fee applied on each seat'}
//               {platformFee.applicableOn === 'total_booking' && 'Fee applied on total booking amount'}
//             </small> */}
//           </div>
//         </div>

//         {/* Preview/Calculation Example */}
//         {platformFee.value > 0 && (
//           <div className="fee-preview">
//             <div className="preview-title">Fee Calculation Preview:</div>
//             <div className="preview-details">
//               <span>
//                 {platformFee.type === 'fixed' 
//                   ? `₹${platformFee.value} ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
//                      platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`
//                   : `${platformFee.value}% of fare ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
//                      platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };
// const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
//   const { token } = useSelector(state => state.user);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('basic');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
//   const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
//   const [blockedSeats, setBlockedSeats] = useState([]);
//   const [cancellationTime, setCancellationTime] = useState({
//   hours: 1,
//   minutes: 0
// });

//    const [platformFee, setPlatformFee] = useState({
//     type: 'fixed',
//     value: 0,
//     applicableOn: 'per_ticket'
//   });

//   // Booking Closed Before State
//   const [bookingClosedBefore, setBookingClosedBefore] = useState({
//     hours: 1,
//     minutes: 0
//   });

//   // Bus Form State
//   const [form, setForm] = useState({
//     busNumber: '',
//     busName: '',
//     busType: 'Non-AC',
//     busCategory: 'Seater',
//     amenities: []
//   });

//   // Trip Type State
//   const [tripType, setTripType] = useState('oneWay');
//   const [activeMatrixTab, setActiveMatrixTab] = useState('up');

//   // Route States - NEW: Source & Destination instead of RouteSelector
//   const [sourceCity, setSourceCity] = useState('');
//   const [destinationCity, setDestinationCity] = useState('');
//   const [availableRoutes, setAvailableRoutes] = useState([]);
//   const [selectedRoute, setSelectedRoute] = useState(null);
//   const [loadingRoutes, setLoadingRoutes] = useState(false);
//   const [showRouteDropdown, setShowRouteDropdown] = useState(false);
//   const [routeSearchTerm, setRouteSearchTerm] = useState('');

//   // Seat Layout States
//   const [layoutTemplates, setLayoutTemplates] = useState([]);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [activeSeats, setActiveSeats] = useState([]);
//   const [customSeatLabels, setCustomSeatLabels] = useState({});
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [loadingLayouts, setLoadingLayouts] = useState(false);
//   const [editingSeat, setEditingSeat] = useState(null);
//   const [tempSeatLabel, setTempSeatLabel] = useState('');

//   // Pricing States
//   const [pricing, setPricing] = useState({
//     basePrice: '',
//     baseDistance: '',
//     costPerKm: ''
//   });

//   // Fare Matrices
//   const [fareMatrixUp, setFareMatrixUp] = useState([]);
//   const [fareMatrixDown, setFareMatrixDown] = useState([]);

//   // Operating Days
//   const [operatingDays, setOperatingDays] = useState([
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ]);

//   // Image States
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   // Add this new state alongside existing route states
// const [localRouteNameSearch, setLocalRouteNameSearch] = useState('');
// const [localRouteSearchLoading, setLocalRouteSearchLoading] = useState(false);

//   // Constants
//   const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
//   const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
//   const AMENITIES_LIST = [
//     'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
//     'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
//     'GPS Tracking', 'SOS Switch'
//   ];
//   const DAYS_OF_WEEK = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
//   ];

//   // Add this function to handle cancellation time changes
// const handleCancellationTimeChange = (field, value) => {
//   setCancellationTime(prev => ({
//     ...prev,
//     [field]: parseInt(value) || 0
//   }));
// };

// // Add validation for cancellation time (add to validateBookingTime function or create new)
// const validateCancellationTime = () => {
//   const totalMinutes = (cancellationTime.hours * 60) + cancellationTime.minutes;
//   if (totalMinutes < 0) {
//     toast.error('Cancellation time cannot be negative');
//     return false;
//   }
//   if (cancellationTime.hours > 48) {
//     toast.error('Cancellation hours cannot exceed 48');
//     return false;
//   }
//   if (cancellationTime.minutes > 59) {
//     toast.error('Minutes cannot exceed 59');
//     return false;
//   }
  
//   // Optional: Validate against booking closed time
//   const bookingMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//   if (totalMinutes >= bookingMinutes) {
//     toast.warning('Cancellation time should be less than booking cut-off time for practical purposes');
//   }
//   return true;
// };

// // Add this new function alongside fetchRoutesBySourceDestination
// const fetchRoutesByLocalName = async (localName) => {
//   if (!localName || !localName.trim()) {
//     setAvailableRoutes([]);
//     return;
//   }

//   setLocalRouteSearchLoading(true);
//   setLoadingRoutes(true);
//   try {
//     const response = await getAllBusownerAdminRoutes(
//       token,
//       1,
//       50,
//       '',   // search
//       '',   // busOwnerId
//       {},   // no city filters
//       localName.trim()  // localRouteName ← NEW param
//     );

//     if (response && response.success && response.routes) {
//       setAvailableRoutes(response.routes);
//     } else {
//       setAvailableRoutes([]);
//     }
//   } catch (error) {
//     console.error('Error fetching routes by local name:', error);
//     toast.error('Failed to fetch routes');
//     setAvailableRoutes([]);
//   } finally {
//     setLocalRouteSearchLoading(false);
//     setLoadingRoutes(false);
//   }
// };

//   // Fetch routes based on source and destination
//   const fetchRoutesBySourceDestination = async () => {
//     if (!sourceCity || !destinationCity) {
//       setAvailableRoutes([]);
//       return;
//     }

//     setLoadingRoutes(true);
//     try {
//       const response = await getAllBusownerAdminRoutes(
//         token,
//         1,
//         50,
//         '',
//         '',
//         { originCity: sourceCity, destinationCity: destinationCity }
//       );
      
//       if (response && response.success && response.routes) {
//         setAvailableRoutes(response.routes);
//       } else {
//         setAvailableRoutes([]);
//       }
//     } catch (error) {
//       console.error('Error fetching routes:', error);
//       toast.error('Failed to fetch routes');
//       setAvailableRoutes([]);
//     } finally {
//       setLoadingRoutes(false);
//     }
//   };

//   // Add this useEffect alongside the existing city-based useEffect
// useEffect(() => {
//   const timer = setTimeout(() => {
//     if (localRouteNameSearch.trim()) {
//       // Clear city inputs when searching by local name
//       fetchRoutesByLocalName(localRouteNameSearch);
//     }
//   }, 500);
//   return () => clearTimeout(timer);
// }, [localRouteNameSearch]);

//   // Debounced fetch when source or destination changes
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (sourceCity && destinationCity) {
//         fetchRoutesBySourceDestination();
//       }
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [sourceCity, destinationCity]);

//   // Filter routes based on search term
//   const filteredRoutes = availableRoutes.filter(route =>
//     route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//     route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
//   route.localRouteName?.toLowerCase().includes(routeSearchTerm.toLowerCase())  // ← ADD
//   );

//   const handleSelectRoute = (route) => {
//     setSelectedRoute(route);
//     setShowRouteDropdown(false);
//     setRouteSearchTerm('');
//     setFareMatrixUp([]);
//     setFareMatrixDown([]);
//   };

//   useEffect(() => {
//     const savedData = localStorage.getItem('pendingBusFormData');
//     if (savedData) {
//       const formData = JSON.parse(savedData);
//       if (window.confirm('You have unsaved bus data. Would you like to restore it?')) {
//         setForm(prev => ({
//           ...prev,
//           busNumber: formData.busNumber || '',
//           busName: formData.busName || '',
//           busType: formData.busType || 'AC',
//           busCategory: formData.busCategory || 'Seater',
//           amenities: formData.amenities || []
//         }));
//         setTripType(formData.tripType || 'oneWay');
//         setPricing(formData.pricing || { basePrice: '', baseDistance: '', costPerKm: '' });
//         setOperatingDays(formData.operatingDays || DAYS_OF_WEEK);
//         if (formData.bookingClosedBefore) {
//           setBookingClosedBefore(formData.bookingClosedBefore);
//         }
//         setSelectedConfiguration(formData.selectedConfiguration || '2*2');
//         localStorage.removeItem('pendingBusFormData');
//       } else {
//         localStorage.removeItem('pendingBusFormData');
//       }
//     }
//   }, []);

//   const handleAddNewRoute = () => {
//     const currentFormData = {
//       busNumber: form.busNumber,
//       busName: form.busName,
//       busType: form.busType,
//       busCategory: form.busCategory,
//       amenities: form.amenities,
//       tripType: tripType,
//       pricing: pricing,
//       operatingDays: operatingDays,
//       bookingClosedBefore: bookingClosedBefore,
//       selectedConfiguration: selectedConfiguration,
//     };
//     localStorage.setItem('pendingBusFormData', JSON.stringify(currentFormData));

//     toast.info('Redirecting to create route. Your current bus form data has been saved.');

//     navigate('/routes', {
//       state: {
//         returnTo: 'busowners',
//         ownerId: ownerId,
//         formData: currentFormData,
//         sourceCity: sourceCity,
//         destinationCity: destinationCity
//       }
//     });
//   };

//   const validateBookingTime = () => {
//     const totalMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
//     if (totalMinutes < 0) {
//       toast.error('Booking close time cannot be negative');
//       return false;
//     }
//     if (bookingClosedBefore.hours > 24) {
//       toast.error('Booking close hours cannot exceed 24');
//       return false;
//     }
//     if (bookingClosedBefore.minutes > 59) {
//       toast.error('Minutes cannot exceed 59');
//       return false;
//     }
//     return true;
//   };

//   const handleBookingTimeChange = (field, value) => {
//     setBookingClosedBefore(prev => ({
//       ...prev,
//       [field]: parseInt(value) || 0
//     }));
//   };

//   // Fetch configurations when category changes
//   useEffect(() => {
//     if (form.busCategory) {
//       fetchAvailableConfigurations();
//     }
//   }, [form.busCategory, token]);

//   const getCategoryMultiplier = () => {
//     const multipliers = {
//       'Seater': 1.0,
//       'Sleeper': 1.5,
//       'Seater+Sleeper': 1.3
//     };
//     return multipliers[form.busCategory] || 1.0;
//   };

//   const getStopColor = (type) => {
//     switch (type) {
//       case 'origin': return '#4c51bf';
//       case 'destination': return '#40c057';
//       default: return '#667eea';
//     }
//   };

//   const fetchAvailableConfigurations = async () => {
//     try {
//       setLoadingLayouts(true);
//       const response = await getAllCategory(token);

//       if (response && response.success && response.data) {
//         let relevantCategories = response.data;

//         if (form.busCategory === 'Seater') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seat') ||
//             cat.availableSeatTypes?.includes('seater')
//           );
//         } else if (form.busCategory === 'Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('sleeper')
//           );
//         } else if (form.busCategory === 'Seater+Sleeper') {
//           relevantCategories = response.data.filter(cat =>
//             cat.availableSeatTypes?.includes('seater+sleeper') ||
//             cat.availableSeatTypes?.includes('seat+sleeper')
//           );
//         }

//         const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

//         if (configs.length > 0) {
//           setAvailableConfigurations(configs);
//           setSelectedConfiguration(configs[0]);
//           setLayoutTemplates([]);
//         } else {
//           setAvailableConfigurations([]);
//           setLayoutTemplates([]);
//           toast.info(`No configurations available for ${form.busCategory}`);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//       setAvailableConfigurations([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const fetchLayouts = async (config) => {
//     try {
//       if (!config) return;

//       setLoadingLayouts(true);

//       let bustype = config.replace('x', '*');

//       const response = await getSeatLayoutsByBustype(bustype, token);

//       if (response && response.success) {
//         if (response.data && Array.isArray(response.data)) {
//           let filteredLayouts = response.data;

//           if (form.busCategory === 'Seater') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seat' || layout.seatType === 'seater'
//             );
//           } else if (form.busCategory === 'Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'sleeper'
//             );
//           } else if (form.busCategory === 'Seater+Sleeper') {
//             filteredLayouts = response.data.filter(layout =>
//               layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
//             );
//           }

//           setLayoutTemplates(filteredLayouts);

//           if (filteredLayouts.length === 0) {
//             toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
//           }
//         } else {
//           setLayoutTemplates([]);
//           toast.info(`No layouts found for ${config} configuration`);
//         }
//       } else {
//         console.error('Failed to fetch layouts:', response);
//         setLayoutTemplates([]);
//         toast.error(response?.message || 'Failed to load seat layouts');
//       }
//     } catch (error) {
//       console.error("Layout Fetch Error:", error);
//       toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
//       setLayoutTemplates([]);
//     } finally {
//       setLoadingLayouts(false);
//     }
//   };

//   const handleCategoryChange = (category) => {
//     setForm(prev => ({ ...prev, busCategory: category }));
//     setSelectedTemplate(null);
//     setActiveSeats([]);
//     setLayoutTemplates([]);
//     setCustomSeatLabels({});
//   };

//   // const handleImageUpload = (event) => {
//   //   const files = Array.from(event.target.files);
//   //   const newImages = [];

//   //   files.forEach(file => {
//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       newImages.push({
//   //         file: file,
//   //         preview: e.target.result,
//   //         name: file.name
//   //       });

//   //       if (newImages.length === files.length) {
//   //         setSelectedImages(prev => [...prev, ...newImages]);
//   //       }
//   //     };
//   //     reader.readAsDataURL(file);
//   //   });
//   // };

//   const handleImageUpload = (event) => {
//   const files = Array.from(event.target.files);
//   console.log('📸 Files selected for upload:', files.length);
  
//   const newImages = [];

//   files.forEach((file, index) => {
//     console.log(`File ${index + 1}: ${file.name} (${file.size} bytes, ${file.type})`);
    
//     // ✅ Ensure it's a valid file
//     if (!(file instanceof File)) {
//       console.error(`❌ File ${index + 1} is not a File object`);
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       newImages.push({
//         file: file, // Store the actual File object
//         preview: e.target.result, // Store preview URL for display
//         name: file.name,
//         size: file.size,
//         type: file.type
//       });

//       if (newImages.length === files.length) {
//         setSelectedImages(prev => [...prev, ...newImages]);
//         console.log(`✅ Added ${newImages.length} images. Total: ${selectedImages.length + newImages.length}`);
//       }
//     };
//     reader.onerror = (error) => {
//       console.error('❌ Error reading file:', error);
//     };
//     reader.readAsDataURL(file);
//   });
// };

//   const removeImage = (index) => {
//     setSelectedImages(prev => prev.filter((_, i) => i !== index));
//   };

//   const handleVideoUpload = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setSelectedVideo({
//           file: file,
//           preview: e.target.result,
//           name: file.name,
//           size: file.size
//         });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const removeVideo = () => {
//     setSelectedVideo(null);
//   };

//   const openTemplateSelector = () => {
//     if (!form.busCategory) {
//       toast.error('Please select a Bus Category first');
//       return;
//     }
//     if (!selectedConfiguration) {
//       toast.error('Please select a Bus Configuration first');
//       return;
//     }
//     if (layoutTemplates.length === 0) {
//       toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
//       return;
//     }
//     setShowTemplateModal(true);
//   };

//   const handleSelectTemplate = (template) => {
//     setSelectedTemplate(template);
//     setActiveSeats([]);
//     setBlockedSeats([]);
//     setCustomSeatLabels({});
//     setShowTemplateModal(false);
//     setShowLayoutModal(true);
//     toast.success(`Selected template: ${template.name}`);
//   };

//   const handleSeatPress = (seatObj) => {
//     setEditingSeat(seatObj.seatNumber);
//     if (activeSeats.includes(seatObj.seatNumber)) {
//       setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
//     } else {
//       setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
//     }
//   };

//   const autoRenumberSeats = () => {
//     const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
//       if (a.row === b.row) return a.column - b.column;
//       return a.row - b.row;
//     });

//     let counter = 1;
//     const newLabels = {};

//     sortedSeats.forEach(s => {
//       if (activeSeats.includes(s.seatNumber)) {
//         newLabels[s.seatNumber] = String(counter++);
//       }
//     });

//     setCustomSeatLabels(newLabels);
//   };

//   const toggleDay = (day) => {
//     setOperatingDays(prev =>
//       prev.includes(day)
//         ? prev.filter(d => d !== day)
//         : [...prev, day]
//     );
//   };

// // const generateMatrixForRoute = (routeData) => {
// //   if (!routeData) return [];
 
// //   const baseP = parseFloat(pricing.basePrice) || 0;
// //   const baseD = parseFloat(pricing.baseDistance) || 0;
// //   const costK = parseFloat(pricing.costPerKm) || 0;
// //   const multiplier = getCategoryMultiplier();
 
// //   const sortedStops = [...(routeData.intermediateStops || [])]
// //     .sort((a, b) => a.sequence - b.sequence);
 
// //   // ✅ FIX 1: Store distances rounded to 1 decimal using integer math
// //   const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;
 
// //   const allStops = [
// //     {
// //       id: 'origin',
// //       name: routeData.origin?.city || 'Origin',
// //       distanceFromOrigin: 0,
// //       type: 'origin'
// //     },
// //     ...sortedStops.map((s, i) => ({
// //       id: s._id || `stop_${i}`,
// //       name: s.city || s.name || `Stop ${i + 1}`,
// //       distanceFromOrigin: toSafeDistance(s.distanceFromOrigin),
// //       type: 'stop',
// //       sequence: s.sequence
// //     })),
// //     {
// //       id: 'destination',
// //       name: routeData.destination?.city || 'Destination',
// //       distanceFromOrigin: toSafeDistance(
// //         routeData.destination?.distanceFromOrigin ||
// //         routeData.routeDetails?.totalDistance ||
// //         0
// //       ),
// //       type: 'destination'
// //     }
// //   ];
 
// //   const matrix = allStops.map((fromStop, i) => {
// //     const toCells = allStops.map((toStop, j) => {
// //       if (j > i) {
// //         // ✅ FIX 2: Use integer subtraction (×10) to avoid floating point drift
// //         // e.g., 178 - 0 = 178 exactly, not 177.9999...
// //         const fromInt = Math.round(fromStop.distanceFromOrigin * 10);
// //         const toInt   = Math.round(toStop.distanceFromOrigin * 10);
// //         const distance = (toInt - fromInt) / 10; // back to km with 1 decimal
 
// //         // ✅ FIX 3: Round extraDistance before multiplying to avoid drift
// //         let price = baseP;
// //         if (distance > baseD) {
// //           const extraDistance = Math.round((distance - baseD) * 10) / 10;
// //           price = baseP + (extraDistance * costK);
// //         }
 
// //         // ✅ FIX 4: Round AFTER applying multiplier
// //         price = Math.round(price * multiplier);
 
// //         return {
// //           toId: toStop.id,
// //           toName: toStop.name,
// //           distanceKm: distance,
// //           price: price
// //         };
// //       }
// //       return null;
// //     });
 
// //     return {
// //       fromId: fromStop.id,
// //       fromName: fromStop.name,
// //       fromType: fromStop.type,
// //       sequence: fromStop.sequence,
// //       toCells: toCells
// //     };
// //   });
 
// //   return matrix.filter(row => row.fromId !== 'destination');
// // };

// const generateMatrixForRoute = (routeData) => {
//   if (!routeData) return [];

//   const baseP = parseFloat(pricing.basePrice) || 0;
//   const baseD = parseFloat(pricing.baseDistance) || 0;
//   const costK = parseFloat(pricing.costPerKm) || 0;
//   const multiplier = getCategoryMultiplier();

//   const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;

//   const sortedStops = [...(routeData.intermediateStops || [])]
//     .sort((a, b) => a.sequence - b.sequence);

//   // Build raw stops
//   const rawStops = [
//     {
//       id: 'origin',
//       name: routeData.origin?.city || 'Origin',
//       rawDist: toSafeDistance(routeData.origin?.distanceFromOrigin || 0),
//       type: 'origin'
//     },
//     ...sortedStops.map((s, i) => ({
//       id: s._id || `stop_${i}`,
//       name: s.city || s.name || `Stop ${i + 1}`,
//       rawDist: toSafeDistance(s.distanceFromOrigin),
//       type: 'stop',
//       sequence: s.sequence
//     })),
//     {
//       id: 'destination',
//       name: routeData.destination?.city || 'Destination',
//       rawDist: toSafeDistance(
//         routeData.destination?.distanceFromOrigin ||
//         routeData.routeDetails?.totalDistance ||
//         0
//       ),
//       type: 'destination'
//     }
//   ];

//   // ✅ CORE FIX: Find min and max raw distances
//   const allRawDists = rawStops.map(s => s.rawDist);
//   const minDist = Math.min(...allRawDists);
//   const maxDist = Math.max(...allRawDists);

//   // Check if this is a descending route (DOWN) - origin has higher dist than destination
//   const originRaw = rawStops[0].rawDist;
//   const destRaw   = rawStops[rawStops.length - 1].rawDist;
//   const isDescending = destRaw < originRaw;

//   // Normalize every stop to 0-based ascending distance
//   const normalizedStops = rawStops.map(stop => ({
//     ...stop,
//     distanceFromOrigin: isDescending
//       ? toSafeDistance(maxDist - stop.rawDist)   // flip: high→0, low→high
//       : toSafeDistance(stop.rawDist - minDist)    // shift to 0-base
//   }));

//   // ✅ ALWAYS sort by normalized distance ascending — this is the key fix
//   // Without this sort, column indices don't match ascending distance order
//   // and j > i produces negative (toInt - fromInt) values
//   const allStops = normalizedStops.sort(
//     (a, b) => a.distanceFromOrigin - b.distanceFromOrigin
//   );

//   // Build matrix — with sorted stops, j > i ALWAYS means further stop
//   const matrix = allStops.map((fromStop, i) => {
//     const toCells = allStops.map((toStop, j) => {
//       if (j > i) {
//         const fromInt  = Math.round(fromStop.distanceFromOrigin * 10);
//         const toInt    = Math.round(toStop.distanceFromOrigin * 10);
//         // ✅ Math.abs as final safety — can never be negative after sort
//         const distance = Math.abs((toInt - fromInt) / 10);

//         let price = baseP;
//         if (distance > baseD) {
//           const extraDistance = Math.round((distance - baseD) * 10) / 10;
//           price = baseP + (extraDistance * costK);
//         }
//         price = Math.round(price * multiplier);

//         return {
//           toId: toStop.id,
//           toName: toStop.name,
//           distanceKm: distance,
//           price: price
//         };
//       }
//       return null;
//     });

//     return {
//       fromId: fromStop.id,
//       fromName: fromStop.name,
//       fromType: fromStop.type,
//       sequence: fromStop.sequence,
//       toCells: toCells
//     };
//   });

//   return matrix.filter(row => row.fromId !== 'destination');
// };

//   const handleGenerateMatrix = () => {
//     if (!selectedRoute) {
//       toast.error('Please select a Route first.');
//       return;
//     }

//     if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
//       toast.error("The selected route does not have return journey details configured.");
//       return;
//     }

//     if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
//       toast.error('Please fill all Pricing Fields.');
//       return;
//     }

//     const matrixUp = generateMatrixForRoute(selectedRoute);
//     setFareMatrixUp(matrixUp);

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
//       setFareMatrixDown(matrixDown);
//     } else {
//       setFareMatrixDown([]);
//     }

//     toast.success(tripType === 'roundTrip'
//       ? "Both Fare Matrices Generated!"
//       : "Fare Matrix Generated!"
//     );
//   };

//   const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

//     const updatedMatrix = currentMatrix.map((row, rIndex) => {
//       if (rIndex !== rowIndex) return row;
//       const newToCells = [...row.toCells];
//       if (newToCells[colIndex]) {
//         newToCells[colIndex] = {
//           ...newToCells[colIndex],
//           price: parseInt(newPrice) || 0
//         };
//       }
//       return { ...row, toCells: newToCells };
//     });

//     if (isUp) {
//       setFareMatrixUp(updatedMatrix);
//     } else {
//       setFareMatrixDown(updatedMatrix);
//     }
//   };

//   const getSeatPosition = (column) => {
//     switch (parseInt(column)) {
//       case 1: return 'window';
//       case 2: return 'middle';
//       case 3: return 'aisle';
//       case 4: return 'window';
//       default: return 'aisle';
//     }
//   };

//   // const handleSubmitBus = async () => {
//   //   try {
//   //     setIsSubmitting(true);
//   //     setError(null);

//   //     if (!validateBookingTime()) {
//   //       setIsSubmitting(false);
//   //       return;
//   //     }

//   //     if (!form.busNumber) throw new Error('Bus Number is required');
//   //     if (!form.busName) throw new Error('Bus Name is required');
//   //     if (!form.busType) throw new Error('Bus Type is required');
//   //     if (!form.busCategory) throw new Error('Bus Category is required');
//   //     if (!selectedRoute) throw new Error('Please select a route');
//   //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
//   //     if (!selectedTemplate) throw new Error('Please configure seat layout');
//   //     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

//   //     const amenitiesArray = form.amenities || [];

//   //     const finalSeatsPayload = selectedTemplate.seats
//   //       .filter(s => activeSeats.includes(s.seatNumber))
//   //       .map(s => {
//   //         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//   //         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//   //         const isBlocked = blockedSeats.includes(s.seatNumber);

//   //         return {
//   //           seatNumber: s.seatNumber,
//   //           globalSeatIndex: finalGlobalIndex,
//   //           row: s.row,
//   //           column: s.column,
//   //           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//   //           position: s.position || getSeatPosition(s.column),
//   //           isBlocked: isBlocked,
//   //           isAvailable: !isBlocked,
//   //         };
//   //       });

//   //     const seatConfigPayload = {
//   //       busType: selectedTemplate.configuration || '2*2',
//   //       totalSeats: activeSeats.length
//   //     };

//   //     const routeSchedules = [];
//   //     const routeIdToSave = selectedRoute._id || selectedRoute.id;

//   //     routeSchedules.push({
//   //       routeId: routeIdToSave,
//   //       direction: 'UP',
//   //       fareMatrix: fareMatrixUp,
//   //       operatingDays: operatingDays,
//   //       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//   //       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//   //     });

//   //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//   //       routeSchedules.push({
//   //         routeId: routeIdToSave,
//   //         direction: 'DOWN',
//   //         fareMatrix: fareMatrixDown,
//   //         operatingDays: operatingDays,
//   //         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//   //         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//   //       });
//   //     }

//   //     const fareDetails = {
//   //       basePrice: parseFloat(pricing.basePrice) || 0,
//   //       baseDistance: parseFloat(pricing.baseDistance) || 0,
//   //       costPerKm: parseFloat(pricing.costPerKm) || 0
//   //     };

//   //     const formData = new FormData();

//   //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//   //     formData.append('busName', form.busName.trim());
//   //     formData.append('busType', form.busType);
//   //     formData.append('busCategory', form.busCategory);
//   //     formData.append('totalSeats', String(activeSeats.length));
//   //     formData.append('tripType', tripType);
//   //     formData.append('busClass', 'Economy');

//   //     formData.append('amenities', JSON.stringify(amenitiesArray));
//   //     formData.append('seats', JSON.stringify(finalSeatsPayload));
//   //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//   //     formData.append('routeSchedules', JSON.stringify(routeSchedules));
//   //     formData.append('fareDetails', JSON.stringify(fareDetails));
//   //     formData.append('operatingDays', JSON.stringify(operatingDays));
//   //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));

//   //     selectedImages.forEach((img, index) => {
//   //       if (img.file) {
//   //         formData.append('images', img.file);
//   //       }
//   //     });

//   //     if (selectedVideo && selectedVideo.file) {
//   //       formData.append('videos', selectedVideo.file);
//   //     }

//   //     const response = await addBusToOwner(ownerId, formData, token);

//   //     if (response && response.success) {
//   //       toast.success(tripType === 'roundTrip'
//   //         ? 'Bus added successfully with round trip routes!'
//   //         : 'Bus added successfully!'
//   //       );
//   //       onBusAdded();
//   //       onClose();
//   //     } else {
//   //       throw new Error(response?.message || 'Failed to add bus');
//   //     }

//   //   } catch (err) {
//   //     console.error('Error adding bus:', err);
//   //     setError(err.message || 'Failed to add bus');
//   //     toast.error(err.message || 'Failed to add bus');
//   //   } finally {
//   //     setIsSubmitting(false);
//   //   }
//   // };

// //   const handleSubmitBus = async () => {
// //   try {
// //     setIsSubmitting(true);
// //     setError(null);

// //     if (!validateBookingTime()) {
// //       setIsSubmitting(false);
// //       return;
// //     }

// //         if (!validateCancellationTime()) {
// //       setIsSubmitting(false);
// //       return;
// //     }

// //     if (!form.busNumber) throw new Error('Bus Number is required');
// //     if (!form.busName) throw new Error('Bus Name is required');
// //     if (!form.busType) throw new Error('Bus Type is required');
// //     if (!form.busCategory) throw new Error('Bus Category is required');
// //     if (!selectedRoute) throw new Error('Please select a route');
// //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
// //     if (!selectedTemplate) throw new Error('Please configure seat layout');
// //     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

// //     const amenitiesArray = form.amenities || [];

// //     const finalSeatsPayload = selectedTemplate.seats
// //       .filter(s => activeSeats.includes(s.seatNumber))
// //       .map(s => {
// //         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
// //         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
// //         const isBlocked = blockedSeats.includes(s.seatNumber);

// //         return {
// //           seatNumber: s.seatNumber,
// //           globalSeatIndex: finalGlobalIndex,
// //           row: s.row,
// //           column: s.column,
// //           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
// //           position: s.position || getSeatPosition(s.column),
// //           isBlocked: isBlocked,
// //           isAvailable: !isBlocked,
// //         };
// //       });

// //     const seatConfigPayload = {
// //       busType: selectedTemplate.configuration || '2*2',
// //       totalSeats: activeSeats.length
// //     };

// //     const routeSchedules = [];
// //     const routeIdToSave = selectedRoute._id || selectedRoute.id;

// //     routeSchedules.push({
// //       routeId: routeIdToSave,
// //       direction: 'UP',
// //       fareMatrix: fareMatrixUp,
// //       operatingDays: operatingDays,
// //       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
// //       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
// //     });

// //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
// //       routeSchedules.push({
// //         routeId: routeIdToSave,
// //         direction: 'DOWN',
// //         fareMatrix: fareMatrixDown,
// //         operatingDays: operatingDays,
// //         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
// //         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
// //       });
// //     }

// //     const fareDetails = {
// //       basePrice: parseFloat(pricing.basePrice) || 0,
// //       baseDistance: parseFloat(pricing.baseDistance) || 0,
// //       costPerKm: parseFloat(pricing.costPerKm) || 0
// //     };

// //     // Platform Fee object
// //     const platformFeeData = {
// //       type: platformFee.type,
// //       value: platformFee.value,
// //       applicableOn: platformFee.applicableOn
// //     };

// //     const formData = new FormData();

// //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
// //     formData.append('busName', form.busName.trim());
// //     formData.append('busType', form.busType);
// //     formData.append('busCategory', form.busCategory);
// //     formData.append('totalSeats', String(activeSeats.length));
// //     formData.append('tripType', tripType);
// //     formData.append('busClass', 'Economy');

// //     formData.append('cancellationTime', JSON.stringify(cancellationTime));

// //     formData.append('amenities', JSON.stringify(amenitiesArray));
// //     formData.append('seats', JSON.stringify(finalSeatsPayload));
// //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
// //     formData.append('routeSchedules', JSON.stringify(routeSchedules));
// //     formData.append('fareDetails', JSON.stringify(fareDetails));
// //     formData.append('operatingDays', JSON.stringify(operatingDays));
// //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
    
// //     // Append platform fee data
// //     formData.append('platformFee', JSON.stringify(platformFeeData));

// //     selectedImages.forEach((img, index) => {
// //       if (img.file) {
// //         formData.append('images', img.file);
// //       }
// //     });

// //     if (selectedVideo && selectedVideo.file) {
// //       formData.append('videos', selectedVideo.file);
// //     }

// //     const response = await addBusToOwner(ownerId, formData, token);

// //     if (response && response.success) {
// //       toast.success(tripType === 'roundTrip'
// //         ? 'Bus added successfully with round trip routes!'
// //         : 'Bus added successfully!'
// //       );
// //       onBusAdded();
// //       onClose();
// //     } else {
// //       throw new Error(response?.message || 'Failed to add bus');
// //     }

// //   } catch (err) {
// //     console.error('Error adding bus:', err);
// //     setError(err.message || 'Failed to add bus');
// //     toast.error(err.message || 'Failed to add bus');
// //   } finally {
// //     setIsSubmitting(false);
// //   }
// // };

// const handleSubmitBus = async () => {
//   try {
//     setIsSubmitting(true);
//     setError(null);

//     // ✅ DEBUG: Log selected images before submit
//     console.log('=== SUBMIT BUS DEBUG ===');
//     console.log('Selected images count:', selectedImages.length);
//     console.log('Selected video:', selectedVideo ? selectedVideo.name : 'None');
    
//     if (selectedImages.length > 0) {
//       selectedImages.forEach((img, i) => {
//         console.log(`Image ${i + 1}:`, img.file ? `${img.file.name} (${img.file.size} bytes, ${img.file.type})` : 'No file object');
//       });
//     }

//     // Validation
//     if (!validateBookingTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//     if (!validateCancellationTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//     if (!form.busNumber) throw new Error('Bus Number is required');
//     if (!form.busName) throw new Error('Bus Name is required');
//     if (!form.busType) throw new Error('Bus Type is required');
//     if (!form.busCategory) throw new Error('Bus Category is required');
//     if (!selectedRoute) throw new Error('Please select a route');
//     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
//     if (!selectedTemplate) throw new Error('Please configure seat layout');
//     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

//     // ⚠️ Warning if no images (but don't block submission)
//     if (selectedImages.length === 0) {
//       toast.warning('No images selected. It\'s recommended to add bus images.');
//     }

//     // Prepare data
//     const amenitiesArray = form.amenities || [];

//     const finalSeatsPayload = selectedTemplate.seats
//       .filter(s => activeSeats.includes(s.seatNumber))
//       .map(s => {
//         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//         const isBlocked = blockedSeats.includes(s.seatNumber);

//         return {
//           seatNumber: s.seatNumber,
//           globalSeatIndex: finalGlobalIndex,
//           row: s.row,
//           column: s.column,
//           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//           position: s.position || getSeatPosition(s.column),
//           isBlocked: isBlocked,
//           isAvailable: !isBlocked,
//         };
//       });

//     const seatConfigPayload = {
//       busType: selectedTemplate.configuration || '2*2',
//       totalSeats: activeSeats.length
//     };

//     const routeSchedules = [];
//     const routeIdToSave = selectedRoute._id || selectedRoute.id;

//     routeSchedules.push({
//       routeId: routeIdToSave,
//       direction: 'UP',
//       fareMatrix: fareMatrixUp,
//       operatingDays: operatingDays,
//       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//     });

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       routeSchedules.push({
//         routeId: routeIdToSave,
//         direction: 'DOWN',
//         fareMatrix: fareMatrixDown,
//         operatingDays: operatingDays,
//         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//       });
//     }

//     const fareDetails = {
//       basePrice: parseFloat(pricing.basePrice) || 0,
//       baseDistance: parseFloat(pricing.baseDistance) || 0,
//       costPerKm: parseFloat(pricing.costPerKm) || 0
//     };

//     const platformFeeData = {
//       type: platformFee.type,
//       value: platformFee.value,
//       applicableOn: platformFee.applicableOn
//     };

//     // ✅ CREATE FORMDATA
//     const formData = new FormData();

//     // ✅ Append all text fields
//     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//     formData.append('busName', form.busName.trim());
//     formData.append('busType', form.busType);
//     formData.append('busCategory', form.busCategory);
//     formData.append('totalSeats', String(activeSeats.length));
//     formData.append('tripType', tripType);
//     formData.append('busClass', 'Economy');
//     formData.append('cancellationTime', JSON.stringify(cancellationTime));
//     formData.append('amenities', JSON.stringify(amenitiesArray));
//     formData.append('seats', JSON.stringify(finalSeatsPayload));
//     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//     formData.append('routeSchedules', JSON.stringify(routeSchedules));
//     formData.append('fareDetails', JSON.stringify(fareDetails));
//     formData.append('operatingDays', JSON.stringify(operatingDays));
//     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
//     formData.append('platformFee', JSON.stringify(platformFeeData));

//     // ✅ APPEND IMAGES - Using for loop instead of forEach with await
//     console.log('📸 Appending images to FormData...');
//     let imageAppendedCount = 0;
    
//     // ✅ Use a simple for loop instead of forEach to avoid async issues
//     for (let i = 0; i < selectedImages.length; i++) {
//       const img = selectedImages[i];
//       if (img.file) {
//         // Make sure it's a valid File object
//         if (img.file instanceof File || img.file instanceof Blob) {
//           formData.append('images', img.file);
//           imageAppendedCount++;
//           console.log(`✅ Appended image ${i + 1}: ${img.file.name} (${img.file.size} bytes)`);
//         } else {
//           console.error(`❌ Image ${i + 1} is not a valid File object:`, img.file);
//         }
//       }
//     }

//     console.log(`📸 Total images appended: ${imageAppendedCount}`);

//     // ✅ APPEND VIDEOS
//     if (selectedVideo && selectedVideo.file) {
//       if (selectedVideo.file instanceof File || selectedVideo.file instanceof Blob) {
//         formData.append('videos', selectedVideo.file);
//         console.log(`🎬 Appended video: ${selectedVideo.file.name} (${selectedVideo.file.size} bytes)`);
//       } else {
//         console.error('❌ Video is not a valid File object:', selectedVideo.file);
//       }
//     }

//     // ✅ DEBUG: Log all FormData entries (for debugging)
//     console.log('=== FORMDATA ENTRIES ===');
//     for (let [key, value] of formData.entries()) {
//       if (key === 'images' || key === 'videos') {
//         console.log(`${key}: ${value.name} (${value.size} bytes, ${value.type})`);
//       } else {
//         const stringValue = typeof value === 'string' ? value : String(value);
//         console.log(`${key}: ${stringValue.substring(0, 100)}${stringValue.length > 100 ? '...' : ''}`);
//       }
//     }

//     // ✅ Log the actual FormData for debugging
//     console.log('FormData size:', formData.getAll('images').length, 'images');
    
//     // ✅ SEND REQUEST
//     const response = await addBusToOwner(ownerId, formData, token);

//     console.log('=== RESPONSE ===', response);

//     if (response && response.success) {
//       toast.success(tripType === 'roundTrip'
//         ? 'Bus added successfully with round trip routes!'
//         : 'Bus added successfully!'
//       );
//       onBusAdded();
//       onClose();
//     } else {
//       throw new Error(response?.message || 'Failed to add bus');
//     }

//   } catch (err) {
//     console.error('❌ Error adding bus:', err);
//     setError(err.message || 'Failed to add bus');
//     toast.error(err.message || 'Failed to add bus');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   const renderMatrix = (type) => {
//     const isUp = type === 'up';
//     const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
//     const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

//     if (!currentRoute || currentMatrix.length === 0) return null;

//     const sortedStops = [...(currentRoute.intermediateStops || [])]
//       .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//     const allStops = [
//       { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
//       ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
//       { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
//     ];

//     return (
//       <div className="matrix-section">
//         <h5 className="matrix-title">
//           {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
//         </h5>
//         <div className="matrix-container">
//           <div className="matrix-table-wrapper">
//             <table className="fare-matrix-table">
//               <thead>
//                 <tr>
//                   <th className="from-cell">From \ To</th>
//                   {allStops.map((stop, i) => (
//                     <th className="price-cell" key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
//                       <div className="stop-header">
//                         <span className="stop-name">{stop.name}</span>
//                         <span className="stop-type">{stop.type}</span>
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentMatrix.map((row, rowIndex) => (
//                   <tr key={rowIndex}>
//                     <td
//                       className="from-cell"
//                       style={{ backgroundColor: getStopColor(row.fromType) }}
//                     >
//                       <div className="from-stop">
//                         <span className="stop-name">{row.fromName}</span>
//                         <span className="stop-type">{row.fromType}</span>
//                       </div>
//                     </td>
//                     {row.toCells.map((cell, colIndex) => {
//                       if (cell) {
//                         return (
//                           <td key={colIndex} className="price-cell">
//                             <div className="fare-cell">
//                               <span className="distance">{cell.distanceKm} km</span>
//                               <div className="price-input-group">
//                                 <span className="currency">₹</span>
//                                 <input
//                                   type="number"
//                                   className="matrix-input"
//                                   value={cell.price}
//                                   onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
//                                   min="0"
//                                   step="1"
//                                 />
//                               </div>
//                             </div>
//                            </td>
//                         );
//                       }
//                       return <td key={colIndex} className="na-cell">—</td>;
//                     })}
//                    </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderSeatVisualizer = () => {
//     if (!selectedTemplate) return null;

//     const { seats, configuration } = selectedTemplate;

//     let leftCount = 2, rightCount = 2;
//     try {
//       if (configuration && configuration.includes('*')) {
//         const parts = configuration.split('*');
//         leftCount = parseInt(parts[0]) || 2;
//         rightCount = parseInt(parts[1]) || 2;
//       }
//     } catch (e) {
//       leftCount = 2;
//       rightCount = 2;
//     }

//     const totalConfigCols = leftCount + rightCount;

//     const seatsByRow = {};
//     seats.forEach(seat => {
//       if (!seatsByRow[seat.row]) {
//         seatsByRow[seat.row] = [];
//       }
//       seatsByRow[seat.row].push(seat);
//     });

//     const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

//     const rows = [];

//     const renderSeat = (seatObj) => {
//       const isSelected = activeSeats.includes(seatObj.seatNumber);
//       const isBlocked = blockedSeats.includes(seatObj.seatNumber);
//       const isSleeper = seatObj.seatType === 'sleeper' ||
//         seatObj.seatType === 'seat+sleeper' ||
//         selectedTemplate.seatType === 'sleeper' ||
//         selectedTemplate.seatType === 'seater+sleeper';

//       const displayLabel = isSelected
//         ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
//         : "";

//       let seatClass = '';
//       if (isSelected) {
//         seatClass = isBlocked ? 'blocked' : 'selected';
//       } else {
//         seatClass = 'inactive';
//       }

//       return (
//         <button
//           key={seatObj.seatNumber}
//           className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
//           onClick={() => handleSeatPress(seatObj)}
//           type="button"
//         >
//           <span className="seat-number">{displayLabel}</span>
//         </button>
//       );
//     };

//     rowNumbers.forEach(rowNum => {
//       const seatsInRow = seatsByRow[rowNum];

//       const isBackRow = seatsInRow.some(s => s.position === 'back') ||
//         seatsInRow.length > totalConfigCols;

//       if (isBackRow) {
//         const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row back-row">
//             <div className="seats-container">
//               {sortedSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       } else {
//         const leftSeats = seatsInRow
//           .filter(s => (s.column || 0) <= leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         const rightSeats = seatsInRow
//           .filter(s => (s.column || 0) > leftCount)
//           .sort((a, b) => (a.column || 0) - (b.column || 0));

//         rows.push(
//           <div key={`row-${rowNum}`} className="seat-row">
//             <div className="left-seats">
//               {leftSeats.map(seat => renderSeat(seat))}
//             </div>
//             <div className="aisle">Aisle</div>
//             <div className="right-seats">
//               {rightSeats.map(seat => renderSeat(seat))}
//             </div>
//           </div>
//         );
//       }
//     });

//     return (
//       <div className="seat-layout-visualizer">
//         <div className="bus-header">
//           <div className="driver-area">Driver</div>
//           <div className="bus-info">
//             <span className="bus-config">{selectedTemplate.configuration}</span>
//             <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
//           </div>
//         </div>
//         <div className="bus-body">
//           {rows}
//         </div>
//         <div className="seat-legend">
//           <div className="legend-item">
//             <div className="seat-sample selected"></div>
//             <span>Active Seat ({activeSeats.length})</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample inactive"></div>
//             <span>Inactive Seat</span>
//           </div>
//           <div className="legend-item">
//             <div className="seat-sample sleeper"></div>
//             <span>Sleeper</span>
//           </div>
//         </div>
//         <div className="seat-summary">
//           <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
//         </div>
//       </div>
//     );
//   };

//   const ProgressSteps = () => (
//     <div className="progress-steps">
//       <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">1</div>
//         <div className="step-label">Basic Info</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">2</div>
//         <div className="step-label">Route & Pricing</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
//         <div className="step-icon">3</div>
//         <div className="step-label">Fare Matrix</div>
//       </div>
//       <div className="step-connector"></div>
//       <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
//         <div className="step-icon">4</div>
//         <div className="step-label">Seat Layout</div>
//       </div>
//     </div>
//   );

//   const renderBasicInfoTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Bus Information</h3>
//         <p className="section-subtitle">Enter basic details about the bus</p>
//       </div>

//       <div className="form-grid">
//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🚌</span>
//             Bus Number *
//           </label>
//           <input
//             type="text"
//             value={form.busNumber}
//             onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
//             placeholder="e.g., WB01AB1234"
//             className="modern-input"
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label className="input-label">
//             <span className="label-icon">🏷️</span>
//             Bus Name *
//           </label>
//           <input
//             type="text"
//             value={form.busName}
//             onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
//             placeholder="e.g., Volvo Multi-Axle"
//             className="modern-input"
//             required
//           />
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🖼️</span>
//           Bus Images
//         </h4>
//         <div className="images-upload-area">
//           <input
//             type="file"
//             id="bus-images"
//             multiple
//             accept="image/*"
//             onChange={handleImageUpload}
//             className="image-upload-input"
//             style={{ display: 'none' }}
//           />
//           <label htmlFor="bus-images" className="image-upload-label">
//             <span className="upload-icon">📁</span>
//             <span className="upload-text">Click to upload images</span>
//             <span className="upload-hint">Upload multiple images (max 10)</span>
//           </label>

//           {selectedImages.length > 0 && (
//             <div className="selected-images-preview">
//               <h5>Selected Images ({selectedImages.length})</h5>
//               <div className="images-grid">
//                 {selectedImages.map((image, index) => (
//                   <div key={index} className="image-preview-item">
//                     <img
//                       src={image.preview}
//                       alt={`Bus ${index + 1}`}
//                       className="preview-image"
//                     />
//                     <button
//                       type="button"
//                       className="remove-image-btn"
//                       onClick={() => removeImage(index)}
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* <div className="video-upload-section" style={{ marginTop: '15px' }}>
//             <input
//               type="file"
//               id="bus-video"
//               accept="video/*"
//               onChange={handleVideoUpload}
//               className="video-upload-input"
//               style={{ display: 'none' }}
//             />
//             <label htmlFor="bus-video" className="video-upload-label">
//               <span className="upload-icon">🎥</span>
//               <span className="upload-text">Click to upload video</span>
//               <span className="upload-hint">Upload one video (optional)</span>
//             </label>

//             {selectedVideo && (
//               <div className="selected-video-preview">
//                 <div className="video-info">
//                   <span className="video-name">{selectedVideo.name}</span>
//                   <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
//                 </div>
//                 <button
//                   type="button"
//                   className="remove-video-btn"
//                   onClick={removeVideo}
//                 >
//                   Remove
//                 </button>
//               </div>
//             )}
//           </div> */}
//         </div>
//       </div>

//       <div className="form-row">
//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">🔧</span>
//             Bus Type *
//           </label>
//           <select
//             value={form.busType}
//             onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
//             className="modern-select"
//           >
//             {BUS_TYPES.map(type => (
//               <option key={type} value={type}>{type}</option>
//             ))}
//           </select>
//         </div>

//         <div className="form-group">
//           <label className="input-label">
//             <span className="label-icon">📊</span>
//             Bus Category *
//           </label>
//           <select
//             value={form.busCategory}
//             onChange={(e) => handleCategoryChange(e.target.value)}
//             className="modern-select"
//           >
//             <option value="">Select Category</option>
//             {BUS_CATEGORIES.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//           <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">⏰</span>
//           Booking Cut-off Time
//         </h4>
//         <div className="booking-time-container">
//           <div className="time-input-group">
//             <label className="input-label">Hours before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="24"
//                 value={bookingClosedBefore.hours}
//                 onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">hours</span>
//             </div>
//           </div>
//           <div className="time-input-group">
//             <label className="input-label">Minutes before departure</label>
//             <div className="time-input-wrapper">
//               <input
//                 type="number"
//                 min="0"
//                 max="59"
//                 value={bookingClosedBefore.minutes}
//                 onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
//                 className="modern-input time-input"
//               />
//               <span className="time-unit">minutes</span>
//             </div>
//           </div>
//         </div>
//       </div>

// <div className="section-card">
//   <h4 className="card-title">
//     <span className="title-icon">⏰</span>
//     Cancellation Time
//   </h4>
//   <div className="booking-time-container">
//     <div className="time-input-group">
//       <label className="input-label">Hours before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="48"
//           value={cancellationTime.hours}
//           onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">hours</span>
//       </div>
//     </div>
//     <div className="time-input-group">
//       <label className="input-label">Minutes before departure</label>
//       <div className="time-input-wrapper">
//         <input
//           type="number"
//           min="0"
//           max="59"
//           value={cancellationTime.minutes}
//           onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
//           className="modern-input time-input"
//         />
//         <span className="time-unit">minutes</span>
//       </div>
//     </div>
//   </div>
//   <small className="helper-text">
//     Cancellation allowed up to this time before departure
//   </small>
// </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">✨</span>
//           Amenities
//         </h4>
//         <div className="amenities-grid compact">
//           {AMENITIES_LIST.map(amenity => (
//             <label key={amenity} className="amenity-option compact">
//               <input
//                 type="checkbox"
//                 checked={form.amenities.includes(amenity)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: [...prev.amenities, amenity]
//                     }));
//                   } else {
//                     setForm(prev => ({
//                       ...prev,
//                       amenities: prev.amenities.filter(a => a !== amenity)
//                     }));
//                   }
//                 }}
//                 className="amenity-checkbox"
//               />
//               <span className="amenity-content">
//                 <span className="amenity-icon">✓</span>
//                 <span className="amenity-label">{amenity}</span>
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           className="modern-btn primary full-width"
//           onClick={() => setActiveTab('route')}
//           disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
//         >
//           Continue to Route & Pricing
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderRouteTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Route & Pricing Configuration</h3>
//         <p className="section-subtitle">Select source, destination and configure pricing for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔄</span>
//           Trip Type
//         </h4>
//         <div className="trip-type-container">
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
//             onClick={() => setTripType('oneWay')}
//           >
//             <span className="btn-icon">➡️</span>
//             One Way
//           </button>
//           <button
//             type="button"
//             className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
//             onClick={() => setTripType('roundTrip')}
//           >
//             <span className="btn-icon">🔄</span>
//             Round Trip
//           </button>
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📍</span>
//           Source & Destination
//         </h4>
        
//         <div className="form-row">
//           <div className="form-group">
//             <label className="input-label">Source City *</label>
//             <input
//               type="text"
//               value={sourceCity}
//               onChange={(e) => {
//                 setSourceCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter source city"
//               className="modern-input"
//             />
//           </div>
    
//           <div className="form-group">
//             <label className="input-label">Destination City *</label>
//             <input
//               type="text"
//               value={destinationCity}
//               onChange={(e) => {
//                 setDestinationCity(e.target.value);
//                 setSelectedRoute(null);
//               }}
//               placeholder="Enter destination city"
//               className="modern-input"
//             />
//           </div>

//        {/* Replace the existing OR search form-group */}
// <div className="form-group" style={{ marginTop: '10px' }}>
//   <label className="input-label">— OR — Search by Local Route Name</label>
//   <div style={{ position: 'relative' }}>
//     <input
//       type="text"
//       value={localRouteNameSearch}
//       onChange={(e) => {
//         const val = e.target.value;
//         setLocalRouteNameSearch(val);
//         setSelectedRoute(null);
//         // Clear city fields when using local name search
//         if (val.trim()) {
//           setSourceCity('');
//           setDestinationCity('');
//         }
//       }}
//       placeholder="e.g. Panskura to Bagnan local name..."
//       className="modern-input"
//     />
//     {localRouteSearchLoading && (
//       <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//         <div className="spinner-small"></div>
//       </div>
//     )}
//   </div>
//   <small className="helper-text">
//     Search routes directly by local name without entering city filters
//   </small>
// </div>
//         </div>
//       </div>

//       {/* {sourceCity && destinationCity && ( */}
//       {(sourceCity && destinationCity || availableRoutes.length > 0) && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">🗺️</span>
//             Select Route
//           </h4>
          
//           <div className="route-selector">
//   <label className="input-label">Available Routes *</label>
//   <div className="route-dropdown-container">
//     <input
//       type="text"
//       value={selectedRoute ? `${selectedRoute.localRouteName ? `${selectedRoute.localRouteName} - ` : ''}${selectedRoute.routeName}` : routeSearchTerm}
//       onClick={() => setShowRouteDropdown(!showRouteDropdown)}
//       onChange={(e) => {
//         setRouteSearchTerm(e.target.value);
//         setShowRouteDropdown(true);
//         if (selectedRoute) setSelectedRoute(null);
//       }}
//       placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
//       className="modern-input"
//       disabled={loadingRoutes}
//       style={{ cursor: 'pointer' }}
//     />
//     {loadingRoutes && (
//       <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//         <div className="spinner-small"></div>
//       </div>
//     )}
    
//     {showRouteDropdown && availableRoutes.length > 0 && (
//       <div className="route-dropdown">
//         <div className="dropdown-search">
//           <input
//             type="text"
//             value={routeSearchTerm}
//             onChange={(e) => setRouteSearchTerm(e.target.value)}
//             placeholder="Search routes..."
//             className="dropdown-search-input"
//             autoFocus
//           />
//         </div>
//         <div className="dropdown-list">
//           {filteredRoutes.length === 0 ? (
//             <div className="dropdown-empty">No matching routes</div>
//           ) : (
//             filteredRoutes.map((route) => (
//               <div
//                 key={route._id}
//                 className="dropdown-item"
//                 onClick={() => handleSelectRoute(route)}
//               >
//                <div className="route-number">
//   {route.localRouteName ? (
//     <div className="route-name-stack">
//       <div className="local-route-name">{route.localRouteName}</div>
//       <div className="route-name">{route.routeName}</div>
//     </div>
//   ) : (
//     <div className="route-name">{route.routeName}</div>
//   )}
// </div>
//                 <div className="route-details">
//                   {route.origin?.city} → {route.destination?.city} • 
//                   {route.isRoundTrip ? ' Round Trip' : ' One Way'} • 
//                   {route.routeDetails?.totalDistance || 0} km
//                 </div>
//                 {route.creatorType === 'BusOwner' && (
//                   <span className="owner-badge">Owner</span>
//                 )}
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     )}
//   </div>
  
//   {availableRoutes.length === 0 && sourceCity && destinationCity && !loadingRoutes && (
//     <div className="no-routes-message">
//       <p>No routes found for {sourceCity} → {destinationCity}</p>
//       <button type="button" onClick={handleAddNewRoute} className="create-route-btn">
//         + Create New Route
//       </button>
//     </div>
//   )}
  
//   {selectedRoute && selectedRoute.isRoundTrip && (
//     <small className="helper-text">✓ Round trip route selected - both UP and DOWN matrices will be generated</small>
//   )}
// </div>
//         </div>
//       )}

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">📅</span>
//           Operating Days *
//         </h4>
//         <div className="days-grid compact">
//           {DAYS_OF_WEEK.map(day => (
//             <button
//               key={day}
//               type="button"
//               className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
//               onClick={() => toggleDay(day)}
//               title={day}
//             >
//               {day.substring(0, 3)}
//             </button>
//           ))}
//         </div>
//         <div className="selected-days">
//           Selected: {operatingDays.length} days
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💰</span>
//           Pricing Configuration
//         </h4>

//         <div className="form-row">
//           <div className="form-group">
//             <label>Base Price (₹) *</label>
//             <input
//               type="number"
//               value={pricing.basePrice}
//               onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
//               placeholder="e.g., 100"
//               className="modern-input"
//               min="0"
//               step="1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Base Distance (km) *</label>
//             <input
//               type="number"
//               value={pricing.baseDistance}
//               onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
//               placeholder="e.g., 15"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//           <div className="form-group">
//             <label>Cost per km (₹) *</label>
//             <input
//               type="number"
//               value={pricing.costPerKm}
//               onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
//               placeholder="e.g., 4"
//               className="modern-input"
//               min="0"
//               step="0.1"
//             />
//           </div>
//         </div>

//         {selectedRoute && (
//           <div className="pricing-summary">
//             <div className="summary-item">
//               <span>Category Multiplier:</span>
//               <span className="value accent">{getCategoryMultiplier()}x</span>
//             </div>
//             <div className="summary-item">
//               <span>Route Distance:</span>
//               <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
//             </div>
//           </div>
//         )}
//       </div>

//        <PlatformFeeConfig 
//       platformFee={platformFee} 
//       onChange={setPlatformFee} 
//     />

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('basic')}
//         >
//           ← Back
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary generate-matrix-btn"
//           onClick={() => {
//             handleGenerateMatrix();
//             if (fareMatrixUp.length > 0) {
//               setActiveTab('matrix');
//             }
//           }}
//           disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
//         >
//           Generate Fare Matrix
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderMatrixTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Fare Matrix Configuration</h3>
//         <p className="section-subtitle">Review and edit fares for each route</p>
//       </div>

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
//         <div className="matrix-tabs">
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('up')}
//           >
//             Up Route: {selectedRoute.routeName}
//           </button>
//           <button
//             type="button"
//             className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
//             onClick={() => setActiveMatrixTab('down')}
//           >
//             Down Route: Return Route
//           </button>
//         </div>
//       )}

//       {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
//         <>
//           {activeMatrixTab === 'up' && renderMatrix('up')}
//           {activeMatrixTab === 'down' && renderMatrix('down')}
//         </>
//       ) : (
//         renderMatrix('up')
//       )}

//       <div className="matrix-info">
//         <div className="info-card">
//           <div className="info-item">
//             <span className="label">Total Stops:</span>
//             <span className="value">
//               {selectedRoute ?
//                 (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
//             </span>
//           </div>
//           <div className="info-item">
//             <span className="label">Category Multiplier:</span>
//             <span className="value accent">{getCategoryMultiplier()}x</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Base Price:</span>
//             <span className="value">₹{pricing.basePrice}</span>
//           </div>
//           <div className="info-item">
//             <span className="label">Cost/km:</span>
//             <span className="value">₹{pricing.costPerKm}</span>
//           </div>
//         </div>
//       </div>

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('route')}
//         >
//           ← Back to Pricing
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={() => setActiveTab('seats')}
//           disabled={fareMatrixUp.length === 0}
//         >
//           Continue to Seat Layout
//           <span className="btn-icon">→</span>
//         </button>
//       </div>
//     </div>
//   );

//   const renderSeatLayoutTab = () => (
//     <div className="tab-content-wrapper">
//       <div className="section-title">
//         <h3>Seat Layout Configuration</h3>
//         <p className="section-subtitle">Configure seat layout for this bus</p>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">🔧</span>
//           Bus Configuration
//         </h4>
//         <div className="config-selector">
//           <label className="input-label">Select Bus Configuration *</label>
//           {loadingLayouts ? (
//             <div className="loading-configs">
//               <span>Loading configurations...</span>
//             </div>
//           ) : (
//             <>
//               <div className="config-buttons">
//                 {availableConfigurations.map(config => (
//                   <button
//                     key={config}
//                     type="button"
//                     className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
//                     onClick={() => {
//                       setSelectedConfiguration(config);
//                       setSelectedTemplate(null);
//                       setActiveSeats([]);
//                       setCustomSeatLabels({});
//                       fetchLayouts(config);
//                     }}
//                   >
//                     {config}
//                   </button>
//                 ))}
//               </div>
//               <small className="helper-text">
//                 {form.busCategory} bus with {selectedConfiguration} configuration
//               </small>
//             </>
//           )}
//         </div>
//       </div>

//       <div className="section-card">
//         <h4 className="card-title">
//           <span className="title-icon">💺</span>
//           Seat Layout Template
//         </h4>

//         {!selectedTemplate ? (
//           <button
//             type="button"
//             className="modern-btn outline full-width"
//             onClick={openTemplateSelector}
//             disabled={loadingLayouts}
//           >
//             {loadingLayouts ? (
//               <>
//                 <span className="btn-icon">⏳</span>
//                 Loading Layouts...
//               </>
//             ) : (
//               <>
//                 <span className="btn-icon">📋</span>
//                 Select Layout Template
//               </>
//             )}
//           </button>
//         ) : (
//           <div className="selected-template-info">
//             <div className="template-details">
//               <span className="template-name">{selectedTemplate.name}</span>
//               <span className="template-config">{selectedTemplate.configuration}</span>
//               <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
//               <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
//             </div>
//             <button
//               type="button"
//               className="btn-small"
//               onClick={() => {
//                 setSelectedTemplate(null);
//                 setActiveSeats([]);
//                 setCustomSeatLabels({});
//               }}
//             >
//               Change
//             </button>
//           </div>
//         )}
//       </div>

//       {selectedTemplate && (
//         <div className="section-card">
//           <h4 className="card-title">
//             <span className="title-icon">👁️</span>
//             Seat Layout Visualizer
//           </h4>
//           <button
//             type="button"
//             className="view-layout-btn"
//             onClick={() => setShowLayoutModal(true)}
//           >
//             View / Edit Seat Numbers
//           </button>

//           <div className="seat-summary">
//             <div className="summary-item">
//               <span>Total Seats in Template:</span>
//               <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
//             </div>
//             <div className="summary-item">
//               <span>Active Seats:</span>
//               <span className="value accent">{activeSeats.length}</span>
//             </div>
//             <div className="summary-item">
//               <span>Inactive Seats:</span>
//               <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="form-actions">
//         <button
//           type="button"
//           className="modern-btn outline"
//           onClick={() => setActiveTab('matrix')}
//         >
//           ← Back to Matrix
//         </button>
//         <button
//           type="button"
//           className="modern-btn primary"
//           onClick={handleSubmitBus}
//           disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
//         >
//           {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
//           <span className="btn-icon">✓</span>
//         </button>
//       </div>
//     </div>
//   );

//   // Layout Modal and other modals remain the same...
//   const renderLayoutModal = () => (
//     <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//       <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Seat Numbers</h3>
//           <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
//           <div className="seat-legend three-items">
//             <div className="legend-item">
//               <div className="seat-sample selected"></div>
//               <span>Active</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample blocked"></div>
//               <span>Blocked</span>
//             </div>
//             <div className="legend-item">
//               <div className="seat-sample inactive"></div>
//               <span>Disabled</span>
//             </div>
//           </div>
//           {renderSeatVisualizer()}
//           <div className="layout-footer">
//             <span>Total: {activeSeats.length}</span>
//             <div className="footer-actions">
//               <button className="auto-number-btn" onClick={autoRenumberSeats}>
//                 Auto-Number
//               </button>
//               <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderTemplateModal = () => (
//     <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
//       <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Select Seat Layout Template</h3>
//           <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
//         </div>
//         <div className="modal-body">
//           {loadingLayouts ? (
//             <div className="loading-container">
//               <p>Loading templates...</p>
//             </div>
//           ) : layoutTemplates.length === 0 ? (
//             <div className="no-templates">
//               <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
//               <p className="hint">Available configurations with layouts:</p>
//               <div className="available-configs">
//                 {availableConfigurations.map(config => (
//                   <span key={config} className="config-chip">{config}</span>
//                 ))}
//               </div>
//               <p className="hint">Try selecting a different configuration</p>
//             </div>
//           ) : (
//             <div className="templates-grid">
//               {layoutTemplates.map(template => (
//                 <button
//                   type="button"
//                   key={template._id}
//                   className="template-card"
//                   onClick={() => handleSelectTemplate(template)}
//                 >
//                   <h4 className="template-name">{template.name}</h4>
//                   <div className="template-details">
//                     <span className="config">Config: {template.configuration}</span>
//                     <span className="seats">Seats: {template.totalSeats}</span>
//                   </div>
//                   <div className="template-preview">
//                     <span className="rows">Rows: {template.rows}</span>
//                     <span className="cols">Cols: {template.columns}</span>
//                     <span className="seat-type">Type: {template.seatType || 'seat'}</span>
//                   </div>
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   const renderSeatEditModal = () => (
//     <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
//       <div className="modal-content seat-edit-modal" style={{    "max-width": "500px",
//     "max-height": "35vh"}} onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Set Seat Label</h3>
//         </div>
//         <div className="modal-body">
//           <input
//             type="text"
//             value={tempSeatLabel}
//             onChange={(e) => setTempSeatLabel(e.target.value)}
//             placeholder="e.g. 1 or 1A"
//             className="seat-input"
//             autoFocus
//           />
//         </div>
//         <div className="modal-footer three-buttons">
//           <button
//             className="modal-action-btn active-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Active
//           </button>
          
//           <button
//             className="modal-action-btn block-btn"
//             onClick={() => {
//               if (tempSeatLabel.trim() === '') {
//                 toast.error('Please enter a valid seat number');
//                 return;
//               }
//               if (!activeSeats.includes(editingSeat)) {
//                 setActiveSeats([...activeSeats, editingSeat]);
//               }
//               if (!blockedSeats.includes(editingSeat)) {
//                 setBlockedSeats([...blockedSeats, editingSeat]);
//               }
//               setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
//               setEditingSeat(null);
//             }}
//           >
//             Block
//           </button>
//           <button
//             className="modal-action-btn disable-btn"
//             onClick={() => {
//               setActiveSeats(activeSeats.filter(s => s !== editingSeat));
//               setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
//               setEditingSeat(null);
//             }}
//           >
//             Disable
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="modal-overlay modern" onClick={onClose}>
//       <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="modal-header modern">
//           <div className="header-content">
//             <h2 className="modal-title">
//               <span className="title-icon">🚌</span>
//               Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
//             </h2>
//             <p className="modal-subtitle">Configure bus details with route selection</p>
//           </div>
//           <button className="modal-close-btn modern" onClick={onClose}>
//             <span className="close-icon">×</span>
//           </button>
//         </div>

//         <div className="modal-body modern">
//           <ProgressSteps />

//           <div className="tab-container">
//             {activeTab === 'basic' && renderBasicInfoTab()}
//             {activeTab === 'route' && renderRouteTab()}
//             {activeTab === 'matrix' && renderMatrixTab()}
//             {activeTab === 'seats' && renderSeatLayoutTab()}
//           </div>

//           {error && (
//             <div className="error-message modern">
//               <span className="error-icon">⚠️</span>
//               {error}
//             </div>
//           )}
//         </div>
//       </div>

//       {showLayoutModal && renderLayoutModal()}
//       {showTemplateModal && renderTemplateModal()}
//       {editingSeat && renderSeatEditModal()}
//     </div>
//   );
// };
// const BusOwnerManage = () => {
//   const { token } = useSelector(state => state.user);
//   const [busOwners, setBusOwners] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingOwner, setEditingOwner] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingOwner, setViewingOwner] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showAddBusModal, setShowAddBusModal] = useState(false);
//   const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
//   const [busSearchTerm, setBusSearchTerm] = useState('');
//   const [newOwner, setNewOwner] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     companyName: ''
//   });
//   const [error, setError] = useState(null);
//   const [busUpdateTrigger, setBusUpdateTrigger] = useState(0);

//   // Bus Management states - UPDATED for new modal
//   const [showBusManagement, setShowBusManagement] = useState(false);
//   const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
//   const [selectedOwner, setSelectedOwner] = useState(null);
//   const [busDetailsLoading, setBusDetailsLoading] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalOwners, setTotalOwners] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   const getFullImageUrl = (imagePath) => {
//     if (imagePath.startsWith('http')) {
//       return imagePath;
//     }
//     return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
//   };

//   useEffect(() => {
//     fetchBusOwners();
//   }, [currentPage]);



//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchBusOwners();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

// const refreshBusList = async () => {
//   if (!selectedOwner) return;
  
//   try {
//     setBusDetailsLoading(true);
//     const response = await getBusOwnerById(selectedOwner.id, token);
    
//     if (response.success && response.data) {
//       // Try busAll first, fall back to buses array
//       const busData = response.data.busAll || response.data.buses || [];
      
//       const processedBuses = busData.map(bus => {
//         const driver = bus.driver ? {
//           name: bus.driver.name || 'N/A',
//           contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//           licenseNumber: bus.driver.licenseNumber || 'N/A',
//           experience: bus.driver.experience || 0
//         } : null;

//         const conductor = bus.conductor ? {
//           name: bus.conductor.name || 'N/A',
//           contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//         } : null;

//         return { ...bus, driver, conductor };
//       });
      
//       // This updates the buses shown in BusManagementModal
//       setSelectedOwnerBuses(processedBuses);
      
//       setSelectedOwner(prev => ({
//         ...prev,
//         busAll: busData
//       }));
//     }
//   } catch (err) {
//     console.error('Error refreshing bus list:', err);
//     toast.error('Failed to refresh bus list');
//   } finally {
//     setBusDetailsLoading(false);
//   }
// };

//   const fetchBusOwners = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);

//       const response = await getBusOwners(token, currentPage, pageSize, searchTerm);
// console.log("getBusOwners : ",response)
//       if (response && response.success && response.busOwners) {
//         const transformedOwners = response.busOwners.map((owner, index) => ({
//           id: owner._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: owner.profileImage || '',
//           name: owner.name || '',
//           company: owner.companyName || '',
//           email: owner.email || '',
//           phone: owner.phone || '',
//           buses: owner.busCount || 0,
//           routes: owner.routeCount || 0,
//           joined: new Date(owner.createdAt).toISOString().split('T')[0],
//           status: owner.isVerified ? 'Verified' : 'Pending',
//           adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
//           _id: owner._id,
//           isVerified: owner.isVerified,
//           isProfileComplete: owner.isProfileComplete,
//           isApprovedByAdmin: owner.isApprovedByAdmin,
//           activeBuses: owner.activeBuses || 0,
//           driverCount: owner.driverCount || 0,
//           conductorCount: owner.conductorCount || 0,
//           createdAt: owner.createdAt,
//           updatedAt: owner.updatedAt,
//           address: owner.address || {},
//           city: owner.address?.city || '',
//           state: owner.address?.state || owner.state || '',
//           pincode: owner.address?.pincode || '',
//           busAll: owner.busAll || []
//         }));

//         setBusOwners(transformedOwners);

//         if (response.totalPages) {
//           setTotalPages(response.totalPages);
//         }
//         if (response.total) {
//           setTotalOwners(response.total);
//         } else {
//           setTotalOwners(response.busOwners.length);
//         }
//       } else {
//         setError('No bus owners data found in response');
//         setBusOwners([]);
//         setTotalPages(1);
//         setTotalOwners(0);
//       }
//     } catch (err) {
//       console.error('Error fetching bus owners:', err);
//       setError('Failed to fetch bus owners. Please try again.');
//       setBusOwners([]);
//       setTotalPages(1);
//       setTotalOwners(0);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const fetchBusOwnerById = async (id) => {
//     try {
//       const response = await getBusOwnerById(id, token);
//       console.log("response.data : ", response.data)
//       return response.data || response;
//     } catch (err) {
//       console.error('Error fetching bus owner:', err);
//       throw err;
//     }
//   };

// const handleApproveOwner = async (ownerId) => {
//   try {
//     setError(null);
//     const response = await approveBusOwner(ownerId, token);

//     if (response.success) {
//       setBusOwners(prevOwners =>
//         prevOwners.map(owner =>
//           owner.id === ownerId ? {
//             ...owner,
//             isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
//             adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending',
//             // Add these lines to update the status and verification
//             isVerified: response.data?.isVerified || true,
//             status: response.data?.isVerified ? 'Verified' : 'Pending'
//           } : owner
//         )
//       );
//       toast.success('Bus owner approved and verified successfully!');
//     } else {
//       throw new Error(response.message || 'Failed to approve bus owner');
//     }
//   } catch (err) {
//     console.error('Error approving bus owner:', err);
//     setError('Failed to approve bus owner. Please try again.');
//     toast.error('Failed to approve bus owner. Please try again.');
//   }
// };

//   const handleManageBuses = async (owner) => {
//     console.log("handleManageBuses ; ", owner)
//     if (owner.buses === 0) {
//       // alert('This owner has no buses registered.');
//       toast.error("This owner has no buses registered")
//       return;
//     }

//     console.log('Owner bus data:', owner);

//     // Check if busAll exists and has data
//     if (!owner.busAll || owner.busAll.length === 0) {
//       // If no bus data, try to fetch it separately
//       try {
//         setBusDetailsLoading(true);
//         const response = await getBusOwnerById(owner.id, token);

//         if (response.success && response.data && response.data.busAll) {
//           // Update the owner with bus data
//           const updatedOwner = {
//             ...owner,
//             busAll: response.data.busAll || []
//           };

//           // Process the bus data
//           const processedBuses = updatedOwner.busAll.map(bus => {
//             const driver = bus.driver ? {
//               name: bus.driver.name || 'N/A',
//               contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//               licenseNumber: bus.driver.licenseNumber || 'N/A',
//               experience: bus.driver.experience || 0
//             } : null;

//             const conductor = bus.conductor ? {
//               name: bus.conductor.name || 'N/A',
//               contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//             } : null;

//             return {
//               ...bus,
//               driver,
//               conductor
//             };
//           });

//           console.log('Fetched and processed buses:', processedBuses);

//           setSelectedOwner(updatedOwner);
//           setSelectedOwnerBuses(processedBuses);
//           setShowBusManagement(true);
//           setBusSearchTerm('');
//         } else {
//           alert('Could not fetch bus data. Please try again.');
//         }
//       } catch (err) {
//         console.error('Error fetching bus details:', err);
//         alert('Failed to fetch bus details. Please try again.');
//       } finally {
//         setBusDetailsLoading(false);
//       }
//       return;
//     }

//     // If busAll data exists, process it
//     const processedBuses = owner.busAll.map(bus => {
//       const driver = bus.driver ? {
//         name: bus.driver.name || 'N/A',
//         contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
//         licenseNumber: bus.driver.licenseNumber || 'N/A',
//         experience: bus.driver.experience || 0
//       } : null;

//       const conductor = bus.conductor ? {
//         name: bus.conductor.name || 'N/A',
//         contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
//       } : null;

//       return {
//         ...bus,
//         driver,
//         conductor
//       };
//     });

//     console.log('Processed buses:', processedBuses);

//     setSelectedOwner(owner);
//     setSelectedOwnerBuses(processedBuses);
//     setShowBusManagement(true);
//     setBusSearchTerm('');
//   };
//   // Add this function after your other handler functions
//   const filteredBuses = selectedOwnerBuses.filter(bus =>
//     (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
//     (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
//     (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
//   );

//   const handleRejectOwner = async (ownerId) => {
//     if (window.confirm('Are you sure you want to reject this bus owner?')) {
//       try {
//         setError(null);

//         if (!ownerId || typeof ownerId !== 'string') {
//           throw new Error('Invalid owner ID');
//         }

//         const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

//         if (response.success) {
//           setBusOwners(prevOwners =>
//             prevOwners.map(owner =>
//               owner.id === ownerId ? {
//                 ...owner,
//                 isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
//                 adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
//               } : owner
//             )
//           );
//           toast.success('Bus owner rejected successfully!');
//         } else {
//           throw new Error(response.message || 'Failed to reject bus owner');
//         }
//       } catch (err) {
//         console.error('Error rejecting bus owner:', err);
//         setError('Failed to reject bus owner. Please try again.');
//         toast.error('Failed to reject bus owner. Please try again.');
//       }
//     }
//   };

//   const filteredOwners = busOwners;

//   const handleViewOwner = async (owner) => {
//     try {
//       const ownerData = await fetchBusOwnerById(owner.id);
//       setViewingOwner({
//         ...owner,
//         profileImage: ownerData.profileImage || owner.profileImage,
//         name: ownerData.name || owner.name,
//         company: ownerData.companyName || owner.company,
//         email: ownerData.email || owner.email,
//         phone: ownerData.phone || owner.phone,
//         address: ownerData.address || owner.address,
//         isVerified: ownerData.isVerified,
//         isProfileComplete: ownerData.isProfileComplete,
//         isApprovedByAdmin: ownerData.isApprovedByAdmin,

//         // Stats (numbers for the stat cards)
//         busCount: ownerData.stats?.busCount || 0,      // ← renamed to busCount
//         activeBuses: ownerData.stats?.activeBuses || 0,
//         driverCount: ownerData.stats?.driverCount || 0,
//         conductorCount: ownerData.stats?.conductorCount || 0,

//         // Arrays for the detail sections
//         routes: ownerData.routes || [],
//         buses: ownerData.buses || [],                   // ← array only, no conflict

//         status: ownerData.isApprovedByAdmin ? 'Active' : 'Pending',
//         joined: ownerData.createdAt
//           ? new Date(ownerData.createdAt).toLocaleDateString()
//           : owner.joined,
//       });
//     } catch (err) {
//       setViewingOwner(owner);
//       toast.info('Could not fetch latest owner details. Showing cached data.');
//     }
//   };

//   const handleEditOwner = (owner) => {
//     setEditingOwner(owner.id);
//     setEditForm({
//       name: owner.name || '',
//       companyName: owner.company || '',
//       email: owner.email || '',
//       phone: owner.phone || '',
//       status: owner.status || 'Pending',
//       isApprovedByAdmin: owner.isApprovedByAdmin || false
//     });
//   };

//   const closeBusManagement = () => {
//     setShowBusManagement(false);
//     setSelectedOwnerBuses([]);
//     setSelectedOwner(null);
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       if (!editingOwner || typeof editingOwner !== 'string') {
//         throw new Error('Invalid owner ID for editing');
//       }

//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phone: editForm.phone,
//         companyName: editForm.companyName,
//         isVerified: editForm.status === 'Verified',
//         isApprovedByAdmin: editForm.isApprovedByAdmin
//       };

//       const response = await updateBusOwner(editingOwner, updateData, token);

//       if (response.success) {
//         setBusOwners(prevOwners =>
//           prevOwners.map(owner =>
//             owner.id === editingOwner ? {
//               ...owner,
//               name: response.data?.name || editForm.name,
//               company: response.data?.companyName || editForm.companyName,
//               email: response.data?.email || editForm.email,
//               phone: response.data?.phone || editForm.phone,
//               status: response.data?.isVerified ? 'Verified' : 'Pending',
//               isVerified: response.data?.isVerified,
//               isApprovedByAdmin: response.data?.isApprovedByAdmin,
//               adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
//             } : owner
//           )
//         );

//         setEditingOwner(null);
//         setEditForm({});
//         toast.success('Bus owner updated successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to update bus owner');
//       }
//     } catch (err) {
//       console.error('Error updating bus owner:', err);
//       setError('Failed to update bus owner. Please try again.');
//       toast.error('Failed to update bus owner. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingOwner(null);
//     setEditForm({});
//     setError(null);
//   };

//   // const handleDeleteOwner = async (ownerId) => {
//   //   if (window.confirm('Are you sure you want to delete this bus owner?')) {
//   //     try {
//   //       setError(null);
//   //       const response = await deleteBusOwner(ownerId, token);

//   //       if (response.success) {
//   //         setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//   //         setTotalOwners(prev => prev - 1);
//   //         toast.success('Bus owner deleted successfully!');
//   //       } else {
//   //         throw new Error(response.message || 'Failed to delete bus owner');
//   //       }
//   //     } catch (err) {
//   //       console.error('Error deleting bus owner:', err);
//   //       setError('Failed to delete bus owner. Please try again.');
//   //       toast.error('Failed to delete bus owner. Please try again.');
//   //     }
//   //   }
//   // };

//   const handleDeleteOwner = async (ownerId) => {
//   if (window.confirm('Are you sure you want to delete this bus owner?')) {
//     try {
//       setError(null);
//       const response = await deleteBusOwner(ownerId, token);

//       if (response.success) {
//         setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
//         setTotalOwners(prev => prev - 1);
//         toast.success('Bus owner deleted successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to delete bus owner');
//       }
//     } catch (err) {
//       console.error('Error deleting bus owner:', err);
      
//       // Extract the error message from the response
//       const errorMessage = err.response?.data?.message || err.message || 'Failed to delete bus owner. Please try again.';
      
//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   }
// };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleNewOwnerChange = (e) => {
//     const { name, value } = e.target;
//     setNewOwner(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleAddOwner = async () => {
//     try {
//       setError(null);

//       if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
//         toast.error('Please fill in all required fields');
//         return;
//       }

//       const response = await createBusOwner(newOwner, token);
//       console.log("response............ : ", response)
//       if (response.success) {
//         const newOwnerWithId = {
//           id: response.data.id,
//           serialNo: busOwners.length + 1,
//           profileImage: '',
//           name: response.data.name,
//           company: response.data.companyName,
//           email: response.data.email,
//           phone: response.data.phone,
//           buses: 0,
//           routes: 0,
//           joined: new Date(response.data.createdAt).toISOString().split('T')[0],
//           status: 'Pending',
//           adminApproval: 'Pending',
//           isVerified: false,
//           isApprovedByAdmin: false,
//           createdAt: response.data.createdAt
//         };

//         setBusOwners(prev => [newOwnerWithId, ...prev]);
//         setTotalOwners(prev => prev + 1);
//         setShowAddModal(false);
//         setNewOwner({
//           name: '',
//           companyName: '',
//           email: '',
//           phone: ''
//         });
//          setSearchTerm('');
//         toast.success('Bus owner added successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to add bus owner');
//       }
//     } catch (err) {
//       console.error('Error adding bus owner:', err);

//       // Extract error message from the response
//       let errorMessage = 'Failed to add bus owner. Please try again.';

//       if (err.response?.data?.message) {
//         // Get the message from the API response
//         errorMessage = err.response.data.message;
//       } else if (err.message) {
//         errorMessage = err.message;
//       }

//       setError(errorMessage);
//       toast.error(errorMessage);
//     }
//   };

//   const closeViewModal = () => {
//     setViewingOwner(null);
//   };

//   const closeAddModal = () => {
//     setShowAddModal(false);
//     setNewOwner({
//       name: '',
//       companyName: '',
//       email: '',
//       phone: ''
//     });
//     setError(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     // The useEffect will trigger fetchBusOwners automatically
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const currentPageOwners = busOwners;
//   const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
//   const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
//   const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

//   const handleAddBusClick = (owner) => {
//     setSelectedOwnerForBus(owner);
//     setShowAddBusModal(true);
//   };

//   const handleBusAdded = () => {
//     fetchBusOwners();
//     toast.success('Bus added successfully!');
//   };

//   const closeAddBusModal = () => {
//     setShowAddBusModal(false);
//     setSelectedOwnerForBus(null);
//   };

//   if (loading && busOwners.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Bus Owner Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search bus owners by name, company, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Owner
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Owners</h3>
//           <p>{totalOwners}</p>
//           <span>All registered owners</span>
//         </div>
//         <div className="stat-card">
//           <h3>Verified Owners</h3>
//           <p>{verifiedOwners}</p>
//           <span>Verified on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Approved Owners</h3>
//           <p>{approvedOwners}</p>
//           <span>Approved on page {currentPage}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{totalBuses}</p>
//           <span>active fleet</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Profile</th>
//               <th>Owner Name</th>
//               <th>Company</th>
//               <th>Contact</th>
//               <th>Buses</th>
//               <th>Admin Approval</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOwners.length > 0 ? (
//               filteredOwners.map(owner => (
//                 <tr key={owner.id}>
//                   <td>{owner.serialNo}</td>
//                   <td>
//                     <div className="profile-image-cell">
//                       <img
//                         src={getFullImageUrl(owner.profileImage)}
//                         alt={owner.name || 'Bus Owner'}
//                         className="customer-avatar"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                         }}
//                       />
//                     </div>
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Owner Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.name || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <input
//                         type="text"
//                         name="companyName"
//                         value={editForm.companyName || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Company Name"
//                         style={{ width: '100%', padding: '5px' }}
//                       />
//                     ) : (
//                       owner.company || 'N/A'
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{ width: '100%', padding: '5px' }}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div>{owner.email || 'N/A'}</div>
//                         <div className="phone">{owner.phone || 'N/A'}</div>
//                       </div>
//                     )}
//                   </td>

//                   <td>{owner.buses}</td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="isApprovedByAdmin"
//                         value={editForm.isApprovedByAdmin || false}
//                         onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="true">Approved</option>
//                         <option value="false">Pending</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <select
//                         name="status"
//                         value={editForm.status || 'Pending'}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                         style={{ width: '100%', padding: '5px' }}
//                       >
//                         <option value="Verified">Verified</option>
//                         <option value="Pending">Pending</option>
//                         <option value="Suspended">Suspended</option>
//                       </select>
//                     ) : (
//                       <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
//                         {owner.status || 'Pending'}
//                       </span>
//                     )}
//                   </td>

//                   <td>
//                     {editingOwner === owner.id ? (
//                       <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
//                         <button
//                           className="action-btn save"
//                           onClick={handleSaveEdit}
//                           style={{ backgroundColor: '#28a745', color: 'white' }}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="action-btn cancel"
//                           onClick={handleCancelEdit}
//                           style={{ backgroundColor: '#6c757d', color: 'white' }}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewOwner(owner)}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditOwner(owner)}
//                         >
//                           Edit
//                         </button>

//                         <button
//                           className="action-btn add-bus"
//                           onClick={() => handleAddBusClick(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title="Add new bus for this owner"
//                         >
//                           + Add Bus
//                         </button>

//                         <button
//                           className="action-btn manage"
//                           onClick={() => handleManageBuses(owner)}
//                           style={{
//                             backgroundColor: '#007bff',
//                             color: 'white'
//                           }}
//                           title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
//                         >
//                           Manage Buses
//                         </button>

//                         {!owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn approve"
//                             onClick={() => handleApproveOwner(owner.id)}
//                             style={{ backgroundColor: '#28a745' }}
//                           >
//                             Approve
//                           </button>
//                         )}
//                         {owner.isApprovedByAdmin && (
//                           <button
//                             className="action-btn reject"
//                             onClick={() => handleRejectOwner(owner.id)}
//                             style={{ backgroundColor: '#ffc107', color: '#000' }}
//                           >
//                             Reject
//                           </button>
//                         )}
//                         <button
//                           className="action-btn delete"
//                           onClick={() => handleDeleteOwner(owner.id)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="9" className="no-data">
//                   <p>No bus owners found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all bus owners
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {filteredOwners.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No bus owners found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {busOwners.length} of {totalOwners} bus owners
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages || totalPages === 0}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* View Modal */}
//       {/* {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Owner Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="customer-profile-image">
//                   <img
//                     src={getFullImageUrl(viewingOwner.profileImage)}
//                     alt={viewingOwner.name || 'Bus Owner'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                     }}
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Serial No:</label>
//                   <span>{viewingOwner.serialNo}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>ID:</label>
//                   <span>#{viewingOwner.id}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Owner Name:</label>
//                   <span>{viewingOwner.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Company:</label>
//                   <span>{viewingOwner.company || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{viewingOwner.email || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{viewingOwner.phone || 'N/A'}</span>
//                 </div>

//                 <div className="detail-row">
//                   <label>Address:</label>
//                   <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
//                     {viewingOwner.address?.city && (
//                       <span>City: {viewingOwner.address.city}</span>
//                     )}
//                     {viewingOwner.address?.state && (
//                       <span>State: {viewingOwner.address.state}</span>
//                     )}
//                     {viewingOwner.address?.pincode && (
//                       <span>Pincode: {viewingOwner.address.pincode}</span>
//                     )}
//                     {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
//                       <span>N/A</span>
//                     )}
//                   </div>
//                 </div>

//                 <div className="detail-row">
//                   <label>Total Buses:</label>
//                   <span>{viewingOwner.buses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Active Buses:</label>
//                   <span>{viewingOwner.activeBuses || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Drivers:</label>
//                   <span>{viewingOwner.driverCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Conductors:</label>
//                   <span>{viewingOwner.conductorCount || 0}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{viewingOwner.joined}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
//                     {viewingOwner.status || 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Admin Approval:</label>
//                   <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                     {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Profile Complete:</label>
//                   <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Verified:</label>
//                   <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}
//       {/* View Modal */}
//       {viewingOwner && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modern-dashboard-modal" onClick={(e) => e.stopPropagation()}>

//             {/* Header with Glassmorphism */}
//             <header className="dashboard-header">
//               <div className="header-left">
//                 <div className="icon-box"><i className="fas fa-bus"></i></div>
//                 <div>
//                   <h3>Bus Owner Profile</h3>
//                   <span className="subtitle">Management Console</span>
//                 </div>
//               </div>
//               <button className="close-icon-btn" onClick={closeViewModal}>&times;</button>
//             </header>

//             <div className="dashboard-body">

//               {/* Top Section: Profile & Stats Combined */}
//               <section className="profile-overview-card">
//                 <div className="owner-brand">
//                   <div className="avatar-wrapper">
//                     <img
//                       src={getFullImageUrl(viewingOwner.profileImage)}
//                       alt="Profile"
//                       onError={(e) => { e.target.src = ''; }}
//                     />
//                     {viewingOwner.isVerified && <div className="verified-badge"><i className="fas fa-check"></i></div>}
//                   </div>
//                   <div className="brand-details">
//                     <h2>{viewingOwner.name || 'N/A'}</h2>
//                     <p className="owner-id-tag">ID: {viewingOwner.id}</p>
//                     <div className="quick-tags">
//                       <span className={`tag ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
//                         {viewingOwner.isApprovedByAdmin ? 'Verified Partner' : 'Pending Review'}
//                       </span>
//                       <span className="tag city-tag"><i className="fas fa-map-marker-alt"></i> {viewingOwner.address?.city}, {viewingOwner.address?.state}</span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="stats-strip">
//                   <div className="stat-node">
//                     <label>Buses</label>
//                     <div className="value">{viewingOwner.busCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Drivers</label>
//                     <div className="value">{viewingOwner.driverCount || 0}</div>
//                   </div>
//                   <div className="stat-node">
//                     <label>Conductors</label>
//                     <div className="value">{viewingOwner.conductorCount || 0}</div>
//                   </div>
//                 </div>
//               </section>

//               {/* Horizontal Routes List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-route"></i> Active Routes</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.routes?.map((route, index) => (
//                     <div key={index} className="modern-row-card route-row">
//                       <div className="row-main-info">
//                         <div className="route-code">{route.routeNumber}</div>
//                         <div className="journey-stepper">
//                           <span className="">{route.origin?.city}</span>
//                           <div className="connector-line">
//                             <i className="fas fa-chevron-right"></i>
//                           </div>
//                           <span className="">{route.destination?.city}</span>
//                         </div>
//                       </div>
//                       <div className="row-meta-info">
//                         <div className="meta-item"><i className="fas fa-road"></i> {route.routeDetails?.totalDistance} km</div>
//                         <div className="meta-item"><i className="fas fa-clock"></i> {route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</div>
//                         <div className="meta-item bus-pill"><i className="fas fa-bus-alt"></i> {route.busCount} assigned</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </section>

//               {/* Horizontal Buses List */}
//               <section className="content-group">
//                 <div className="section-title">
//                   <h4><i className="fas fa-shuttle-van"></i> Bus Details</h4>
//                 </div>
//                 <div className="row-wise-container">
//                   {viewingOwner.buses?.map((bus, index) => (
//                     <div key={index} className="modern-row-card bus-row">
//                       <div className="bus-identity">
//                         <div className={`status-indicator ${bus.isActive ? 'online' : 'offline'}`}></div>
//                         <div>
//                           <strong>{bus.busName}</strong>
//                           <div className="plate-number">{bus.busNumber}</div>
//                         </div>
//                       </div>

//                       <div className="bus-specs-row">
//                         <span><i className="fas fa-chair"></i> {bus.totalSeats} Seats</span>
//                         <span><i className="fas fa-snowflake"></i> {bus.busType}</span>
//                       </div>

//                       <div className="bus-amenities-tags">
//                         {bus.amenities?.slice(0, 2).map((a, i) => <span key={i} className="mini-tag">{a}</span>)}
//                       </div>

//                       {/* <div className="bus-action-link">
//                   <button className="view-tracking-btn">Live Track</button>
//                 </div> */}
//                     </div>
//                   ))}
//                 </div>
//               </section>

//             </div>

//             <footer className="dashboard-footer">
//               <button className="btn-secondary" onClick={closeViewModal}>close</button>
//             </footer>
//           </div>
//         </div>
//       )}
//       {/* NEW - Modern Bus Management Modal */}
// {/* Update the BusManagementModal component call */}
// {showBusManagement && selectedOwner && (
//   <BusManagementModal
//     key={busUpdateTrigger} // Add this to force re-render
//     owner={selectedOwner}
//     buses={selectedOwnerBuses}
//     onClose={closeBusManagement}
//     onUpdate={async () => {
//       await refreshBusList();
//       await fetchBusOwners();
//     }}
//   />
// )}

//       {/* Add Modal */}
//       {showAddModal && (
//         <div className="modal-overlay" onClick={closeAddModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Bus Owner</h3>
//               <button className="modal-close-btn" onClick={closeAddModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Owner Name *:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={newOwner.name}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter owner name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Company Name *:</label>
//                   <input
//                     type="text"
//                     name="companyName"
//                     value={newOwner.companyName}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter company name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Email *:</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={newOwner.email}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter email address"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone *:</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={newOwner.phone}
//                     onChange={handleNewOwnerChange}
//                     className="edit-input"
//                     placeholder="Enter phone number"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeAddModal}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleAddOwner}>
//                 Add Owner
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add Bus Modal */}
//       {showAddBusModal && selectedOwnerForBus && (
//         <AddBusModal
//           ownerId={selectedOwnerForBus.id}
//           onClose={closeAddBusModal}
//           onBusAdded={handleBusAdded}
//         />
//       )}
//     </div>
//   );
// };

// export default BusOwnerManage;


import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import {
  getBusOwners,
  getBusOwnerById,
  createBusOwner,
  updateBusOwner,
  deleteBusOwner,
  approveBusOwner,
  addBusToOwner,
  getSeatLayoutsByBustype,
  getAllCategory
} from '../../Services/Operations/ProductAPI';
import {
  getDriversByBusOwner,
  getConductorsByBusOwner,
  assignDriverToBus,
  assignConductorToBus,
  unassignDriverFromBus,
  unassignConductorFromBus
} from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify';
import '../../Styles/BusFareChart.css';
import { getAllBusownerAdminRoutes } from '../../Services/Operations/ProductAPI';
import BusManagementModal from './BusManagementModal'; // Import the new modal
import { useNavigate } from 'react-router-dom';

const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-avatar"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Profile</th>
          <th>Owner Name</th>
          <th>Company</th>
          <th>Contact</th>
          <th>Buses</th>
          <th>Admin Approval</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modern-dashboard-modal skeleton">
      <div className="dashboard-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="dashboard-body">
        <div className="skeleton-profile-section"></div>
        <div className="skeleton-stats-strip"></div>
        <div className="skeleton-routes-section"></div>
        <div className="skeleton-buses-section"></div>
      </div>
      <div className="dashboard-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const RouteSelector = ({ value, onChange, onAddNew, token, disabled, loadingRoutes, originCity, destinationCity }) => {
  const [routes, setRoutes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchRoutes = async () => {
    setIsLoading(true);
    try {
      const response = await getAllBusownerAdminRoutes(
        token,
        1,
        100,
        searchTerm,
        '', // busOwnerId - empty to get both admin and busowner routes
        { originCity, destinationCity } // Pass filters
      );
      console.log("getAllBusownerAdminRoutes :::::::::::: ",response)
      if (response && response.success && response.routes) {
        setRoutes(response.routes);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (showDropdown) {
      fetchRoutes();
    }
  }, [showDropdown, searchTerm, originCity, destinationCity]);

  const handleSelect = (route) => {
    onChange(route);
    setShowDropdown(false);
    setSearchTerm('');
  };

  return (
    <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
      <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            type="text"
            value={value ? value.routeName || value.masterRouteName : searchTerm}
            onClick={() => setShowDropdown(!showDropdown)}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setShowDropdown(true);
              if (value) onChange(null);
            }}
            placeholder="Select or search route..."
            className="modern-input"
            disabled={disabled}
            style={{ cursor: 'pointer' }}
          />
          {isLoading && (
            <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
              <div className="spinner-small"></div>
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onAddNew}
          className="btn btn-outline-primary"
          style={{
            padding: '8px 16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            whiteSpace: 'nowrap'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
        >
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>+</span> New Route
        </button>
      </div>

      {showDropdown && (routes.length > 0 || searchTerm) && (
        <div className="master-route-dropdown" style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          zIndex: 1000,
          maxHeight: '300px',
          overflowY: 'auto',
          marginTop: '4px'
        }}>
          {routes.length === 0 ? (
            <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
              {originCity || destinationCity
                ? `No routes found for ${originCity || ''} → ${destinationCity || ''}. Click + to create one.`
                : 'No routes found. Click + to create one.'}
            </div>
          ) : (
            routes.map((route) => (
              <div
                key={route._id}
                className="dropdown-item"
                onClick={() => handleSelect(route)}
                style={{
                  padding: '10px 12px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                  {route.routeNumber || ''} - {route.routeName || route.masterRouteName || 'Route'}
                  {route.creatorType === 'BusOwner' && (
                    <span style={{
                      marginLeft: '8px',
                      fontSize: '10px',
                      backgroundColor: '#ffc107',
                      color: '#000',
                      padding: '2px 6px',
                      borderRadius: '4px'
                    }}>
                      Owner
                    </span>
                  )}
                </div>
                <div style={{ fontSize: '12px', color: '#6c757d' }}>
                  {route.origin?.city} → {route.destination?.city} •
                  {route.isRoundTrip ? ' Round Trip' : ' One Way'} •
                  {route.routeDetails?.totalDistance || 0} km
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
const PlatformFeeConfig = ({ platformFee, onChange }) => {
  return (
    <div className="section-card">
      <h4 className="card-title">
        <span className="title-icon">💰</span>
        Platform Fee Configuration
      </h4>
      
      <div className="platform-fee-container">
        <div className="form-row">
          <div className="form-group">
            <label className="input-label">Fee Type</label>
            <select
              value={platformFee.type}
              onChange={(e) => onChange({ ...platformFee, type: e.target.value })}
              className="modern-select"
            >
              <option value="fixed">Fixed Amount (₹)</option>
              <option value="percentage">Percentage (%)</option>
            </select>
            <small className="helper-text">
              {platformFee.type === 'fixed' 
                ? 'Charge a fixed amount per booking' 
                : 'Charge a percentage of the fare'}
            </small>
          </div>

          {/* <div className="form-group">
            <label className="input-label">
              {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
            </label>
            <input
              type="number"
              min="0"
              step={platformFee.type === 'fixed' ? "1" : "0.1"}
              value={platformFee.value}
              onChange={(e) => onChange({ ...platformFee, value: parseFloat(e.target.value) || 0 })}
              className="modern-input"
              placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
            />
            
          </div> */}

          <div className="form-group">
  <label className="input-label">
    {platformFee.type === 'fixed' ? 'Fee Amount (₹)' : 'Fee Percentage (%)'}
  </label>
  <input
    type="number"
    min="0"
    step={platformFee.type === 'fixed' ? "1" : "0.1"}
    value={platformFee.value === 0 ? '' : platformFee.value}
    onChange={(e) => {
      const rawValue = e.target.value;
      const value = rawValue === '' ? 0 : parseFloat(rawValue);
      onChange({ ...platformFee, value: isNaN(value) ? 0 : value });
    }}
    className="modern-input"
    placeholder={platformFee.type === 'fixed' ? "e.g., 50" : "e.g., 5"}
    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
  />
</div>

          <div className="form-group">
            <label className="input-label">Applicable On</label>
            <select
              value={platformFee.applicableOn}
              onChange={(e) => onChange({ ...platformFee, applicableOn: e.target.value })}
              className="modern-select"
            >
              <option value="per_ticket">Per Ticket</option>
              <option value="per_person">Per Person</option>
              {/* <option value="total_booking">Total Booking Amount</option> */}
            </select>
            {/* <small className="helper-text">
              {platformFee.applicableOn === 'per_ticket' && 'Fee applied on each ticket'}
              {platformFee.applicableOn === 'per_seat' && 'Fee applied on each seat'}
              {platformFee.applicableOn === 'total_booking' && 'Fee applied on total booking amount'}
            </small> */}
          </div>
        </div>

        {/* Preview/Calculation Example */}
        {platformFee.value > 0 && (
          <div className="fee-preview">
            <div className="preview-title">Fee Calculation Preview:</div>
            <div className="preview-details">
              <span>
                {platformFee.type === 'fixed' 
                  ? `₹${platformFee.value} ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
                     platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`
                  : `${platformFee.value}% of fare ${platformFee.applicableOn === 'per_ticket' ? 'per ticket' : 
                     platformFee.applicableOn === 'per_seat' ? 'per seat' : 'per booking'}`}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const AddBusModal = ({ ownerId, onClose, onBusAdded }) => {
  const { token } = useSelector(state => state.user);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('basic');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [selectedConfiguration, setSelectedConfiguration] = useState('2*2');
  const [availableConfigurations, setAvailableConfigurations] = useState(['2*2']);
  const [blockedSeats, setBlockedSeats] = useState([]);
  const [cancellationTime, setCancellationTime] = useState({
  hours: 1,
  minutes: 0
});

   const [platformFee, setPlatformFee] = useState({
    type: 'fixed',
    value: 0,
    applicableOn: 'per_ticket'
  });

  // Booking Closed Before State
  const [bookingClosedBefore, setBookingClosedBefore] = useState({
    hours: 1,
    minutes: 0
  });

  // Bus Form State
  const [form, setForm] = useState({
    busNumber: '',
    busName: '',
    busType: 'Non-AC',
    busCategory: 'Seater',
    amenities: []
  });

  // Trip Type State
  const [tripType, setTripType] = useState('oneWay');
  const [activeMatrixTab, setActiveMatrixTab] = useState('up');

  // Route States - NEW: Source & Destination instead of RouteSelector
  const [sourceCity, setSourceCity] = useState('');
  const [destinationCity, setDestinationCity] = useState('');
  const [availableRoutes, setAvailableRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [loadingRoutes, setLoadingRoutes] = useState(false);
  const [showRouteDropdown, setShowRouteDropdown] = useState(false);
  const [routeSearchTerm, setRouteSearchTerm] = useState('');

  // Seat Layout States
  const [layoutTemplates, setLayoutTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [activeSeats, setActiveSeats] = useState([]);
  const [customSeatLabels, setCustomSeatLabels] = useState({});
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [loadingLayouts, setLoadingLayouts] = useState(false);
  const [editingSeat, setEditingSeat] = useState(null);
  const [tempSeatLabel, setTempSeatLabel] = useState('');

  // Pricing States
  const [pricing, setPricing] = useState({
    basePrice: '',
    baseDistance: '',
    costPerKm: ''
  });

  // Fare Matrices
  const [fareMatrixUp, setFareMatrixUp] = useState([]);
  const [fareMatrixDown, setFareMatrixDown] = useState([]);

  // Operating Days
  const [operatingDays, setOperatingDays] = useState([
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ]);

  // Image States
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Add this new state alongside existing route states
const [localRouteNameSearch, setLocalRouteNameSearch] = useState('');
const [localRouteSearchLoading, setLocalRouteSearchLoading] = useState(false);

  // Constants
  const BUS_TYPES = ['AC', 'Non-AC', 'Volvo', 'Sleeper'];
  const BUS_CATEGORIES = ['Seater', 'Sleeper', 'Seater+Sleeper'];
  const AMENITIES_LIST = [
    'WiFi', 'Charging Point', 'Blankets', 'Water Bottle',
    'Reading Light', 'CCTV', 'Emergency Exit', 'TV', 'Snacks',
    'GPS Tracking', 'SOS Switch'
  ];
  const DAYS_OF_WEEK = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ];

  // Add this function to handle cancellation time changes
const handleCancellationTimeChange = (field, value) => {
  setCancellationTime(prev => ({
    ...prev,
    [field]: parseInt(value) || 0
  }));
};

// Add validation for cancellation time (add to validateBookingTime function or create new)
const validateCancellationTime = () => {
  const totalMinutes = (cancellationTime.hours * 60) + cancellationTime.minutes;
  if (totalMinutes < 0) {
    toast.error('Cancellation time cannot be negative');
    return false;
  }
  if (cancellationTime.hours > 48) {
    toast.error('Cancellation hours cannot exceed 48');
    return false;
  }
  if (cancellationTime.minutes > 59) {
    toast.error('Minutes cannot exceed 59');
    return false;
  }
  
  // Optional: Validate against booking closed time
  const bookingMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
  if (totalMinutes >= bookingMinutes) {
    toast.warning('Cancellation time should be less than booking cut-off time for practical purposes');
  }
  return true;
};

// Add this new function alongside fetchRoutesBySourceDestination
const fetchRoutesByLocalName = async (localName) => {
  if (!localName || !localName.trim()) {
    setAvailableRoutes([]);
    return;
  }

  setLocalRouteSearchLoading(true);
  setLoadingRoutes(true);
  try {
    const response = await getAllBusownerAdminRoutes(
      token,
      1,
      50,
      '',   // search
      '',   // busOwnerId
      {},   // no city filters
      localName.trim()  // localRouteName ← NEW param
    );

    if (response && response.success && response.routes) {
      setAvailableRoutes(response.routes);
    } else {
      setAvailableRoutes([]);
    }
  } catch (error) {
    console.error('Error fetching routes by local name:', error);
    toast.error('Failed to fetch routes');
    setAvailableRoutes([]);
  } finally {
    setLocalRouteSearchLoading(false);
    setLoadingRoutes(false);
  }
};

  // Fetch routes based on source and destination
  const fetchRoutesBySourceDestination = async () => {
    if (!sourceCity || !destinationCity) {
      setAvailableRoutes([]);
      return;
    }

    setLoadingRoutes(true);
    try {
      const response = await getAllBusownerAdminRoutes(
        token,
        1,
        50,
        '',
        '',
        { originCity: sourceCity, destinationCity: destinationCity }
      );
      
      if (response && response.success && response.routes) {
        setAvailableRoutes(response.routes);
      } else {
        setAvailableRoutes([]);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
      toast.error('Failed to fetch routes');
      setAvailableRoutes([]);
    } finally {
      setLoadingRoutes(false);
    }
  };

  // Add this useEffect alongside the existing city-based useEffect
useEffect(() => {
  const timer = setTimeout(() => {
    if (localRouteNameSearch.trim()) {
      // Clear city inputs when searching by local name
      fetchRoutesByLocalName(localRouteNameSearch);
    }
  }, 500);
  return () => clearTimeout(timer);
}, [localRouteNameSearch]);

  // Debounced fetch when source or destination changes
  useEffect(() => {
    const timer = setTimeout(() => {
      if (sourceCity && destinationCity) {
        fetchRoutesBySourceDestination();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [sourceCity, destinationCity]);

  // Filter routes based on search term
  const filteredRoutes = availableRoutes.filter(route =>
    route.routeName?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
    route.routeNumber?.toLowerCase().includes(routeSearchTerm.toLowerCase()) ||
  route.localRouteName?.toLowerCase().includes(routeSearchTerm.toLowerCase())  // ← ADD
  );

  const handleSelectRoute = (route) => {
    setSelectedRoute(route);
    setShowRouteDropdown(false);
    setRouteSearchTerm('');
    setFareMatrixUp([]);
    setFareMatrixDown([]);
  };

  useEffect(() => {
    const savedData = localStorage.getItem('pendingBusFormData');
    if (savedData) {
      const formData = JSON.parse(savedData);
      if (window.confirm('You have unsaved bus data. Would you like to restore it?')) {
        setForm(prev => ({
          ...prev,
          busNumber: formData.busNumber || '',
          busName: formData.busName || '',
          busType: formData.busType || 'AC',
          busCategory: formData.busCategory || 'Seater',
          amenities: formData.amenities || []
        }));
        setTripType(formData.tripType || 'oneWay');
        setPricing(formData.pricing || { basePrice: '', baseDistance: '', costPerKm: '' });
        setOperatingDays(formData.operatingDays || DAYS_OF_WEEK);
        if (formData.bookingClosedBefore) {
          setBookingClosedBefore(formData.bookingClosedBefore);
        }
        setSelectedConfiguration(formData.selectedConfiguration || '2*2');
        localStorage.removeItem('pendingBusFormData');
      } else {
        localStorage.removeItem('pendingBusFormData');
      }
    }
  }, []);

  const handleAddNewRoute = () => {
    const currentFormData = {
      busNumber: form.busNumber,
      busName: form.busName,
      busType: form.busType,
      busCategory: form.busCategory,
      amenities: form.amenities,
      tripType: tripType,
      pricing: pricing,
      operatingDays: operatingDays,
      bookingClosedBefore: bookingClosedBefore,
      selectedConfiguration: selectedConfiguration,
    };
    localStorage.setItem('pendingBusFormData', JSON.stringify(currentFormData));

    toast.info('Redirecting to create route. Your current bus form data has been saved.');

    navigate('/routes', {
      state: {
        returnTo: 'busowners',
        ownerId: ownerId,
        formData: currentFormData,
        sourceCity: sourceCity,
        destinationCity: destinationCity
      }
    });
  };

  const validateBookingTime = () => {
    const totalMinutes = (bookingClosedBefore.hours * 60) + bookingClosedBefore.minutes;
    if (totalMinutes < 0) {
      toast.error('Booking close time cannot be negative');
      return false;
    }
    if (bookingClosedBefore.hours > 24) {
      toast.error('Booking close hours cannot exceed 24');
      return false;
    }
    if (bookingClosedBefore.minutes > 59) {
      toast.error('Minutes cannot exceed 59');
      return false;
    }
    return true;
  };

  const handleBookingTimeChange = (field, value) => {
    setBookingClosedBefore(prev => ({
      ...prev,
      [field]: parseInt(value) || 0
    }));
  };

  // Fetch configurations when category changes
  useEffect(() => {
    if (form.busCategory) {
      fetchAvailableConfigurations();
    }
  }, [form.busCategory, token]);

  const getCategoryMultiplier = () => {
    const multipliers = {
      'Seater': 1.0,
      'Sleeper': 1.5,
      'Seater+Sleeper': 1.3
    };
    return multipliers[form.busCategory] || 1.0;
  };

  const getStopColor = (type) => {
    switch (type) {
      case 'origin': return '#4c51bf';
      case 'destination': return '#40c057';
      default: return '#667eea';
    }
  };

  const fetchAvailableConfigurations = async () => {
    try {
      setLoadingLayouts(true);
      const response = await getAllCategory(token);

      if (response && response.success && response.data) {
        let relevantCategories = response.data;

        if (form.busCategory === 'Seater') {
          relevantCategories = response.data.filter(cat =>
            cat.availableSeatTypes?.includes('seat') ||
            cat.availableSeatTypes?.includes('seater')
          );
        } else if (form.busCategory === 'Sleeper') {
          relevantCategories = response.data.filter(cat =>
            cat.availableSeatTypes?.includes('sleeper')
          );
        } else if (form.busCategory === 'Seater+Sleeper') {
          relevantCategories = response.data.filter(cat =>
            cat.availableSeatTypes?.includes('seater+sleeper') ||
            cat.availableSeatTypes?.includes('seat+sleeper')
          );
        }

        const configs = [...new Set(relevantCategories.map(cat => cat.configuration))];

        if (configs.length > 0) {
          setAvailableConfigurations(configs);
          setSelectedConfiguration(configs[0]);
          setLayoutTemplates([]);
        } else {
          setAvailableConfigurations([]);
          setLayoutTemplates([]);
          toast.info(`No configurations available for ${form.busCategory}`);
        }
      }
    } catch (error) {
      console.error('Error fetching configurations:', error);
      setAvailableConfigurations([]);
    } finally {
      setLoadingLayouts(false);
    }
  };

  const fetchLayouts = async (config) => {
    try {
      if (!config) return;

      setLoadingLayouts(true);

      let bustype = config.replace('x', '*');

      const response = await getSeatLayoutsByBustype(bustype, token);

      if (response && response.success) {
        if (response.data && Array.isArray(response.data)) {
          let filteredLayouts = response.data;

          if (form.busCategory === 'Seater') {
            filteredLayouts = response.data.filter(layout =>
              layout.seatType === 'seat' || layout.seatType === 'seater'
            );
          } else if (form.busCategory === 'Sleeper') {
            filteredLayouts = response.data.filter(layout =>
              layout.seatType === 'sleeper'
            );
          } else if (form.busCategory === 'Seater+Sleeper') {
            filteredLayouts = response.data.filter(layout =>
              layout.seatType === 'seater+sleeper' || layout.seatType === 'seat+sleeper'
            );
          }

          setLayoutTemplates(filteredLayouts);

          if (filteredLayouts.length === 0) {
            toast.info(`No ${form.busCategory} layouts found for ${config} configuration`);
          }
        } else {
          setLayoutTemplates([]);
          toast.info(`No layouts found for ${config} configuration`);
        }
      } else {
        console.error('Failed to fetch layouts:', response);
        setLayoutTemplates([]);
        toast.error(response?.message || 'Failed to load seat layouts');
      }
    } catch (error) {
      console.error("Layout Fetch Error:", error);
      toast.error('Failed to load seat layouts: ' + (error.message || 'Unknown error'));
      setLayoutTemplates([]);
    } finally {
      setLoadingLayouts(false);
    }
  };

  const handleCategoryChange = (category) => {
    setForm(prev => ({ ...prev, busCategory: category }));
    setSelectedTemplate(null);
    setActiveSeats([]);
    setLayoutTemplates([]);
    setCustomSeatLabels({});
  };

  // const handleImageUpload = (event) => {
  //   const files = Array.from(event.target.files);
  //   const newImages = [];

  //   files.forEach(file => {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       newImages.push({
  //         file: file,
  //         preview: e.target.result,
  //         name: file.name
  //       });

  //       if (newImages.length === files.length) {
  //         setSelectedImages(prev => [...prev, ...newImages]);
  //       }
  //     };
  //     reader.readAsDataURL(file);
  //   });
  // };

  const handleImageUpload = (event) => {
  const files = Array.from(event.target.files);
  console.log('📸 Files selected for upload:', files.length);
  
  const newImages = [];

  files.forEach((file, index) => {
    console.log(`File ${index + 1}: ${file.name} (${file.size} bytes, ${file.type})`);
    
    // ✅ Ensure it's a valid file
    if (!(file instanceof File)) {
      console.error(`❌ File ${index + 1} is not a File object`);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      newImages.push({
        file: file, // Store the actual File object
        preview: e.target.result, // Store preview URL for display
        name: file.name,
        size: file.size,
        type: file.type
      });

      if (newImages.length === files.length) {
        setSelectedImages(prev => [...prev, ...newImages]);
        console.log(`✅ Added ${newImages.length} images. Total: ${selectedImages.length + newImages.length}`);
      }
    };
    reader.onerror = (error) => {
      console.error('❌ Error reading file:', error);
    };
    reader.readAsDataURL(file);
  });
};

  const removeImage = (index) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedVideo({
          file: file,
          preview: e.target.result,
          name: file.name,
          size: file.size
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const removeVideo = () => {
    setSelectedVideo(null);
  };

  const openTemplateSelector = () => {
    if (!form.busCategory) {
      toast.error('Please select a Bus Category first');
      return;
    }
    if (!selectedConfiguration) {
      toast.error('Please select a Bus Configuration first');
      return;
    }
    if (layoutTemplates.length === 0) {
      toast.error(`No layouts available for ${selectedConfiguration}. Please try a different configuration.`);
      return;
    }
    setShowTemplateModal(true);
  };

  const handleSelectTemplate = (template) => {
    setSelectedTemplate(template);
    setActiveSeats([]);
    setBlockedSeats([]);
    setCustomSeatLabels({});
    setShowTemplateModal(false);
    setShowLayoutModal(true);
    toast.success(`Selected template: ${template.name}`);
  };

  const handleSeatPress = (seatObj) => {
    setEditingSeat(seatObj.seatNumber);
    if (activeSeats.includes(seatObj.seatNumber)) {
      setTempSeatLabel(String(customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber));
    } else {
      setTempSeatLabel(String(seatObj.globalSeatIndex || seatObj.seatNumber));
    }
  };

  const autoRenumberSeats = () => {
    const sortedSeats = [...(selectedTemplate.seats || [])].sort((a, b) => {
      if (a.row === b.row) return a.column - b.column;
      return a.row - b.row;
    });

    let counter = 1;
    const newLabels = {};

    sortedSeats.forEach(s => {
      if (activeSeats.includes(s.seatNumber)) {
        newLabels[s.seatNumber] = String(counter++);
      }
    });

    setCustomSeatLabels(newLabels);
  };

  const toggleDay = (day) => {
    setOperatingDays(prev =>
      prev.includes(day)
        ? prev.filter(d => d !== day)
        : [...prev, day]
    );
  };

// const generateMatrixForRoute = (routeData) => {
//   if (!routeData) return [];
 
//   const baseP = parseFloat(pricing.basePrice) || 0;
//   const baseD = parseFloat(pricing.baseDistance) || 0;
//   const costK = parseFloat(pricing.costPerKm) || 0;
//   const multiplier = getCategoryMultiplier();
 
//   const sortedStops = [...(routeData.intermediateStops || [])]
//     .sort((a, b) => a.sequence - b.sequence);
 
//   // ✅ FIX 1: Store distances rounded to 1 decimal using integer math
//   const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;
 
//   const allStops = [
//     {
//       id: 'origin',
//       name: routeData.origin?.city || 'Origin',
//       distanceFromOrigin: 0,
//       type: 'origin'
//     },
//     ...sortedStops.map((s, i) => ({
//       id: s._id || `stop_${i}`,
//       name: s.city || s.name || `Stop ${i + 1}`,
//       distanceFromOrigin: toSafeDistance(s.distanceFromOrigin),
//       type: 'stop',
//       sequence: s.sequence
//     })),
//     {
//       id: 'destination',
//       name: routeData.destination?.city || 'Destination',
//       distanceFromOrigin: toSafeDistance(
//         routeData.destination?.distanceFromOrigin ||
//         routeData.routeDetails?.totalDistance ||
//         0
//       ),
//       type: 'destination'
//     }
//   ];
 
//   const matrix = allStops.map((fromStop, i) => {
//     const toCells = allStops.map((toStop, j) => {
//       if (j > i) {
//         // ✅ FIX 2: Use integer subtraction (×10) to avoid floating point drift
//         // e.g., 178 - 0 = 178 exactly, not 177.9999...
//         const fromInt = Math.round(fromStop.distanceFromOrigin * 10);
//         const toInt   = Math.round(toStop.distanceFromOrigin * 10);
//         const distance = (toInt - fromInt) / 10; // back to km with 1 decimal
 
//         // ✅ FIX 3: Round extraDistance before multiplying to avoid drift
//         let price = baseP;
//         if (distance > baseD) {
//           const extraDistance = Math.round((distance - baseD) * 10) / 10;
//           price = baseP + (extraDistance * costK);
//         }
 
//         // ✅ FIX 4: Round AFTER applying multiplier
//         price = Math.round(price * multiplier);
 
//         return {
//           toId: toStop.id,
//           toName: toStop.name,
//           distanceKm: distance,
//           price: price
//         };
//       }
//       return null;
//     });
 
//     return {
//       fromId: fromStop.id,
//       fromName: fromStop.name,
//       fromType: fromStop.type,
//       sequence: fromStop.sequence,
//       toCells: toCells
//     };
//   });
 
//   return matrix.filter(row => row.fromId !== 'destination');
// };

const generateMatrixForRoute = (routeData) => {
  if (!routeData) return [];

  const baseP = parseFloat(pricing.basePrice) || 0;
  const baseD = parseFloat(pricing.baseDistance) || 0;
  const costK = parseFloat(pricing.costPerKm) || 0;
  const multiplier = getCategoryMultiplier();

  const toSafeDistance = (val) => Math.round(parseFloat(val || 0) * 10) / 10;

  const sortedStops = [...(routeData.intermediateStops || [])]
    .sort((a, b) => a.sequence - b.sequence);

  // Build raw stops
  const rawStops = [
    {
      id: 'origin',
      name: routeData.origin?.city || 'Origin',
      rawDist: toSafeDistance(routeData.origin?.distanceFromOrigin || 0),
      type: 'origin'
    },
    ...sortedStops.map((s, i) => ({
      id: s._id || `stop_${i}`,
      name: s.city || s.name || `Stop ${i + 1}`,
      rawDist: toSafeDistance(s.distanceFromOrigin),
      type: 'stop',
      sequence: s.sequence
    })),
    {
      id: 'destination',
      name: routeData.destination?.city || 'Destination',
      rawDist: toSafeDistance(
        routeData.destination?.distanceFromOrigin ||
        routeData.routeDetails?.totalDistance ||
        0
      ),
      type: 'destination'
    }
  ];

  // ✅ CORE FIX: Find min and max raw distances
  const allRawDists = rawStops.map(s => s.rawDist);
  const minDist = Math.min(...allRawDists);
  const maxDist = Math.max(...allRawDists);

  // Check if this is a descending route (DOWN) - origin has higher dist than destination
  const originRaw = rawStops[0].rawDist;
  const destRaw   = rawStops[rawStops.length - 1].rawDist;
  const isDescending = destRaw < originRaw;

  // Normalize every stop to 0-based ascending distance
  const normalizedStops = rawStops.map(stop => ({
    ...stop,
    distanceFromOrigin: isDescending
      ? toSafeDistance(maxDist - stop.rawDist)   // flip: high→0, low→high
      : toSafeDistance(stop.rawDist - minDist)    // shift to 0-base
  }));

  // ✅ ALWAYS sort by normalized distance ascending — this is the key fix
  // Without this sort, column indices don't match ascending distance order
  // and j > i produces negative (toInt - fromInt) values
  const allStops = normalizedStops.sort(
    (a, b) => a.distanceFromOrigin - b.distanceFromOrigin
  );

  // Build matrix — with sorted stops, j > i ALWAYS means further stop
  const matrix = allStops.map((fromStop, i) => {
    const toCells = allStops.map((toStop, j) => {
      if (j > i) {
        const fromInt  = Math.round(fromStop.distanceFromOrigin * 10);
        const toInt    = Math.round(toStop.distanceFromOrigin * 10);
        // ✅ Math.abs as final safety — can never be negative after sort
        const distance = Math.abs((toInt - fromInt) / 10);

        let price = baseP;
        if (distance > baseD) {
          const extraDistance = Math.round((distance - baseD) * 10) / 10;
          price = baseP + (extraDistance * costK);
        }
        price = Math.round(price * multiplier);

        return {
          toId: toStop.id,
          toName: toStop.name,
          distanceKm: distance,
          price: price
        };
      }
      return null;
    });

    return {
      fromId: fromStop.id,
      fromName: fromStop.name,
      fromType: fromStop.type,
      sequence: fromStop.sequence,
      toCells: toCells
    };
  });

  return matrix.filter(row => row.fromId !== 'destination');
};

  const handleGenerateMatrix = () => {
    if (!selectedRoute) {
      toast.error('Please select a Route first.');
      return;
    }

    if (tripType === 'roundTrip' && !selectedRoute.returnJourney) {
      toast.error("The selected route does not have return journey details configured.");
      return;
    }

    if (!pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm) {
      toast.error('Please fill all Pricing Fields.');
      return;
    }

    const matrixUp = generateMatrixForRoute(selectedRoute);
    setFareMatrixUp(matrixUp);

    if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
      const matrixDown = generateMatrixForRoute(selectedRoute.returnJourney);
      setFareMatrixDown(matrixDown);
    } else {
      setFareMatrixDown([]);
    }

    toast.success(tripType === 'roundTrip'
      ? "Both Fare Matrices Generated!"
      : "Fare Matrix Generated!"
    );
  };

  const handlePriceChange = (type, rowIndex, colIndex, newPrice) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? [...fareMatrixUp] : [...fareMatrixDown];

    const updatedMatrix = currentMatrix.map((row, rIndex) => {
      if (rIndex !== rowIndex) return row;
      const newToCells = [...row.toCells];
      if (newToCells[colIndex]) {
        newToCells[colIndex] = {
          ...newToCells[colIndex],
          price: parseInt(newPrice) || 0
        };
      }
      return { ...row, toCells: newToCells };
    });

    if (isUp) {
      setFareMatrixUp(updatedMatrix);
    } else {
      setFareMatrixDown(updatedMatrix);
    }
  };

  const getSeatPosition = (column) => {
    switch (parseInt(column)) {
      case 1: return 'window';
      case 2: return 'middle';
      case 3: return 'aisle';
      case 4: return 'window';
      default: return 'aisle';
    }
  };

  // const handleSubmitBus = async () => {
  //   try {
  //     setIsSubmitting(true);
  //     setError(null);

  //     if (!validateBookingTime()) {
  //       setIsSubmitting(false);
  //       return;
  //     }

  //     if (!form.busNumber) throw new Error('Bus Number is required');
  //     if (!form.busName) throw new Error('Bus Name is required');
  //     if (!form.busType) throw new Error('Bus Type is required');
  //     if (!form.busCategory) throw new Error('Bus Category is required');
  //     if (!selectedRoute) throw new Error('Please select a route');
  //     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
  //     if (!selectedTemplate) throw new Error('Please configure seat layout');
  //     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

  //     const amenitiesArray = form.amenities || [];

  //     const finalSeatsPayload = selectedTemplate.seats
  //       .filter(s => activeSeats.includes(s.seatNumber))
  //       .map(s => {
  //         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
  //         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
  //         const isBlocked = blockedSeats.includes(s.seatNumber);

  //         return {
  //           seatNumber: s.seatNumber,
  //           globalSeatIndex: finalGlobalIndex,
  //           row: s.row,
  //           column: s.column,
  //           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
  //           position: s.position || getSeatPosition(s.column),
  //           isBlocked: isBlocked,
  //           isAvailable: !isBlocked,
  //         };
  //       });

  //     const seatConfigPayload = {
  //       busType: selectedTemplate.configuration || '2*2',
  //       totalSeats: activeSeats.length
  //     };

  //     const routeSchedules = [];
  //     const routeIdToSave = selectedRoute._id || selectedRoute.id;

  //     routeSchedules.push({
  //       routeId: routeIdToSave,
  //       direction: 'UP',
  //       fareMatrix: fareMatrixUp,
  //       operatingDays: operatingDays,
  //       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
  //       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
  //     });

  //     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
  //       routeSchedules.push({
  //         routeId: routeIdToSave,
  //         direction: 'DOWN',
  //         fareMatrix: fareMatrixDown,
  //         operatingDays: operatingDays,
  //         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
  //         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
  //       });
  //     }

  //     const fareDetails = {
  //       basePrice: parseFloat(pricing.basePrice) || 0,
  //       baseDistance: parseFloat(pricing.baseDistance) || 0,
  //       costPerKm: parseFloat(pricing.costPerKm) || 0
  //     };

  //     const formData = new FormData();

  //     formData.append('busNumber', form.busNumber.toUpperCase().trim());
  //     formData.append('busName', form.busName.trim());
  //     formData.append('busType', form.busType);
  //     formData.append('busCategory', form.busCategory);
  //     formData.append('totalSeats', String(activeSeats.length));
  //     formData.append('tripType', tripType);
  //     formData.append('busClass', 'Economy');

  //     formData.append('amenities', JSON.stringify(amenitiesArray));
  //     formData.append('seats', JSON.stringify(finalSeatsPayload));
  //     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
  //     formData.append('routeSchedules', JSON.stringify(routeSchedules));
  //     formData.append('fareDetails', JSON.stringify(fareDetails));
  //     formData.append('operatingDays', JSON.stringify(operatingDays));
  //     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));

  //     selectedImages.forEach((img, index) => {
  //       if (img.file) {
  //         formData.append('images', img.file);
  //       }
  //     });

  //     if (selectedVideo && selectedVideo.file) {
  //       formData.append('videos', selectedVideo.file);
  //     }

  //     const response = await addBusToOwner(ownerId, formData, token);

  //     if (response && response.success) {
  //       toast.success(tripType === 'roundTrip'
  //         ? 'Bus added successfully with round trip routes!'
  //         : 'Bus added successfully!'
  //       );
  //       onBusAdded();
  //       onClose();
  //     } else {
  //       throw new Error(response?.message || 'Failed to add bus');
  //     }

  //   } catch (err) {
  //     console.error('Error adding bus:', err);
  //     setError(err.message || 'Failed to add bus');
  //     toast.error(err.message || 'Failed to add bus');
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

//   const handleSubmitBus = async () => {
//   try {
//     setIsSubmitting(true);
//     setError(null);

//     if (!validateBookingTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//         if (!validateCancellationTime()) {
//       setIsSubmitting(false);
//       return;
//     }

//     if (!form.busNumber) throw new Error('Bus Number is required');
//     if (!form.busName) throw new Error('Bus Name is required');
//     if (!form.busType) throw new Error('Bus Type is required');
//     if (!form.busCategory) throw new Error('Bus Category is required');
//     if (!selectedRoute) throw new Error('Please select a route');
//     if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
//     if (!selectedTemplate) throw new Error('Please configure seat layout');
//     if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

//     const amenitiesArray = form.amenities || [];

//     const finalSeatsPayload = selectedTemplate.seats
//       .filter(s => activeSeats.includes(s.seatNumber))
//       .map(s => {
//         const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
//         const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
//         const isBlocked = blockedSeats.includes(s.seatNumber);

//         return {
//           seatNumber: s.seatNumber,
//           globalSeatIndex: finalGlobalIndex,
//           row: s.row,
//           column: s.column,
//           seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
//           position: s.position || getSeatPosition(s.column),
//           isBlocked: isBlocked,
//           isAvailable: !isBlocked,
//         };
//       });

//     const seatConfigPayload = {
//       busType: selectedTemplate.configuration || '2*2',
//       totalSeats: activeSeats.length
//     };

//     const routeSchedules = [];
//     const routeIdToSave = selectedRoute._id || selectedRoute.id;

//     routeSchedules.push({
//       routeId: routeIdToSave,
//       direction: 'UP',
//       fareMatrix: fareMatrixUp,
//       operatingDays: operatingDays,
//       departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
//       arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
//     });

//     if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
//       routeSchedules.push({
//         routeId: routeIdToSave,
//         direction: 'DOWN',
//         fareMatrix: fareMatrixDown,
//         operatingDays: operatingDays,
//         departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
//         arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
//       });
//     }

//     const fareDetails = {
//       basePrice: parseFloat(pricing.basePrice) || 0,
//       baseDistance: parseFloat(pricing.baseDistance) || 0,
//       costPerKm: parseFloat(pricing.costPerKm) || 0
//     };

//     // Platform Fee object
//     const platformFeeData = {
//       type: platformFee.type,
//       value: platformFee.value,
//       applicableOn: platformFee.applicableOn
//     };

//     const formData = new FormData();

//     formData.append('busNumber', form.busNumber.toUpperCase().trim());
//     formData.append('busName', form.busName.trim());
//     formData.append('busType', form.busType);
//     formData.append('busCategory', form.busCategory);
//     formData.append('totalSeats', String(activeSeats.length));
//     formData.append('tripType', tripType);
//     formData.append('busClass', 'Economy');

//     formData.append('cancellationTime', JSON.stringify(cancellationTime));

//     formData.append('amenities', JSON.stringify(amenitiesArray));
//     formData.append('seats', JSON.stringify(finalSeatsPayload));
//     formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
//     formData.append('routeSchedules', JSON.stringify(routeSchedules));
//     formData.append('fareDetails', JSON.stringify(fareDetails));
//     formData.append('operatingDays', JSON.stringify(operatingDays));
//     formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
    
//     // Append platform fee data
//     formData.append('platformFee', JSON.stringify(platformFeeData));

//     selectedImages.forEach((img, index) => {
//       if (img.file) {
//         formData.append('images', img.file);
//       }
//     });

//     if (selectedVideo && selectedVideo.file) {
//       formData.append('videos', selectedVideo.file);
//     }

//     const response = await addBusToOwner(ownerId, formData, token);

//     if (response && response.success) {
//       toast.success(tripType === 'roundTrip'
//         ? 'Bus added successfully with round trip routes!'
//         : 'Bus added successfully!'
//       );
//       onBusAdded();
//       onClose();
//     } else {
//       throw new Error(response?.message || 'Failed to add bus');
//     }

//   } catch (err) {
//     console.error('Error adding bus:', err);
//     setError(err.message || 'Failed to add bus');
//     toast.error(err.message || 'Failed to add bus');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

const handleSubmitBus = async () => {
  try {
    setIsSubmitting(true);
    setError(null);

    // ✅ DEBUG: Log selected images before submit
    console.log('=== SUBMIT BUS DEBUG ===');
    console.log('Selected images count:', selectedImages.length);
    console.log('Selected video:', selectedVideo ? selectedVideo.name : 'None');
    
    if (selectedImages.length > 0) {
      selectedImages.forEach((img, i) => {
        console.log(`Image ${i + 1}:`, img.file ? `${img.file.name} (${img.file.size} bytes, ${img.file.type})` : 'No file object');
      });
    }

    // Validation
    if (!validateBookingTime()) {
      setIsSubmitting(false);
      return;
    }

    if (!validateCancellationTime()) {
      setIsSubmitting(false);
      return;
    }

    if (!form.busNumber) throw new Error('Bus Number is required');
    if (!form.busName) throw new Error('Bus Name is required');
    if (!form.busType) throw new Error('Bus Type is required');
    if (!form.busCategory) throw new Error('Bus Category is required');
    if (!selectedRoute) throw new Error('Please select a route');
    if (operatingDays.length === 0) throw new Error('Please select at least one operating day');
    if (!selectedTemplate) throw new Error('Please configure seat layout');
    if (fareMatrixUp.length === 0) throw new Error('Please generate Fare Matrix');

    // ⚠️ Warning if no images (but don't block submission)
    if (selectedImages.length === 0) {
      toast.warning('No images selected. It\'s recommended to add bus images.');
    }

    // Prepare data
    const amenitiesArray = form.amenities || [];

    const finalSeatsPayload = selectedTemplate.seats
      .filter(s => activeSeats.includes(s.seatNumber))
      .map(s => {
        const label = customSeatLabels[s.seatNumber] || s.globalSeatIndex || s.seatNumber;
        const finalGlobalIndex = isNaN(Number(label)) ? label : Number(label);
        const isBlocked = blockedSeats.includes(s.seatNumber);

        return {
          seatNumber: s.seatNumber,
          globalSeatIndex: finalGlobalIndex,
          row: s.row,
          column: s.column,
          seatType: s.seatType || form.busCategory.toLowerCase().replace('+', '+'),
          position: s.position || getSeatPosition(s.column),
          isBlocked: isBlocked,
          isAvailable: !isBlocked,
        };
      });

    const seatConfigPayload = {
      busType: selectedTemplate.configuration || '2*2',
      totalSeats: activeSeats.length
    };

    const routeSchedules = [];
    const routeIdToSave = selectedRoute._id || selectedRoute.id;

    routeSchedules.push({
      routeId: routeIdToSave,
      direction: 'UP',
      fareMatrix: fareMatrixUp,
      operatingDays: operatingDays,
      departureTime: selectedRoute.departureTime || selectedRoute.origin?.departureTime || '08:00',
      arrivalTime: selectedRoute.arrivalTime || selectedRoute.destination?.arrivalTime || '20:00'
    });

    if (tripType === 'roundTrip' && selectedRoute.returnJourney) {
      routeSchedules.push({
        routeId: routeIdToSave,
        direction: 'DOWN',
        fareMatrix: fareMatrixDown,
        operatingDays: operatingDays,
        departureTime: selectedRoute.returnJourney.departureTime || selectedRoute.returnJourney.origin?.departureTime || '08:00',
        arrivalTime: selectedRoute.returnJourney.arrivalTime || selectedRoute.returnJourney.destination?.arrivalTime || '20:00'
      });
    }

    const fareDetails = {
      basePrice: parseFloat(pricing.basePrice) || 0,
      baseDistance: parseFloat(pricing.baseDistance) || 0,
      costPerKm: parseFloat(pricing.costPerKm) || 0
    };

    const platformFeeData = {
      type: platformFee.type,
      value: platformFee.value,
      applicableOn: platformFee.applicableOn
    };

    // ✅ CREATE FORMDATA
    const formData = new FormData();

    // ✅ Append all text fields
    formData.append('busNumber', form.busNumber.toUpperCase().trim());
    formData.append('busName', form.busName.trim());
    formData.append('busType', form.busType);
    formData.append('busCategory', form.busCategory);
    formData.append('totalSeats', String(activeSeats.length));
    formData.append('tripType', tripType);
    formData.append('busClass', 'Economy');
    formData.append('cancellationTime', JSON.stringify(cancellationTime));
    formData.append('amenities', JSON.stringify(amenitiesArray));
    formData.append('seats', JSON.stringify(finalSeatsPayload));
    formData.append('seatConfiguration', JSON.stringify(seatConfigPayload));
    formData.append('routeSchedules', JSON.stringify(routeSchedules));
    formData.append('fareDetails', JSON.stringify(fareDetails));
    formData.append('operatingDays', JSON.stringify(operatingDays));
    formData.append('bookingClosedBefore', JSON.stringify(bookingClosedBefore));
    formData.append('platformFee', JSON.stringify(platformFeeData));

    // ✅ APPEND IMAGES - Using for loop instead of forEach with await
    console.log('📸 Appending images to FormData...');
    let imageAppendedCount = 0;
    
    // ✅ Use a simple for loop instead of forEach to avoid async issues
    for (let i = 0; i < selectedImages.length; i++) {
      const img = selectedImages[i];
      if (img.file) {
        // Make sure it's a valid File object
        if (img.file instanceof File || img.file instanceof Blob) {
          formData.append('images', img.file);
          imageAppendedCount++;
          console.log(`✅ Appended image ${i + 1}: ${img.file.name} (${img.file.size} bytes)`);
        } else {
          console.error(`❌ Image ${i + 1} is not a valid File object:`, img.file);
        }
      }
    }

    console.log(`📸 Total images appended: ${imageAppendedCount}`);

    // ✅ APPEND VIDEOS
    if (selectedVideo && selectedVideo.file) {
      if (selectedVideo.file instanceof File || selectedVideo.file instanceof Blob) {
        formData.append('videos', selectedVideo.file);
        console.log(`🎬 Appended video: ${selectedVideo.file.name} (${selectedVideo.file.size} bytes)`);
      } else {
        console.error('❌ Video is not a valid File object:', selectedVideo.file);
      }
    }

    // ✅ DEBUG: Log all FormData entries (for debugging)
    console.log('=== FORMDATA ENTRIES ===');
    for (let [key, value] of formData.entries()) {
      if (key === 'images' || key === 'videos') {
        console.log(`${key}: ${value.name} (${value.size} bytes, ${value.type})`);
      } else {
        const stringValue = typeof value === 'string' ? value : String(value);
        console.log(`${key}: ${stringValue.substring(0, 100)}${stringValue.length > 100 ? '...' : ''}`);
      }
    }

    // ✅ Log the actual FormData for debugging
    console.log('FormData size:', formData.getAll('images').length, 'images');
    
    // ✅ SEND REQUEST
    const response = await addBusToOwner(ownerId, formData, token);

    console.log('=== RESPONSE ===', response);

    if (response && response.success) {
      toast.success(tripType === 'roundTrip'
        ? 'Bus added successfully with round trip routes!'
        : 'Bus added successfully!'
      );
      onBusAdded();
      onClose();
    } else {
      throw new Error(response?.message || 'Failed to add bus');
    }

  } catch (err) {
    console.error('❌ Error adding bus:', err);
    setError(err.message || 'Failed to add bus');
    toast.error(err.message || 'Failed to add bus');
  } finally {
    setIsSubmitting(false);
  }
};

  const renderMatrix = (type) => {
    const isUp = type === 'up';
    const currentMatrix = isUp ? fareMatrixUp : fareMatrixDown;
    const currentRoute = isUp ? selectedRoute : selectedRoute?.returnJourney;

    if (!currentRoute || currentMatrix.length === 0) return null;

    const sortedStops = [...(currentRoute.intermediateStops || [])]
      .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

    const allStops = [
      { name: currentRoute.origin?.city || 'Origin', type: 'origin' },
      ...sortedStops.map(s => ({ name: s.city || s.name || 'Stop', type: 'stop' })),
      { name: currentRoute.destination?.city || 'Destination', type: 'destination' }
    ];

    return (
      <div className="matrix-section">
        <h5 className="matrix-title">
          {isUp ? 'Up Route Fare Matrix' : 'Down Route Fare Matrix'}
        </h5>
        <div className="matrix-container">
          <div className="matrix-table-wrapper">
            <table className="fare-matrix-table">
              <thead>
                <tr>
                  <th className="from-cell">From \ To</th>
                  {allStops.map((stop, i) => (
                    <th className="price-cell" key={i} style={{ backgroundColor: getStopColor(stop.type) }}>
                      <div className="stop-header">
                        <span className="stop-name">{stop.name}</span>
                        <span className="stop-type">{stop.type}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentMatrix.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td
                      className="from-cell"
                      style={{ backgroundColor: getStopColor(row.fromType) }}
                    >
                      <div className="from-stop">
                        <span className="stop-name">{row.fromName}</span>
                        <span className="stop-type">{row.fromType}</span>
                      </div>
                    </td>
                    {row.toCells.map((cell, colIndex) => {
                      if (cell) {
                        return (
                          <td key={colIndex} className="price-cell">
                            <div className="fare-cell">
                              <span className="distance">{cell.distanceKm} km</span>
                              <div className="price-input-group">
                                <span className="currency">₹</span>
                                <input
                                  type="number"
                                  className="matrix-input"
                                  value={cell.price}
                                  onChange={(e) => handlePriceChange(type, rowIndex, colIndex, e.target.value)}
                                  min="0"
                                  step="1"
                                />
                              </div>
                            </div>
                           </td>
                        );
                      }
                      return <td key={colIndex} className="na-cell">—</td>;
                    })}
                   </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const renderSeatVisualizer = () => {
    if (!selectedTemplate) return null;

    const { seats, configuration } = selectedTemplate;

    let leftCount = 2, rightCount = 2;
    try {
      if (configuration && configuration.includes('*')) {
        const parts = configuration.split('*');
        leftCount = parseInt(parts[0]) || 2;
        rightCount = parseInt(parts[1]) || 2;
      }
    } catch (e) {
      leftCount = 2;
      rightCount = 2;
    }

    const totalConfigCols = leftCount + rightCount;

    const seatsByRow = {};
    seats.forEach(seat => {
      if (!seatsByRow[seat.row]) {
        seatsByRow[seat.row] = [];
      }
      seatsByRow[seat.row].push(seat);
    });

    const rowNumbers = Object.keys(seatsByRow).map(Number).sort((a, b) => a - b);

    const rows = [];

    const renderSeat = (seatObj) => {
      const isSelected = activeSeats.includes(seatObj.seatNumber);
      const isBlocked = blockedSeats.includes(seatObj.seatNumber);
      const isSleeper = seatObj.seatType === 'sleeper' ||
        seatObj.seatType === 'seat+sleeper' ||
        selectedTemplate.seatType === 'sleeper' ||
        selectedTemplate.seatType === 'seater+sleeper';

      const displayLabel = isSelected
        ? (customSeatLabels[seatObj.seatNumber] || seatObj.globalSeatIndex || seatObj.seatNumber)
        : "";

      let seatClass = '';
      if (isSelected) {
        seatClass = isBlocked ? 'blocked' : 'selected';
      } else {
        seatClass = 'inactive';
      }

      return (
        <button
          key={seatObj.seatNumber}
          className={`seat-btn ${isSleeper ? 'sleeper' : ''} ${seatClass}`}
          onClick={() => handleSeatPress(seatObj)}
          type="button"
        >
          <span className="seat-number">{displayLabel}</span>
        </button>
      );
    };

    rowNumbers.forEach(rowNum => {
      const seatsInRow = seatsByRow[rowNum];

      const isBackRow = seatsInRow.some(s => s.position === 'back') ||
        seatsInRow.length > totalConfigCols;

      if (isBackRow) {
        const sortedSeats = seatsInRow.sort((a, b) => (a.column || 0) - (b.column || 0));
        rows.push(
          <div key={`row-${rowNum}`} className="seat-row back-row">
            <div className="seats-container">
              {sortedSeats.map(seat => renderSeat(seat))}
            </div>
          </div>
        );
      } else {
        const leftSeats = seatsInRow
          .filter(s => (s.column || 0) <= leftCount)
          .sort((a, b) => (a.column || 0) - (b.column || 0));

        const rightSeats = seatsInRow
          .filter(s => (s.column || 0) > leftCount)
          .sort((a, b) => (a.column || 0) - (b.column || 0));

        rows.push(
          <div key={`row-${rowNum}`} className="seat-row">
            <div className="left-seats">
              {leftSeats.map(seat => renderSeat(seat))}
            </div>
            <div className="aisle">Aisle</div>
            <div className="right-seats">
              {rightSeats.map(seat => renderSeat(seat))}
            </div>
          </div>
        );
      }
    });

    return (
      <div className="seat-layout-visualizer">
        <div className="bus-header">
          <div className="driver-area">Driver</div>
          <div className="bus-info">
            <span className="bus-config">{selectedTemplate.configuration}</span>
            <span className="bus-type">{selectedTemplate.seatType || 'seat'}</span>
          </div>
        </div>
        <div className="bus-body">
          {rows}
        </div>
        <div className="seat-legend">
          <div className="legend-item">
            <div className="seat-sample selected"></div>
            <span>Active Seat ({activeSeats.length})</span>
          </div>
          <div className="legend-item">
            <div className="seat-sample inactive"></div>
            <span>Inactive Seat</span>
          </div>
          <div className="legend-item">
            <div className="seat-sample sleeper"></div>
            <span>Sleeper</span>
          </div>
        </div>
        <div className="seat-summary">
          <strong>Total Active Seats: {activeSeats.length} / {selectedTemplate.totalSeats || seats.length}</strong>
        </div>
      </div>
    );
  };

  const ProgressSteps = () => (
    <div className="progress-steps">
      <div className={`step ${activeTab === 'basic' ? 'active' : ''} ${['route', 'matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
        <div className="step-icon">1</div>
        <div className="step-label">Basic Info</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'route' ? 'active' : ''} ${['matrix', 'seats'].includes(activeTab) ? 'completed' : ''}`}>
        <div className="step-icon">2</div>
        <div className="step-label">Route & Pricing</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'matrix' ? 'active' : ''} ${['seats'].includes(activeTab) ? 'completed' : ''}`}>
        <div className="step-icon">3</div>
        <div className="step-label">Fare Matrix</div>
      </div>
      <div className="step-connector"></div>
      <div className={`step ${activeTab === 'seats' ? 'active' : ''}`}>
        <div className="step-icon">4</div>
        <div className="step-label">Seat Layout</div>
      </div>
    </div>
  );

  const renderBasicInfoTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Bus Information</h3>
        <p className="section-subtitle">Enter basic details about the bus</p>
      </div>

      <div className="form-grid">
        <div className="input-group">
          <label className="input-label">
            <span className="label-icon">🚌</span>
            Bus Number *
          </label>
          <input
            type="text"
            value={form.busNumber}
            onChange={(e) => setForm(prev => ({ ...prev, busNumber: e.target.value }))}
            placeholder="e.g., WB01AB1234"
            className="modern-input"
            required
          />
        </div>

        <div className="input-group">
          <label className="input-label">
            <span className="label-icon">🏷️</span>
            Bus Name *
          </label>
          <input
            type="text"
            value={form.busName}
            onChange={(e) => setForm(prev => ({ ...prev, busName: e.target.value }))}
            placeholder="e.g., Volvo Multi-Axle"
            className="modern-input"
            required
          />
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">🖼️</span>
          Bus Images
        </h4>
        <div className="images-upload-area">
          <input
            type="file"
            id="bus-images"
            multiple
            accept="image/*"
            onChange={handleImageUpload}
            className="image-upload-input"
            style={{ display: 'none' }}
          />
          <label htmlFor="bus-images" className="image-upload-label">
            <span className="upload-icon">📁</span>
            <span className="upload-text">Click to upload images</span>
            <span className="upload-hint">Upload multiple images (max 10)</span>
          </label>

          {selectedImages.length > 0 && (
            <div className="selected-images-preview">
              <h5>Selected Images ({selectedImages.length})</h5>
              <div className="images-grid">
                {selectedImages.map((image, index) => (
                  <div key={index} className="image-preview-item">
                    <img
                      src={image.preview}
                      alt={`Bus ${index + 1}`}
                      className="preview-image"
                    />
                    <button
                      type="button"
                      className="remove-image-btn"
                      onClick={() => removeImage(index)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* <div className="video-upload-section" style={{ marginTop: '15px' }}>
            <input
              type="file"
              id="bus-video"
              accept="video/*"
              onChange={handleVideoUpload}
              className="video-upload-input"
              style={{ display: 'none' }}
            />
            <label htmlFor="bus-video" className="video-upload-label">
              <span className="upload-icon">🎥</span>
              <span className="upload-text">Click to upload video</span>
              <span className="upload-hint">Upload one video (optional)</span>
            </label>

            {selectedVideo && (
              <div className="selected-video-preview">
                <div className="video-info">
                  <span className="video-name">{selectedVideo.name}</span>
                  <span className="video-size">{(selectedVideo.size / (1024 * 1024)).toFixed(2)} MB</span>
                </div>
                <button
                  type="button"
                  className="remove-video-btn"
                  onClick={removeVideo}
                >
                  Remove
                </button>
              </div>
            )}
          </div> */}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="input-label">
            <span className="label-icon">🔧</span>
            Bus Type *
          </label>
          <select
            value={form.busType}
            onChange={(e) => setForm(prev => ({ ...prev, busType: e.target.value }))}
            className="modern-select"
          >
            {BUS_TYPES.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="input-label">
            <span className="label-icon">📊</span>
            Bus Category *
          </label>
          <select
            value={form.busCategory}
            onChange={(e) => handleCategoryChange(e.target.value)}
            className="modern-select"
          >
            <option value="">Select Category</option>
            {BUS_CATEGORIES.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
          <small className="helper-text">Multiplier: {getCategoryMultiplier()}x</small>
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">⏰</span>
          Booking Cut-off Time
        </h4>
        <div className="booking-time-container">
          <div className="time-input-group">
            <label className="input-label">Hours before departure</label>
            <div className="time-input-wrapper">
              <input
                type="number"
                min="0"
                max="24"
                value={bookingClosedBefore.hours}
                onChange={(e) => handleBookingTimeChange('hours', e.target.value)}
                className="modern-input time-input"
              />
              <span className="time-unit">hours</span>
            </div>
          </div>
          <div className="time-input-group">
            <label className="input-label">Minutes before departure</label>
            <div className="time-input-wrapper">
              <input
                type="number"
                min="0"
                max="59"
                value={bookingClosedBefore.minutes}
                onChange={(e) => handleBookingTimeChange('minutes', e.target.value)}
                className="modern-input time-input"
              />
              <span className="time-unit">minutes</span>
            </div>
          </div>
        </div>
      </div>

<div className="section-card">
  <h4 className="card-title">
    <span className="title-icon">⏰</span>
    Cancellation Time
  </h4>
  <div className="booking-time-container">
    <div className="time-input-group">
      <label className="input-label">Hours before departure</label>
      <div className="time-input-wrapper">
        <input
          type="number"
          min="0"
          max="48"
          value={cancellationTime.hours}
          onChange={(e) => handleCancellationTimeChange('hours', e.target.value)}
          className="modern-input time-input"
        />
        <span className="time-unit">hours</span>
      </div>
    </div>
    <div className="time-input-group">
      <label className="input-label">Minutes before departure</label>
      <div className="time-input-wrapper">
        <input
          type="number"
          min="0"
          max="59"
          value={cancellationTime.minutes}
          onChange={(e) => handleCancellationTimeChange('minutes', e.target.value)}
          className="modern-input time-input"
        />
        <span className="time-unit">minutes</span>
      </div>
    </div>
  </div>
  <small className="helper-text">
    Cancellation allowed up to this time before departure
  </small>
</div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">✨</span>
          Amenities
        </h4>
        <div className="amenities-grid compact">
          {AMENITIES_LIST.map(amenity => (
            <label key={amenity} className="amenity-option compact">
              <input
                type="checkbox"
                checked={form.amenities.includes(amenity)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setForm(prev => ({
                      ...prev,
                      amenities: [...prev.amenities, amenity]
                    }));
                  } else {
                    setForm(prev => ({
                      ...prev,
                      amenities: prev.amenities.filter(a => a !== amenity)
                    }));
                  }
                }}
                className="amenity-checkbox"
              />
              <span className="amenity-content">
                <span className="amenity-icon">✓</span>
                <span className="amenity-label">{amenity}</span>
              </span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-actions">
        <button
          className="modern-btn primary full-width"
          onClick={() => setActiveTab('route')}
          disabled={!form.busNumber || !form.busName || !form.busType || !form.busCategory}
        >
          Continue to Route & Pricing
          <span className="btn-icon">→</span>
        </button>
      </div>
    </div>
  );

  const renderRouteTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Route & Pricing Configuration</h3>
        <p className="section-subtitle">Select source, destination and configure pricing for this bus</p>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">🔄</span>
          Trip Type
        </h4>
        <div className="trip-type-container">
          <button
            type="button"
            className={`trip-type-btn ${tripType === 'oneWay' ? 'active' : ''}`}
            onClick={() => setTripType('oneWay')}
          >
            <span className="btn-icon">➡️</span>
            One Way
          </button>
          <button
            type="button"
            className={`trip-type-btn ${tripType === 'roundTrip' ? 'active' : ''}`}
            onClick={() => setTripType('roundTrip')}
          >
            <span className="btn-icon">🔄</span>
            Round Trip
          </button>
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">📍</span>
          Source & Destination
        </h4>
        
        <div className="form-row">
          <div className="form-group">
            <label className="input-label">Source City *</label>
            <input
              type="text"
              value={sourceCity}
              onChange={(e) => {
                setSourceCity(e.target.value);
                setSelectedRoute(null);
              }}
              placeholder="Enter source city"
              className="modern-input"
            />
          </div>
    
          <div className="form-group">
            <label className="input-label">Destination City *</label>
            <input
              type="text"
              value={destinationCity}
              onChange={(e) => {
                setDestinationCity(e.target.value);
                setSelectedRoute(null);
              }}
              placeholder="Enter destination city"
              className="modern-input"
            />
          </div>

       {/* Replace the existing OR search form-group */}
<div className="form-group" style={{ marginTop: '10px' }}>
  <label className="input-label">— OR — Search by Local Route Name</label>
  <div style={{ position: 'relative' }}>
    <input
      type="text"
      value={localRouteNameSearch}
      onChange={(e) => {
        const val = e.target.value;
        setLocalRouteNameSearch(val);
        setSelectedRoute(null);
        // Clear city fields when using local name search
        if (val.trim()) {
          setSourceCity('');
          setDestinationCity('');
        }
      }}
      placeholder="e.g. Panskura to Bagnan local name..."
      className="modern-input"
    />
    {localRouteSearchLoading && (
      <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
        <div className="spinner-small"></div>
      </div>
    )}
  </div>
  <small className="helper-text">
    Search routes directly by local name without entering city filters
  </small>
</div>
        </div>
      </div>

      {/* {sourceCity && destinationCity && ( */}
      {(sourceCity && destinationCity || availableRoutes.length > 0) && (
        <div className="section-card">
          <h4 className="card-title">
            <span className="title-icon">🗺️</span>
            Select Route
          </h4>
          
          <div className="route-selector">
  <label className="input-label">Available Routes *</label>
  <div className="route-dropdown-container">
    <input
      type="text"
      value={selectedRoute ? `${selectedRoute.localRouteName ? `${selectedRoute.localRouteName} - ` : ''}${selectedRoute.routeName}` : routeSearchTerm}
      onClick={() => setShowRouteDropdown(!showRouteDropdown)}
      onChange={(e) => {
        setRouteSearchTerm(e.target.value);
        setShowRouteDropdown(true);
        if (selectedRoute) setSelectedRoute(null);
      }}
      placeholder={loadingRoutes ? "Loading routes..." : "Click to select route"}
      className="modern-input"
      disabled={loadingRoutes}
      style={{ cursor: 'pointer' }}
    />
    {loadingRoutes && (
      <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
        <div className="spinner-small"></div>
      </div>
    )}
    
    {showRouteDropdown && availableRoutes.length > 0 && (
      <div className="route-dropdown">
        <div className="dropdown-search">
          <input
            type="text"
            value={routeSearchTerm}
            onChange={(e) => setRouteSearchTerm(e.target.value)}
            placeholder="Search routes..."
            className="dropdown-search-input"
            autoFocus
          />
        </div>
        <div className="dropdown-list">
          {filteredRoutes.length === 0 ? (
            <div className="dropdown-empty">No matching routes</div>
          ) : (
            filteredRoutes.map((route) => (
              <div
                key={route._id}
                className="dropdown-item"
                onClick={() => handleSelectRoute(route)}
              >
               <div className="route-number">
  {route.localRouteName ? (
    <div className="route-name-stack">
      <div className="local-route-name">{route.localRouteName}</div>
      <div className="route-name">{route.routeName}</div>
    </div>
  ) : (
    <div className="route-name">{route.routeName}</div>
  )}
</div>
                <div className="route-details">
                  {route.origin?.city} → {route.destination?.city} • 
                  {route.isRoundTrip ? ' Round Trip' : ' One Way'} • 
                  {route.routeDetails?.totalDistance || 0} km
                </div>
                {route.creatorType === 'BusOwner' && (
                  <span className="owner-badge">Owner</span>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    )}
  </div>
  
  {availableRoutes.length === 0 && sourceCity && destinationCity && !loadingRoutes && (
    <div className="no-routes-message">
      <p>No routes found for {sourceCity} → {destinationCity}</p>
      <button type="button" onClick={handleAddNewRoute} className="create-route-btn">
        + Create New Route
      </button>
    </div>
  )}
  
  {selectedRoute && selectedRoute.isRoundTrip && (
    <small className="helper-text">✓ Round trip route selected - both UP and DOWN matrices will be generated</small>
  )}
</div>
        </div>
      )}

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">📅</span>
          Operating Days *
        </h4>
        <div className="days-grid compact">
          {DAYS_OF_WEEK.map(day => (
            <button
              key={day}
              type="button"
              className={`day-btn ${operatingDays.includes(day) ? 'active' : ''}`}
              onClick={() => toggleDay(day)}
              title={day}
            >
              {day.substring(0, 3)}
            </button>
          ))}
        </div>
        <div className="selected-days">
          Selected: {operatingDays.length} days
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">💰</span>
          Pricing Configuration
        </h4>

        <div className="form-row">
          <div className="form-group">
            <label>Base Price (₹) *</label>
            <input
              type="number"
              value={pricing.basePrice}
              onChange={(e) => setPricing({ ...pricing, basePrice: e.target.value })}
              placeholder="e.g., 100"
              className="modern-input"
              min="0"
              step="1"
            />
          </div>
          <div className="form-group">
            <label>Base Distance (km) *</label>
            <input
              type="number"
              value={pricing.baseDistance}
              onChange={(e) => setPricing({ ...pricing, baseDistance: e.target.value })}
              placeholder="e.g., 15"
              className="modern-input"
              min="0"
              step="0.1"
            />
          </div>
          <div className="form-group">
            <label>Cost per km (₹) *</label>
            <input
              type="number"
              value={pricing.costPerKm}
              onChange={(e) => setPricing({ ...pricing, costPerKm: e.target.value })}
              placeholder="e.g., 4"
              className="modern-input"
              min="0"
              step="0.1"
            />
          </div>
        </div>

        {selectedRoute && (
          <div className="pricing-summary">
            <div className="summary-item">
              <span>Category Multiplier:</span>
              <span className="value accent">{getCategoryMultiplier()}x</span>
            </div>
            <div className="summary-item">
              <span>Route Distance:</span>
              <span className="value">{selectedRoute.routeDetails?.totalDistance || 0} km</span>
            </div>
          </div>
        )}
      </div>

       <PlatformFeeConfig 
      platformFee={platformFee} 
      onChange={setPlatformFee} 
    />

      <div className="form-actions">
        <button
          type="button"
          className="modern-btn outline"
          onClick={() => setActiveTab('basic')}
        >
          ← Back
        </button>
        <button
          type="button"
          className="modern-btn primary generate-matrix-btn"
          onClick={() => {
            handleGenerateMatrix();
            if (fareMatrixUp.length > 0) {
              setActiveTab('matrix');
            }
          }}
          disabled={!selectedRoute || !pricing.basePrice || !pricing.baseDistance || !pricing.costPerKm}
        >
          Generate Fare Matrix
          <span className="btn-icon">→</span>
        </button>
      </div>
    </div>
  );

  const renderMatrixTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Fare Matrix Configuration</h3>
        <p className="section-subtitle">Review and edit fares for each route</p>
      </div>

      {tripType === 'roundTrip' && selectedRoute?.returnJourney && (
        <div className="matrix-tabs">
          <button
            type="button"
            className={`matrix-tab ${activeMatrixTab === 'up' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('up')}
          >
            Up Route: {selectedRoute.routeName}
          </button>
          <button
            type="button"
            className={`matrix-tab ${activeMatrixTab === 'down' ? 'active' : ''}`}
            onClick={() => setActiveMatrixTab('down')}
          >
            Down Route: Return Route
          </button>
        </div>
      )}

      {tripType === 'roundTrip' && selectedRoute?.returnJourney ? (
        <>
          {activeMatrixTab === 'up' && renderMatrix('up')}
          {activeMatrixTab === 'down' && renderMatrix('down')}
        </>
      ) : (
        renderMatrix('up')
      )}

      <div className="matrix-info">
        <div className="info-card">
          <div className="info-item">
            <span className="label">Total Stops:</span>
            <span className="value">
              {selectedRoute ?
                (selectedRoute.intermediateStops?.length || 0) + 2 : 0}
            </span>
          </div>
          <div className="info-item">
            <span className="label">Category Multiplier:</span>
            <span className="value accent">{getCategoryMultiplier()}x</span>
          </div>
          <div className="info-item">
            <span className="label">Base Price:</span>
            <span className="value">₹{pricing.basePrice}</span>
          </div>
          <div className="info-item">
            <span className="label">Cost/km:</span>
            <span className="value">₹{pricing.costPerKm}</span>
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="modern-btn outline"
          onClick={() => setActiveTab('route')}
        >
          ← Back to Pricing
        </button>
        <button
          type="button"
          className="modern-btn primary"
          onClick={() => setActiveTab('seats')}
          disabled={fareMatrixUp.length === 0}
        >
          Continue to Seat Layout
          <span className="btn-icon">→</span>
        </button>
      </div>
    </div>
  );

  const renderSeatLayoutTab = () => (
    <div className="tab-content-wrapper">
      <div className="section-title">
        <h3>Seat Layout Configuration</h3>
        <p className="section-subtitle">Configure seat layout for this bus</p>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">🔧</span>
          Bus Configuration
        </h4>
        <div className="config-selector">
          <label className="input-label">Select Bus Configuration *</label>
          {loadingLayouts ? (
            <div className="loading-configs">
              <span>Loading configurations...</span>
            </div>
          ) : (
            <>
              <div className="config-buttons">
                {availableConfigurations.map(config => (
                  <button
                    key={config}
                    type="button"
                    className={`config-btn ${selectedConfiguration === config ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedConfiguration(config);
                      setSelectedTemplate(null);
                      setActiveSeats([]);
                      setCustomSeatLabels({});
                      fetchLayouts(config);
                    }}
                  >
                    {config}
                  </button>
                ))}
              </div>
              <small className="helper-text">
                {form.busCategory} bus with {selectedConfiguration} configuration
              </small>
            </>
          )}
        </div>
      </div>

      <div className="section-card">
        <h4 className="card-title">
          <span className="title-icon">💺</span>
          Seat Layout Template
        </h4>

        {!selectedTemplate ? (
          <button
            type="button"
            className="modern-btn outline full-width"
            onClick={openTemplateSelector}
            disabled={loadingLayouts}
          >
            {loadingLayouts ? (
              <>
                <span className="btn-icon">⏳</span>
                Loading Layouts...
              </>
            ) : (
              <>
                <span className="btn-icon">📋</span>
                Select Layout Template
              </>
            )}
          </button>
        ) : (
          <div className="selected-template-info">
            <div className="template-details">
              <span className="template-name">{selectedTemplate.name}</span>
              <span className="template-config">{selectedTemplate.configuration}</span>
              <span className="template-seats">{selectedTemplate.totalSeats} seats</span>
              <span className="template-type">{selectedTemplate.seatType || 'seat'}</span>
            </div>
            <button
              type="button"
              className="btn-small"
              onClick={() => {
                setSelectedTemplate(null);
                setActiveSeats([]);
                setCustomSeatLabels({});
              }}
            >
              Change
            </button>
          </div>
        )}
      </div>

      {selectedTemplate && (
        <div className="section-card">
          <h4 className="card-title">
            <span className="title-icon">👁️</span>
            Seat Layout Visualizer
          </h4>
          <button
            type="button"
            className="view-layout-btn"
            onClick={() => setShowLayoutModal(true)}
          >
            View / Edit Seat Numbers
          </button>

          <div className="seat-summary">
            <div className="summary-item">
              <span>Total Seats in Template:</span>
              <span className="value">{selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0}</span>
            </div>
            <div className="summary-item">
              <span>Active Seats:</span>
              <span className="value accent">{activeSeats.length}</span>
            </div>
            <div className="summary-item">
              <span>Inactive Seats:</span>
              <span className="value">{(selectedTemplate.totalSeats || selectedTemplate.seats?.length || 0) - activeSeats.length}</span>
            </div>
          </div>
        </div>
      )}

      <div className="form-actions">
        <button
          type="button"
          className="modern-btn outline"
          onClick={() => setActiveTab('matrix')}
        >
          ← Back to Matrix
        </button>
        <button
          type="button"
          className="modern-btn primary"
          onClick={handleSubmitBus}
          disabled={!selectedTemplate || activeSeats.length === 0 || isSubmitting}
        >
          {isSubmitting ? 'Adding Bus...' : `${tripType === 'roundTrip' ? 'Add Round Trip Bus' : 'Add Bus'}`}
          <span className="btn-icon">✓</span>
        </button>
      </div>
    </div>
  );

  // Layout Modal and other modals remain the same...
  const renderLayoutModal = () => (
    <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
      <div className="modal-content layout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Edit Seat Numbers</h3>
          <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
        </div>
        <div className="modal-body">
          <p className="instruction-text">Tap a seat to enter its number and activate it.</p>
          <div className="seat-legend three-items">
            <div className="legend-item">
              <div className="seat-sample selected"></div>
              <span>Active</span>
            </div>
            <div className="legend-item">
              <div className="seat-sample blocked"></div>
              <span>Blocked</span>
            </div>
            <div className="legend-item">
              <div className="seat-sample inactive"></div>
              <span>Disabled</span>
            </div>
          </div>
          {renderSeatVisualizer()}
          <div className="layout-footer">
            <span>Total: {activeSeats.length}</span>
            <div className="footer-actions">
              <button className="auto-number-btn" onClick={autoRenumberSeats}>
                Auto-Number
              </button>
              <button className="confirm-btn" onClick={() => setShowLayoutModal(false)}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTemplateModal = () => (
    <div className="modal-overlay" onClick={() => setShowTemplateModal(false)}>
      <div className="modal-content template-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Select Seat Layout Template</h3>
          <button className="modal-close-btn" onClick={() => setShowTemplateModal(false)}>×</button>
        </div>
        <div className="modal-body">
          {loadingLayouts ? (
            <div className="loading-container">
              <p>Loading templates...</p>
            </div>
          ) : layoutTemplates.length === 0 ? (
            <div className="no-templates">
              <p>No {form.busCategory} layouts found for {selectedConfiguration} configuration</p>
              <p className="hint">Available configurations with layouts:</p>
              <div className="available-configs">
                {availableConfigurations.map(config => (
                  <span key={config} className="config-chip">{config}</span>
                ))}
              </div>
              <p className="hint">Try selecting a different configuration</p>
            </div>
          ) : (
            <div className="templates-grid">
              {layoutTemplates.map(template => (
                <button
                  type="button"
                  key={template._id}
                  className="template-card"
                  onClick={() => handleSelectTemplate(template)}
                >
                  <h4 className="template-name">{template.name}</h4>
                  <div className="template-details">
                    <span className="config">Config: {template.configuration}</span>
                    <span className="seats">Seats: {template.totalSeats}</span>
                  </div>
                  <div className="template-preview">
                    <span className="rows">Rows: {template.rows}</span>
                    <span className="cols">Cols: {template.columns}</span>
                    <span className="seat-type">Type: {template.seatType || 'seat'}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderSeatEditModal = () => (
    <div className="modal-overlay" onClick={() => setEditingSeat(null)}>
      <div className="modal-content seat-edit-modal" style={{    "max-width": "500px",
    "max-height": "35vh"}} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Set Seat Label</h3>
        </div>
        <div className="modal-body">
          <input
            type="text"
            value={tempSeatLabel}
            onChange={(e) => setTempSeatLabel(e.target.value)}
            placeholder="e.g. 1 or 1A"
            className="seat-input"
            autoFocus
          />
        </div>
        <div className="modal-footer three-buttons">
          <button
            className="modal-action-btn active-btn"
            onClick={() => {
              if (tempSeatLabel.trim() === '') {
                toast.error('Please enter a valid seat number');
                return;
              }
              if (!activeSeats.includes(editingSeat)) {
                setActiveSeats([...activeSeats, editingSeat]);
              }
              setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
              setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
              setEditingSeat(null);
            }}
          >
            Active
          </button>
          
          <button
            className="modal-action-btn block-btn"
            onClick={() => {
              if (tempSeatLabel.trim() === '') {
                toast.error('Please enter a valid seat number');
                return;
              }
              if (!activeSeats.includes(editingSeat)) {
                setActiveSeats([...activeSeats, editingSeat]);
              }
              if (!blockedSeats.includes(editingSeat)) {
                setBlockedSeats([...blockedSeats, editingSeat]);
              }
              setCustomSeatLabels(prev => ({ ...prev, [editingSeat]: tempSeatLabel }));
              setEditingSeat(null);
            }}
          >
            Block
          </button>
          <button
            className="modal-action-btn disable-btn"
            onClick={() => {
              setActiveSeats(activeSeats.filter(s => s !== editingSeat));
              setBlockedSeats(blockedSeats.filter(s => s !== editingSeat));
              setEditingSeat(null);
            }}
          >
            Disable
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="modal-overlay modern" onClick={onClose}>
      <div className="modal-content modern add-bus-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header modern">
          <div className="header-content">
            <h2 className="modal-title">
              <span className="title-icon">🚌</span>
              Add New Bus {tripType === 'roundTrip' ? '(Round Trip)' : ''}
            </h2>
            <p className="modal-subtitle">Configure bus details with route selection</p>
          </div>
          <button className="modal-close-btn modern" onClick={onClose}>
            <span className="close-icon">×</span>
          </button>
        </div>

        <div className="modal-body modern">
          <ProgressSteps />

          <div className="tab-container">
            {activeTab === 'basic' && renderBasicInfoTab()}
            {activeTab === 'route' && renderRouteTab()}
            {activeTab === 'matrix' && renderMatrixTab()}
            {activeTab === 'seats' && renderSeatLayoutTab()}
          </div>

          {error && (
            <div className="error-message modern">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}
        </div>
      </div>

      {showLayoutModal && renderLayoutModal()}
      {showTemplateModal && renderTemplateModal()}
      {editingSeat && renderSeatEditModal()}
    </div>
  );
};
const BusOwnerManage = () => {
  const { token } = useSelector(state => state.user);
  const [busOwners, setBusOwners] = useState([]);
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingOwner, setEditingOwner] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingOwner, setViewingOwner] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddBusModal, setShowAddBusModal] = useState(false);
  const [selectedOwnerForBus, setSelectedOwnerForBus] = useState(null);
  const [busSearchTerm, setBusSearchTerm] = useState('');
  const [newOwner, setNewOwner] = useState({
    name: '',
    email: '',
    phone: '',
    companyName: ''
  });
  const [error, setError] = useState(null);
  const [busUpdateTrigger, setBusUpdateTrigger] = useState(0);

  // Bus Management states - UPDATED for new modal
  const [showBusManagement, setShowBusManagement] = useState(false);
  const [selectedOwnerBuses, setSelectedOwnerBuses] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [busDetailsLoading, setBusDetailsLoading] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalOwners, setTotalOwners] = useState(0);
  const [pageSize] = useState(10);

  const getSequentialNumber = (index) => {
    return (currentPage - 1) * pageSize + index + 1;
  };

  const getFullImageUrl = (imagePath) => {
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    return `${process.env.REACT_APP_BASE_URL}/uploads/${imagePath}`;
  };

  useEffect(() => {
    fetchBusOwners();
  }, [currentPage]);



  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchBusOwners();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm]);

const refreshBusList = async () => {
  if (!selectedOwner) return;
  
  try {
    setBusDetailsLoading(true);
    const response = await getBusOwnerById(selectedOwner.id, token);
    
    if (response.success && response.data) {
      // Try busAll first, fall back to buses array
      const busData = response.data.busAll || response.data.buses || [];
      
      const processedBuses = busData.map(bus => {
        const driver = bus.driver ? {
          name: bus.driver.name || 'N/A',
          contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
          licenseNumber: bus.driver.licenseNumber || 'N/A',
          experience: bus.driver.experience || 0
        } : null;

        const conductor = bus.conductor ? {
          name: bus.conductor.name || 'N/A',
          contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
        } : null;

        return { ...bus, driver, conductor };
      });
      
      // This updates the buses shown in BusManagementModal
      setSelectedOwnerBuses(processedBuses);
      
      setSelectedOwner(prev => ({
        ...prev,
        busAll: busData
      }));
    }
  } catch (err) {
    console.error('Error refreshing bus list:', err);
    toast.error('Failed to refresh bus list');
  } finally {
    setBusDetailsLoading(false);
  }
};

  const fetchBusOwners = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);

      const response = await getBusOwners(token, currentPage, pageSize, searchTerm);
console.log("getBusOwners : ",response)
      if (response && response.success && response.busOwners) {
        const transformedOwners = response.busOwners.map((owner, index) => ({
          id: owner._id,
          serialNo: getSequentialNumber(index),
          profileImage: owner.profileImage || '',
          name: owner.name || '',
          company: owner.companyName || '',
          email: owner.email || '',
          phone: owner.phone || '',
          buses: owner.busCount || 0,
          routes: owner.routeCount || 0,
          joined: new Date(owner.createdAt).toISOString().split('T')[0],
          status: owner.isVerified ? 'Verified' : 'Pending',
          adminApproval: owner.isApprovedByAdmin ? 'Approved' : 'Pending',
          _id: owner._id,
          isVerified: owner.isVerified,
          isProfileComplete: owner.isProfileComplete,
          isApprovedByAdmin: owner.isApprovedByAdmin,
          activeBuses: owner.activeBuses || 0,
          driverCount: owner.driverCount || 0,
          conductorCount: owner.conductorCount || 0,
          createdAt: owner.createdAt,
          updatedAt: owner.updatedAt,
          address: owner.address || {},
          city: owner.address?.city || '',
          state: owner.address?.state || owner.state || '',
          pincode: owner.address?.pincode || '',
          busAll: owner.busAll || []
        }));

        setBusOwners(transformedOwners);

        if (response.totalPages) {
          setTotalPages(response.totalPages);
        }
        if (response.total) {
          setTotalOwners(response.total);
        } else {
          setTotalOwners(response.busOwners.length);
        }
      } else {
        setError('No bus owners data found in response');
        setBusOwners([]);
        setTotalPages(1);
        setTotalOwners(0);
      }
    } catch (err) {
      console.error('Error fetching bus owners:', err);
      setError('Failed to fetch bus owners. Please try again.');
      setBusOwners([]);
      setTotalPages(1);
      setTotalOwners(0);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const fetchBusOwnerById = async (id) => {
    try {
      const response = await getBusOwnerById(id, token);
      console.log("response.data : ", response.data)
      return response.data || response;
    } catch (err) {
      console.error('Error fetching bus owner:', err);
      throw err;
    }
  };

const handleApproveOwner = async (ownerId) => {
  try {
    setError(null);
    const response = await approveBusOwner(ownerId, token);

    if (response.success) {
      setBusOwners(prevOwners =>
        prevOwners.map(owner =>
          owner.id === ownerId ? {
            ...owner,
            isApprovedByAdmin: response.data?.isApprovedByAdmin || true,
            adminApproval: (response.data?.isApprovedByAdmin || true) ? 'Approved' : 'Pending',
            // Add these lines to update the status and verification
            isVerified: response.data?.isVerified || true,
            status: response.data?.isVerified ? 'Verified' : 'Pending'
          } : owner
        )
      );
      toast.success('Bus owner approved and verified successfully!');
    } else {
      throw new Error(response.message || 'Failed to approve bus owner');
    }
  } catch (err) {
    console.error('Error approving bus owner:', err);
    setError('Failed to approve bus owner. Please try again.');
    toast.error('Failed to approve bus owner. Please try again.');
  }
};

  const handleManageBuses = async (owner) => {
    console.log("handleManageBuses ; ", owner)
    if (owner.buses === 0) {
      // alert('This owner has no buses registered.');
      toast.error("This owner has no buses registered")
      return;
    }

    console.log('Owner bus data:', owner);

    // Check if busAll exists and has data
    if (!owner.busAll || owner.busAll.length === 0) {
      // If no bus data, try to fetch it separately
      try {
        setBusDetailsLoading(true);
        const response = await getBusOwnerById(owner.id, token);

        if (response.success && response.data && response.data.busAll) {
          // Update the owner with bus data
          const updatedOwner = {
            ...owner,
            busAll: response.data.busAll || []
          };

          // Process the bus data
          const processedBuses = updatedOwner.busAll.map(bus => {
            const driver = bus.driver ? {
              name: bus.driver.name || 'N/A',
              contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
              licenseNumber: bus.driver.licenseNumber || 'N/A',
              experience: bus.driver.experience || 0
            } : null;

            const conductor = bus.conductor ? {
              name: bus.conductor.name || 'N/A',
              contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
            } : null;

            return {
              ...bus,
              driver,
              conductor
            };
          });

          console.log('Fetched and processed buses:', processedBuses);

          setSelectedOwner(updatedOwner);
          setSelectedOwnerBuses(processedBuses);
          setShowBusManagement(true);
          setBusSearchTerm('');
        } else {
          alert('Could not fetch bus data. Please try again.');
        }
      } catch (err) {
        console.error('Error fetching bus details:', err);
        alert('Failed to fetch bus details. Please try again.');
      } finally {
        setBusDetailsLoading(false);
      }
      return;
    }

    // If busAll data exists, process it
    const processedBuses = owner.busAll.map(bus => {
      const driver = bus.driver ? {
        name: bus.driver.name || 'N/A',
        contactNumber: bus.driver.contactNumber || bus.driver.mobileNumber || 'N/A',
        licenseNumber: bus.driver.licenseNumber || 'N/A',
        experience: bus.driver.experience || 0
      } : null;

      const conductor = bus.conductor ? {
        name: bus.conductor.name || 'N/A',
        contactNumber: bus.conductor.contactNumber || bus.conductor.mobileNumber || 'N/A'
      } : null;

      return {
        ...bus,
        driver,
        conductor
      };
    });

    console.log('Processed buses:', processedBuses);

    setSelectedOwner(owner);
    setSelectedOwnerBuses(processedBuses);
    setShowBusManagement(true);
    setBusSearchTerm('');
  };
  // Add this function after your other handler functions
  const filteredBuses = selectedOwnerBuses.filter(bus =>
    (bus.busName && bus.busName.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.busNumber && bus.busNumber.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.driver?.name && bus.driver.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.conductor?.name && bus.conductor.name.toLowerCase().includes(busSearchTerm.toLowerCase())) ||
    (bus.driver?.contactNumber && bus.driver.contactNumber.includes(busSearchTerm)) ||
    (bus.conductor?.contactNumber && bus.conductor.contactNumber.includes(busSearchTerm))
  );

  const handleRejectOwner = async (ownerId) => {
    if (window.confirm('Are you sure you want to reject this bus owner?')) {
      try {
        setError(null);

        if (!ownerId || typeof ownerId !== 'string') {
          throw new Error('Invalid owner ID');
        }

        const response = await updateBusOwner(ownerId, { isApprovedByAdmin: false }, token);

        if (response.success) {
          setBusOwners(prevOwners =>
            prevOwners.map(owner =>
              owner.id === ownerId ? {
                ...owner,
                isApprovedByAdmin: response.data?.isApprovedByAdmin || false,
                adminApproval: (response.data?.isApprovedByAdmin || false) ? 'Approved' : 'Rejected'
              } : owner
            )
          );
          toast.success('Bus owner rejected successfully!');
        } else {
          throw new Error(response.message || 'Failed to reject bus owner');
        }
      } catch (err) {
        console.error('Error rejecting bus owner:', err);
        setError('Failed to reject bus owner. Please try again.');
        toast.error('Failed to reject bus owner. Please try again.');
      }
    }
  };

  const filteredOwners = busOwners;

  const handleViewOwner = async (owner) => {
    try {
      const ownerData = await fetchBusOwnerById(owner.id);
      setViewingOwner({
        ...owner,
        profileImage: ownerData.profileImage || owner.profileImage,
        name: ownerData.name || owner.name,
        company: ownerData.companyName || owner.company,
        email: ownerData.email || owner.email,
        phone: ownerData.phone || owner.phone,
        address: ownerData.address || owner.address,
        isVerified: ownerData.isVerified,
        isProfileComplete: ownerData.isProfileComplete,
        isApprovedByAdmin: ownerData.isApprovedByAdmin,

        // Stats (numbers for the stat cards)
        busCount: ownerData.stats?.busCount || 0,      // ← renamed to busCount
        activeBuses: ownerData.stats?.activeBuses || 0,
        driverCount: ownerData.stats?.driverCount || 0,
        conductorCount: ownerData.stats?.conductorCount || 0,

        // Arrays for the detail sections
        routes: ownerData.routes || [],
        buses: ownerData.buses || [],                   // ← array only, no conflict

        // Bank details (only present if owner has added them)
        bankDetails: ownerData.bankDetails || ownerData.bankAccount || null,

        status: ownerData.isApprovedByAdmin ? 'Active' : 'Pending',
        joined: ownerData.createdAt
          ? new Date(ownerData.createdAt).toLocaleDateString()
          : owner.joined,
      });
    } catch (err) {
      setViewingOwner(owner);
      toast.info('Could not fetch latest owner details. Showing cached data.');
    }
  };

  const handleEditOwner = (owner) => {
    setEditingOwner(owner.id);
    setEditForm({
      name: owner.name || '',
      companyName: owner.company || '',
      email: owner.email || '',
      phone: owner.phone || '',
      status: owner.status || 'Pending',
      isApprovedByAdmin: owner.isApprovedByAdmin || false
    });
  };

  const closeBusManagement = () => {
    setShowBusManagement(false);
    setSelectedOwnerBuses([]);
    setSelectedOwner(null);
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);

      if (!editingOwner || typeof editingOwner !== 'string') {
        throw new Error('Invalid owner ID for editing');
      }

      const updateData = {
        name: editForm.name,
        email: editForm.email,
        phone: editForm.phone,
        companyName: editForm.companyName,
        isVerified: editForm.status === 'Verified',
        isApprovedByAdmin: editForm.isApprovedByAdmin
      };

      const response = await updateBusOwner(editingOwner, updateData, token);

      if (response.success) {
        setBusOwners(prevOwners =>
          prevOwners.map(owner =>
            owner.id === editingOwner ? {
              ...owner,
              name: response.data?.name || editForm.name,
              company: response.data?.companyName || editForm.companyName,
              email: response.data?.email || editForm.email,
              phone: response.data?.phone || editForm.phone,
              status: response.data?.isVerified ? 'Verified' : 'Pending',
              isVerified: response.data?.isVerified,
              isApprovedByAdmin: response.data?.isApprovedByAdmin,
              adminApproval: response.data?.isApprovedByAdmin ? 'Approved' : 'Pending'
            } : owner
          )
        );

        setEditingOwner(null);
        setEditForm({});
        toast.success('Bus owner updated successfully!');
      } else {
        throw new Error(response.message || 'Failed to update bus owner');
      }
    } catch (err) {
      console.error('Error updating bus owner:', err);
      setError('Failed to update bus owner. Please try again.');
      toast.error('Failed to update bus owner. Please try again.');
    }
  };

  const handleCancelEdit = () => {
    setEditingOwner(null);
    setEditForm({});
    setError(null);
  };

  // const handleDeleteOwner = async (ownerId) => {
  //   if (window.confirm('Are you sure you want to delete this bus owner?')) {
  //     try {
  //       setError(null);
  //       const response = await deleteBusOwner(ownerId, token);

  //       if (response.success) {
  //         setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
  //         setTotalOwners(prev => prev - 1);
  //         toast.success('Bus owner deleted successfully!');
  //       } else {
  //         throw new Error(response.message || 'Failed to delete bus owner');
  //       }
  //     } catch (err) {
  //       console.error('Error deleting bus owner:', err);
  //       setError('Failed to delete bus owner. Please try again.');
  //       toast.error('Failed to delete bus owner. Please try again.');
  //     }
  //   }
  // };

  const handleDeleteOwner = async (ownerId) => {
  if (window.confirm('Are you sure you want to delete this bus owner?')) {
    try {
      setError(null);
      const response = await deleteBusOwner(ownerId, token);

      if (response.success) {
        setBusOwners(prevOwners => prevOwners.filter(owner => owner.id !== ownerId));
        setTotalOwners(prev => prev - 1);
        toast.success('Bus owner deleted successfully!');
      } else {
        throw new Error(response.message || 'Failed to delete bus owner');
      }
    } catch (err) {
      console.error('Error deleting bus owner:', err);
      
      // Extract the error message from the response
      const errorMessage = err.response?.data?.message || err.message || 'Failed to delete bus owner. Please try again.';
      
      setError(errorMessage);
      toast.error(errorMessage);
    }
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNewOwnerChange = (e) => {
    const { name, value } = e.target;
    setNewOwner(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAddOwner = async () => {
    try {
      setError(null);

      if (!newOwner.name || !newOwner.email || !newOwner.phone || !newOwner.companyName) {
        toast.error('Please fill in all required fields');
        return;
      }

      const response = await createBusOwner(newOwner, token);
      console.log("response............ : ", response)
      if (response.success) {
        const newOwnerWithId = {
          id: response.data.id,
          serialNo: busOwners.length + 1,
          profileImage: '',
          name: response.data.name,
          company: response.data.companyName,
          email: response.data.email,
          phone: response.data.phone,
          buses: 0,
          routes: 0,
          joined: new Date(response.data.createdAt).toISOString().split('T')[0],
          status: 'Pending',
          adminApproval: 'Pending',
          isVerified: false,
          isApprovedByAdmin: false,
          createdAt: response.data.createdAt
        };

        setBusOwners(prev => [newOwnerWithId, ...prev]);
        setTotalOwners(prev => prev + 1);
        setShowAddModal(false);
        setNewOwner({
          name: '',
          companyName: '',
          email: '',
          phone: ''
        });
         setSearchTerm('');
        toast.success('Bus owner added successfully!');
      } else {
        throw new Error(response.message || 'Failed to add bus owner');
      }
    } catch (err) {
      console.error('Error adding bus owner:', err);

      // Extract error message from the response
      let errorMessage = 'Failed to add bus owner. Please try again.';

      if (err.response?.data?.message) {
        // Get the message from the API response
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  const closeViewModal = () => {
    setViewingOwner(null);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
    setNewOwner({
      name: '',
      companyName: '',
      email: '',
      phone: ''
    });
    setError(null);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    // The useEffect will trigger fetchBusOwners automatically
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const currentPageOwners = busOwners;
  const verifiedOwners = currentPageOwners.filter(o => o.status === 'Verified').length;
  const approvedOwners = currentPageOwners.filter(o => o.isApprovedByAdmin).length;
  const totalBuses = currentPageOwners.reduce((sum, owner) => sum + owner.buses, 0);

  const handleAddBusClick = (owner) => {
    setSelectedOwnerForBus(owner);
    setShowAddBusModal(true);
  };

  const handleBusAdded = () => {
    fetchBusOwners();
    toast.success('Bus added successfully!');
  };

  const closeAddBusModal = () => {
    setShowAddBusModal(false);
    setSelectedOwnerForBus(null);
  };

  if (loading && busOwners.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Bus Owner Management</h1>
        <div className="header-actions">
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Search bus owners by name, company, email or phone..."
              className="search-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "70%" }}
            />
            {searching && (
              <span style={{
                position: 'absolute', right: '10px', top: '50%',
                transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
              }}>
                searching...
              </span>
            )}
          </div>
          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          <button className="add-btn" onClick={() => setShowAddModal(true)}>
            + Add Owner
          </button>
        </div>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
        Page: {currentPage} | Total Pages: {totalPages} | Total Owners: {totalOwners}
      </div>

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Owners</h3>
          <p>{totalOwners}</p>
          <span>All registered owners</span>
        </div>
        <div className="stat-card">
          <h3>Verified Owners</h3>
          <p>{verifiedOwners}</p>
          <span>Verified on page {currentPage}</span>
        </div>
        <div className="stat-card">
          <h3>Approved Owners</h3>
          <p>{approvedOwners}</p>
          <span>Approved on page {currentPage}</span>
        </div>
        <div className="stat-card">
          <h3>Total Buses</h3>
          <p>{totalBuses}</p>
          <span>active fleet</span>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Profile</th>
              <th>Owner Name</th>
              <th>Company</th>
              <th>Contact</th>
              <th>Buses</th>
              <th>Admin Approval</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredOwners.length > 0 ? (
              filteredOwners.map(owner => (
                <tr key={owner.id}>
                  <td>{owner.serialNo}</td>
                  <td>
                    <div className="profile-image-cell">
                      <img
                        src={getFullImageUrl(owner.profileImage)}
                        alt={owner.name || 'Bus Owner'}
                        className="customer-avatar"
                        onError={(e) => {
                          e.target.onerror = null;
                        }}
                      />
                    </div>
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <input
                        type="text"
                        name="name"
                        value={editForm.name || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Owner Name"
                        style={{ width: '100%', padding: '5px' }}
                      />
                    ) : (
                      owner.name || 'N/A'
                    )}
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <input
                        type="text"
                        name="companyName"
                        value={editForm.companyName || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Company Name"
                        style={{ width: '100%', padding: '5px' }}
                      />
                    ) : (
                      owner.company || 'N/A'
                    )}
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <input
                          type="email"
                          name="email"
                          value={editForm.email || ''}
                          onChange={handleInputChange}
                          className="edit-input"
                          placeholder="Email"
                          style={{ width: '100%', padding: '5px' }}
                        />
                        <input
                          type="text"
                          name="phone"
                          value={editForm.phone || ''}
                          onChange={handleInputChange}
                          className="edit-input"
                          placeholder="Phone"
                          style={{ width: '100%', padding: '5px' }}
                        />
                      </div>
                    ) : (
                      <div>
                        <div>{owner.email || 'N/A'}</div>
                        <div className="phone">{owner.phone || 'N/A'}</div>
                      </div>
                    )}
                  </td>

                  <td>{owner.buses}</td>

                  <td>
                    {editingOwner === owner.id ? (
                      <select
                        name="isApprovedByAdmin"
                        value={editForm.isApprovedByAdmin || false}
                        onChange={(e) => setEditForm(prev => ({ ...prev, isApprovedByAdmin: e.target.value === 'true' }))}
                        className="edit-select"
                        style={{ width: '100%', padding: '5px' }}
                      >
                        <option value="true">Approved</option>
                        <option value="false">Pending</option>
                      </select>
                    ) : (
                      <span className={`status-badge ${owner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
                        {owner.isApprovedByAdmin ? 'Approved' : 'Pending'}
                      </span>
                    )}
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <select
                        name="status"
                        value={editForm.status || 'Pending'}
                        onChange={handleInputChange}
                        className="edit-select"
                        style={{ width: '100%', padding: '5px' }}
                      >
                        <option value="Verified">Verified</option>
                        <option value="Pending">Pending</option>
                        <option value="Suspended">Suspended</option>
                      </select>
                    ) : (
                      <span className={`status-badge ${owner.status ? owner.status.toLowerCase() : 'pending'}`}>
                        {owner.status || 'Pending'}
                      </span>
                    )}
                  </td>

                  <td>
                    {editingOwner === owner.id ? (
                      <div className="edit-actions" style={{ display: 'flex', gap: '5px' }}>
                        <button
                          className="action-btn save"
                          onClick={handleSaveEdit}
                          style={{ backgroundColor: '#28a745', color: 'white' }}
                        >
                          Save
                        </button>
                        <button
                          className="action-btn cancel"
                          onClick={handleCancelEdit}
                          style={{ backgroundColor: '#6c757d', color: 'white' }}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <div className="action-buttons">
                        <button
                          className="action-btn view"
                          onClick={() => handleViewOwner(owner)}
                        >
                          View
                        </button>
                        <button
                          className="action-btn edit"
                          onClick={() => handleEditOwner(owner)}
                        >
                          Edit
                        </button>

                        <button
                          className="action-btn add-bus"
                          onClick={() => handleAddBusClick(owner)}
                          style={{
                            backgroundColor: '#007bff',
                            color: 'white'
                          }}
                          title="Add new bus for this owner"
                        >
                          + Add Bus
                        </button>

                        <button
                          className="action-btn manage"
                          onClick={() => handleManageBuses(owner)}
                          style={{
                            backgroundColor: '#007bff',
                            color: 'white'
                          }}
                          title={owner.buses === 0 ? 'No buses available' : 'Manage buses'}
                        >
                          Manage Buses
                        </button>

                        {!owner.isApprovedByAdmin && (
                          <button
                            className="action-btn approve"
                            onClick={() => handleApproveOwner(owner.id)}
                            style={{ backgroundColor: '#28a745' }}
                          >
                            Approve
                          </button>
                        )}
                        {owner.isApprovedByAdmin && (
                          <button
                            className="action-btn reject"
                            onClick={() => handleRejectOwner(owner.id)}
                            style={{ backgroundColor: '#ffc107', color: '#000' }}
                          >
                            Reject
                          </button>
                        )}
                        <button
                          className="action-btn delete"
                          onClick={() => handleDeleteOwner(owner.id)}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="no-data">
                  <p>No bus owners found {searchTerm ? 'matching your search' : ''}.</p>
                  {searchTerm && (
                    <button className="clear-filters-link" onClick={handleRefresh}>
                      Clear search to see all bus owners
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {filteredOwners.length === 0 && !loading && (
          <div className="no-data">
            <p>No bus owners found matching your search.</p>
          </div>
        )}
      </div>

      <div className="pagination-container">
        <div className="pagination-info">
          Showing {busOwners.length} of {totalOwners} bus owners
          (Page {currentPage} of {totalPages})
          {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
        </div>
        <div className="pagination-controls">
          <button
            className="pagination-btn"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <div className="page-numbers">
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNumber;
              if (totalPages <= 5) {
                pageNumber = i + 1;
              } else if (currentPage <= 3) {
                pageNumber = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNumber = totalPages - 4 + i;
              } else {
                pageNumber = currentPage - 2 + i;
              }

              return (
                <button
                  key={pageNumber}
                  className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                  onClick={() => handlePageClick(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>

          <button
            className="pagination-btn"
            onClick={handleNextPage}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </button>
        </div>
      </div>

      {/* View Modal */}
      {/* {viewingOwner && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Bus Owner Details</h3>
              <button className="modal-close-btn" onClick={closeViewModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="customer-profile-image">
                  <img
                    src={getFullImageUrl(viewingOwner.profileImage)}
                    alt={viewingOwner.name || 'Bus Owner'}
                    className="profile-image-large"
                    onError={(e) => {
                      e.target.onerror = null;
                    }}
                  />
                </div>
                <div className="detail-row">
                  <label>Serial No:</label>
                  <span>{viewingOwner.serialNo}</span>
                </div>
                <div className="detail-row">
                  <label>ID:</label>
                  <span>#{viewingOwner.id}</span>
                </div>
                <div className="detail-row">
                  <label>Owner Name:</label>
                  <span>{viewingOwner.name || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Company:</label>
                  <span>{viewingOwner.company || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Email:</label>
                  <span>{viewingOwner.email || 'N/A'}</span>
                </div>
                <div className="detail-row">
                  <label>Phone:</label>
                  <span>{viewingOwner.phone || 'N/A'}</span>
                </div>

                <div className="detail-row">
                  <label>Address:</label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    {viewingOwner.address?.city && (
                      <span>City: {viewingOwner.address.city}</span>
                    )}
                    {viewingOwner.address?.state && (
                      <span>State: {viewingOwner.address.state}</span>
                    )}
                    {viewingOwner.address?.pincode && (
                      <span>Pincode: {viewingOwner.address.pincode}</span>
                    )}
                    {(!viewingOwner.address?.city && !viewingOwner.address?.state && !viewingOwner.address?.pincode) && (
                      <span>N/A</span>
                    )}
                  </div>
                </div>

                <div className="detail-row">
                  <label>Total Buses:</label>
                  <span>{viewingOwner.buses || 0}</span>
                </div>
                <div className="detail-row">
                  <label>Active Buses:</label>
                  <span>{viewingOwner.activeBuses || 0}</span>
                </div>
                <div className="detail-row">
                  <label>Drivers:</label>
                  <span>{viewingOwner.driverCount || 0}</span>
                </div>
                <div className="detail-row">
                  <label>Conductors:</label>
                  <span>{viewingOwner.conductorCount || 0}</span>
                </div>
                <div className="detail-row">
                  <label>Joined Date:</label>
                  <span>{viewingOwner.joined}</span>
                </div>
                <div className="detail-row">
                  <label>Status:</label>
                  <span className={`status-badge ${viewingOwner.status ? viewingOwner.status.toLowerCase() : 'pending'}`}>
                    {viewingOwner.status || 'Pending'}
                  </span>
                </div>
                <div className="detail-row">
                  <label>Admin Approval:</label>
                  <span className={`status-badge ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
                    {viewingOwner.isApprovedByAdmin ? 'Approved' : 'Pending'}
                  </span>
                </div>
                <div className="detail-row">
                  <label>Profile Complete:</label>
                  <span>{viewingOwner.isProfileComplete ? 'Yes' : 'No'}</span>
                </div>
                <div className="detail-row">
                  <label>Verified:</label>
                  <span>{viewingOwner.isVerified ? 'Yes' : 'No'}</span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )} */}
      {/* View Modal */}
      {viewingOwner && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modern-dashboard-modal" onClick={(e) => e.stopPropagation()}>

            {/* Header with Glassmorphism */}
            <header className="dashboard-header">
              <div className="header-left">
                <div className="icon-box"><i className="fas fa-bus"></i></div>
                <div>
                  <h3>Bus Owner Profile</h3>
                  <span className="subtitle">Management Console</span>
                </div>
              </div>
              <button className="close-icon-btn" onClick={closeViewModal}>&times;</button>
            </header>

            <div className="dashboard-body">

              {/* Top Section: Profile & Stats Combined */}
              <section className="profile-overview-card">
                <div className="owner-brand">
                  <div className="avatar-wrapper">
                    <img
                      src={getFullImageUrl(viewingOwner.profileImage)}
                      alt="Profile"
                      onError={(e) => { e.target.src = ''; }}
                    />
                    {viewingOwner.isVerified && <div className="verified-badge"><i className="fas fa-check"></i></div>}
                  </div>
                  <div className="brand-details">
                    <h2>{viewingOwner.name || 'N/A'}</h2>
                    <p className="owner-id-tag">ID: {viewingOwner.id}</p>
                    <div className="quick-tags">
                      <span className={`tag ${viewingOwner.isApprovedByAdmin ? 'approved' : 'pending'}`}>
                        {viewingOwner.isApprovedByAdmin ? 'Verified Partner' : 'Pending Review'}
                      </span>
                      <span className="tag city-tag"><i className="fas fa-map-marker-alt"></i> {viewingOwner.address?.city}, {viewingOwner.address?.state}</span>
                    </div>
                  </div>
                </div>

                <div className="stats-strip">
                  <div className="stat-node">
                    <label>Buses</label>
                    <div className="value">{viewingOwner.busCount || 0}</div>
                  </div>
                  <div className="stat-node">
                    <label>Drivers</label>
                    <div className="value">{viewingOwner.driverCount || 0}</div>
                  </div>
                  <div className="stat-node">
                    <label>Conductors</label>
                    <div className="value">{viewingOwner.conductorCount || 0}</div>
                  </div>
                </div>
              </section>

              {/* Horizontal Routes List */}
              <section className="content-group">
                <div className="section-title">
                  <h4><i className="fas fa-route"></i> Active Routes</h4>
                </div>
                <div className="row-wise-container">
                  {viewingOwner.routes?.map((route, index) => (
                    <div key={index} className="modern-row-card route-row">
                      <div className="row-main-info">
                        <div className="route-code">{route.routeNumber}</div>
                        <div className="journey-stepper">
                          <span className="">{route.origin?.city}</span>
                          <div className="connector-line">
                            <i className="fas fa-chevron-right"></i>
                          </div>
                          <span className="">{route.destination?.city}</span>
                        </div>
                      </div>
                      <div className="row-meta-info">
                        <div className="meta-item"><i className="fas fa-road"></i> {route.routeDetails?.totalDistance} km</div>
                        <div className="meta-item"><i className="fas fa-clock"></i> {route.routeDetails?.estimatedDuration?.hours}h {route.routeDetails?.estimatedDuration?.minutes}m</div>
                        <div className="meta-item bus-pill"><i className="fas fa-bus-alt"></i> {route.busCount} assigned</div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* Horizontal Buses List */}
              <section className="content-group">
                <div className="section-title">
                  <h4><i className="fas fa-shuttle-van"></i> Bus Details</h4>
                </div>
                <div className="row-wise-container">
                  {viewingOwner.buses?.map((bus, index) => (
                    <div key={index} className="modern-row-card bus-row">
                      <div className="bus-identity">
                        <div className={`status-indicator ${bus.isActive ? 'online' : 'offline'}`}></div>
                        <div>
                          <strong>{bus.busName}</strong>
                          <div className="plate-number">{bus.busNumber}</div>
                        </div>
                      </div>

                      <div className="bus-specs-row">
                        <span><i className="fas fa-chair"></i> {bus.totalSeats} Seats</span>
                        <span><i className="fas fa-snowflake"></i> {bus.busType}</span>
                      </div>

                      <div className="bus-amenities-tags">
                        {bus.amenities?.slice(0, 2).map((a, i) => <span key={i} className="mini-tag">{a}</span>)}
                      </div>

                      {/* <div className="bus-action-link">
                  <button className="view-tracking-btn">Live Track</button>
                </div> */}
                    </div>
                  ))}
                </div>
              </section>

              {/* Bank Details - only shown if the owner has added bank details */}
              {viewingOwner.bankDetails && (
                <section className="content-group">
                  <div className="section-title">
                    <h4><i className="fas fa-university"></i> Bank Details</h4>
                  </div>
                  <div className="row-wise-container">
                    <div className="modern-row-card bank-row">
                      <div className="bank-details-grid">
                        {viewingOwner.bankDetails.accountHolderName && (
                          <div className="bank-detail-item">
                            <label>Account Holder</label>
                            <span>{viewingOwner.bankDetails.accountHolderName}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.bankName && (
                          <div className="bank-detail-item">
                            <label>Bank Name</label>
                            <span>{viewingOwner.bankDetails.bankName}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.accountNumber && (
                          <div className="bank-detail-item">
                            <label>Account Number</label>
                            <span>{viewingOwner.bankDetails.accountNumber}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.ifscCode && (
                          <div className="bank-detail-item">
                            <label>IFSC Code</label>
                            <span>{viewingOwner.bankDetails.ifscCode}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.branchName && (
                          <div className="bank-detail-item">
                            <label>Branch</label>
                            <span>{viewingOwner.bankDetails.branchName}</span>
                          </div>
                        )}
                        {viewingOwner.bankDetails.upiId && (
                          <div className="bank-detail-item">
                            <label>UPI ID</label>
                            <span>{viewingOwner.bankDetails.upiId}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              )}

            </div>

            <footer className="dashboard-footer">
              <button className="btn-secondary" onClick={closeViewModal}>close</button>
            </footer>
          </div>
        </div>
      )}
      {/* NEW - Modern Bus Management Modal */}
{/* Update the BusManagementModal component call */}
{showBusManagement && selectedOwner && (
  <BusManagementModal
    key={busUpdateTrigger} // Add this to force re-render
    owner={selectedOwner}
    buses={selectedOwnerBuses}
    onClose={closeBusManagement}
    onUpdate={async () => {
      await refreshBusList();
      await fetchBusOwners();
    }}
  />
)}

      {/* Add Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={closeAddModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Add New Bus Owner</h3>
              <button className="modal-close-btn" onClick={closeAddModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="detail-row">
                  <label>Owner Name *:</label>
                  <input
                    type="text"
                    name="name"
                    value={newOwner.name}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter owner name"
                    required
                  />
                </div>
                <div className="detail-row">
                  <label>Company Name *:</label>
                  <input
                    type="text"
                    name="companyName"
                    value={newOwner.companyName}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter company name"
                    required
                  />
                </div>
                <div className="detail-row">
                  <label>Email *:</label>
                  <input
                    type="email"
                    name="email"
                    value={newOwner.email}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter email address"
                    required
                  />
                </div>
                <div className="detail-row">
                  <label>Phone *:</label>
                  <input
                    type="text"
                    name="phone"
                    value={newOwner.phone}
                    onChange={handleNewOwnerChange}
                    className="edit-input"
                    placeholder="Enter phone number"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={closeAddModal}>
                Cancel
              </button>
              <button className="action-btn save" onClick={handleAddOwner}>
                Add Owner
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Bus Modal */}
      {showAddBusModal && selectedOwnerForBus && (
        <AddBusModal
          ownerId={selectedOwnerForBus.id}
          onClose={closeAddBusModal}
          onBusAdded={handleBusAdded}
        />
      )}
    </div>
  );
};

export default BusOwnerManage;